export const OCCUPATION_PROFILES = [
  {
    "code": "11-1011.00",
    "aptitudeProfile": {
      "Verbal": 98,
      "Numeric": 87,
      "Spatial": 20,
      "ClericalPerception": 97,
      "FormPerception": 79,
      "GeneralLearning": 93
    },
    "interestProfile": {
      "Artistic": 95,
      "Scientific": 96,
      "Plants/Animals": 88,
      "Protective": 79,
      "Mechanical": 20,
      "Industrial": 90,
      "Business Detail": 99,
      "Selling": 98,
      "Accommodating": 90,
      "Humanitarian": 27,
      "Leading/Influencing": 100,
      "Physical Performing": 94
    },
    "fitScore": 80
  },
  {
    "code": "11-1011.03",
    "aptitudeProfile": {
      "Verbal": 90,
      "Numeric": 65,
      "Spatial": 72,
      "ClericalPerception": 73,
      "FormPerception": 21,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 92,
      "Plants/Animals": 68,
      "Protective": 21,
      "Mechanical": 72,
      "Industrial": 79,
      "Business Detail": 87,
      "Selling": 93,
      "Accommodating": 58,
      "Humanitarian": 88,
      "Leading/Influencing": 95,
      "Physical Performing": 65
    },
    "fitScore": 71
  },
  {
    "code": "11-1021.00",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 69,
      "Spatial": 14,
      "ClericalPerception": 45,
      "FormPerception": 14,
      "GeneralLearning": 68
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 71,
      "Plants/Animals": 71,
      "Protective": 14,
      "Mechanical": 14,
      "Industrial": 70,
      "Business Detail": 94,
      "Selling": 74,
      "Accommodating": 50,
      "Humanitarian": 25,
      "Leading/Influencing": 90,
      "Physical Performing": 77
    },
    "fitScore": 55
  },
  {
    "code": "11-2011.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 71,
      "Spatial": 94,
      "ClericalPerception": 91,
      "FormPerception": 63,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 81,
      "Scientific": 85,
      "Plants/Animals": 75,
      "Protective": 63,
      "Mechanical": 94,
      "Industrial": 76,
      "Business Detail": 86,
      "Selling": 90,
      "Accommodating": 75,
      "Humanitarian": 80,
      "Leading/Influencing": 94,
      "Physical Performing": 65
    },
    "fitScore": 80
  },
  {
    "code": "11-2021.00",
    "aptitudeProfile": {
      "Verbal": 85,
      "Numeric": 80,
      "Spatial": 86,
      "ClericalPerception": 90,
      "FormPerception": 52,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 88,
      "Plants/Animals": 85,
      "Protective": 52,
      "Mechanical": 86,
      "Industrial": 74,
      "Business Detail": 93,
      "Selling": 91,
      "Accommodating": 78,
      "Humanitarian": 86,
      "Leading/Influencing": 91,
      "Physical Performing": 80
    },
    "fitScore": 80
  },
  {
    "code": "11-2022.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 79,
      "Spatial": 7,
      "ClericalPerception": 76,
      "FormPerception": 24,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 87,
      "Plants/Animals": 86,
      "Protective": 24,
      "Mechanical": 7,
      "Industrial": 78,
      "Business Detail": 89,
      "Selling": 89,
      "Accommodating": 70,
      "Humanitarian": 23,
      "Leading/Influencing": 95,
      "Physical Performing": 69
    },
    "fitScore": 62
  },
  {
    "code": "11-3012.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 50,
      "Spatial": 17,
      "ClericalPerception": 54,
      "FormPerception": 36,
      "GeneralLearning": 58
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 61,
      "Plants/Animals": 56,
      "Protective": 36,
      "Mechanical": 17,
      "Industrial": 55,
      "Business Detail": 90,
      "Selling": 68,
      "Accommodating": 44,
      "Humanitarian": 25,
      "Leading/Influencing": 81,
      "Physical Performing": 65
    },
    "fitScore": 53
  },
  {
    "code": "11-3013.00",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 56,
      "Spatial": 55,
      "ClericalPerception": 47,
      "FormPerception": 48,
      "GeneralLearning": 64
    },
    "interestProfile": {
      "Artistic": 61,
      "Scientific": 60,
      "Plants/Animals": 56,
      "Protective": 48,
      "Mechanical": 55,
      "Industrial": 66,
      "Business Detail": 86,
      "Selling": 51,
      "Accommodating": 57,
      "Humanitarian": 49,
      "Leading/Influencing": 92,
      "Physical Performing": 49
    },
    "fitScore": 59
  },
  {
    "code": "11-3021.00",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 77,
      "Spatial": 86,
      "ClericalPerception": 75,
      "FormPerception": 50,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 86,
      "Plants/Animals": 79,
      "Protective": 50,
      "Mechanical": 86,
      "Industrial": 83,
      "Business Detail": 83,
      "Selling": 82,
      "Accommodating": 70,
      "Humanitarian": 87,
      "Leading/Influencing": 90,
      "Physical Performing": 74
    },
    "fitScore": 78
  },
  {
    "code": "11-3031.00",
    "aptitudeProfile": {
      "Verbal": 92,
      "Numeric": 93,
      "Spatial": 19,
      "ClericalPerception": 76,
      "FormPerception": 69,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 84,
      "Scientific": 86,
      "Plants/Animals": 96,
      "Protective": 69,
      "Mechanical": 19,
      "Industrial": 92,
      "Business Detail": 98,
      "Selling": 83,
      "Accommodating": 92,
      "Humanitarian": 89,
      "Leading/Influencing": 99,
      "Physical Performing": 88
    },
    "fitScore": 78
  },
  {
    "code": "11-3031.01",
    "aptitudeProfile": {
      "Verbal": 90,
      "Numeric": 98,
      "Spatial": 42,
      "ClericalPerception": 84,
      "FormPerception": 70,
      "GeneralLearning": 91
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 88,
      "Plants/Animals": 99,
      "Protective": 70,
      "Mechanical": 42,
      "Industrial": 96,
      "Business Detail": 98,
      "Selling": 76,
      "Accommodating": 94,
      "Humanitarian": 91,
      "Leading/Influencing": 100,
      "Physical Performing": 90
    },
    "fitScore": 82
  },
  {
    "code": "11-3031.03",
    "aptitudeProfile": {
      "Verbal": 81,
      "Numeric": 97,
      "Spatial": null,
      "ClericalPerception": 84,
      "FormPerception": 82,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 87,
      "Plants/Animals": 98,
      "Protective": 82,
      "Mechanical": null,
      "Industrial": 90,
      "Business Detail": 95,
      "Selling": 81,
      "Accommodating": 98,
      "Humanitarian": 88,
      "Leading/Influencing": 90,
      "Physical Performing": 96
    },
    "fitScore": 88
  },
  {
    "code": "11-3051.00",
    "aptitudeProfile": {
      "Verbal": 82,
      "Numeric": 84,
      "Spatial": 37,
      "ClericalPerception": 91,
      "FormPerception": 71,
      "GeneralLearning": 84
    },
    "interestProfile": {
      "Artistic": 72,
      "Scientific": 87,
      "Plants/Animals": 84,
      "Protective": 71,
      "Mechanical": 37,
      "Industrial": 88,
      "Business Detail": 90,
      "Selling": 85,
      "Accommodating": 79,
      "Humanitarian": 29,
      "Leading/Influencing": 98,
      "Physical Performing": 73
    },
    "fitScore": 75
  },
  {
    "code": "11-3051.01",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 82,
      "Spatial": 74,
      "ClericalPerception": 90,
      "FormPerception": 94,
      "GeneralLearning": 88
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 86,
      "Plants/Animals": 82,
      "Protective": 94,
      "Mechanical": 74,
      "Industrial": 84,
      "Business Detail": 88,
      "Selling": 78,
      "Accommodating": 91,
      "Humanitarian": 88,
      "Leading/Influencing": 91,
      "Physical Performing": 80
    },
    "fitScore": 85
  },
  {
    "code": "11-3051.02",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 89,
      "Spatial": 46,
      "ClericalPerception": 71,
      "FormPerception": 72,
      "GeneralLearning": 80
    },
    "interestProfile": {
      "Artistic": 72,
      "Scientific": 75,
      "Plants/Animals": 88,
      "Protective": 72,
      "Mechanical": 46,
      "Industrial": 87,
      "Business Detail": 97,
      "Selling": 72,
      "Accommodating": 85,
      "Humanitarian": 39,
      "Leading/Influencing": 98,
      "Physical Performing": 91
    },
    "fitScore": 75
  },
  {
    "code": "11-3051.03",
    "aptitudeProfile": {
      "Verbal": 85,
      "Numeric": 79,
      "Spatial": 74,
      "ClericalPerception": 85,
      "FormPerception": 87,
      "GeneralLearning": 66
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 67,
      "Plants/Animals": 79,
      "Protective": 87,
      "Mechanical": 74,
      "Industrial": 78,
      "Business Detail": 94,
      "Selling": 76,
      "Accommodating": 84,
      "Humanitarian": 84,
      "Leading/Influencing": 95,
      "Physical Performing": 83
    },
    "fitScore": 80
  },
  {
    "code": "11-3051.04",
    "aptitudeProfile": {
      "Verbal": 85,
      "Numeric": 79,
      "Spatial": 25,
      "ClericalPerception": 80,
      "FormPerception": 82,
      "GeneralLearning": 84
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 80,
      "Plants/Animals": 79,
      "Protective": 82,
      "Mechanical": 25,
      "Industrial": 80,
      "Business Detail": 94,
      "Selling": 70,
      "Accommodating": 79,
      "Humanitarian": 30,
      "Leading/Influencing": 95,
      "Physical Performing": 79
    },
    "fitScore": 72
  },
  {
    "code": "11-3051.06",
    "aptitudeProfile": {
      "Verbal": 85,
      "Numeric": 85,
      "Spatial": 73,
      "ClericalPerception": 97,
      "FormPerception": 95,
      "GeneralLearning": 75
    },
    "interestProfile": {
      "Artistic": 80,
      "Scientific": 78,
      "Plants/Animals": 88,
      "Protective": 95,
      "Mechanical": 73,
      "Industrial": 85,
      "Business Detail": 89,
      "Selling": 81,
      "Accommodating": 88,
      "Humanitarian": 48,
      "Leading/Influencing": 95,
      "Physical Performing": 79
    },
    "fitScore": 83
  },
  {
    "code": "11-3061.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 83,
      "Spatial": 24,
      "ClericalPerception": 91,
      "FormPerception": 43,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 73,
      "Scientific": 86,
      "Plants/Animals": 87,
      "Protective": 43,
      "Mechanical": 24,
      "Industrial": 80,
      "Business Detail": 94,
      "Selling": 90,
      "Accommodating": 70,
      "Humanitarian": 84,
      "Leading/Influencing": 97,
      "Physical Performing": 75
    },
    "fitScore": 71
  },
  {
    "code": "11-3071.00",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 70,
      "Spatial": 27,
      "ClericalPerception": 78,
      "FormPerception": 68,
      "GeneralLearning": 76
    },
    "interestProfile": {
      "Artistic": 73,
      "Scientific": 79,
      "Plants/Animals": 67,
      "Protective": 68,
      "Mechanical": 27,
      "Industrial": 69,
      "Business Detail": 95,
      "Selling": 76,
      "Accommodating": 69,
      "Humanitarian": 34,
      "Leading/Influencing": 92,
      "Physical Performing": 78
    },
    "fitScore": 68
  },
  {
    "code": "11-3071.04",
    "aptitudeProfile": {
      "Verbal": 89,
      "Numeric": 79,
      "Spatial": 64,
      "ClericalPerception": 66,
      "FormPerception": 57,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 76,
      "Plants/Animals": 81,
      "Protective": 57,
      "Mechanical": 64,
      "Industrial": 80,
      "Business Detail": 96,
      "Selling": 70,
      "Accommodating": 77,
      "Humanitarian": 87,
      "Leading/Influencing": 97,
      "Physical Performing": 78
    },
    "fitScore": 75
  },
  {
    "code": "11-3111.00",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 81,
      "Spatial": 9,
      "ClericalPerception": 38,
      "FormPerception": 8,
      "GeneralLearning": 48
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 59,
      "Plants/Animals": 86,
      "Protective": 8,
      "Mechanical": 9,
      "Industrial": 81,
      "Business Detail": 91,
      "Selling": 74,
      "Accommodating": 60,
      "Humanitarian": 88,
      "Leading/Influencing": 94,
      "Physical Performing": 74
    },
    "fitScore": 56
  },
  {
    "code": "11-3121.00",
    "aptitudeProfile": {
      "Verbal": 92,
      "Numeric": 67,
      "Spatial": 40,
      "ClericalPerception": 77,
      "FormPerception": 34,
      "GeneralLearning": 83
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 87,
      "Plants/Animals": 80,
      "Protective": 34,
      "Mechanical": 40,
      "Industrial": 72,
      "Business Detail": 92,
      "Selling": 89,
      "Accommodating": 65,
      "Humanitarian": 88,
      "Leading/Influencing": 96,
      "Physical Performing": 67
    },
    "fitScore": 70
  },
  {
    "code": "11-3131.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 42,
      "Spatial": 59,
      "ClericalPerception": 91,
      "FormPerception": 40,
      "GeneralLearning": 76
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 87,
      "Plants/Animals": 50,
      "Protective": 40,
      "Mechanical": 59,
      "Industrial": 76,
      "Business Detail": 61,
      "Selling": 89,
      "Accommodating": 46,
      "Humanitarian": 87,
      "Leading/Influencing": 93,
      "Physical Performing": 24
    },
    "fitScore": 66
  },
  {
    "code": "11-9013.00",
    "aptitudeProfile": {
      "Verbal": 79,
      "Numeric": 77,
      "Spatial": 80,
      "ClericalPerception": 93,
      "FormPerception": 88,
      "GeneralLearning": 82
    },
    "interestProfile": {
      "Artistic": 67,
      "Scientific": 83,
      "Plants/Animals": 76,
      "Protective": 88,
      "Mechanical": 80,
      "Industrial": 73,
      "Business Detail": 94,
      "Selling": 76,
      "Accommodating": 83,
      "Humanitarian": 50,
      "Leading/Influencing": 93,
      "Physical Performing": 79
    },
    "fitScore": 81
  },
  {
    "code": "11-9021.00",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 85,
      "Spatial": 80,
      "ClericalPerception": 79,
      "FormPerception": 83,
      "GeneralLearning": 81
    },
    "interestProfile": {
      "Artistic": 71,
      "Scientific": 78,
      "Plants/Animals": 86,
      "Protective": 83,
      "Mechanical": 80,
      "Industrial": 83,
      "Business Detail": 96,
      "Selling": 67,
      "Accommodating": 87,
      "Humanitarian": 34,
      "Leading/Influencing": 98,
      "Physical Performing": 76
    },
    "fitScore": 80
  },
  {
    "code": "11-9031.00",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 65,
      "Spatial": 40,
      "ClericalPerception": 66,
      "FormPerception": 36,
      "GeneralLearning": 83
    },
    "interestProfile": {
      "Artistic": 81,
      "Scientific": 84,
      "Plants/Animals": 66,
      "Protective": 36,
      "Mechanical": 40,
      "Industrial": 77,
      "Business Detail": 85,
      "Selling": 79,
      "Accommodating": 60,
      "Humanitarian": 88,
      "Leading/Influencing": 92,
      "Physical Performing": 64
    },
    "fitScore": 67
  },
  {
    "code": "11-9032.00",
    "aptitudeProfile": {
      "Verbal": 97,
      "Numeric": 78,
      "Spatial": 70,
      "ClericalPerception": 81,
      "FormPerception": 53,
      "GeneralLearning": 93
    },
    "interestProfile": {
      "Artistic": 93,
      "Scientific": 93,
      "Plants/Animals": 78,
      "Protective": 53,
      "Mechanical": 70,
      "Industrial": 90,
      "Business Detail": 96,
      "Selling": 94,
      "Accommodating": 80,
      "Humanitarian": 94,
      "Leading/Influencing": 98,
      "Physical Performing": 87
    },
    "fitScore": 82
  },
  {
    "code": "11-9033.00",
    "aptitudeProfile": {
      "Verbal": 92,
      "Numeric": 68,
      "Spatial": 53,
      "ClericalPerception": 83,
      "FormPerception": 50,
      "GeneralLearning": 83
    },
    "interestProfile": {
      "Artistic": 87,
      "Scientific": 89,
      "Plants/Animals": 72,
      "Protective": 50,
      "Mechanical": 53,
      "Industrial": 83,
      "Business Detail": 86,
      "Selling": 91,
      "Accommodating": 73,
      "Humanitarian": 92,
      "Leading/Influencing": 93,
      "Physical Performing": 69
    },
    "fitScore": 75
  },
  {
    "code": "11-9041.00",
    "aptitudeProfile": {
      "Verbal": 91,
      "Numeric": 97,
      "Spatial": 51,
      "ClericalPerception": 92,
      "FormPerception": 68,
      "GeneralLearning": 83
    },
    "interestProfile": {
      "Artistic": 87,
      "Scientific": 90,
      "Plants/Animals": 97,
      "Protective": 68,
      "Mechanical": 51,
      "Industrial": 97,
      "Business Detail": 96,
      "Selling": 93,
      "Accommodating": 96,
      "Humanitarian": 26,
      "Leading/Influencing": 99,
      "Physical Performing": 93
    },
    "fitScore": 82
  },
  {
    "code": "11-9041.01",
    "aptitudeProfile": {
      "Verbal": 73,
      "Numeric": 88,
      "Spatial": 83,
      "ClericalPerception": 85,
      "FormPerception": 74,
      "GeneralLearning": 83
    },
    "interestProfile": {
      "Artistic": 75,
      "Scientific": 84,
      "Plants/Animals": 92,
      "Protective": 74,
      "Mechanical": 83,
      "Industrial": 76,
      "Business Detail": 76,
      "Selling": 81,
      "Accommodating": 92,
      "Humanitarian": 78,
      "Leading/Influencing": 75,
      "Physical Performing": 84
    },
    "fitScore": 81
  },
  {
    "code": "11-9051.00",
    "aptitudeProfile": {
      "Verbal": 75,
      "Numeric": 72,
      "Spatial": 40,
      "ClericalPerception": 36,
      "FormPerception": 22,
      "GeneralLearning": 44
    },
    "interestProfile": {
      "Artistic": 63,
      "Scientific": 44,
      "Plants/Animals": 73,
      "Protective": 22,
      "Mechanical": 40,
      "Industrial": 65,
      "Business Detail": 93,
      "Selling": 56,
      "Accommodating": 44,
      "Humanitarian": 73,
      "Leading/Influencing": 94,
      "Physical Performing": 73
    },
    "fitScore": 55
  },
  {
    "code": "11-9071.00",
    "aptitudeProfile": {
      "Verbal": 71,
      "Numeric": 86,
      "Spatial": 34,
      "ClericalPerception": 70,
      "FormPerception": 79,
      "GeneralLearning": 74
    },
    "interestProfile": {
      "Artistic": 57,
      "Scientific": 69,
      "Plants/Animals": 82,
      "Protective": 79,
      "Mechanical": 34,
      "Industrial": 71,
      "Business Detail": 98,
      "Selling": 59,
      "Accommodating": 79,
      "Humanitarian": 71,
      "Leading/Influencing": 96,
      "Physical Performing": 88
    },
    "fitScore": 71
  },
  {
    "code": "11-9081.00",
    "aptitudeProfile": {
      "Verbal": 89,
      "Numeric": 80,
      "Spatial": 29,
      "ClericalPerception": 85,
      "FormPerception": 57,
      "GeneralLearning": 61
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 74,
      "Plants/Animals": 76,
      "Protective": 57,
      "Mechanical": 29,
      "Industrial": 67,
      "Business Detail": 99,
      "Selling": 83,
      "Accommodating": 79,
      "Humanitarian": 39,
      "Leading/Influencing": 96,
      "Physical Performing": 91
    },
    "fitScore": 70
  },
  {
    "code": "11-9111.00",
    "aptitudeProfile": {
      "Verbal": 93,
      "Numeric": 72,
      "Spatial": 19,
      "ClericalPerception": 68,
      "FormPerception": 43,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 84,
      "Plants/Animals": 75,
      "Protective": 43,
      "Mechanical": 19,
      "Industrial": 75,
      "Business Detail": 98,
      "Selling": 86,
      "Accommodating": 66,
      "Humanitarian": 88,
      "Leading/Influencing": 98,
      "Physical Performing": 85
    },
    "fitScore": 69
  },
  {
    "code": "11-9121.00",
    "aptitudeProfile": {
      "Verbal": 91,
      "Numeric": 87,
      "Spatial": 9,
      "ClericalPerception": 49,
      "FormPerception": 32,
      "GeneralLearning": 92
    },
    "interestProfile": {
      "Artistic": 87,
      "Scientific": 90,
      "Plants/Animals": 90,
      "Protective": 32,
      "Mechanical": 9,
      "Industrial": 90,
      "Business Detail": 89,
      "Selling": 83,
      "Accommodating": 86,
      "Humanitarian": 33,
      "Leading/Influencing": 94,
      "Physical Performing": 83
    },
    "fitScore": 66
  },
  {
    "code": "11-9121.01",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 65,
      "Spatial": 64,
      "ClericalPerception": 64,
      "FormPerception": 63,
      "GeneralLearning": 82
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 75,
      "Plants/Animals": 76,
      "Protective": 63,
      "Mechanical": 64,
      "Industrial": 78,
      "Business Detail": 37,
      "Selling": 66,
      "Accommodating": 70,
      "Humanitarian": 88,
      "Leading/Influencing": 59,
      "Physical Performing": 52
    },
    "fitScore": 68
  },
  {
    "code": "11-9121.02",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 92,
      "Spatial": 82,
      "ClericalPerception": 81,
      "FormPerception": 80,
      "GeneralLearning": 82
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 81,
      "Plants/Animals": 89,
      "Protective": 80,
      "Mechanical": 82,
      "Industrial": 88,
      "Business Detail": 88,
      "Selling": 74,
      "Accommodating": 88,
      "Humanitarian": 88,
      "Leading/Influencing": 79,
      "Physical Performing": 94
    },
    "fitScore": 83
  },
  {
    "code": "11-9131.00",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 68,
      "Spatial": 42,
      "ClericalPerception": 54,
      "FormPerception": 48,
      "GeneralLearning": 67
    },
    "interestProfile": {
      "Artistic": 69,
      "Scientific": 64,
      "Plants/Animals": 66,
      "Protective": 48,
      "Mechanical": 42,
      "Industrial": 70,
      "Business Detail": 96,
      "Selling": 62,
      "Accommodating": 61,
      "Humanitarian": 86,
      "Leading/Influencing": 94,
      "Physical Performing": 77
    },
    "fitScore": 65
  },
  {
    "code": "11-9141.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 77,
      "Spatial": 36,
      "ClericalPerception": 19,
      "FormPerception": 7,
      "GeneralLearning": 59
    },
    "interestProfile": {
      "Artistic": 75,
      "Scientific": 59,
      "Plants/Animals": 75,
      "Protective": 7,
      "Mechanical": 36,
      "Industrial": 77,
      "Business Detail": 97,
      "Selling": 64,
      "Accommodating": 49,
      "Humanitarian": 84,
      "Leading/Influencing": 97,
      "Physical Performing": 80
    },
    "fitScore": 57
  },
  {
    "code": "11-9151.00",
    "aptitudeProfile": {
      "Verbal": 90,
      "Numeric": 70,
      "Spatial": 51,
      "ClericalPerception": 83,
      "FormPerception": 50,
      "GeneralLearning": 77
    },
    "interestProfile": {
      "Artistic": 84,
      "Scientific": 84,
      "Plants/Animals": 75,
      "Protective": 50,
      "Mechanical": 51,
      "Industrial": 66,
      "Business Detail": 93,
      "Selling": 89,
      "Accommodating": 69,
      "Humanitarian": 81,
      "Leading/Influencing": 93,
      "Physical Performing": 78
    },
    "fitScore": 73
  },
  {
    "code": "11-9161.00",
    "aptitudeProfile": {
      "Verbal": 90,
      "Numeric": 62,
      "Spatial": 56,
      "ClericalPerception": 96,
      "FormPerception": 65,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 94,
      "Plants/Animals": 70,
      "Protective": 65,
      "Mechanical": 56,
      "Industrial": 80,
      "Business Detail": 82,
      "Selling": 94,
      "Accommodating": 67,
      "Humanitarian": 42,
      "Leading/Influencing": 96,
      "Physical Performing": 55
    },
    "fitScore": 75
  },
  {
    "code": "11-9171.00",
    "aptitudeProfile": {
      "Verbal": 82,
      "Numeric": 57,
      "Spatial": 22,
      "ClericalPerception": 34,
      "FormPerception": 14,
      "GeneralLearning": 27
    },
    "interestProfile": {
      "Artistic": 70,
      "Scientific": 36,
      "Plants/Animals": 60,
      "Protective": 14,
      "Mechanical": 22,
      "Industrial": 57,
      "Business Detail": 91,
      "Selling": 63,
      "Accommodating": 41,
      "Humanitarian": 30,
      "Leading/Influencing": 93,
      "Physical Performing": 62
    },
    "fitScore": 46
  },
  {
    "code": "11-9179.01",
    "aptitudeProfile": {
      "Verbal": 79,
      "Numeric": 38,
      "Spatial": 30,
      "ClericalPerception": 68,
      "FormPerception": 26,
      "GeneralLearning": 76
    },
    "interestProfile": {
      "Artistic": 73,
      "Scientific": 82,
      "Plants/Animals": 48,
      "Protective": 26,
      "Mechanical": 30,
      "Industrial": 41,
      "Business Detail": 74,
      "Selling": 83,
      "Accommodating": 46,
      "Humanitarian": 26,
      "Leading/Influencing": 73,
      "Physical Performing": 47
    },
    "fitScore": 53
  },
  {
    "code": "11-9179.02",
    "aptitudeProfile": {
      "Verbal": 72,
      "Numeric": 71,
      "Spatial": 49,
      "ClericalPerception": 69,
      "FormPerception": 30,
      "GeneralLearning": 70
    },
    "interestProfile": {
      "Artistic": 63,
      "Scientific": 77,
      "Plants/Animals": 74,
      "Protective": 30,
      "Mechanical": 49,
      "Industrial": 55,
      "Business Detail": 91,
      "Selling": 80,
      "Accommodating": 57,
      "Humanitarian": 65,
      "Leading/Influencing": 91,
      "Physical Performing": 73
    },
    "fitScore": 64
  },
  {
    "code": "11-9199.01",
    "aptitudeProfile": {
      "Verbal": 89,
      "Numeric": 38,
      "Spatial": 12,
      "ClericalPerception": 56,
      "FormPerception": 39,
      "GeneralLearning": 80
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 78,
      "Plants/Animals": 39,
      "Protective": 39,
      "Mechanical": 12,
      "Industrial": 66,
      "Business Detail": 68,
      "Selling": 76,
      "Accommodating": 41,
      "Humanitarian": 90,
      "Leading/Influencing": 75,
      "Physical Performing": 52
    },
    "fitScore": 56
  },
  {
    "code": "11-9199.02",
    "aptitudeProfile": {
      "Verbal": 89,
      "Numeric": 31,
      "Spatial": 16,
      "ClericalPerception": 43,
      "FormPerception": 34,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 81,
      "Plants/Animals": 26,
      "Protective": 34,
      "Mechanical": 16,
      "Industrial": 53,
      "Business Detail": 82,
      "Selling": 68,
      "Accommodating": 33,
      "Humanitarian": 88,
      "Leading/Influencing": 74,
      "Physical Performing": 60
    },
    "fitScore": 54
  },
  {
    "code": "11-9199.08",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 62,
      "Spatial": 70,
      "ClericalPerception": 70,
      "FormPerception": 68,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 77,
      "Plants/Animals": 60,
      "Protective": 68,
      "Mechanical": 70,
      "Industrial": 73,
      "Business Detail": 86,
      "Selling": 71,
      "Accommodating": 65,
      "Humanitarian": 87,
      "Leading/Influencing": 87,
      "Physical Performing": 69
    },
    "fitScore": 73
  },
  {
    "code": "11-9199.09",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 71,
      "Spatial": 50,
      "ClericalPerception": 80,
      "FormPerception": 73,
      "GeneralLearning": 74
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 74,
      "Plants/Animals": 71,
      "Protective": 73,
      "Mechanical": 50,
      "Industrial": 78,
      "Business Detail": 90,
      "Selling": 72,
      "Accommodating": 70,
      "Humanitarian": 38,
      "Leading/Influencing": 95,
      "Physical Performing": 67
    },
    "fitScore": 72
  },
  {
    "code": "11-9199.10",
    "aptitudeProfile": {
      "Verbal": 85,
      "Numeric": 78,
      "Spatial": 82,
      "ClericalPerception": 47,
      "FormPerception": 43,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 82,
      "Plants/Animals": 81,
      "Protective": 43,
      "Mechanical": 82,
      "Industrial": 81,
      "Business Detail": 91,
      "Selling": 71,
      "Accommodating": 80,
      "Humanitarian": 86,
      "Leading/Influencing": 95,
      "Physical Performing": 73
    },
    "fitScore": 74
  },
  {
    "code": "11-9199.11",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 92,
      "Spatial": 32,
      "ClericalPerception": 79,
      "FormPerception": 56,
      "GeneralLearning": 88
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 88,
      "Plants/Animals": 94,
      "Protective": 56,
      "Mechanical": 32,
      "Industrial": 94,
      "Business Detail": 85,
      "Selling": 83,
      "Accommodating": 92,
      "Humanitarian": 30,
      "Leading/Influencing": 96,
      "Physical Performing": 79
    },
    "fitScore": 74
  },
  {
    "code": "13-1011.00",
    "aptitudeProfile": {
      "Verbal": 82,
      "Numeric": 33,
      "Spatial": 12,
      "ClericalPerception": 18,
      "FormPerception": 1,
      "GeneralLearning": 68
    },
    "interestProfile": {
      "Artistic": 75,
      "Scientific": 71,
      "Plants/Animals": 43,
      "Protective": 1,
      "Mechanical": 12,
      "Industrial": 50,
      "Business Detail": 64,
      "Selling": 74,
      "Accommodating": 19,
      "Humanitarian": 87,
      "Leading/Influencing": 63,
      "Physical Performing": 43
    },
    "fitScore": 43
  },
  {
    "code": "13-1021.00",
    "aptitudeProfile": {
      "Verbal": 61,
      "Numeric": 85,
      "Spatial": 19,
      "ClericalPerception": 35,
      "FormPerception": 16,
      "GeneralLearning": 50
    },
    "interestProfile": {
      "Artistic": 54,
      "Scientific": 53,
      "Plants/Animals": 83,
      "Protective": 16,
      "Mechanical": 19,
      "Industrial": 62,
      "Business Detail": 93,
      "Selling": 50,
      "Accommodating": 59,
      "Humanitarian": 63,
      "Leading/Influencing": 88,
      "Physical Performing": 81
    },
    "fitScore": 52
  },
  {
    "code": "13-1022.00",
    "aptitudeProfile": {
      "Verbal": 60,
      "Numeric": 87,
      "Spatial": 47,
      "ClericalPerception": 47,
      "FormPerception": 39,
      "GeneralLearning": 55
    },
    "interestProfile": {
      "Artistic": 60,
      "Scientific": 56,
      "Plants/Animals": 92,
      "Protective": 39,
      "Mechanical": 47,
      "Industrial": 66,
      "Business Detail": 79,
      "Selling": 64,
      "Accommodating": 83,
      "Humanitarian": 61,
      "Leading/Influencing": 83,
      "Physical Performing": 78
    },
    "fitScore": 62
  },
  {
    "code": "13-1023.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 81,
      "Spatial": 12,
      "ClericalPerception": 26,
      "FormPerception": 6,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 75,
      "Scientific": 69,
      "Plants/Animals": 82,
      "Protective": 6,
      "Mechanical": 12,
      "Industrial": 76,
      "Business Detail": 95,
      "Selling": 63,
      "Accommodating": 49,
      "Humanitarian": 87,
      "Leading/Influencing": 92,
      "Physical Performing": 85
    },
    "fitScore": 56
  },
  {
    "code": "13-1031.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 76,
      "Spatial": 7,
      "ClericalPerception": 49,
      "FormPerception": 73,
      "GeneralLearning": 88
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 76,
      "Plants/Animals": 78,
      "Protective": 73,
      "Mechanical": 7,
      "Industrial": 82,
      "Business Detail": 70,
      "Selling": 62,
      "Accommodating": 80,
      "Humanitarian": 27,
      "Leading/Influencing": 65,
      "Physical Performing": 83
    },
    "fitScore": 64
  },
  {
    "code": "13-1032.00",
    "aptitudeProfile": {
      "Verbal": 54,
      "Numeric": 47,
      "Spatial": 25,
      "ClericalPerception": 10,
      "FormPerception": 25,
      "GeneralLearning": 38
    },
    "interestProfile": {
      "Artistic": 68,
      "Scientific": 30,
      "Plants/Animals": 55,
      "Protective": 25,
      "Mechanical": 25,
      "Industrial": 53,
      "Business Detail": 16,
      "Selling": 39,
      "Accommodating": 47,
      "Humanitarian": 29,
      "Leading/Influencing": 28,
      "Physical Performing": 41
    },
    "fitScore": 36
  },
  {
    "code": "13-1041.00",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 22,
      "Spatial": 19,
      "ClericalPerception": 47,
      "FormPerception": 46,
      "GeneralLearning": 64
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 61,
      "Plants/Animals": 23,
      "Protective": 46,
      "Mechanical": 19,
      "Industrial": 48,
      "Business Detail": 35,
      "Selling": 62,
      "Accommodating": 27,
      "Humanitarian": 34,
      "Leading/Influencing": 35,
      "Physical Performing": 37
    },
    "fitScore": 44
  },
  {
    "code": "13-1041.01",
    "aptitudeProfile": {
      "Verbal": 79,
      "Numeric": 73,
      "Spatial": 52,
      "ClericalPerception": 91,
      "FormPerception": 99,
      "GeneralLearning": 91
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 86,
      "Plants/Animals": 79,
      "Protective": 99,
      "Mechanical": 52,
      "Industrial": 84,
      "Business Detail": 44,
      "Selling": 74,
      "Accommodating": 94,
      "Humanitarian": 47,
      "Leading/Influencing": 59,
      "Physical Performing": 67
    },
    "fitScore": 77
  },
  {
    "code": "13-1041.03",
    "aptitudeProfile": {
      "Verbal": 90,
      "Numeric": 53,
      "Spatial": 36,
      "ClericalPerception": 65,
      "FormPerception": 69,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 90,
      "Scientific": 84,
      "Plants/Animals": 65,
      "Protective": 69,
      "Mechanical": 36,
      "Industrial": 74,
      "Business Detail": 51,
      "Selling": 81,
      "Accommodating": 72,
      "Humanitarian": 93,
      "Leading/Influencing": 61,
      "Physical Performing": 63
    },
    "fitScore": 68
  },
  {
    "code": "13-1041.04",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 68,
      "Spatial": 82,
      "ClericalPerception": 94,
      "FormPerception": 99,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 86,
      "Plants/Animals": 76,
      "Protective": 99,
      "Mechanical": 82,
      "Industrial": 79,
      "Business Detail": 43,
      "Selling": 74,
      "Accommodating": 92,
      "Humanitarian": 59,
      "Leading/Influencing": 59,
      "Physical Performing": 58
    },
    "fitScore": 79
  },
  {
    "code": "13-1041.06",
    "aptitudeProfile": {
      "Verbal": 89,
      "Numeric": 32,
      "Spatial": 45,
      "ClericalPerception": 81,
      "FormPerception": 93,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 85,
      "Plants/Animals": 27,
      "Protective": 93,
      "Mechanical": 45,
      "Industrial": 72,
      "Business Detail": 68,
      "Selling": 80,
      "Accommodating": 68,
      "Humanitarian": 39,
      "Leading/Influencing": 84,
      "Physical Performing": 51
    },
    "fitScore": 69
  },
  {
    "code": "13-1041.07",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 50,
      "Spatial": 32,
      "ClericalPerception": 70,
      "FormPerception": 59,
      "GeneralLearning": 80
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 78,
      "Plants/Animals": 64,
      "Protective": 59,
      "Mechanical": 32,
      "Industrial": 69,
      "Business Detail": 50,
      "Selling": 77,
      "Accommodating": 71,
      "Humanitarian": 88,
      "Leading/Influencing": 67,
      "Physical Performing": 49
    },
    "fitScore": 64
  },
  {
    "code": "13-1041.08",
    "aptitudeProfile": {
      "Verbal": 71,
      "Numeric": 71,
      "Spatial": 18,
      "ClericalPerception": 51,
      "FormPerception": 50,
      "GeneralLearning": 51
    },
    "interestProfile": {
      "Artistic": 65,
      "Scientific": 53,
      "Plants/Animals": 71,
      "Protective": 50,
      "Mechanical": 18,
      "Industrial": 77,
      "Business Detail": 73,
      "Selling": 55,
      "Accommodating": 66,
      "Humanitarian": 84,
      "Leading/Influencing": 81,
      "Physical Performing": 61
    },
    "fitScore": 57
  },
  {
    "code": "13-1051.00",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 99,
      "Spatial": 86,
      "ClericalPerception": 62,
      "FormPerception": 56,
      "GeneralLearning": 84
    },
    "interestProfile": {
      "Artistic": 74,
      "Scientific": 79,
      "Plants/Animals": 99,
      "Protective": 56,
      "Mechanical": 86,
      "Industrial": 96,
      "Business Detail": 95,
      "Selling": 68,
      "Accommodating": 95,
      "Humanitarian": 88,
      "Leading/Influencing": 96,
      "Physical Performing": 97
    },
    "fitScore": 82
  },
  {
    "code": "13-1071.00",
    "aptitudeProfile": {
      "Verbal": 82,
      "Numeric": 21,
      "Spatial": 14,
      "ClericalPerception": 10,
      "FormPerception": 11,
      "GeneralLearning": 60
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 54,
      "Plants/Animals": 30,
      "Protective": 11,
      "Mechanical": 14,
      "Industrial": 47,
      "Business Detail": 50,
      "Selling": 56,
      "Accommodating": 31,
      "Humanitarian": 87,
      "Leading/Influencing": 59,
      "Physical Performing": 29
    },
    "fitScore": 39
  },
  {
    "code": "13-1074.00",
    "aptitudeProfile": {
      "Verbal": 20,
      "Numeric": 33,
      "Spatial": 8,
      "ClericalPerception": 2,
      "FormPerception": 4,
      "GeneralLearning": 10
    },
    "interestProfile": {
      "Artistic": 23,
      "Scientific": 8,
      "Plants/Animals": 21,
      "Protective": 4,
      "Mechanical": 8,
      "Industrial": 14,
      "Business Detail": 52,
      "Selling": 14,
      "Accommodating": 9,
      "Humanitarian": 14,
      "Leading/Influencing": 24,
      "Physical Performing": 54
    },
    "fitScore": 17
  },
  {
    "code": "13-1075.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 44,
      "Spatial": 34,
      "ClericalPerception": 70,
      "FormPerception": 28,
      "GeneralLearning": 77
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 82,
      "Plants/Animals": 55,
      "Protective": 28,
      "Mechanical": 34,
      "Industrial": 64,
      "Business Detail": 44,
      "Selling": 87,
      "Accommodating": 41,
      "Humanitarian": 88,
      "Leading/Influencing": 53,
      "Physical Performing": 52
    },
    "fitScore": 58
  },
  {
    "code": "13-1081.00",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 83,
      "Spatial": 91,
      "ClericalPerception": 75,
      "FormPerception": 50,
      "GeneralLearning": 88
    },
    "interestProfile": {
      "Artistic": 74,
      "Scientific": 88,
      "Plants/Animals": 82,
      "Protective": 50,
      "Mechanical": 91,
      "Industrial": 80,
      "Business Detail": 95,
      "Selling": 81,
      "Accommodating": 73,
      "Humanitarian": 85,
      "Leading/Influencing": 95,
      "Physical Performing": 85
    },
    "fitScore": 80
  },
  {
    "code": "13-1081.01",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 98,
      "Spatial": 91,
      "ClericalPerception": 93,
      "FormPerception": 66,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 92,
      "Plants/Animals": 98,
      "Protective": 66,
      "Mechanical": 91,
      "Industrial": 97,
      "Business Detail": 91,
      "Selling": 91,
      "Accommodating": 94,
      "Humanitarian": 91,
      "Leading/Influencing": 95,
      "Physical Performing": 93
    },
    "fitScore": 88
  },
  {
    "code": "13-1081.02",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 90,
      "Spatial": 72,
      "ClericalPerception": 81,
      "FormPerception": 80,
      "GeneralLearning": 74
    },
    "interestProfile": {
      "Artistic": 66,
      "Scientific": 74,
      "Plants/Animals": 94,
      "Protective": 80,
      "Mechanical": 72,
      "Industrial": 83,
      "Business Detail": 88,
      "Selling": 72,
      "Accommodating": 94,
      "Humanitarian": 87,
      "Leading/Influencing": 87,
      "Physical Performing": 84
    },
    "fitScore": 80
  },
  {
    "code": "13-1111.00",
    "aptitudeProfile": {
      "Verbal": 92,
      "Numeric": 79,
      "Spatial": 25,
      "ClericalPerception": 80,
      "FormPerception": 38,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 84,
      "Scientific": 91,
      "Plants/Animals": 75,
      "Protective": 38,
      "Mechanical": 25,
      "Industrial": 84,
      "Business Detail": 97,
      "Selling": 91,
      "Accommodating": 71,
      "Humanitarian": 90,
      "Leading/Influencing": 97,
      "Physical Performing": 85
    },
    "fitScore": 72
  },
  {
    "code": "13-1121.00",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 55,
      "Spatial": 26,
      "ClericalPerception": 81,
      "FormPerception": 36,
      "GeneralLearning": 69
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 82,
      "Plants/Animals": 73,
      "Protective": 36,
      "Mechanical": 26,
      "Industrial": 65,
      "Business Detail": 50,
      "Selling": 88,
      "Accommodating": 65,
      "Humanitarian": 28,
      "Leading/Influencing": 61,
      "Physical Performing": 47
    },
    "fitScore": 58
  },
  {
    "code": "13-1131.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 68,
      "Spatial": 24,
      "ClericalPerception": 54,
      "FormPerception": 6,
      "GeneralLearning": 77
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 86,
      "Plants/Animals": 75,
      "Protective": 6,
      "Mechanical": 24,
      "Industrial": 80,
      "Business Detail": 71,
      "Selling": 89,
      "Accommodating": 52,
      "Humanitarian": 87,
      "Leading/Influencing": 88,
      "Physical Performing": 54
    },
    "fitScore": 59
  },
  {
    "code": "13-1141.00",
    "aptitudeProfile": {
      "Verbal": 75,
      "Numeric": 83,
      "Spatial": 13,
      "ClericalPerception": 47,
      "FormPerception": 45,
      "GeneralLearning": 63
    },
    "interestProfile": {
      "Artistic": 67,
      "Scientific": 62,
      "Plants/Animals": 80,
      "Protective": 45,
      "Mechanical": 13,
      "Industrial": 80,
      "Business Detail": 91,
      "Selling": 61,
      "Accommodating": 77,
      "Humanitarian": 84,
      "Leading/Influencing": 89,
      "Physical Performing": 84
    },
    "fitScore": 62
  },
  {
    "code": "13-1151.00",
    "aptitudeProfile": {
      "Verbal": 82,
      "Numeric": 32,
      "Spatial": 38,
      "ClericalPerception": 78,
      "FormPerception": 20,
      "GeneralLearning": 66
    },
    "interestProfile": {
      "Artistic": 80,
      "Scientific": 81,
      "Plants/Animals": 43,
      "Protective": 20,
      "Mechanical": 38,
      "Industrial": 58,
      "Business Detail": 41,
      "Selling": 88,
      "Accommodating": 30,
      "Humanitarian": 84,
      "Leading/Influencing": 63,
      "Physical Performing": 30
    },
    "fitScore": 54
  },
  {
    "code": "13-1161.00",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 91,
      "Spatial": 42,
      "ClericalPerception": 93,
      "FormPerception": 54,
      "GeneralLearning": 90
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 94,
      "Plants/Animals": 90,
      "Protective": 54,
      "Mechanical": 42,
      "Industrial": 88,
      "Business Detail": 96,
      "Selling": 93,
      "Accommodating": 86,
      "Humanitarian": 90,
      "Leading/Influencing": 94,
      "Physical Performing": 93
    },
    "fitScore": 80
  },
  {
    "code": "13-1161.01",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 68,
      "Spatial": 19,
      "ClericalPerception": 79,
      "FormPerception": 40,
      "GeneralLearning": 76
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 87,
      "Plants/Animals": 63,
      "Protective": 40,
      "Mechanical": 19,
      "Industrial": 71,
      "Business Detail": 66,
      "Selling": 90,
      "Accommodating": 66,
      "Humanitarian": 85,
      "Leading/Influencing": 57,
      "Physical Performing": 78
    },
    "fitScore": 63
  },
  {
    "code": "13-1199.04",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 53,
      "Spatial": 69,
      "ClericalPerception": 93,
      "FormPerception": 82,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 92,
      "Plants/Animals": 66,
      "Protective": 82,
      "Mechanical": 69,
      "Industrial": 71,
      "Business Detail": 64,
      "Selling": 90,
      "Accommodating": 82,
      "Humanitarian": 85,
      "Leading/Influencing": 88,
      "Physical Performing": 37
    },
    "fitScore": 77
  },
  {
    "code": "13-1199.05",
    "aptitudeProfile": {
      "Verbal": 82,
      "Numeric": 62,
      "Spatial": 51,
      "ClericalPerception": 78,
      "FormPerception": 54,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 75,
      "Scientific": 77,
      "Plants/Animals": 73,
      "Protective": 54,
      "Mechanical": 51,
      "Industrial": 77,
      "Business Detail": 68,
      "Selling": 75,
      "Accommodating": 67,
      "Humanitarian": 88,
      "Leading/Influencing": 87,
      "Physical Performing": 43
    },
    "fitScore": 68
  },
  {
    "code": "13-1199.06",
    "aptitudeProfile": {
      "Verbal": 58,
      "Numeric": 74,
      "Spatial": 47,
      "ClericalPerception": 30,
      "FormPerception": 6,
      "GeneralLearning": 40
    },
    "interestProfile": {
      "Artistic": 48,
      "Scientific": 48,
      "Plants/Animals": 79,
      "Protective": 6,
      "Mechanical": 47,
      "Industrial": 70,
      "Business Detail": 75,
      "Selling": 45,
      "Accommodating": 45,
      "Humanitarian": 74,
      "Leading/Influencing": 86,
      "Physical Performing": 43
    },
    "fitScore": 49
  },
  {
    "code": "13-2011.00",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 92,
      "Spatial": 16,
      "ClericalPerception": 58,
      "FormPerception": 65,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 73,
      "Scientific": 71,
      "Plants/Animals": 92,
      "Protective": 65,
      "Mechanical": 16,
      "Industrial": 87,
      "Business Detail": 92,
      "Selling": 61,
      "Accommodating": 86,
      "Humanitarian": 86,
      "Leading/Influencing": 91,
      "Physical Performing": 89
    },
    "fitScore": 70
  },
  {
    "code": "13-2023.00",
    "aptitudeProfile": {
      "Verbal": 71,
      "Numeric": 75,
      "Spatial": 35,
      "ClericalPerception": 35,
      "FormPerception": 39,
      "GeneralLearning": 78
    },
    "interestProfile": {
      "Artistic": 69,
      "Scientific": 68,
      "Plants/Animals": 70,
      "Protective": 39,
      "Mechanical": 35,
      "Industrial": 76,
      "Business Detail": 80,
      "Selling": 52,
      "Accommodating": 59,
      "Humanitarian": 41,
      "Leading/Influencing": 74,
      "Physical Performing": 79
    },
    "fitScore": 59
  },
  {
    "code": "13-2031.00",
    "aptitudeProfile": {
      "Verbal": 75,
      "Numeric": 98,
      "Spatial": 11,
      "ClericalPerception": 65,
      "FormPerception": 59,
      "GeneralLearning": 68
    },
    "interestProfile": {
      "Artistic": 68,
      "Scientific": 65,
      "Plants/Animals": 99,
      "Protective": 59,
      "Mechanical": 11,
      "Industrial": 93,
      "Business Detail": 94,
      "Selling": 58,
      "Accommodating": 93,
      "Humanitarian": 80,
      "Leading/Influencing": 98,
      "Physical Performing": 87
    },
    "fitScore": 69
  },
  {
    "code": "13-2041.00",
    "aptitudeProfile": {
      "Verbal": 62,
      "Numeric": 96,
      "Spatial": 7,
      "ClericalPerception": 60,
      "FormPerception": 66,
      "GeneralLearning": 81
    },
    "interestProfile": {
      "Artistic": 68,
      "Scientific": 71,
      "Plants/Animals": 98,
      "Protective": 66,
      "Mechanical": 7,
      "Industrial": 85,
      "Business Detail": 73,
      "Selling": 55,
      "Accommodating": 93,
      "Humanitarian": 76,
      "Leading/Influencing": 76,
      "Physical Performing": 86
    },
    "fitScore": 67
  },
  {
    "code": "13-2052.00",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 95,
      "Spatial": 12,
      "ClericalPerception": 66,
      "FormPerception": 44,
      "GeneralLearning": 81
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 78,
      "Plants/Animals": 97,
      "Protective": 44,
      "Mechanical": 12,
      "Industrial": 93,
      "Business Detail": 75,
      "Selling": 70,
      "Accommodating": 83,
      "Humanitarian": 89,
      "Leading/Influencing": 87,
      "Physical Performing": 84
    },
    "fitScore": 68
  },
  {
    "code": "13-2053.00",
    "aptitudeProfile": {
      "Verbal": 53,
      "Numeric": 66,
      "Spatial": 14,
      "ClericalPerception": 28,
      "FormPerception": 35,
      "GeneralLearning": 65
    },
    "interestProfile": {
      "Artistic": 61,
      "Scientific": 59,
      "Plants/Animals": 65,
      "Protective": 35,
      "Mechanical": 14,
      "Industrial": 69,
      "Business Detail": 38,
      "Selling": 39,
      "Accommodating": 65,
      "Humanitarian": 79,
      "Leading/Influencing": 40,
      "Physical Performing": 52
    },
    "fitScore": 47
  },
  {
    "code": "13-2061.00",
    "aptitudeProfile": {
      "Verbal": 85,
      "Numeric": 89,
      "Spatial": 34,
      "ClericalPerception": 69,
      "FormPerception": 70,
      "GeneralLearning": 93
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 86,
      "Plants/Animals": 92,
      "Protective": 70,
      "Mechanical": 34,
      "Industrial": 94,
      "Business Detail": 63,
      "Selling": 71,
      "Accommodating": 90,
      "Humanitarian": 91,
      "Leading/Influencing": 90,
      "Physical Performing": 70
    },
    "fitScore": 76
  },
  {
    "code": "13-2071.00",
    "aptitudeProfile": {
      "Verbal": 70,
      "Numeric": 81,
      "Spatial": 18,
      "ClericalPerception": 51,
      "FormPerception": 22,
      "GeneralLearning": 71
    },
    "interestProfile": {
      "Artistic": 74,
      "Scientific": 72,
      "Plants/Animals": 82,
      "Protective": 22,
      "Mechanical": 18,
      "Industrial": 79,
      "Business Detail": 62,
      "Selling": 71,
      "Accommodating": 61,
      "Humanitarian": 83,
      "Leading/Influencing": 64,
      "Physical Performing": 77
    },
    "fitScore": 58
  },
  {
    "code": "13-2072.00",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 86,
      "Spatial": 4,
      "ClericalPerception": 21,
      "FormPerception": 13,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 66,
      "Plants/Animals": 87,
      "Protective": 13,
      "Mechanical": 4,
      "Industrial": 83,
      "Business Detail": 77,
      "Selling": 61,
      "Accommodating": 66,
      "Humanitarian": 84,
      "Leading/Influencing": 81,
      "Physical Performing": 82
    },
    "fitScore": 55
  },
  {
    "code": "13-2081.00",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 86,
      "Spatial": 19,
      "ClericalPerception": 45,
      "FormPerception": 57,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 73,
      "Scientific": 73,
      "Plants/Animals": 85,
      "Protective": 57,
      "Mechanical": 19,
      "Industrial": 86,
      "Business Detail": 87,
      "Selling": 55,
      "Accommodating": 75,
      "Humanitarian": 88,
      "Leading/Influencing": 88,
      "Physical Performing": 84
    },
    "fitScore": 67
  },
  {
    "code": "13-2082.00",
    "aptitudeProfile": {
      "Verbal": 57,
      "Numeric": 84,
      "Spatial": 12,
      "ClericalPerception": 37,
      "FormPerception": 23,
      "GeneralLearning": 52
    },
    "interestProfile": {
      "Artistic": 53,
      "Scientific": 51,
      "Plants/Animals": 89,
      "Protective": 23,
      "Mechanical": 12,
      "Industrial": 83,
      "Business Detail": 60,
      "Selling": 55,
      "Accommodating": 66,
      "Humanitarian": 87,
      "Leading/Influencing": 69,
      "Physical Performing": 70
    },
    "fitScore": 52
  },
  {
    "code": "13-2099.01",
    "aptitudeProfile": {
      "Verbal": 68,
      "Numeric": 100,
      "Spatial": 13,
      "ClericalPerception": 73,
      "FormPerception": 33,
      "GeneralLearning": 84
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 88,
      "Plants/Animals": 100,
      "Protective": 33,
      "Mechanical": 13,
      "Industrial": 99,
      "Business Detail": 79,
      "Selling": 88,
      "Accommodating": 98,
      "Humanitarian": 91,
      "Leading/Influencing": 86,
      "Physical Performing": 98
    },
    "fitScore": 71
  },
  {
    "code": "13-2099.04",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 77,
      "Spatial": 13,
      "ClericalPerception": 53,
      "FormPerception": 64,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 81,
      "Plants/Animals": 74,
      "Protective": 64,
      "Mechanical": 13,
      "Industrial": 79,
      "Business Detail": 88,
      "Selling": 74,
      "Accommodating": 83,
      "Humanitarian": 87,
      "Leading/Influencing": 87,
      "Physical Performing": 84
    },
    "fitScore": 69
  },
  {
    "code": "15-1211.00",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 76,
      "Spatial": 94,
      "ClericalPerception": 89,
      "FormPerception": 70,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 73,
      "Scientific": 88,
      "Plants/Animals": 80,
      "Protective": 70,
      "Mechanical": 94,
      "Industrial": 82,
      "Business Detail": 67,
      "Selling": 86,
      "Accommodating": 78,
      "Humanitarian": 87,
      "Leading/Influencing": 79,
      "Physical Performing": 70
    },
    "fitScore": 81
  },
  {
    "code": "15-1211.01",
    "aptitudeProfile": {
      "Verbal": 89,
      "Numeric": 73,
      "Spatial": 81,
      "ClericalPerception": 95,
      "FormPerception": 65,
      "GeneralLearning": 88
    },
    "interestProfile": {
      "Artistic": 84,
      "Scientific": 93,
      "Plants/Animals": 76,
      "Protective": 65,
      "Mechanical": 81,
      "Industrial": 90,
      "Business Detail": 76,
      "Selling": 91,
      "Accommodating": 74,
      "Humanitarian": 96,
      "Leading/Influencing": 83,
      "Physical Performing": 72
    },
    "fitScore": 82
  },
  {
    "code": "15-1212.00",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 42,
      "Spatial": 74,
      "ClericalPerception": 73,
      "FormPerception": 82,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 74,
      "Scientific": 81,
      "Plants/Animals": 49,
      "Protective": 82,
      "Mechanical": 74,
      "Industrial": 58,
      "Business Detail": 67,
      "Selling": 71,
      "Accommodating": 76,
      "Humanitarian": 88,
      "Leading/Influencing": 63,
      "Physical Performing": 55
    },
    "fitScore": 71
  },
  {
    "code": "15-1221.00",
    "aptitudeProfile": {
      "Verbal": 79,
      "Numeric": 94,
      "Spatial": 96,
      "ClericalPerception": 95,
      "FormPerception": 66,
      "GeneralLearning": 94
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 96,
      "Plants/Animals": 93,
      "Protective": 66,
      "Mechanical": 96,
      "Industrial": 90,
      "Business Detail": 91,
      "Selling": 93,
      "Accommodating": 88,
      "Humanitarian": 84,
      "Leading/Influencing": 91,
      "Physical Performing": 94
    },
    "fitScore": 88
  },
  {
    "code": "15-1231.00",
    "aptitudeProfile": {
      "Verbal": 58,
      "Numeric": 29,
      "Spatial": 83,
      "ClericalPerception": 48,
      "FormPerception": 43,
      "GeneralLearning": 75
    },
    "interestProfile": {
      "Artistic": 59,
      "Scientific": 72,
      "Plants/Animals": 35,
      "Protective": 43,
      "Mechanical": 83,
      "Industrial": 36,
      "Business Detail": 36,
      "Selling": 65,
      "Accommodating": 44,
      "Humanitarian": 67,
      "Leading/Influencing": 43,
      "Physical Performing": 34
    },
    "fitScore": 54
  },
  {
    "code": "15-1232.00",
    "aptitudeProfile": {
      "Verbal": 81,
      "Numeric": 24,
      "Spatial": 79,
      "ClericalPerception": 70,
      "FormPerception": 57,
      "GeneralLearning": 52
    },
    "interestProfile": {
      "Artistic": 75,
      "Scientific": 56,
      "Plants/Animals": 38,
      "Protective": 57,
      "Mechanical": 79,
      "Industrial": 54,
      "Business Detail": 39,
      "Selling": 67,
      "Accommodating": 47,
      "Humanitarian": 87,
      "Leading/Influencing": 62,
      "Physical Performing": 21
    },
    "fitScore": 59
  },
  {
    "code": "15-1241.00",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 71,
      "Spatial": 75,
      "ClericalPerception": 78,
      "FormPerception": 70,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 83,
      "Plants/Animals": 75,
      "Protective": 70,
      "Mechanical": 75,
      "Industrial": 83,
      "Business Detail": 50,
      "Selling": 76,
      "Accommodating": 76,
      "Humanitarian": 88,
      "Leading/Influencing": 69,
      "Physical Performing": 63
    },
    "fitScore": 75
  },
  {
    "code": "15-1241.01",
    "aptitudeProfile": {
      "Verbal": 60,
      "Numeric": 80,
      "Spatial": 22,
      "ClericalPerception": 72,
      "FormPerception": 65,
      "GeneralLearning": 39
    },
    "interestProfile": {
      "Artistic": 53,
      "Scientific": 49,
      "Plants/Animals": 81,
      "Protective": 65,
      "Mechanical": 22,
      "Industrial": 70,
      "Business Detail": 82,
      "Selling": 62,
      "Accommodating": 74,
      "Humanitarian": 21,
      "Leading/Influencing": 81,
      "Physical Performing": 73
    },
    "fitScore": 59
  },
  {
    "code": "15-1242.00",
    "aptitudeProfile": {
      "Verbal": 65,
      "Numeric": 80,
      "Spatial": 86,
      "ClericalPerception": 75,
      "FormPerception": 77,
      "GeneralLearning": 84
    },
    "interestProfile": {
      "Artistic": 61,
      "Scientific": 81,
      "Plants/Animals": 79,
      "Protective": 77,
      "Mechanical": 86,
      "Industrial": 78,
      "Business Detail": 77,
      "Selling": 69,
      "Accommodating": 83,
      "Humanitarian": 82,
      "Leading/Influencing": 77,
      "Physical Performing": 78
    },
    "fitScore": 78
  },
  {
    "code": "15-1243.00",
    "aptitudeProfile": {
      "Verbal": 65,
      "Numeric": 83,
      "Spatial": 81,
      "ClericalPerception": 84,
      "FormPerception": 79,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 62,
      "Scientific": 80,
      "Plants/Animals": 82,
      "Protective": 79,
      "Mechanical": 81,
      "Industrial": 78,
      "Business Detail": 76,
      "Selling": 76,
      "Accommodating": 82,
      "Humanitarian": 85,
      "Leading/Influencing": 69,
      "Physical Performing": 84
    },
    "fitScore": 78
  },
  {
    "code": "15-1243.01",
    "aptitudeProfile": {
      "Verbal": 58,
      "Numeric": 77,
      "Spatial": 61,
      "ClericalPerception": 55,
      "FormPerception": 47,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 59,
      "Scientific": 72,
      "Plants/Animals": 80,
      "Protective": 47,
      "Mechanical": 61,
      "Industrial": 78,
      "Business Detail": 52,
      "Selling": 61,
      "Accommodating": 74,
      "Humanitarian": 84,
      "Leading/Influencing": 58,
      "Physical Performing": 64
    },
    "fitScore": 64
  },
  {
    "code": "15-1244.00",
    "aptitudeProfile": {
      "Verbal": 60,
      "Numeric": 73,
      "Spatial": 86,
      "ClericalPerception": 81,
      "FormPerception": 73,
      "GeneralLearning": 74
    },
    "interestProfile": {
      "Artistic": 56,
      "Scientific": 77,
      "Plants/Animals": 77,
      "Protective": 73,
      "Mechanical": 86,
      "Industrial": 79,
      "Business Detail": 57,
      "Selling": 63,
      "Accommodating": 78,
      "Humanitarian": 84,
      "Leading/Influencing": 71,
      "Physical Performing": 51
    },
    "fitScore": 73
  },
  {
    "code": "15-1251.00",
    "aptitudeProfile": {
      "Verbal": 55,
      "Numeric": 82,
      "Spatial": 77,
      "ClericalPerception": 63,
      "FormPerception": 59,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 57,
      "Scientific": 70,
      "Plants/Animals": 82,
      "Protective": 59,
      "Mechanical": 77,
      "Industrial": 66,
      "Business Detail": 72,
      "Selling": 62,
      "Accommodating": 75,
      "Humanitarian": 63,
      "Leading/Influencing": 73,
      "Physical Performing": 76
    },
    "fitScore": 69
  },
  {
    "code": "15-1253.00",
    "aptitudeProfile": {
      "Verbal": 70,
      "Numeric": 60,
      "Spatial": 61,
      "ClericalPerception": 72,
      "FormPerception": 77,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 78,
      "Plants/Animals": 54,
      "Protective": 77,
      "Mechanical": 61,
      "Industrial": 74,
      "Business Detail": 44,
      "Selling": 65,
      "Accommodating": 73,
      "Humanitarian": 88,
      "Leading/Influencing": 38,
      "Physical Performing": 72
    },
    "fitScore": 69
  },
  {
    "code": "15-1254.00",
    "aptitudeProfile": {
      "Verbal": 41,
      "Numeric": 69,
      "Spatial": 94,
      "ClericalPerception": 81,
      "FormPerception": 73,
      "GeneralLearning": 67
    },
    "interestProfile": {
      "Artistic": 44,
      "Scientific": 71,
      "Plants/Animals": 73,
      "Protective": 73,
      "Mechanical": 94,
      "Industrial": 64,
      "Business Detail": 40,
      "Selling": 68,
      "Accommodating": 79,
      "Humanitarian": 76,
      "Leading/Influencing": 35,
      "Physical Performing": 63
    },
    "fitScore": 68
  },
  {
    "code": "15-1255.01",
    "aptitudeProfile": {
      "Verbal": 64,
      "Numeric": 72,
      "Spatial": 97,
      "ClericalPerception": 97,
      "FormPerception": 64,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 70,
      "Scientific": 89,
      "Plants/Animals": 71,
      "Protective": 64,
      "Mechanical": 97,
      "Industrial": 72,
      "Business Detail": 52,
      "Selling": 92,
      "Accommodating": 67,
      "Humanitarian": 80,
      "Leading/Influencing": 49,
      "Physical Performing": 72
    },
    "fitScore": 75
  },
  {
    "code": "15-1299.01",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 45,
      "Spatial": 79,
      "ClericalPerception": 59,
      "FormPerception": 53,
      "GeneralLearning": 77
    },
    "interestProfile": {
      "Artistic": 72,
      "Scientific": 74,
      "Plants/Animals": 64,
      "Protective": 53,
      "Mechanical": 79,
      "Industrial": 49,
      "Business Detail": 50,
      "Selling": 70,
      "Accommodating": 67,
      "Humanitarian": 85,
      "Leading/Influencing": 44,
      "Physical Performing": 48
    },
    "fitScore": 64
  },
  {
    "code": "15-1299.02",
    "aptitudeProfile": {
      "Verbal": 57,
      "Numeric": 88,
      "Spatial": 41,
      "ClericalPerception": 43,
      "FormPerception": 52,
      "GeneralLearning": 67
    },
    "interestProfile": {
      "Artistic": 53,
      "Scientific": 62,
      "Plants/Animals": 81,
      "Protective": 52,
      "Mechanical": 41,
      "Industrial": 94,
      "Business Detail": 79,
      "Selling": 51,
      "Accommodating": 79,
      "Humanitarian": 26,
      "Leading/Influencing": 67,
      "Physical Performing": 83
    },
    "fitScore": 61
  },
  {
    "code": "15-1299.03",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 38,
      "Spatial": 64,
      "ClericalPerception": 57,
      "FormPerception": 61,
      "GeneralLearning": 65
    },
    "interestProfile": {
      "Artistic": 73,
      "Scientific": 63,
      "Plants/Animals": 43,
      "Protective": 61,
      "Mechanical": 64,
      "Industrial": 52,
      "Business Detail": 73,
      "Selling": 63,
      "Accommodating": 59,
      "Humanitarian": 83,
      "Leading/Influencing": 72,
      "Physical Performing": 50
    },
    "fitScore": 62
  },
  {
    "code": "15-1299.08",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 72,
      "Spatial": 82,
      "ClericalPerception": 86,
      "FormPerception": 70,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 86,
      "Plants/Animals": 82,
      "Protective": 70,
      "Mechanical": 82,
      "Industrial": 80,
      "Business Detail": 59,
      "Selling": 83,
      "Accommodating": 79,
      "Humanitarian": 87,
      "Leading/Influencing": 79,
      "Physical Performing": 60
    },
    "fitScore": 78
  },
  {
    "code": "15-1299.09",
    "aptitudeProfile": {
      "Verbal": 85,
      "Numeric": 73,
      "Spatial": 81,
      "ClericalPerception": 83,
      "FormPerception": 52,
      "GeneralLearning": 80
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 86,
      "Plants/Animals": 79,
      "Protective": 52,
      "Mechanical": 81,
      "Industrial": 78,
      "Business Detail": 86,
      "Selling": 83,
      "Accommodating": 72,
      "Humanitarian": 87,
      "Leading/Influencing": 92,
      "Physical Performing": 62
    },
    "fitScore": 77
  },
  {
    "code": "15-2011.00",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 100,
      "Spatial": 42,
      "ClericalPerception": 66,
      "FormPerception": 66,
      "GeneralLearning": 92
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 88,
      "Plants/Animals": 100,
      "Protective": 66,
      "Mechanical": 42,
      "Industrial": 99,
      "Business Detail": 97,
      "Selling": 77,
      "Accommodating": 100,
      "Humanitarian": 94,
      "Leading/Influencing": 97,
      "Physical Performing": 99
    },
    "fitScore": 81
  },
  {
    "code": "15-2021.00",
    "aptitudeProfile": {
      "Verbal": 75,
      "Numeric": 100,
      "Spatial": 74,
      "ClericalPerception": 96,
      "FormPerception": 68,
      "GeneralLearning": 95
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 97,
      "Plants/Animals": 100,
      "Protective": 68,
      "Mechanical": 74,
      "Industrial": 100,
      "Business Detail": 90,
      "Selling": 95,
      "Accommodating": 100,
      "Humanitarian": 92,
      "Leading/Influencing": 97,
      "Physical Performing": 100
    },
    "fitScore": 88
  },
  {
    "code": "15-2031.00",
    "aptitudeProfile": {
      "Verbal": 79,
      "Numeric": 100,
      "Spatial": 25,
      "ClericalPerception": 83,
      "FormPerception": 56,
      "GeneralLearning": 93
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 94,
      "Plants/Animals": 100,
      "Protective": 56,
      "Mechanical": 25,
      "Industrial": 99,
      "Business Detail": 95,
      "Selling": 89,
      "Accommodating": 99,
      "Humanitarian": 88,
      "Leading/Influencing": 97,
      "Physical Performing": 99
    },
    "fitScore": 79
  },
  {
    "code": "15-2041.00",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 100,
      "Spatial": 61,
      "ClericalPerception": 81,
      "FormPerception": 59,
      "GeneralLearning": 90
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 90,
      "Plants/Animals": 100,
      "Protective": 59,
      "Mechanical": 61,
      "Industrial": 100,
      "Business Detail": 94,
      "Selling": 85,
      "Accommodating": 99,
      "Humanitarian": 91,
      "Leading/Influencing": 99,
      "Physical Performing": 99
    },
    "fitScore": 84
  },
  {
    "code": "15-2041.01",
    "aptitudeProfile": {
      "Verbal": 82,
      "Numeric": 100,
      "Spatial": 87,
      "ClericalPerception": 88,
      "FormPerception": 57,
      "GeneralLearning": 96
    },
    "interestProfile": {
      "Artistic": 88,
      "Scientific": 95,
      "Plants/Animals": 99,
      "Protective": 57,
      "Mechanical": 87,
      "Industrial": 100,
      "Business Detail": 88,
      "Selling": 90,
      "Accommodating": 98,
      "Humanitarian": 92,
      "Leading/Influencing": 95,
      "Physical Performing": 99
    },
    "fitScore": 88
  },
  {
    "code": "15-2051.01",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 92,
      "Spatial": 24,
      "ClericalPerception": 67,
      "FormPerception": 52,
      "GeneralLearning": 84
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 86,
      "Plants/Animals": 91,
      "Protective": 52,
      "Mechanical": 24,
      "Industrial": 92,
      "Business Detail": 84,
      "Selling": 84,
      "Accommodating": 92,
      "Humanitarian": 88,
      "Leading/Influencing": 90,
      "Physical Performing": 89
    },
    "fitScore": 73
  },
  {
    "code": "15-2051.02",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 86,
      "Spatial": 26,
      "ClericalPerception": 70,
      "FormPerception": 66,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 82,
      "Plants/Animals": 88,
      "Protective": 66,
      "Mechanical": 26,
      "Industrial": 91,
      "Business Detail": 57,
      "Selling": 72,
      "Accommodating": 88,
      "Humanitarian": 86,
      "Leading/Influencing": 85,
      "Physical Performing": 68
    },
    "fitScore": 71
  },
  {
    "code": "15-2099.01",
    "aptitudeProfile": {
      "Verbal": 64,
      "Numeric": 96,
      "Spatial": 87,
      "ClericalPerception": 81,
      "FormPerception": 84,
      "GeneralLearning": 72
    },
    "interestProfile": {
      "Artistic": 67,
      "Scientific": 74,
      "Plants/Animals": 93,
      "Protective": 84,
      "Mechanical": 87,
      "Industrial": 87,
      "Business Detail": 90,
      "Selling": 70,
      "Accommodating": 96,
      "Humanitarian": 82,
      "Leading/Influencing": 75,
      "Physical Performing": 96
    },
    "fitScore": 82
  },
  {
    "code": "17-1011.00",
    "aptitudeProfile": {
      "Verbal": 88,
      "Numeric": 90,
      "Spatial": 94,
      "ClericalPerception": 99,
      "FormPerception": 94,
      "GeneralLearning": 90
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 95,
      "Plants/Animals": 93,
      "Protective": 94,
      "Mechanical": 94,
      "Industrial": 94,
      "Business Detail": 88,
      "Selling": 95,
      "Accommodating": 95,
      "Humanitarian": 49,
      "Leading/Influencing": 98,
      "Physical Performing": 79
    },
    "fitScore": 90
  },
  {
    "code": "17-1012.00",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 75,
      "Spatial": 100,
      "ClericalPerception": 88,
      "FormPerception": 52,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 74,
      "Scientific": 87,
      "Plants/Animals": 72,
      "Protective": 52,
      "Mechanical": 100,
      "Industrial": 80,
      "Business Detail": 85,
      "Selling": 88,
      "Accommodating": 67,
      "Humanitarian": 87,
      "Leading/Influencing": 87,
      "Physical Performing": 78
    },
    "fitScore": 79
  },
  {
    "code": "17-1021.00",
    "aptitudeProfile": {
      "Verbal": 62,
      "Numeric": 73,
      "Spatial": 28,
      "ClericalPerception": 65,
      "FormPerception": 82,
      "GeneralLearning": 63
    },
    "interestProfile": {
      "Artistic": 63,
      "Scientific": 61,
      "Plants/Animals": 74,
      "Protective": 82,
      "Mechanical": 28,
      "Industrial": 78,
      "Business Detail": 53,
      "Selling": 60,
      "Accommodating": 83,
      "Humanitarian": 24,
      "Leading/Influencing": 53,
      "Physical Performing": 70
    },
    "fitScore": 62
  },
  {
    "code": "17-1022.00",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 99,
      "Spatial": 94,
      "ClericalPerception": 71,
      "FormPerception": 79,
      "GeneralLearning": 84
    },
    "interestProfile": {
      "Artistic": 71,
      "Scientific": 77,
      "Plants/Animals": 99,
      "Protective": 79,
      "Mechanical": 94,
      "Industrial": 96,
      "Business Detail": 99,
      "Selling": 56,
      "Accommodating": 97,
      "Humanitarian": 70,
      "Leading/Influencing": 99,
      "Physical Performing": 96
    },
    "fitScore": 85
  },
  {
    "code": "17-1022.01",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 100,
      "Spatial": 64,
      "ClericalPerception": 72,
      "FormPerception": 96,
      "GeneralLearning": 84
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 79,
      "Plants/Animals": 99,
      "Protective": 96,
      "Mechanical": 64,
      "Industrial": 98,
      "Business Detail": 94,
      "Selling": 74,
      "Accommodating": 100,
      "Humanitarian": 44,
      "Leading/Influencing": 94,
      "Physical Performing": 99
    },
    "fitScore": 84
  },
  {
    "code": "17-2011.00",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 98,
      "Spatial": 95,
      "ClericalPerception": 89,
      "FormPerception": 72,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 90,
      "Plants/Animals": 97,
      "Protective": 72,
      "Mechanical": 95,
      "Industrial": 98,
      "Business Detail": 84,
      "Selling": 85,
      "Accommodating": 97,
      "Humanitarian": 92,
      "Leading/Influencing": 89,
      "Physical Performing": 96
    },
    "fitScore": 89
  },
  {
    "code": "17-2021.00",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 96,
      "Spatial": 69,
      "ClericalPerception": 85,
      "FormPerception": 59,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 89,
      "Plants/Animals": 93,
      "Protective": 59,
      "Mechanical": 69,
      "Industrial": 95,
      "Business Detail": 94,
      "Selling": 83,
      "Accommodating": 86,
      "Humanitarian": 41,
      "Leading/Influencing": 94,
      "Physical Performing": 96
    },
    "fitScore": 81
  },
  {
    "code": "17-2031.00",
    "aptitudeProfile": {
      "Verbal": 85,
      "Numeric": 98,
      "Spatial": 99,
      "ClericalPerception": 93,
      "FormPerception": 82,
      "GeneralLearning": 92
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 94,
      "Plants/Animals": 96,
      "Protective": 82,
      "Mechanical": 99,
      "Industrial": 97,
      "Business Detail": 94,
      "Selling": 91,
      "Accommodating": 97,
      "Humanitarian": 92,
      "Leading/Influencing": 95,
      "Physical Performing": 97
    },
    "fitScore": 92
  },
  {
    "code": "17-2041.00",
    "aptitudeProfile": {
      "Verbal": 71,
      "Numeric": 99,
      "Spatial": 97,
      "ClericalPerception": 98,
      "FormPerception": 96,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 74,
      "Scientific": 92,
      "Plants/Animals": 99,
      "Protective": 96,
      "Mechanical": 97,
      "Industrial": 96,
      "Business Detail": 93,
      "Selling": 91,
      "Accommodating": 99,
      "Humanitarian": 86,
      "Leading/Influencing": 89,
      "Physical Performing": 99
    },
    "fitScore": 92
  },
  {
    "code": "17-2051.00",
    "aptitudeProfile": {
      "Verbal": 88,
      "Numeric": 99,
      "Spatial": 75,
      "ClericalPerception": 99,
      "FormPerception": 98,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 92,
      "Plants/Animals": 99,
      "Protective": 98,
      "Mechanical": 75,
      "Industrial": 97,
      "Business Detail": 97,
      "Selling": 92,
      "Accommodating": 99,
      "Humanitarian": 39,
      "Leading/Influencing": 99,
      "Physical Performing": 97
    },
    "fitScore": 90
  },
  {
    "code": "17-2051.01",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 99,
      "Spatial": 60,
      "ClericalPerception": 93,
      "FormPerception": 71,
      "GeneralLearning": 90
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 93,
      "Plants/Animals": 99,
      "Protective": 71,
      "Mechanical": 60,
      "Industrial": 97,
      "Business Detail": 95,
      "Selling": 91,
      "Accommodating": 96,
      "Humanitarian": 30,
      "Leading/Influencing": 98,
      "Physical Performing": 95
    },
    "fitScore": 84
  },
  {
    "code": "17-2051.02",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 98,
      "Spatial": 53,
      "ClericalPerception": 93,
      "FormPerception": 74,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 93,
      "Plants/Animals": 99,
      "Protective": 74,
      "Mechanical": 53,
      "Industrial": 97,
      "Business Detail": 96,
      "Selling": 93,
      "Accommodating": 98,
      "Humanitarian": 26,
      "Leading/Influencing": 98,
      "Physical Performing": 95
    },
    "fitScore": 83
  },
  {
    "code": "17-2061.00",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 90,
      "Spatial": 97,
      "ClericalPerception": 78,
      "FormPerception": 65,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 86,
      "Plants/Animals": 83,
      "Protective": 65,
      "Mechanical": 97,
      "Industrial": 88,
      "Business Detail": 84,
      "Selling": 81,
      "Accommodating": 80,
      "Humanitarian": 90,
      "Leading/Influencing": 70,
      "Physical Performing": 96
    },
    "fitScore": 83
  },
  {
    "code": "17-2071.00",
    "aptitudeProfile": {
      "Verbal": 82,
      "Numeric": 93,
      "Spatial": 93,
      "ClericalPerception": 87,
      "FormPerception": 70,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 86,
      "Plants/Animals": 95,
      "Protective": 70,
      "Mechanical": 93,
      "Industrial": 92,
      "Business Detail": 76,
      "Selling": 81,
      "Accommodating": 89,
      "Humanitarian": 89,
      "Leading/Influencing": 82,
      "Physical Performing": 88
    },
    "fitScore": 85
  },
  {
    "code": "17-2072.00",
    "aptitudeProfile": {
      "Verbal": 75,
      "Numeric": 95,
      "Spatial": 99,
      "ClericalPerception": 88,
      "FormPerception": 72,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 89,
      "Plants/Animals": 95,
      "Protective": 72,
      "Mechanical": 99,
      "Industrial": 92,
      "Business Detail": 81,
      "Selling": 85,
      "Accommodating": 95,
      "Humanitarian": 88,
      "Leading/Influencing": 81,
      "Physical Performing": 93
    },
    "fitScore": 87
  },
  {
    "code": "17-2072.01",
    "aptitudeProfile": {
      "Verbal": 69,
      "Numeric": 72,
      "Spatial": 82,
      "ClericalPerception": 48,
      "FormPerception": 23,
      "GeneralLearning": 83
    },
    "interestProfile": {
      "Artistic": 63,
      "Scientific": 81,
      "Plants/Animals": 73,
      "Protective": 23,
      "Mechanical": 82,
      "Industrial": 63,
      "Business Detail": 83,
      "Selling": 74,
      "Accommodating": 58,
      "Humanitarian": 76,
      "Leading/Influencing": 77,
      "Physical Performing": 79
    },
    "fitScore": 66
  },
  {
    "code": "17-2081.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 92,
      "Spatial": 87,
      "ClericalPerception": 94,
      "FormPerception": 71,
      "GeneralLearning": 88
    },
    "interestProfile": {
      "Artistic": 84,
      "Scientific": 92,
      "Plants/Animals": 88,
      "Protective": 71,
      "Mechanical": 87,
      "Industrial": 92,
      "Business Detail": 91,
      "Selling": 92,
      "Accommodating": 84,
      "Humanitarian": 91,
      "Leading/Influencing": 91,
      "Physical Performing": 94
    },
    "fitScore": 87
  },
  {
    "code": "17-2111.00",
    "aptitudeProfile": {
      "Verbal": 79,
      "Numeric": 65,
      "Spatial": 41,
      "ClericalPerception": 88,
      "FormPerception": 82,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 70,
      "Scientific": 86,
      "Plants/Animals": 51,
      "Protective": 82,
      "Mechanical": 41,
      "Industrial": 77,
      "Business Detail": 88,
      "Selling": 82,
      "Accommodating": 70,
      "Humanitarian": 39,
      "Leading/Influencing": 87,
      "Physical Performing": 80
    },
    "fitScore": 72
  },
  {
    "code": "17-2111.02",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 84,
      "Spatial": 96,
      "ClericalPerception": 78,
      "FormPerception": 91,
      "GeneralLearning": 84
    },
    "interestProfile": {
      "Artistic": 75,
      "Scientific": 82,
      "Plants/Animals": 76,
      "Protective": 91,
      "Mechanical": 96,
      "Industrial": 78,
      "Business Detail": 90,
      "Selling": 70,
      "Accommodating": 91,
      "Humanitarian": 87,
      "Leading/Influencing": 71,
      "Physical Performing": 92
    },
    "fitScore": 84
  },
  {
    "code": "17-2112.00",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 89,
      "Spatial": 27,
      "ClericalPerception": 69,
      "FormPerception": 52,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 80,
      "Scientific": 85,
      "Plants/Animals": 84,
      "Protective": 52,
      "Mechanical": 27,
      "Industrial": 90,
      "Business Detail": 90,
      "Selling": 77,
      "Accommodating": 78,
      "Humanitarian": 25,
      "Leading/Influencing": 90,
      "Physical Performing": 89
    },
    "fitScore": 70
  },
  {
    "code": "17-2112.01",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 91,
      "Spatial": 47,
      "ClericalPerception": 96,
      "FormPerception": 64,
      "GeneralLearning": 90
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 94,
      "Plants/Animals": 93,
      "Protective": 64,
      "Mechanical": 47,
      "Industrial": 94,
      "Business Detail": 73,
      "Selling": 94,
      "Accommodating": 88,
      "Humanitarian": 34,
      "Leading/Influencing": 88,
      "Physical Performing": 83
    },
    "fitScore": 78
  },
  {
    "code": "17-2112.02",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 87,
      "Spatial": 74,
      "ClericalPerception": 70,
      "FormPerception": 63,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 84,
      "Plants/Animals": 88,
      "Protective": 63,
      "Mechanical": 74,
      "Industrial": 89,
      "Business Detail": 81,
      "Selling": 71,
      "Accommodating": 82,
      "Humanitarian": 92,
      "Leading/Influencing": 82,
      "Physical Performing": 85
    },
    "fitScore": 79
  },
  {
    "code": "17-2112.03",
    "aptitudeProfile": {
      "Verbal": 81,
      "Numeric": 98,
      "Spatial": 74,
      "ClericalPerception": 96,
      "FormPerception": 95,
      "GeneralLearning": 90
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 92,
      "Plants/Animals": 99,
      "Protective": 95,
      "Mechanical": 74,
      "Industrial": 98,
      "Business Detail": 90,
      "Selling": 90,
      "Accommodating": 99,
      "Humanitarian": 35,
      "Leading/Influencing": 97,
      "Physical Performing": 93
    },
    "fitScore": 88
  },
  {
    "code": "17-2121.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 96,
      "Spatial": 100,
      "ClericalPerception": 94,
      "FormPerception": 96,
      "GeneralLearning": 90
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 88,
      "Plants/Animals": 93,
      "Protective": 96,
      "Mechanical": 100,
      "Industrial": 95,
      "Business Detail": 94,
      "Selling": 85,
      "Accommodating": 96,
      "Humanitarian": 90,
      "Leading/Influencing": 94,
      "Physical Performing": 97
    },
    "fitScore": 93
  },
  {
    "code": "17-2131.00",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 96,
      "Spatial": 97,
      "ClericalPerception": 93,
      "FormPerception": 84,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 84,
      "Scientific": 90,
      "Plants/Animals": 95,
      "Protective": 84,
      "Mechanical": 97,
      "Industrial": 96,
      "Business Detail": 89,
      "Selling": 86,
      "Accommodating": 96,
      "Humanitarian": 91,
      "Leading/Influencing": 92,
      "Physical Performing": 95
    },
    "fitScore": 91
  },
  {
    "code": "17-2141.00",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 97,
      "Spatial": 43,
      "ClericalPerception": 90,
      "FormPerception": 79,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 90,
      "Plants/Animals": 98,
      "Protective": 79,
      "Mechanical": 43,
      "Industrial": 96,
      "Business Detail": 85,
      "Selling": 86,
      "Accommodating": 97,
      "Humanitarian": 26,
      "Leading/Influencing": 94,
      "Physical Performing": 91
    },
    "fitScore": 80
  },
  {
    "code": "17-2141.01",
    "aptitudeProfile": {
      "Verbal": 82,
      "Numeric": 95,
      "Spatial": 97,
      "ClericalPerception": 95,
      "FormPerception": 86,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 90,
      "Plants/Animals": 96,
      "Protective": 86,
      "Mechanical": 97,
      "Industrial": 94,
      "Business Detail": 80,
      "Selling": 90,
      "Accommodating": 98,
      "Humanitarian": 91,
      "Leading/Influencing": 85,
      "Physical Performing": 92
    },
    "fitScore": 90
  },
  {
    "code": "17-2141.02",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 99,
      "Spatial": 79,
      "ClericalPerception": 93,
      "FormPerception": 52,
      "GeneralLearning": 91
    },
    "interestProfile": {
      "Artistic": 81,
      "Scientific": 94,
      "Plants/Animals": 99,
      "Protective": 52,
      "Mechanical": 79,
      "Industrial": 97,
      "Business Detail": 94,
      "Selling": 93,
      "Accommodating": 94,
      "Humanitarian": 43,
      "Leading/Influencing": 97,
      "Physical Performing": 97
    },
    "fitScore": 84
  },
  {
    "code": "17-2151.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 98,
      "Spatial": 62,
      "ClericalPerception": 96,
      "FormPerception": 93,
      "GeneralLearning": 91
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 93,
      "Plants/Animals": 97,
      "Protective": 93,
      "Mechanical": 62,
      "Industrial": 96,
      "Business Detail": 96,
      "Selling": 92,
      "Accommodating": 99,
      "Humanitarian": 40,
      "Leading/Influencing": 96,
      "Physical Performing": 97
    },
    "fitScore": 87
  },
  {
    "code": "17-2161.00",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 99,
      "Spatial": 90,
      "ClericalPerception": 97,
      "FormPerception": 93,
      "GeneralLearning": 88
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 92,
      "Plants/Animals": 99,
      "Protective": 93,
      "Mechanical": 90,
      "Industrial": 98,
      "Business Detail": 96,
      "Selling": 88,
      "Accommodating": 99,
      "Humanitarian": 92,
      "Leading/Influencing": 97,
      "Physical Performing": 96
    },
    "fitScore": 93
  },
  {
    "code": "17-2171.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 91,
      "Spatial": 95,
      "ClericalPerception": 93,
      "FormPerception": 64,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 90,
      "Plants/Animals": 87,
      "Protective": 64,
      "Mechanical": 95,
      "Industrial": 91,
      "Business Detail": 92,
      "Selling": 89,
      "Accommodating": 82,
      "Humanitarian": 91,
      "Leading/Influencing": 90,
      "Physical Performing": 92
    },
    "fitScore": 86
  },
  {
    "code": "17-2199.03",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 96,
      "Spatial": 96,
      "ClericalPerception": 76,
      "FormPerception": 60,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 84,
      "Plants/Animals": 96,
      "Protective": 60,
      "Mechanical": 96,
      "Industrial": 96,
      "Business Detail": 93,
      "Selling": 80,
      "Accommodating": 94,
      "Humanitarian": 93,
      "Leading/Influencing": 97,
      "Physical Performing": 92
    },
    "fitScore": 86
  },
  {
    "code": "17-2199.05",
    "aptitudeProfile": {
      "Verbal": 71,
      "Numeric": 89,
      "Spatial": 34,
      "ClericalPerception": 82,
      "FormPerception": 52,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 88,
      "Plants/Animals": 84,
      "Protective": 52,
      "Mechanical": 34,
      "Industrial": 87,
      "Business Detail": 60,
      "Selling": 89,
      "Accommodating": 80,
      "Humanitarian": 21,
      "Leading/Influencing": 63,
      "Physical Performing": 92
    },
    "fitScore": 69
  },
  {
    "code": "17-2199.06",
    "aptitudeProfile": {
      "Verbal": 82,
      "Numeric": 94,
      "Spatial": 99,
      "ClericalPerception": 96,
      "FormPerception": 87,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 89,
      "Plants/Animals": 92,
      "Protective": 87,
      "Mechanical": 99,
      "Industrial": 92,
      "Business Detail": 89,
      "Selling": 91,
      "Accommodating": 91,
      "Humanitarian": 91,
      "Leading/Influencing": 85,
      "Physical Performing": 96
    },
    "fitScore": 90
  },
  {
    "code": "17-2199.07",
    "aptitudeProfile": {
      "Verbal": 72,
      "Numeric": 99,
      "Spatial": 98,
      "ClericalPerception": 95,
      "FormPerception": 79,
      "GeneralLearning": 91
    },
    "interestProfile": {
      "Artistic": 81,
      "Scientific": 94,
      "Plants/Animals": 98,
      "Protective": 79,
      "Mechanical": 98,
      "Industrial": 96,
      "Business Detail": 81,
      "Selling": 91,
      "Accommodating": 98,
      "Humanitarian": 90,
      "Leading/Influencing": 73,
      "Physical Performing": 98
    },
    "fitScore": 89
  },
  {
    "code": "17-2199.08",
    "aptitudeProfile": {
      "Verbal": 79,
      "Numeric": 98,
      "Spatial": 67,
      "ClericalPerception": 99,
      "FormPerception": 98,
      "GeneralLearning": 90
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 94,
      "Plants/Animals": 98,
      "Protective": 98,
      "Mechanical": 67,
      "Industrial": 96,
      "Business Detail": 85,
      "Selling": 93,
      "Accommodating": 99,
      "Humanitarian": 29,
      "Leading/Influencing": 88,
      "Physical Performing": 96
    },
    "fitScore": 87
  },
  {
    "code": "17-2199.09",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 98,
      "Spatial": 95,
      "ClericalPerception": 89,
      "FormPerception": 90,
      "GeneralLearning": 92
    },
    "interestProfile": {
      "Artistic": 87,
      "Scientific": 93,
      "Plants/Animals": 97,
      "Protective": 90,
      "Mechanical": 95,
      "Industrial": 98,
      "Business Detail": 89,
      "Selling": 92,
      "Accommodating": 99,
      "Humanitarian": 92,
      "Leading/Influencing": 94,
      "Physical Performing": 96
    },
    "fitScore": 93
  },
  {
    "code": "17-2199.10",
    "aptitudeProfile": {
      "Verbal": 65,
      "Numeric": 98,
      "Spatial": 96,
      "ClericalPerception": 63,
      "FormPerception": 49,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 52,
      "Scientific": 77,
      "Plants/Animals": 97,
      "Protective": 49,
      "Mechanical": 96,
      "Industrial": 92,
      "Business Detail": 97,
      "Selling": 54,
      "Accommodating": 92,
      "Humanitarian": 85,
      "Leading/Influencing": 96,
      "Physical Performing": 90
    },
    "fitScore": 78
  },
  {
    "code": "17-2199.11",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 92,
      "Spatial": 26,
      "ClericalPerception": 93,
      "FormPerception": 59,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 91,
      "Plants/Animals": 92,
      "Protective": 59,
      "Mechanical": 26,
      "Industrial": 91,
      "Business Detail": 84,
      "Selling": 88,
      "Accommodating": 90,
      "Humanitarian": 26,
      "Leading/Influencing": 90,
      "Physical Performing": 83
    },
    "fitScore": 74
  },
  {
    "code": "17-3011.00",
    "aptitudeProfile": {
      "Verbal": 52,
      "Numeric": 84,
      "Spatial": 100,
      "ClericalPerception": 61,
      "FormPerception": 49,
      "GeneralLearning": 47
    },
    "interestProfile": {
      "Artistic": 49,
      "Scientific": 60,
      "Plants/Animals": 85,
      "Protective": 49,
      "Mechanical": 100,
      "Industrial": 78,
      "Business Detail": 69,
      "Selling": 64,
      "Accommodating": 86,
      "Humanitarian": 74,
      "Leading/Influencing": 78,
      "Physical Performing": 67
    },
    "fitScore": 69
  },
  {
    "code": "17-3012.00",
    "aptitudeProfile": {
      "Verbal": 60,
      "Numeric": 76,
      "Spatial": 99,
      "ClericalPerception": 55,
      "FormPerception": 57,
      "GeneralLearning": 38
    },
    "interestProfile": {
      "Artistic": 66,
      "Scientific": 42,
      "Plants/Animals": 73,
      "Protective": 57,
      "Mechanical": 99,
      "Industrial": 61,
      "Business Detail": 67,
      "Selling": 58,
      "Accommodating": 69,
      "Humanitarian": 67,
      "Leading/Influencing": 59,
      "Physical Performing": 79
    },
    "fitScore": 65
  },
  {
    "code": "17-3013.00",
    "aptitudeProfile": {
      "Verbal": 31,
      "Numeric": 93,
      "Spatial": 99,
      "ClericalPerception": 73,
      "FormPerception": 65,
      "GeneralLearning": 30
    },
    "interestProfile": {
      "Artistic": 29,
      "Scientific": 45,
      "Plants/Animals": 89,
      "Protective": 65,
      "Mechanical": 99,
      "Industrial": 73,
      "Business Detail": 84,
      "Selling": 48,
      "Accommodating": 89,
      "Humanitarian": 61,
      "Leading/Influencing": 73,
      "Physical Performing": 82
    },
    "fitScore": 68
  },
  {
    "code": "17-3021.00",
    "aptitudeProfile": {
      "Verbal": 71,
      "Numeric": 82,
      "Spatial": 97,
      "ClericalPerception": 79,
      "FormPerception": 89,
      "GeneralLearning": 80
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 74,
      "Plants/Animals": 77,
      "Protective": 89,
      "Mechanical": 97,
      "Industrial": 73,
      "Business Detail": 80,
      "Selling": 68,
      "Accommodating": 83,
      "Humanitarian": 79,
      "Leading/Influencing": 66,
      "Physical Performing": 91
    },
    "fitScore": 81
  },
  {
    "code": "17-3022.00",
    "aptitudeProfile": {
      "Verbal": 72,
      "Numeric": 96,
      "Spatial": 71,
      "ClericalPerception": 60,
      "FormPerception": 64,
      "GeneralLearning": 66
    },
    "interestProfile": {
      "Artistic": 67,
      "Scientific": 64,
      "Plants/Animals": 97,
      "Protective": 64,
      "Mechanical": 71,
      "Industrial": 88,
      "Business Detail": 95,
      "Selling": 61,
      "Accommodating": 94,
      "Humanitarian": 32,
      "Leading/Influencing": 94,
      "Physical Performing": 92
    },
    "fitScore": 74
  },
  {
    "code": "17-3023.00",
    "aptitudeProfile": {
      "Verbal": 57,
      "Numeric": 66,
      "Spatial": 46,
      "ClericalPerception": 77,
      "FormPerception": 76,
      "GeneralLearning": 77
    },
    "interestProfile": {
      "Artistic": 57,
      "Scientific": 72,
      "Plants/Animals": 59,
      "Protective": 76,
      "Mechanical": 46,
      "Industrial": 71,
      "Business Detail": 61,
      "Selling": 57,
      "Accommodating": 63,
      "Humanitarian": 26,
      "Leading/Influencing": 49,
      "Physical Performing": 72
    },
    "fitScore": 63
  },
  {
    "code": "17-3024.00",
    "aptitudeProfile": {
      "Verbal": 22,
      "Numeric": 70,
      "Spatial": 64,
      "ClericalPerception": 88,
      "FormPerception": 89,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 31,
      "Scientific": 69,
      "Plants/Animals": 76,
      "Protective": 89,
      "Mechanical": 64,
      "Industrial": 58,
      "Business Detail": 18,
      "Selling": 42,
      "Accommodating": 75,
      "Humanitarian": 28,
      "Leading/Influencing": 21,
      "Physical Performing": 42
    },
    "fitScore": 59
  },
  {
    "code": "17-3024.01",
    "aptitudeProfile": {
      "Verbal": 57,
      "Numeric": 77,
      "Spatial": 78,
      "ClericalPerception": 82,
      "FormPerception": 86,
      "GeneralLearning": 88
    },
    "interestProfile": {
      "Artistic": 65,
      "Scientific": 82,
      "Plants/Animals": 71,
      "Protective": 86,
      "Mechanical": 78,
      "Industrial": 81,
      "Business Detail": 49,
      "Selling": 68,
      "Accommodating": 80,
      "Humanitarian": 38,
      "Leading/Influencing": 48,
      "Physical Performing": 80
    },
    "fitScore": 73
  },
  {
    "code": "17-3025.00",
    "aptitudeProfile": {
      "Verbal": 65,
      "Numeric": 82,
      "Spatial": 46,
      "ClericalPerception": 66,
      "FormPerception": 65,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 67,
      "Scientific": 78,
      "Plants/Animals": 81,
      "Protective": 65,
      "Mechanical": 46,
      "Industrial": 81,
      "Business Detail": 66,
      "Selling": 64,
      "Accommodating": 74,
      "Humanitarian": 38,
      "Leading/Influencing": 67,
      "Physical Performing": 81
    },
    "fitScore": 68
  },
  {
    "code": "17-3026.00",
    "aptitudeProfile": {
      "Verbal": 55,
      "Numeric": 83,
      "Spatial": 31,
      "ClericalPerception": 84,
      "FormPerception": 68,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 57,
      "Scientific": 84,
      "Plants/Animals": 85,
      "Protective": 68,
      "Mechanical": 31,
      "Industrial": 85,
      "Business Detail": 50,
      "Selling": 76,
      "Accommodating": 78,
      "Humanitarian": 23,
      "Leading/Influencing": 59,
      "Physical Performing": 76
    },
    "fitScore": 66
  },
  {
    "code": "17-3026.01",
    "aptitudeProfile": {
      "Verbal": 49,
      "Numeric": 83,
      "Spatial": 92,
      "ClericalPerception": 87,
      "FormPerception": 88,
      "GeneralLearning": 63
    },
    "interestProfile": {
      "Artistic": 60,
      "Scientific": 70,
      "Plants/Animals": 84,
      "Protective": 88,
      "Mechanical": 92,
      "Industrial": 75,
      "Business Detail": 42,
      "Selling": 73,
      "Accommodating": 89,
      "Humanitarian": 75,
      "Leading/Influencing": 40,
      "Physical Performing": 76
    },
    "fitScore": 75
  },
  {
    "code": "17-3027.00",
    "aptitudeProfile": {
      "Verbal": 64,
      "Numeric": 90,
      "Spatial": 66,
      "ClericalPerception": 82,
      "FormPerception": 88,
      "GeneralLearning": 75
    },
    "interestProfile": {
      "Artistic": 67,
      "Scientific": 72,
      "Plants/Animals": 94,
      "Protective": 88,
      "Mechanical": 66,
      "Industrial": 83,
      "Business Detail": 65,
      "Selling": 68,
      "Accommodating": 92,
      "Humanitarian": 36,
      "Leading/Influencing": 70,
      "Physical Performing": 80
    },
    "fitScore": 75
  },
  {
    "code": "17-3027.01",
    "aptitudeProfile": {
      "Verbal": 50,
      "Numeric": 80,
      "Spatial": 65,
      "ClericalPerception": 77,
      "FormPerception": 78,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 52,
      "Scientific": 70,
      "Plants/Animals": 68,
      "Protective": 78,
      "Mechanical": 65,
      "Industrial": 76,
      "Business Detail": 71,
      "Selling": 55,
      "Accommodating": 76,
      "Humanitarian": 39,
      "Leading/Influencing": 62,
      "Physical Performing": 80
    },
    "fitScore": 68
  },
  {
    "code": "17-3029.01",
    "aptitudeProfile": {
      "Verbal": 65,
      "Numeric": 82,
      "Spatial": 57,
      "ClericalPerception": 59,
      "FormPerception": 83,
      "GeneralLearning": 81
    },
    "interestProfile": {
      "Artistic": 60,
      "Scientific": 69,
      "Plants/Animals": 73,
      "Protective": 83,
      "Mechanical": 57,
      "Industrial": 80,
      "Business Detail": 86,
      "Selling": 45,
      "Accommodating": 81,
      "Humanitarian": 40,
      "Leading/Influencing": 79,
      "Physical Performing": 84
    },
    "fitScore": 71
  },
  {
    "code": "17-3029.08",
    "aptitudeProfile": {
      "Verbal": 39,
      "Numeric": 70,
      "Spatial": 91,
      "ClericalPerception": 65,
      "FormPerception": 56,
      "GeneralLearning": 27
    },
    "interestProfile": {
      "Artistic": 41,
      "Scientific": 31,
      "Plants/Animals": 69,
      "Protective": 56,
      "Mechanical": 91,
      "Industrial": 60,
      "Business Detail": 53,
      "Selling": 42,
      "Accommodating": 50,
      "Humanitarian": 70,
      "Leading/Influencing": 45,
      "Physical Performing": 65
    },
    "fitScore": 57
  },
  {
    "code": "17-3031.00",
    "aptitudeProfile": {
      "Verbal": 43,
      "Numeric": 76,
      "Spatial": 74,
      "ClericalPerception": 57,
      "FormPerception": 64,
      "GeneralLearning": 36
    },
    "interestProfile": {
      "Artistic": 40,
      "Scientific": 43,
      "Plants/Animals": 61,
      "Protective": 64,
      "Mechanical": 74,
      "Industrial": 83,
      "Business Detail": 60,
      "Selling": 41,
      "Accommodating": 71,
      "Humanitarian": 82,
      "Leading/Influencing": 65,
      "Physical Performing": 62
    },
    "fitScore": 60
  },
  {
    "code": "19-1011.00",
    "aptitudeProfile": {
      "Verbal": 85,
      "Numeric": 93,
      "Spatial": 34,
      "ClericalPerception": 92,
      "FormPerception": 63,
      "GeneralLearning": 90
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 92,
      "Plants/Animals": 89,
      "Protective": 63,
      "Mechanical": 34,
      "Industrial": 94,
      "Business Detail": 89,
      "Selling": 91,
      "Accommodating": 80,
      "Humanitarian": 45,
      "Leading/Influencing": 85,
      "Physical Performing": 96
    },
    "fitScore": 77
  },
  {
    "code": "19-1012.00",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 85,
      "Spatial": 79,
      "ClericalPerception": 85,
      "FormPerception": 82,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 86,
      "Plants/Animals": 87,
      "Protective": 82,
      "Mechanical": 79,
      "Industrial": 84,
      "Business Detail": 72,
      "Selling": 83,
      "Accommodating": 89,
      "Humanitarian": 88,
      "Leading/Influencing": 70,
      "Physical Performing": 85
    },
    "fitScore": 82
  },
  {
    "code": "19-1013.00",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 88,
      "Spatial": 28,
      "ClericalPerception": 89,
      "FormPerception": 82,
      "GeneralLearning": 92
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 92,
      "Plants/Animals": 84,
      "Protective": 82,
      "Mechanical": 28,
      "Industrial": 91,
      "Business Detail": 85,
      "Selling": 89,
      "Accommodating": 89,
      "Humanitarian": 37,
      "Leading/Influencing": 86,
      "Physical Performing": 91
    },
    "fitScore": 78
  },
  {
    "code": "19-1021.00",
    "aptitudeProfile": {
      "Verbal": 93,
      "Numeric": 99,
      "Spatial": 95,
      "ClericalPerception": 97,
      "FormPerception": 92,
      "GeneralLearning": 95
    },
    "interestProfile": {
      "Artistic": 94,
      "Scientific": 97,
      "Plants/Animals": 99,
      "Protective": 92,
      "Mechanical": 95,
      "Industrial": 99,
      "Business Detail": 91,
      "Selling": 97,
      "Accommodating": 99,
      "Humanitarian": 97,
      "Leading/Influencing": 94,
      "Physical Performing": 99
    },
    "fitScore": 96
  },
  {
    "code": "19-1022.00",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 79,
      "Spatial": 89,
      "ClericalPerception": 95,
      "FormPerception": 94,
      "GeneralLearning": 94
    },
    "interestProfile": {
      "Artistic": 89,
      "Scientific": 95,
      "Plants/Animals": 79,
      "Protective": 94,
      "Mechanical": 89,
      "Industrial": 91,
      "Business Detail": 60,
      "Selling": 92,
      "Accommodating": 93,
      "Humanitarian": 94,
      "Leading/Influencing": 74,
      "Physical Performing": 78
    },
    "fitScore": 88
  },
  {
    "code": "19-1023.00",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 76,
      "Spatial": 47,
      "ClericalPerception": 79,
      "FormPerception": 70,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 84,
      "Plants/Animals": 77,
      "Protective": 70,
      "Mechanical": 47,
      "Industrial": 84,
      "Business Detail": 75,
      "Selling": 81,
      "Accommodating": 76,
      "Humanitarian": 47,
      "Leading/Influencing": 79,
      "Physical Performing": 79
    },
    "fitScore": 74
  },
  {
    "code": "19-1029.01",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 98,
      "Spatial": 86,
      "ClericalPerception": 97,
      "FormPerception": 88,
      "GeneralLearning": 91
    },
    "interestProfile": {
      "Artistic": 90,
      "Scientific": 94,
      "Plants/Animals": 98,
      "Protective": 88,
      "Mechanical": 86,
      "Industrial": 95,
      "Business Detail": 79,
      "Selling": 94,
      "Accommodating": 98,
      "Humanitarian": 93,
      "Leading/Influencing": 71,
      "Physical Performing": 97
    },
    "fitScore": 91
  },
  {
    "code": "19-1029.02",
    "aptitudeProfile": {
      "Verbal": 94,
      "Numeric": 97,
      "Spatial": 81,
      "ClericalPerception": 95,
      "FormPerception": 80,
      "GeneralLearning": 95
    },
    "interestProfile": {
      "Artistic": 96,
      "Scientific": 96,
      "Plants/Animals": 98,
      "Protective": 80,
      "Mechanical": 81,
      "Industrial": 99,
      "Business Detail": 76,
      "Selling": 97,
      "Accommodating": 98,
      "Humanitarian": 98,
      "Leading/Influencing": 89,
      "Physical Performing": 96
    },
    "fitScore": 91
  },
  {
    "code": "19-1029.03",
    "aptitudeProfile": {
      "Verbal": 93,
      "Numeric": 97,
      "Spatial": 79,
      "ClericalPerception": 93,
      "FormPerception": 81,
      "GeneralLearning": 94
    },
    "interestProfile": {
      "Artistic": 96,
      "Scientific": 96,
      "Plants/Animals": 98,
      "Protective": 81,
      "Mechanical": 79,
      "Industrial": 98,
      "Business Detail": 69,
      "Selling": 96,
      "Accommodating": 98,
      "Humanitarian": 95,
      "Leading/Influencing": 87,
      "Physical Performing": 92
    },
    "fitScore": 90
  },
  {
    "code": "19-1029.04",
    "aptitudeProfile": {
      "Verbal": 88,
      "Numeric": 96,
      "Spatial": 22,
      "ClericalPerception": 87,
      "FormPerception": 74,
      "GeneralLearning": 93
    },
    "interestProfile": {
      "Artistic": 87,
      "Scientific": 94,
      "Plants/Animals": 95,
      "Protective": 74,
      "Mechanical": 22,
      "Industrial": 96,
      "Business Detail": 90,
      "Selling": 90,
      "Accommodating": 97,
      "Humanitarian": 26,
      "Leading/Influencing": 95,
      "Physical Performing": 94
    },
    "fitScore": 78
  },
  {
    "code": "19-1031.00",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 86,
      "Spatial": 56,
      "ClericalPerception": 77,
      "FormPerception": 79,
      "GeneralLearning": 64
    },
    "interestProfile": {
      "Artistic": 74,
      "Scientific": 69,
      "Plants/Animals": 86,
      "Protective": 79,
      "Mechanical": 56,
      "Industrial": 80,
      "Business Detail": 80,
      "Selling": 79,
      "Accommodating": 89,
      "Humanitarian": 45,
      "Leading/Influencing": 76,
      "Physical Performing": 88
    },
    "fitScore": 74
  },
  {
    "code": "19-1031.02",
    "aptitudeProfile": {
      "Verbal": 79,
      "Numeric": 70,
      "Spatial": 60,
      "ClericalPerception": 59,
      "FormPerception": 40,
      "GeneralLearning": 76
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 78,
      "Plants/Animals": 75,
      "Protective": 40,
      "Mechanical": 60,
      "Industrial": 76,
      "Business Detail": 71,
      "Selling": 74,
      "Accommodating": 71,
      "Humanitarian": 49,
      "Leading/Influencing": 82,
      "Physical Performing": 60
    },
    "fitScore": 66
  },
  {
    "code": "19-1031.03",
    "aptitudeProfile": {
      "Verbal": 71,
      "Numeric": 19,
      "Spatial": 49,
      "ClericalPerception": 77,
      "FormPerception": 64,
      "GeneralLearning": 48
    },
    "interestProfile": {
      "Artistic": 75,
      "Scientific": 58,
      "Plants/Animals": 24,
      "Protective": 64,
      "Mechanical": 49,
      "Industrial": 39,
      "Business Detail": 25,
      "Selling": 73,
      "Accommodating": 32,
      "Humanitarian": 42,
      "Leading/Influencing": 20,
      "Physical Performing": 35
    },
    "fitScore": 50
  },
  {
    "code": "19-1032.00",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 73,
      "Spatial": 79,
      "ClericalPerception": 64,
      "FormPerception": 79,
      "GeneralLearning": 80
    },
    "interestProfile": {
      "Artistic": 72,
      "Scientific": 76,
      "Plants/Animals": 73,
      "Protective": 79,
      "Mechanical": 79,
      "Industrial": 78,
      "Business Detail": 86,
      "Selling": 69,
      "Accommodating": 84,
      "Humanitarian": 55,
      "Leading/Influencing": 90,
      "Physical Performing": 73
    },
    "fitScore": 76
  },
  {
    "code": "19-1041.00",
    "aptitudeProfile": {
      "Verbal": 94,
      "Numeric": 97,
      "Spatial": 87,
      "ClericalPerception": 97,
      "FormPerception": 89,
      "GeneralLearning": 97
    },
    "interestProfile": {
      "Artistic": 95,
      "Scientific": 98,
      "Plants/Animals": 95,
      "Protective": 89,
      "Mechanical": 87,
      "Industrial": 98,
      "Business Detail": 93,
      "Selling": 98,
      "Accommodating": 98,
      "Humanitarian": 95,
      "Leading/Influencing": 92,
      "Physical Performing": 99
    },
    "fitScore": 94
  },
  {
    "code": "19-1042.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 89,
      "Spatial": 55,
      "ClericalPerception": 83,
      "FormPerception": 80,
      "GeneralLearning": 94
    },
    "interestProfile": {
      "Artistic": 89,
      "Scientific": 92,
      "Plants/Animals": 91,
      "Protective": 80,
      "Mechanical": 55,
      "Industrial": 96,
      "Business Detail": 56,
      "Selling": 84,
      "Accommodating": 93,
      "Humanitarian": 93,
      "Leading/Influencing": 85,
      "Physical Performing": 77
    },
    "fitScore": 82
  },
  {
    "code": "19-2011.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 100,
      "Spatial": 19,
      "ClericalPerception": 96,
      "FormPerception": 97,
      "GeneralLearning": 94
    },
    "interestProfile": {
      "Artistic": 90,
      "Scientific": 95,
      "Plants/Animals": 100,
      "Protective": 97,
      "Mechanical": 19,
      "Industrial": 99,
      "Business Detail": 92,
      "Selling": 94,
      "Accommodating": 100,
      "Humanitarian": 35,
      "Leading/Influencing": 89,
      "Physical Performing": 100
    },
    "fitScore": 83
  },
  {
    "code": "19-2012.00",
    "aptitudeProfile": {
      "Verbal": 92,
      "Numeric": 100,
      "Spatial": 100,
      "ClericalPerception": 99,
      "FormPerception": 86,
      "GeneralLearning": 97
    },
    "interestProfile": {
      "Artistic": 94,
      "Scientific": 98,
      "Plants/Animals": 100,
      "Protective": 86,
      "Mechanical": 100,
      "Industrial": 100,
      "Business Detail": 95,
      "Selling": 99,
      "Accommodating": 100,
      "Humanitarian": 97,
      "Leading/Influencing": 96,
      "Physical Performing": 100
    },
    "fitScore": 96
  },
  {
    "code": "19-2021.00",
    "aptitudeProfile": {
      "Verbal": 85,
      "Numeric": 95,
      "Spatial": 57,
      "ClericalPerception": 75,
      "FormPerception": 81,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 89,
      "Scientific": 86,
      "Plants/Animals": 90,
      "Protective": 81,
      "Mechanical": 57,
      "Industrial": 94,
      "Business Detail": 89,
      "Selling": 83,
      "Accommodating": 96,
      "Humanitarian": 93,
      "Leading/Influencing": 76,
      "Physical Performing": 99
    },
    "fitScore": 83
  },
  {
    "code": "19-2031.00",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 97,
      "Spatial": 90,
      "ClericalPerception": 80,
      "FormPerception": 85,
      "GeneralLearning": 92
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 87,
      "Plants/Animals": 98,
      "Protective": 85,
      "Mechanical": 90,
      "Industrial": 97,
      "Business Detail": 85,
      "Selling": 77,
      "Accommodating": 97,
      "Humanitarian": 92,
      "Leading/Influencing": 95,
      "Physical Performing": 89
    },
    "fitScore": 89
  },
  {
    "code": "19-2032.00",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 94,
      "Spatial": 90,
      "ClericalPerception": 86,
      "FormPerception": 79,
      "GeneralLearning": 91
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 90,
      "Plants/Animals": 88,
      "Protective": 79,
      "Mechanical": 90,
      "Industrial": 93,
      "Business Detail": 90,
      "Selling": 85,
      "Accommodating": 90,
      "Humanitarian": 91,
      "Leading/Influencing": 84,
      "Physical Performing": 97
    },
    "fitScore": 88
  },
  {
    "code": "19-2041.00",
    "aptitudeProfile": {
      "Verbal": 85,
      "Numeric": 79,
      "Spatial": 22,
      "ClericalPerception": 59,
      "FormPerception": 70,
      "GeneralLearning": 90
    },
    "interestProfile": {
      "Artistic": 87,
      "Scientific": 86,
      "Plants/Animals": 84,
      "Protective": 70,
      "Mechanical": 22,
      "Industrial": 91,
      "Business Detail": 49,
      "Selling": 81,
      "Accommodating": 90,
      "Humanitarian": 40,
      "Leading/Influencing": 80,
      "Physical Performing": 69
    },
    "fitScore": 69
  },
  {
    "code": "19-2041.01",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 77,
      "Spatial": 59,
      "ClericalPerception": 30,
      "FormPerception": 30,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 80,
      "Plants/Animals": 76,
      "Protective": 30,
      "Mechanical": 59,
      "Industrial": 87,
      "Business Detail": 61,
      "Selling": 70,
      "Accommodating": 74,
      "Humanitarian": 93,
      "Leading/Influencing": 61,
      "Physical Performing": 79
    },
    "fitScore": 66
  },
  {
    "code": "19-2041.02",
    "aptitudeProfile": {
      "Verbal": 85,
      "Numeric": 88,
      "Spatial": 50,
      "ClericalPerception": 82,
      "FormPerception": 60,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 86,
      "Plants/Animals": 89,
      "Protective": 60,
      "Mechanical": 50,
      "Industrial": 85,
      "Business Detail": 87,
      "Selling": 84,
      "Accommodating": 84,
      "Humanitarian": 37,
      "Leading/Influencing": 91,
      "Physical Performing": 85
    },
    "fitScore": 76
  },
  {
    "code": "19-2041.03",
    "aptitudeProfile": {
      "Verbal": 79,
      "Numeric": 95,
      "Spatial": 72,
      "ClericalPerception": 82,
      "FormPerception": 74,
      "GeneralLearning": 93
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 92,
      "Plants/Animals": 92,
      "Protective": 74,
      "Mechanical": 72,
      "Industrial": 94,
      "Business Detail": 88,
      "Selling": 80,
      "Accommodating": 95,
      "Humanitarian": 93,
      "Leading/Influencing": 81,
      "Physical Performing": 94
    },
    "fitScore": 84
  },
  {
    "code": "19-2042.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 94,
      "Spatial": 44,
      "ClericalPerception": 86,
      "FormPerception": 77,
      "GeneralLearning": 91
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 90,
      "Plants/Animals": 95,
      "Protective": 77,
      "Mechanical": 44,
      "Industrial": 94,
      "Business Detail": 75,
      "Selling": 86,
      "Accommodating": 96,
      "Humanitarian": 45,
      "Leading/Influencing": 80,
      "Physical Performing": 91
    },
    "fitScore": 80
  },
  {
    "code": "19-2043.00",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 98,
      "Spatial": 41,
      "ClericalPerception": 94,
      "FormPerception": 94,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 88,
      "Plants/Animals": 97,
      "Protective": 94,
      "Mechanical": 41,
      "Industrial": 95,
      "Business Detail": 87,
      "Selling": 89,
      "Accommodating": 99,
      "Humanitarian": 34,
      "Leading/Influencing": 86,
      "Physical Performing": 97
    },
    "fitScore": 83
  },
  {
    "code": "19-2099.01",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 98,
      "Spatial": 23,
      "ClericalPerception": 91,
      "FormPerception": 84,
      "GeneralLearning": 95
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 95,
      "Plants/Animals": 98,
      "Protective": 84,
      "Mechanical": 23,
      "Industrial": 96,
      "Business Detail": 91,
      "Selling": 89,
      "Accommodating": 98,
      "Humanitarian": 26,
      "Leading/Influencing": 93,
      "Physical Performing": 96
    },
    "fitScore": 80
  },
  {
    "code": "19-3011.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 99,
      "Spatial": 34,
      "ClericalPerception": 76,
      "FormPerception": 23,
      "GeneralLearning": 91
    },
    "interestProfile": {
      "Artistic": 87,
      "Scientific": 94,
      "Plants/Animals": 99,
      "Protective": 23,
      "Mechanical": 34,
      "Industrial": 98,
      "Business Detail": 91,
      "Selling": 93,
      "Accommodating": 95,
      "Humanitarian": 93,
      "Leading/Influencing": 91,
      "Physical Performing": 98
    },
    "fitScore": 75
  },
  {
    "code": "19-3011.01",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 100,
      "Spatial": 74,
      "ClericalPerception": 78,
      "FormPerception": 64,
      "GeneralLearning": 80
    },
    "interestProfile": {
      "Artistic": 87,
      "Scientific": 82,
      "Plants/Animals": 99,
      "Protective": 64,
      "Mechanical": 74,
      "Industrial": 98,
      "Business Detail": 84,
      "Selling": 83,
      "Accommodating": 98,
      "Humanitarian": 91,
      "Leading/Influencing": 80,
      "Physical Performing": 99
    },
    "fitScore": 83
  },
  {
    "code": "19-3022.00",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 98,
      "Spatial": 19,
      "ClericalPerception": 57,
      "FormPerception": 56,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 81,
      "Scientific": 83,
      "Plants/Animals": 99,
      "Protective": 56,
      "Mechanical": 19,
      "Industrial": 93,
      "Business Detail": 94,
      "Selling": 67,
      "Accommodating": 96,
      "Humanitarian": 88,
      "Leading/Influencing": 94,
      "Physical Performing": 94
    },
    "fitScore": 74
  },
  {
    "code": "19-3032.00",
    "aptitudeProfile": {
      "Verbal": 96,
      "Numeric": 95,
      "Spatial": 55,
      "ClericalPerception": 91,
      "FormPerception": 46,
      "GeneralLearning": 92
    },
    "interestProfile": {
      "Artistic": 94,
      "Scientific": 95,
      "Plants/Animals": 95,
      "Protective": 46,
      "Mechanical": 55,
      "Industrial": 96,
      "Business Detail": 97,
      "Selling": 96,
      "Accommodating": 92,
      "Humanitarian": 96,
      "Leading/Influencing": 98,
      "Physical Performing": 95
    },
    "fitScore": 84
  },
  {
    "code": "19-3033.00",
    "aptitudeProfile": {
      "Verbal": 94,
      "Numeric": 22,
      "Spatial": 13,
      "ClericalPerception": 76,
      "FormPerception": 35,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 95,
      "Scientific": 91,
      "Plants/Animals": 26,
      "Protective": 35,
      "Mechanical": 13,
      "Industrial": 77,
      "Business Detail": 20,
      "Selling": 96,
      "Accommodating": 39,
      "Humanitarian": 98,
      "Leading/Influencing": 30,
      "Physical Performing": 49
    },
    "fitScore": 55
  },
  {
    "code": "19-3034.00",
    "aptitudeProfile": {
      "Verbal": 88,
      "Numeric": 71,
      "Spatial": 44,
      "ClericalPerception": 68,
      "FormPerception": 59,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 91,
      "Scientific": 84,
      "Plants/Animals": 68,
      "Protective": 59,
      "Mechanical": 44,
      "Industrial": 80,
      "Business Detail": 63,
      "Selling": 85,
      "Accommodating": 68,
      "Humanitarian": 94,
      "Leading/Influencing": 44,
      "Physical Performing": 92
    },
    "fitScore": 71
  },
  {
    "code": "19-3039.02",
    "aptitudeProfile": {
      "Verbal": 96,
      "Numeric": 71,
      "Spatial": 49,
      "ClericalPerception": 77,
      "FormPerception": 66,
      "GeneralLearning": 98
    },
    "interestProfile": {
      "Artistic": 98,
      "Scientific": 95,
      "Plants/Animals": 68,
      "Protective": 66,
      "Mechanical": 49,
      "Industrial": 94,
      "Business Detail": 61,
      "Selling": 92,
      "Accommodating": 77,
      "Humanitarian": 98,
      "Leading/Influencing": 70,
      "Physical Performing": 89
    },
    "fitScore": 78
  },
  {
    "code": "19-3039.03",
    "aptitudeProfile": {
      "Verbal": 93,
      "Numeric": 72,
      "Spatial": 44,
      "ClericalPerception": 81,
      "FormPerception": 86,
      "GeneralLearning": 97
    },
    "interestProfile": {
      "Artistic": 96,
      "Scientific": 94,
      "Plants/Animals": 69,
      "Protective": 86,
      "Mechanical": 44,
      "Industrial": 77,
      "Business Detail": 71,
      "Selling": 94,
      "Accommodating": 86,
      "Humanitarian": 93,
      "Leading/Influencing": 51,
      "Physical Performing": 96
    },
    "fitScore": 79
  },
  {
    "code": "19-3041.00",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 71,
      "Spatial": 12,
      "ClericalPerception": 37,
      "FormPerception": 13,
      "GeneralLearning": 88
    },
    "interestProfile": {
      "Artistic": 91,
      "Scientific": 87,
      "Plants/Animals": 62,
      "Protective": 13,
      "Mechanical": 12,
      "Industrial": 83,
      "Business Detail": 63,
      "Selling": 88,
      "Accommodating": 65,
      "Humanitarian": 91,
      "Leading/Influencing": 59,
      "Physical Performing": 89
    },
    "fitScore": 59
  },
  {
    "code": "19-3051.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 73,
      "Spatial": 42,
      "ClericalPerception": 81,
      "FormPerception": 47,
      "GeneralLearning": 81
    },
    "interestProfile": {
      "Artistic": 84,
      "Scientific": 87,
      "Plants/Animals": 79,
      "Protective": 47,
      "Mechanical": 42,
      "Industrial": 84,
      "Business Detail": 69,
      "Selling": 90,
      "Accommodating": 74,
      "Humanitarian": 33,
      "Leading/Influencing": 86,
      "Physical Performing": 67
    },
    "fitScore": 69
  },
  {
    "code": "19-3091.00",
    "aptitudeProfile": {
      "Verbal": 92,
      "Numeric": 56,
      "Spatial": 35,
      "ClericalPerception": 91,
      "FormPerception": 89,
      "GeneralLearning": 92
    },
    "interestProfile": {
      "Artistic": 95,
      "Scientific": 94,
      "Plants/Animals": 68,
      "Protective": 89,
      "Mechanical": 35,
      "Industrial": 82,
      "Business Detail": 32,
      "Selling": 95,
      "Accommodating": 89,
      "Humanitarian": 39,
      "Leading/Influencing": 56,
      "Physical Performing": 57
    },
    "fitScore": 73
  },
  {
    "code": "19-3092.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 72,
      "Spatial": 87,
      "ClericalPerception": 83,
      "FormPerception": 78,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 87,
      "Scientific": 86,
      "Plants/Animals": 78,
      "Protective": 78,
      "Mechanical": 87,
      "Industrial": 86,
      "Business Detail": 45,
      "Selling": 79,
      "Accommodating": 79,
      "Humanitarian": 93,
      "Leading/Influencing": 60,
      "Physical Performing": 67
    },
    "fitScore": 80
  },
  {
    "code": "19-3093.00",
    "aptitudeProfile": {
      "Verbal": 92,
      "Numeric": 9,
      "Spatial": 12,
      "ClericalPerception": 27,
      "FormPerception": 6,
      "GeneralLearning": 67
    },
    "interestProfile": {
      "Artistic": 92,
      "Scientific": 69,
      "Plants/Animals": 8,
      "Protective": 6,
      "Mechanical": 12,
      "Industrial": 61,
      "Business Detail": 22,
      "Selling": 75,
      "Accommodating": 10,
      "Humanitarian": 98,
      "Leading/Influencing": 14,
      "Physical Performing": 35
    },
    "fitScore": 39
  },
  {
    "code": "19-3094.00",
    "aptitudeProfile": {
      "Verbal": 90,
      "Numeric": 65,
      "Spatial": 18,
      "ClericalPerception": 31,
      "FormPerception": 16,
      "GeneralLearning": 81
    },
    "interestProfile": {
      "Artistic": 92,
      "Scientific": 79,
      "Plants/Animals": 50,
      "Protective": 16,
      "Mechanical": 18,
      "Industrial": 88,
      "Business Detail": 66,
      "Selling": 81,
      "Accommodating": 66,
      "Humanitarian": 95,
      "Leading/Influencing": 66,
      "Physical Performing": 84
    },
    "fitScore": 59
  },
  {
    "code": "19-3099.01",
    "aptitudeProfile": {
      "Verbal": 82,
      "Numeric": 89,
      "Spatial": 60,
      "ClericalPerception": 95,
      "FormPerception": 68,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 93,
      "Plants/Animals": 82,
      "Protective": 68,
      "Mechanical": 60,
      "Industrial": 91,
      "Business Detail": 91,
      "Selling": 92,
      "Accommodating": 83,
      "Humanitarian": 27,
      "Leading/Influencing": 94,
      "Physical Performing": 88
    },
    "fitScore": 80
  },
  {
    "code": "19-4012.00",
    "aptitudeProfile": {
      "Verbal": 52,
      "Numeric": 70,
      "Spatial": 48,
      "ClericalPerception": 64,
      "FormPerception": 63,
      "GeneralLearning": 40
    },
    "interestProfile": {
      "Artistic": 54,
      "Scientific": 46,
      "Plants/Animals": 76,
      "Protective": 63,
      "Mechanical": 48,
      "Industrial": 58,
      "Business Detail": 53,
      "Selling": 55,
      "Accommodating": 70,
      "Humanitarian": 32,
      "Leading/Influencing": 64,
      "Physical Performing": 54
    },
    "fitScore": 56
  },
  {
    "code": "19-4012.01",
    "aptitudeProfile": {
      "Verbal": 66,
      "Numeric": 82,
      "Spatial": 64,
      "ClericalPerception": 75,
      "FormPerception": 78,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 71,
      "Scientific": 80,
      "Plants/Animals": 81,
      "Protective": 78,
      "Mechanical": 64,
      "Industrial": 83,
      "Business Detail": 58,
      "Selling": 64,
      "Accommodating": 82,
      "Humanitarian": 45,
      "Leading/Influencing": 66,
      "Physical Performing": 74
    },
    "fitScore": 73
  },
  {
    "code": "19-4013.00",
    "aptitudeProfile": {
      "Verbal": 52,
      "Numeric": 68,
      "Spatial": 61,
      "ClericalPerception": 59,
      "FormPerception": 74,
      "GeneralLearning": 60
    },
    "interestProfile": {
      "Artistic": 63,
      "Scientific": 53,
      "Plants/Animals": 76,
      "Protective": 74,
      "Mechanical": 61,
      "Industrial": 68,
      "Business Detail": 22,
      "Selling": 47,
      "Accommodating": 74,
      "Humanitarian": 80,
      "Leading/Influencing": 27,
      "Physical Performing": 52
    },
    "fitScore": 60
  },
  {
    "code": "19-4021.00",
    "aptitudeProfile": {
      "Verbal": 52,
      "Numeric": 76,
      "Spatial": 87,
      "ClericalPerception": 69,
      "FormPerception": 76,
      "GeneralLearning": 75
    },
    "interestProfile": {
      "Artistic": 65,
      "Scientific": 71,
      "Plants/Animals": 79,
      "Protective": 76,
      "Mechanical": 87,
      "Industrial": 85,
      "Business Detail": 17,
      "Selling": 66,
      "Accommodating": 82,
      "Humanitarian": 90,
      "Leading/Influencing": 24,
      "Physical Performing": 67
    },
    "fitScore": 70
  },
  {
    "code": "19-4031.00",
    "aptitudeProfile": {
      "Verbal": 55,
      "Numeric": 76,
      "Spatial": 22,
      "ClericalPerception": 69,
      "FormPerception": 72,
      "GeneralLearning": 71
    },
    "interestProfile": {
      "Artistic": 69,
      "Scientific": 67,
      "Plants/Animals": 79,
      "Protective": 72,
      "Mechanical": 22,
      "Industrial": 81,
      "Business Detail": 20,
      "Selling": 57,
      "Accommodating": 79,
      "Humanitarian": 23,
      "Leading/Influencing": 22,
      "Physical Performing": 63
    },
    "fitScore": 58
  },
  {
    "code": "19-4042.00",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 78,
      "Spatial": 48,
      "ClericalPerception": 66,
      "FormPerception": 70,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 69,
      "Plants/Animals": 79,
      "Protective": 70,
      "Mechanical": 48,
      "Industrial": 83,
      "Business Detail": 57,
      "Selling": 65,
      "Accommodating": 75,
      "Humanitarian": 41,
      "Leading/Influencing": 67,
      "Physical Performing": 72
    },
    "fitScore": 68
  },
  {
    "code": "19-4043.00",
    "aptitudeProfile": {
      "Verbal": 50,
      "Numeric": 73,
      "Spatial": 41,
      "ClericalPerception": 60,
      "FormPerception": 73,
      "GeneralLearning": 39
    },
    "interestProfile": {
      "Artistic": 53,
      "Scientific": 42,
      "Plants/Animals": 73,
      "Protective": 73,
      "Mechanical": 41,
      "Industrial": 68,
      "Business Detail": 51,
      "Selling": 52,
      "Accommodating": 79,
      "Humanitarian": 39,
      "Leading/Influencing": 41,
      "Physical Performing": 71
    },
    "fitScore": 56
  },
  {
    "code": "19-4051.00",
    "aptitudeProfile": {
      "Verbal": 49,
      "Numeric": 63,
      "Spatial": 29,
      "ClericalPerception": 82,
      "FormPerception": 95,
      "GeneralLearning": 56
    },
    "interestProfile": {
      "Artistic": 61,
      "Scientific": 49,
      "Plants/Animals": 62,
      "Protective": 95,
      "Mechanical": 29,
      "Industrial": 62,
      "Business Detail": 31,
      "Selling": 50,
      "Accommodating": 77,
      "Humanitarian": 30,
      "Leading/Influencing": 29,
      "Physical Performing": 67
    },
    "fitScore": 58
  },
  {
    "code": "19-4051.02",
    "aptitudeProfile": {
      "Verbal": 62,
      "Numeric": 78,
      "Spatial": 79,
      "ClericalPerception": 85,
      "FormPerception": 94,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 72,
      "Scientific": 76,
      "Plants/Animals": 81,
      "Protective": 94,
      "Mechanical": 79,
      "Industrial": 78,
      "Business Detail": 38,
      "Selling": 59,
      "Accommodating": 84,
      "Humanitarian": 80,
      "Leading/Influencing": 45,
      "Physical Performing": 71
    },
    "fitScore": 76
  },
  {
    "code": "19-4061.00",
    "aptitudeProfile": {
      "Verbal": 70,
      "Numeric": 77,
      "Spatial": 61,
      "ClericalPerception": 44,
      "FormPerception": 40,
      "GeneralLearning": 46
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 50,
      "Plants/Animals": 79,
      "Protective": 40,
      "Mechanical": 61,
      "Industrial": 89,
      "Business Detail": 35,
      "Selling": 64,
      "Accommodating": 72,
      "Humanitarian": 91,
      "Leading/Influencing": 56,
      "Physical Performing": 65
    },
    "fitScore": 61
  },
  {
    "code": "19-4071.00",
    "aptitudeProfile": {
      "Verbal": 52,
      "Numeric": 63,
      "Spatial": 87,
      "ClericalPerception": 52,
      "FormPerception": 56,
      "GeneralLearning": 60
    },
    "interestProfile": {
      "Artistic": 48,
      "Scientific": 56,
      "Plants/Animals": 62,
      "Protective": 56,
      "Mechanical": 87,
      "Industrial": 54,
      "Business Detail": 67,
      "Selling": 49,
      "Accommodating": 60,
      "Humanitarian": 46,
      "Leading/Influencing": 68,
      "Physical Performing": 59
    },
    "fitScore": 61
  },
  {
    "code": "19-4092.00",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 50,
      "Spatial": 52,
      "ClericalPerception": 90,
      "FormPerception": 98,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 84,
      "Plants/Animals": 60,
      "Protective": 98,
      "Mechanical": 52,
      "Industrial": 74,
      "Business Detail": 36,
      "Selling": 81,
      "Accommodating": 92,
      "Humanitarian": 42,
      "Leading/Influencing": 63,
      "Physical Performing": 44
    },
    "fitScore": 72
  },
  {
    "code": "19-4099.01",
    "aptitudeProfile": {
      "Verbal": 63,
      "Numeric": 84,
      "Spatial": 72,
      "ClericalPerception": 66,
      "FormPerception": 77,
      "GeneralLearning": 55
    },
    "interestProfile": {
      "Artistic": 71,
      "Scientific": 53,
      "Plants/Animals": 77,
      "Protective": 77,
      "Mechanical": 72,
      "Industrial": 75,
      "Business Detail": 71,
      "Selling": 54,
      "Accommodating": 79,
      "Humanitarian": 80,
      "Leading/Influencing": 51,
      "Physical Performing": 90
    },
    "fitScore": 70
  },
  {
    "code": "19-4099.03",
    "aptitudeProfile": {
      "Verbal": 55,
      "Numeric": 90,
      "Spatial": 49,
      "ClericalPerception": 88,
      "FormPerception": 88,
      "GeneralLearning": 68
    },
    "interestProfile": {
      "Artistic": 58,
      "Scientific": 75,
      "Plants/Animals": 90,
      "Protective": 88,
      "Mechanical": 49,
      "Industrial": 84,
      "Business Detail": 63,
      "Selling": 72,
      "Accommodating": 94,
      "Humanitarian": 25,
      "Leading/Influencing": 79,
      "Physical Performing": 73
    },
    "fitScore": 72
  },
  {
    "code": "19-5011.00",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 81,
      "Spatial": 42,
      "ClericalPerception": 75,
      "FormPerception": 95,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 81,
      "Plants/Animals": 78,
      "Protective": 95,
      "Mechanical": 42,
      "Industrial": 81,
      "Business Detail": 87,
      "Selling": 69,
      "Accommodating": 94,
      "Humanitarian": 38,
      "Leading/Influencing": 84,
      "Physical Performing": 85
    },
    "fitScore": 76
  },
  {
    "code": "19-5012.00",
    "aptitudeProfile": {
      "Verbal": 75,
      "Numeric": 68,
      "Spatial": 16,
      "ClericalPerception": 65,
      "FormPerception": 77,
      "GeneralLearning": 80
    },
    "interestProfile": {
      "Artistic": 69,
      "Scientific": 74,
      "Plants/Animals": 57,
      "Protective": 77,
      "Mechanical": 16,
      "Industrial": 69,
      "Business Detail": 88,
      "Selling": 59,
      "Accommodating": 71,
      "Humanitarian": 35,
      "Leading/Influencing": 78,
      "Physical Performing": 81
    },
    "fitScore": 64
  },
  {
    "code": "21-1011.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 17,
      "Spatial": 9,
      "ClericalPerception": 50,
      "FormPerception": 30,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 84,
      "Plants/Animals": 17,
      "Protective": 30,
      "Mechanical": 9,
      "Industrial": 49,
      "Business Detail": 46,
      "Selling": 81,
      "Accommodating": 29,
      "Humanitarian": 26,
      "Leading/Influencing": 48,
      "Physical Performing": 38
    },
    "fitScore": 45
  },
  {
    "code": "21-1012.00",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 23,
      "Spatial": 36,
      "ClericalPerception": 75,
      "FormPerception": 25,
      "GeneralLearning": 77
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 84,
      "Plants/Animals": 36,
      "Protective": 25,
      "Mechanical": 36,
      "Industrial": 53,
      "Business Detail": 14,
      "Selling": 91,
      "Accommodating": 41,
      "Humanitarian": 86,
      "Leading/Influencing": 30,
      "Physical Performing": 31
    },
    "fitScore": 52
  },
  {
    "code": "21-1013.00",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 9,
      "Spatial": 14,
      "ClericalPerception": 83,
      "FormPerception": 53,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 90,
      "Plants/Animals": 16,
      "Protective": 53,
      "Mechanical": 14,
      "Industrial": 43,
      "Business Detail": 2,
      "Selling": 92,
      "Accommodating": 31,
      "Humanitarian": 88,
      "Leading/Influencing": 5,
      "Physical Performing": 18
    },
    "fitScore": 49
  },
  {
    "code": "21-1014.00",
    "aptitudeProfile": {
      "Verbal": 90,
      "Numeric": 18,
      "Spatial": 19,
      "ClericalPerception": 72,
      "FormPerception": 30,
      "GeneralLearning": 92
    },
    "interestProfile": {
      "Artistic": 93,
      "Scientific": 94,
      "Plants/Animals": 26,
      "Protective": 30,
      "Mechanical": 19,
      "Industrial": 56,
      "Business Detail": 19,
      "Selling": 97,
      "Accommodating": 39,
      "Humanitarian": 92,
      "Leading/Influencing": 29,
      "Physical Performing": 47
    },
    "fitScore": 53
  },
  {
    "code": "21-1015.00",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 21,
      "Spatial": 12,
      "ClericalPerception": 38,
      "FormPerception": 19,
      "GeneralLearning": 77
    },
    "interestProfile": {
      "Artistic": 75,
      "Scientific": 75,
      "Plants/Animals": 22,
      "Protective": 19,
      "Mechanical": 12,
      "Industrial": 40,
      "Business Detail": 40,
      "Selling": 71,
      "Accommodating": 24,
      "Humanitarian": 80,
      "Leading/Influencing": 34,
      "Physical Performing": 42
    },
    "fitScore": 42
  },
  {
    "code": "21-1021.00",
    "aptitudeProfile": {
      "Verbal": 85,
      "Numeric": 15,
      "Spatial": 5,
      "ClericalPerception": 54,
      "FormPerception": 37,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 89,
      "Scientific": 76,
      "Plants/Animals": 20,
      "Protective": 37,
      "Mechanical": 5,
      "Industrial": 47,
      "Business Detail": 19,
      "Selling": 81,
      "Accommodating": 30,
      "Humanitarian": 26,
      "Leading/Influencing": 28,
      "Physical Performing": 33
    },
    "fitScore": 43
  },
  {
    "code": "21-1022.00",
    "aptitudeProfile": {
      "Verbal": 79,
      "Numeric": 11,
      "Spatial": 11,
      "ClericalPerception": 83,
      "FormPerception": 35,
      "GeneralLearning": 83
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 90,
      "Plants/Animals": 17,
      "Protective": 35,
      "Mechanical": 11,
      "Industrial": 49,
      "Business Detail": 11,
      "Selling": 92,
      "Accommodating": 24,
      "Humanitarian": 88,
      "Leading/Influencing": 27,
      "Physical Performing": 17
    },
    "fitScore": 48
  },
  {
    "code": "21-1023.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 16,
      "Spatial": 14,
      "ClericalPerception": 91,
      "FormPerception": 64,
      "GeneralLearning": 88
    },
    "interestProfile": {
      "Artistic": 90,
      "Scientific": 92,
      "Plants/Animals": 35,
      "Protective": 64,
      "Mechanical": 14,
      "Industrial": 48,
      "Business Detail": 9,
      "Selling": 97,
      "Accommodating": 58,
      "Humanitarian": 88,
      "Leading/Influencing": 25,
      "Physical Performing": 27
    },
    "fitScore": 57
  },
  {
    "code": "21-1091.00",
    "aptitudeProfile": {
      "Verbal": 81,
      "Numeric": 40,
      "Spatial": 19,
      "ClericalPerception": 40,
      "FormPerception": 5,
      "GeneralLearning": 72
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 77,
      "Plants/Animals": 26,
      "Protective": 5,
      "Mechanical": 19,
      "Industrial": 45,
      "Business Detail": 79,
      "Selling": 80,
      "Accommodating": 16,
      "Humanitarian": 80,
      "Leading/Influencing": 48,
      "Physical Performing": 79
    },
    "fitScore": 48
  },
  {
    "code": "21-1092.00",
    "aptitudeProfile": {
      "Verbal": 70,
      "Numeric": 9,
      "Spatial": 3,
      "ClericalPerception": 16,
      "FormPerception": 12,
      "GeneralLearning": 82
    },
    "interestProfile": {
      "Artistic": 75,
      "Scientific": 74,
      "Plants/Animals": 13,
      "Protective": 12,
      "Mechanical": 3,
      "Industrial": 36,
      "Business Detail": 12,
      "Selling": 56,
      "Accommodating": 17,
      "Humanitarian": 24,
      "Leading/Influencing": 15,
      "Physical Performing": 15
    },
    "fitScore": 31
  },
  {
    "code": "21-1093.00",
    "aptitudeProfile": {
      "Verbal": 57,
      "Numeric": 13,
      "Spatial": 5,
      "ClericalPerception": 66,
      "FormPerception": 50,
      "GeneralLearning": 59
    },
    "interestProfile": {
      "Artistic": 72,
      "Scientific": 66,
      "Plants/Animals": 18,
      "Protective": 50,
      "Mechanical": 5,
      "Industrial": 40,
      "Business Detail": 3,
      "Selling": 71,
      "Accommodating": 29,
      "Humanitarian": 24,
      "Leading/Influencing": 6,
      "Physical Performing": 16
    },
    "fitScore": 38
  },
  {
    "code": "21-1094.00",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 28,
      "Spatial": 16,
      "ClericalPerception": 34,
      "FormPerception": 19,
      "GeneralLearning": 60
    },
    "interestProfile": {
      "Artistic": 75,
      "Scientific": 59,
      "Plants/Animals": 33,
      "Protective": 19,
      "Mechanical": 16,
      "Industrial": 52,
      "Business Detail": 56,
      "Selling": 70,
      "Accommodating": 32,
      "Humanitarian": 30,
      "Leading/Influencing": 64,
      "Physical Performing": 44
    },
    "fitScore": 43
  },
  {
    "code": "21-2011.00",
    "aptitudeProfile": {
      "Verbal": 91,
      "Numeric": 13,
      "Spatial": 13,
      "ClericalPerception": 81,
      "FormPerception": 36,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 87,
      "Scientific": 91,
      "Plants/Animals": 20,
      "Protective": 36,
      "Mechanical": 13,
      "Industrial": 46,
      "Business Detail": 53,
      "Selling": 91,
      "Accommodating": 19,
      "Humanitarian": 88,
      "Leading/Influencing": 69,
      "Physical Performing": 23
    },
    "fitScore": 53
  },
  {
    "code": "21-2021.00",
    "aptitudeProfile": {
      "Verbal": 77,
      "Numeric": 35,
      "Spatial": 51,
      "ClericalPerception": 46,
      "FormPerception": 19,
      "GeneralLearning": 59
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 69,
      "Plants/Animals": 54,
      "Protective": 19,
      "Mechanical": 51,
      "Industrial": 50,
      "Business Detail": 38,
      "Selling": 76,
      "Accommodating": 45,
      "Humanitarian": 84,
      "Leading/Influencing": 49,
      "Physical Performing": 28
    },
    "fitScore": 51
  },
  {
    "code": "23-1011.00",
    "aptitudeProfile": {
      "Verbal": 96,
      "Numeric": 26,
      "Spatial": 49,
      "ClericalPerception": 85,
      "FormPerception": 44,
      "GeneralLearning": 90
    },
    "interestProfile": {
      "Artistic": 98,
      "Scientific": 93,
      "Plants/Animals": 44,
      "Protective": 44,
      "Mechanical": 49,
      "Industrial": 68,
      "Business Detail": 17,
      "Selling": 98,
      "Accommodating": 53,
      "Humanitarian": 97,
      "Leading/Influencing": 22,
      "Physical Performing": 53
    },
    "fitScore": 63
  },
  {
    "code": "23-1012.00",
    "aptitudeProfile": {
      "Verbal": 85,
      "Numeric": 17,
      "Spatial": 8,
      "ClericalPerception": 37,
      "FormPerception": 27,
      "GeneralLearning": 77
    },
    "interestProfile": {
      "Artistic": 92,
      "Scientific": 71,
      "Plants/Animals": 47,
      "Protective": 27,
      "Mechanical": 8,
      "Industrial": 62,
      "Business Detail": 1,
      "Selling": 76,
      "Accommodating": 43,
      "Humanitarian": 97,
      "Leading/Influencing": 5,
      "Physical Performing": 15
    },
    "fitScore": 44
  },
  {
    "code": "23-1021.00",
    "aptitudeProfile": {
      "Verbal": 90,
      "Numeric": 26,
      "Spatial": 3,
      "ClericalPerception": 39,
      "FormPerception": 36,
      "GeneralLearning": 95
    },
    "interestProfile": {
      "Artistic": 91,
      "Scientific": 87,
      "Plants/Animals": 29,
      "Protective": 36,
      "Mechanical": 3,
      "Industrial": 65,
      "Business Detail": 39,
      "Selling": 75,
      "Accommodating": 35,
      "Humanitarian": 94,
      "Leading/Influencing": 43,
      "Physical Performing": 54
    },
    "fitScore": 51
  },
  {
    "code": "23-1022.00",
    "aptitudeProfile": {
      "Verbal": 88,
      "Numeric": 21,
      "Spatial": 13,
      "ClericalPerception": 22,
      "FormPerception": 13,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 91,
      "Scientific": 82,
      "Plants/Animals": 19,
      "Protective": 13,
      "Mechanical": 13,
      "Industrial": 57,
      "Business Detail": 34,
      "Selling": 80,
      "Accommodating": 28,
      "Humanitarian": 91,
      "Leading/Influencing": 34,
      "Physical Performing": 51
    },
    "fitScore": 45
  },
  {
    "code": "23-1023.00",
    "aptitudeProfile": {
      "Verbal": 95,
      "Numeric": 18,
      "Spatial": 12,
      "ClericalPerception": 58,
      "FormPerception": 46,
      "GeneralLearning": 98
    },
    "interestProfile": {
      "Artistic": 95,
      "Scientific": 94,
      "Plants/Animals": 23,
      "Protective": 46,
      "Mechanical": 12,
      "Industrial": 64,
      "Business Detail": 42,
      "Selling": 89,
      "Accommodating": 34,
      "Humanitarian": 94,
      "Leading/Influencing": 62,
      "Physical Performing": 48
    },
    "fitScore": 57
  },
  {
    "code": "23-2011.00",
    "aptitudeProfile": {
      "Verbal": 75,
      "Numeric": 18,
      "Spatial": 13,
      "ClericalPerception": 46,
      "FormPerception": 51,
      "GeneralLearning": 29
    },
    "interestProfile": {
      "Artistic": 73,
      "Scientific": 32,
      "Plants/Animals": 18,
      "Protective": 51,
      "Mechanical": 13,
      "Industrial": 42,
      "Business Detail": 45,
      "Selling": 50,
      "Accommodating": 24,
      "Humanitarian": 84,
      "Leading/Influencing": 40,
      "Physical Performing": 35
    },
    "fitScore": 41
  },
  {
    "code": "23-2093.00",
    "aptitudeProfile": {
      "Verbal": 59,
      "Numeric": 23,
      "Spatial": 15,
      "ClericalPerception": 7,
      "FormPerception": 34,
      "GeneralLearning": 40
    },
    "interestProfile": {
      "Artistic": 73,
      "Scientific": 26,
      "Plants/Animals": 19,
      "Protective": 34,
      "Mechanical": 15,
      "Industrial": 59,
      "Business Detail": 7,
      "Selling": 30,
      "Accommodating": 30,
      "Humanitarian": 89,
      "Leading/Influencing": 7,
      "Physical Performing": 41
    },
    "fitScore": 33
  },
  {
    "code": "25-1011.00",
    "aptitudeProfile": {
      "Verbal": 95,
      "Numeric": 87,
      "Spatial": 19,
      "ClericalPerception": 22,
      "FormPerception": 10,
      "GeneralLearning": 82
    },
    "interestProfile": {
      "Artistic": 93,
      "Scientific": 75,
      "Plants/Animals": 84,
      "Protective": 10,
      "Mechanical": 19,
      "Industrial": 85,
      "Business Detail": 98,
      "Selling": 71,
      "Accommodating": 64,
      "Humanitarian": 92,
      "Leading/Influencing": 95,
      "Physical Performing": 93
    },
    "fitScore": 63
  },
  {
    "code": "25-1021.00",
    "aptitudeProfile": {
      "Verbal": 91,
      "Numeric": 85,
      "Spatial": 44,
      "ClericalPerception": 54,
      "FormPerception": 38,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 89,
      "Scientific": 77,
      "Plants/Animals": 80,
      "Protective": 38,
      "Mechanical": 44,
      "Industrial": 88,
      "Business Detail": 94,
      "Selling": 80,
      "Accommodating": 73,
      "Humanitarian": 92,
      "Leading/Influencing": 92,
      "Physical Performing": 93
    },
    "fitScore": 72
  },
  {
    "code": "25-1022.00",
    "aptitudeProfile": {
      "Verbal": 77,
      "Numeric": 100,
      "Spatial": 19,
      "ClericalPerception": 27,
      "FormPerception": 9,
      "GeneralLearning": 84
    },
    "interestProfile": {
      "Artistic": 84,
      "Scientific": 80,
      "Plants/Animals": 100,
      "Protective": 9,
      "Mechanical": 19,
      "Industrial": 99,
      "Business Detail": 90,
      "Selling": 77,
      "Accommodating": 94,
      "Humanitarian": 91,
      "Leading/Influencing": 89,
      "Physical Performing": 99
    },
    "fitScore": 65
  },
  {
    "code": "25-1031.00",
    "aptitudeProfile": {
      "Verbal": 88,
      "Numeric": 75,
      "Spatial": 46,
      "ClericalPerception": 60,
      "FormPerception": 29,
      "GeneralLearning": 84
    },
    "interestProfile": {
      "Artistic": 89,
      "Scientific": 87,
      "Plants/Animals": 81,
      "Protective": 29,
      "Mechanical": 46,
      "Industrial": 87,
      "Business Detail": 56,
      "Selling": 88,
      "Accommodating": 75,
      "Humanitarian": 32,
      "Leading/Influencing": 70,
      "Physical Performing": 71
    },
    "fitScore": 66
  },
  {
    "code": "25-1032.00",
    "aptitudeProfile": {
      "Verbal": 90,
      "Numeric": 98,
      "Spatial": 93,
      "ClericalPerception": 59,
      "FormPerception": 38,
      "GeneralLearning": 83
    },
    "interestProfile": {
      "Artistic": 90,
      "Scientific": 83,
      "Plants/Animals": 97,
      "Protective": 38,
      "Mechanical": 93,
      "Industrial": 97,
      "Business Detail": 96,
      "Selling": 83,
      "Accommodating": 93,
      "Humanitarian": 91,
      "Leading/Influencing": 96,
      "Physical Performing": 98
    },
    "fitScore": 82
  },
  {
    "code": "25-1041.00",
    "aptitudeProfile": {
      "Verbal": 94,
      "Numeric": 77,
      "Spatial": 18,
      "ClericalPerception": 42,
      "FormPerception": 6,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 92,
      "Scientific": 87,
      "Plants/Animals": 78,
      "Protective": 6,
      "Mechanical": 18,
      "Industrial": 87,
      "Business Detail": 87,
      "Selling": 87,
      "Accommodating": 50,
      "Humanitarian": 94,
      "Leading/Influencing": 91,
      "Physical Performing": 83
    },
    "fitScore": 63
  },
  {
    "code": "25-1042.00",
    "aptitudeProfile": {
      "Verbal": 89,
      "Numeric": 82,
      "Spatial": 14,
      "ClericalPerception": 47,
      "FormPerception": 9,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 94,
      "Scientific": 86,
      "Plants/Animals": 67,
      "Protective": 9,
      "Mechanical": 14,
      "Industrial": 88,
      "Business Detail": 77,
      "Selling": 87,
      "Accommodating": 53,
      "Humanitarian": 92,
      "Leading/Influencing": 60,
      "Physical Performing": 96
    },
    "fitScore": 62
  },
  {
    "code": "25-1043.00",
    "aptitudeProfile": {
      "Verbal": 92,
      "Numeric": 86,
      "Spatial": 4,
      "ClericalPerception": 45,
      "FormPerception": 16,
      "GeneralLearning": 76
    },
    "interestProfile": {
      "Artistic": 94,
      "Scientific": 76,
      "Plants/Animals": 79,
      "Protective": 16,
      "Mechanical": 4,
      "Industrial": 87,
      "Business Detail": 87,
      "Selling": 81,
      "Accommodating": 65,
      "Humanitarian": 32,
      "Leading/Influencing": 70,
      "Physical Performing": 96
    },
    "fitScore": 59
  },
  {
    "code": "25-1051.00",
    "aptitudeProfile": {
      "Verbal": 88,
      "Numeric": 95,
      "Spatial": 20,
      "ClericalPerception": 28,
      "FormPerception": 10,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 93,
      "Scientific": 83,
      "Plants/Animals": 91,
      "Protective": 10,
      "Mechanical": 20,
      "Industrial": 93,
      "Business Detail": 84,
      "Selling": 77,
      "Accommodating": 75,
      "Humanitarian": 92,
      "Leading/Influencing": 74,
      "Physical Performing": 97
    },
    "fitScore": 64
  },
  {
    "code": "25-1052.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 91,
      "Spatial": 47,
      "ClericalPerception": 36,
      "FormPerception": 28,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 90,
      "Scientific": 82,
      "Plants/Animals": 78,
      "Protective": 28,
      "Mechanical": 47,
      "Industrial": 92,
      "Business Detail": 88,
      "Selling": 79,
      "Accommodating": 75,
      "Humanitarian": 94,
      "Leading/Influencing": 68,
      "Physical Performing": 98
    },
    "fitScore": 70
  },
  {
    "code": "25-1053.00",
    "aptitudeProfile": {
      "Verbal": 89,
      "Numeric": 80,
      "Spatial": 15,
      "ClericalPerception": 33,
      "FormPerception": 12,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 90,
      "Scientific": 82,
      "Plants/Animals": 71,
      "Protective": 12,
      "Mechanical": 15,
      "Industrial": 87,
      "Business Detail": 85,
      "Selling": 77,
      "Accommodating": 59,
      "Humanitarian": 94,
      "Leading/Influencing": 75,
      "Physical Performing": 92
    },
    "fitScore": 61
  },
  {
    "code": "25-1054.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 98,
      "Spatial": 38,
      "ClericalPerception": 42,
      "FormPerception": 3,
      "GeneralLearning": 84
    },
    "interestProfile": {
      "Artistic": 91,
      "Scientific": 83,
      "Plants/Animals": 96,
      "Protective": 3,
      "Mechanical": 38,
      "Industrial": 96,
      "Business Detail": 92,
      "Selling": 86,
      "Accommodating": 71,
      "Humanitarian": 94,
      "Leading/Influencing": 75,
      "Physical Performing": 100
    },
    "fitScore": 68
  },
  {
    "code": "25-1061.00",
    "aptitudeProfile": {
      "Verbal": 89,
      "Numeric": 54,
      "Spatial": 19,
      "ClericalPerception": 50,
      "FormPerception": 31,
      "GeneralLearning": 82
    },
    "interestProfile": {
      "Artistic": 92,
      "Scientific": 83,
      "Plants/Animals": 51,
      "Protective": 31,
      "Mechanical": 19,
      "Industrial": 78,
      "Business Detail": 51,
      "Selling": 87,
      "Accommodating": 70,
      "Humanitarian": 95,
      "Leading/Influencing": 41,
      "Physical Performing": 78
    },
    "fitScore": 59
  },
  {
    "code": "25-1062.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 13,
      "Spatial": 14,
      "ClericalPerception": 29,
      "FormPerception": 7,
      "GeneralLearning": 67
    },
    "interestProfile": {
      "Artistic": 88,
      "Scientific": 69,
      "Plants/Animals": 18,
      "Protective": 7,
      "Mechanical": 14,
      "Industrial": 61,
      "Business Detail": 9,
      "Selling": 77,
      "Accommodating": 16,
      "Humanitarian": 95,
      "Leading/Influencing": 18,
      "Physical Performing": 23
    },
    "fitScore": 39
  },
  {
    "code": "25-1063.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 94,
      "Spatial": 51,
      "ClericalPerception": 46,
      "FormPerception": 26,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 88,
      "Scientific": 76,
      "Plants/Animals": 91,
      "Protective": 26,
      "Mechanical": 51,
      "Industrial": 89,
      "Business Detail": 91,
      "Selling": 76,
      "Accommodating": 77,
      "Humanitarian": 89,
      "Leading/Influencing": 76,
      "Physical Performing": 98
    },
    "fitScore": 70
  },
  {
    "code": "25-1064.00",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 55,
      "Spatial": 30,
      "ClericalPerception": 29,
      "FormPerception": 11,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 89,
      "Scientific": 73,
      "Plants/Animals": 42,
      "Protective": 11,
      "Mechanical": 30,
      "Industrial": 78,
      "Business Detail": 28,
      "Selling": 77,
      "Accommodating": 43,
      "Humanitarian": 91,
      "Leading/Influencing": 23,
      "Physical Performing": 77
    },
    "fitScore": 51
  },
  {
    "code": "25-1065.00",
    "aptitudeProfile": {
      "Verbal": 85,
      "Numeric": 26,
      "Spatial": 5,
      "ClericalPerception": 21,
      "FormPerception": 4,
      "GeneralLearning": 58
    },
    "interestProfile": {
      "Artistic": 90,
      "Scientific": 59,
      "Plants/Animals": 20,
      "Protective": 4,
      "Mechanical": 5,
      "Industrial": 57,
      "Business Detail": 35,
      "Selling": 76,
      "Accommodating": 11,
      "Humanitarian": 93,
      "Leading/Influencing": 18,
      "Physical Performing": 68
    },
    "fitScore": 39
  },
  {
    "code": "25-1066.00",
    "aptitudeProfile": {
      "Verbal": 89,
      "Numeric": 74,
      "Spatial": 18,
      "ClericalPerception": 33,
      "FormPerception": 8,
      "GeneralLearning": 82
    },
    "interestProfile": {
      "Artistic": 91,
      "Scientific": 81,
      "Plants/Animals": 57,
      "Protective": 8,
      "Mechanical": 18,
      "Industrial": 87,
      "Business Detail": 80,
      "Selling": 80,
      "Accommodating": 49,
      "Humanitarian": 94,
      "Leading/Influencing": 69,
      "Physical Performing": 91
    },
    "fitScore": 59
  },
  {
    "code": "25-1067.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 43,
      "Spatial": 4,
      "ClericalPerception": 26,
      "FormPerception": 3,
      "GeneralLearning": 84
    },
    "interestProfile": {
      "Artistic": 90,
      "Scientific": 80,
      "Plants/Animals": 25,
      "Protective": 3,
      "Mechanical": 4,
      "Industrial": 65,
      "Business Detail": 57,
      "Selling": 76,
      "Accommodating": 12,
      "Humanitarian": 91,
      "Leading/Influencing": 27,
      "Physical Performing": 85
    },
    "fitScore": 46
  },
  {
    "code": "25-1071.00",
    "aptitudeProfile": {
      "Verbal": 93,
      "Numeric": 68,
      "Spatial": 19,
      "ClericalPerception": 26,
      "FormPerception": 4,
      "GeneralLearning": 76
    },
    "interestProfile": {
      "Artistic": 92,
      "Scientific": 74,
      "Plants/Animals": 67,
      "Protective": 4,
      "Mechanical": 19,
      "Industrial": 86,
      "Business Detail": 78,
      "Selling": 75,
      "Accommodating": 38,
      "Humanitarian": 94,
      "Leading/Influencing": 86,
      "Physical Performing": 73
    },
    "fitScore": 57
  },
  {
    "code": "25-1072.00",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 78,
      "Spatial": 25,
      "ClericalPerception": 68,
      "FormPerception": 53,
      "GeneralLearning": 80
    },
    "interestProfile": {
      "Artistic": 89,
      "Scientific": 79,
      "Plants/Animals": 73,
      "Protective": 53,
      "Mechanical": 25,
      "Industrial": 82,
      "Business Detail": 79,
      "Selling": 82,
      "Accommodating": 70,
      "Humanitarian": 92,
      "Leading/Influencing": 64,
      "Physical Performing": 92
    },
    "fitScore": 69
  },
  {
    "code": "25-1081.00",
    "aptitudeProfile": {
      "Verbal": 94,
      "Numeric": 36,
      "Spatial": 11,
      "ClericalPerception": 27,
      "FormPerception": 2,
      "GeneralLearning": 82
    },
    "interestProfile": {
      "Artistic": 92,
      "Scientific": 78,
      "Plants/Animals": 23,
      "Protective": 2,
      "Mechanical": 11,
      "Industrial": 65,
      "Business Detail": 85,
      "Selling": 80,
      "Accommodating": 8,
      "Humanitarian": 95,
      "Leading/Influencing": 61,
      "Physical Performing": 84
    },
    "fitScore": 50
  },
  {
    "code": "25-1082.00",
    "aptitudeProfile": {
      "Verbal": 90,
      "Numeric": 33,
      "Spatial": 18,
      "ClericalPerception": 22,
      "FormPerception": 17,
      "GeneralLearning": 81
    },
    "interestProfile": {
      "Artistic": 91,
      "Scientific": 73,
      "Plants/Animals": 27,
      "Protective": 17,
      "Mechanical": 18,
      "Industrial": 66,
      "Business Detail": 56,
      "Selling": 75,
      "Accommodating": 30,
      "Humanitarian": 94,
      "Leading/Influencing": 45,
      "Physical Performing": 73
    },
    "fitScore": 49
  },
  {
    "code": "25-1111.00",
    "aptitudeProfile": {
      "Verbal": 90,
      "Numeric": 18,
      "Spatial": 13,
      "ClericalPerception": 16,
      "FormPerception": 2,
      "GeneralLearning": 76
    },
    "interestProfile": {
      "Artistic": 88,
      "Scientific": 71,
      "Plants/Animals": 18,
      "Protective": 2,
      "Mechanical": 13,
      "Industrial": 53,
      "Business Detail": 52,
      "Selling": 71,
      "Accommodating": 8,
      "Humanitarian": 91,
      "Leading/Influencing": 54,
      "Physical Performing": 43
    },
    "fitScore": 41
  },
  {
    "code": "25-1112.00",
    "aptitudeProfile": {
      "Verbal": 92,
      "Numeric": 20,
      "Spatial": 9,
      "ClericalPerception": 33,
      "FormPerception": 6,
      "GeneralLearning": 91
    },
    "interestProfile": {
      "Artistic": 94,
      "Scientific": 85,
      "Plants/Animals": 20,
      "Protective": 6,
      "Mechanical": 9,
      "Industrial": 64,
      "Business Detail": 27,
      "Selling": 80,
      "Accommodating": 12,
      "Humanitarian": 95,
      "Leading/Influencing": 27,
      "Physical Performing": 48
    },
    "fitScore": 45
  },
  {
    "code": "25-1113.00",
    "aptitudeProfile": {
      "Verbal": 92,
      "Numeric": 37,
      "Spatial": 13,
      "ClericalPerception": 34,
      "FormPerception": 3,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 91,
      "Scientific": 86,
      "Plants/Animals": 26,
      "Protective": 3,
      "Mechanical": 13,
      "Industrial": 74,
      "Business Detail": 67,
      "Selling": 83,
      "Accommodating": 20,
      "Humanitarian": 91,
      "Leading/Influencing": 74,
      "Physical Performing": 62
    },
    "fitScore": 51
  },
  {
    "code": "25-1121.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 17,
      "Spatial": 86,
      "ClericalPerception": 50,
      "FormPerception": 10,
      "GeneralLearning": 61
    },
    "interestProfile": {
      "Artistic": 90,
      "Scientific": 74,
      "Plants/Animals": 18,
      "Protective": 10,
      "Mechanical": 86,
      "Industrial": 52,
      "Business Detail": 24,
      "Selling": 88,
      "Accommodating": 18,
      "Humanitarian": 90,
      "Leading/Influencing": 28,
      "Physical Performing": 37
    },
    "fitScore": 52
  },
  {
    "code": "25-1122.00",
    "aptitudeProfile": {
      "Verbal": 88,
      "Numeric": 22,
      "Spatial": 14,
      "ClericalPerception": 22,
      "FormPerception": 10,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 88,
      "Scientific": 69,
      "Plants/Animals": 32,
      "Protective": 10,
      "Mechanical": 14,
      "Industrial": 64,
      "Business Detail": 26,
      "Selling": 75,
      "Accommodating": 26,
      "Humanitarian": 93,
      "Leading/Influencing": 51,
      "Physical Performing": 28
    },
    "fitScore": 43
  },
  {
    "code": "25-1123.00",
    "aptitudeProfile": {
      "Verbal": 96,
      "Numeric": 12,
      "Spatial": 13,
      "ClericalPerception": 30,
      "FormPerception": 8,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 97,
      "Scientific": 80,
      "Plants/Animals": 16,
      "Protective": 8,
      "Mechanical": 13,
      "Industrial": 74,
      "Business Detail": 15,
      "Selling": 88,
      "Accommodating": 18,
      "Humanitarian": 99,
      "Leading/Influencing": 27,
      "Physical Performing": 30
    },
    "fitScore": 43
  },
  {
    "code": "25-1124.00",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 9,
      "Spatial": 13,
      "ClericalPerception": 18,
      "FormPerception": 6,
      "GeneralLearning": 55
    },
    "interestProfile": {
      "Artistic": 88,
      "Scientific": 55,
      "Plants/Animals": 16,
      "Protective": 6,
      "Mechanical": 13,
      "Industrial": 50,
      "Business Detail": 3,
      "Selling": 72,
      "Accommodating": 12,
      "Humanitarian": 91,
      "Leading/Influencing": 10,
      "Physical Performing": 15
    },
    "fitScore": 33
  },
  {
    "code": "25-1125.00",
    "aptitudeProfile": {
      "Verbal": 90,
      "Numeric": 21,
      "Spatial": 8,
      "ClericalPerception": 22,
      "FormPerception": 5,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 94,
      "Scientific": 74,
      "Plants/Animals": 17,
      "Protective": 5,
      "Mechanical": 8,
      "Industrial": 60,
      "Business Detail": 31,
      "Selling": 72,
      "Accommodating": 11,
      "Humanitarian": 94,
      "Leading/Influencing": 21,
      "Physical Performing": 54
    },
    "fitScore": 41
  },
  {
    "code": "25-1126.00",
    "aptitudeProfile": {
      "Verbal": 77,
      "Numeric": 13,
      "Spatial": 11,
      "ClericalPerception": 28,
      "FormPerception": 4,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 89,
      "Scientific": 78,
      "Plants/Animals": 18,
      "Protective": 4,
      "Mechanical": 11,
      "Industrial": 61,
      "Business Detail": 2,
      "Selling": 72,
      "Accommodating": 8,
      "Humanitarian": 95,
      "Leading/Influencing": 4,
      "Physical Performing": 23
    },
    "fitScore": 38
  },
  {
    "code": "25-1192.00",
    "aptitudeProfile": {
      "Verbal": 88,
      "Numeric": 56,
      "Spatial": 30,
      "ClericalPerception": 26,
      "FormPerception": 9,
      "GeneralLearning": 62
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 61,
      "Plants/Animals": 44,
      "Protective": 9,
      "Mechanical": 30,
      "Industrial": 74,
      "Business Detail": 80,
      "Selling": 71,
      "Accommodating": 39,
      "Humanitarian": 90,
      "Leading/Influencing": 72,
      "Physical Performing": 80
    },
    "fitScore": 53
  },
  {
    "code": "25-1193.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 43,
      "Spatial": 19,
      "ClericalPerception": 30,
      "FormPerception": 6,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 73,
      "Plants/Animals": 35,
      "Protective": 6,
      "Mechanical": 19,
      "Industrial": 57,
      "Business Detail": 75,
      "Selling": 77,
      "Accommodating": 28,
      "Humanitarian": 88,
      "Leading/Influencing": 52,
      "Physical Performing": 77
    },
    "fitScore": 49
  },
  {
    "code": "25-1194.00",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 42,
      "Spatial": 11,
      "ClericalPerception": 17,
      "FormPerception": 10,
      "GeneralLearning": 48
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 49,
      "Plants/Animals": 23,
      "Protective": 10,
      "Mechanical": 11,
      "Industrial": 52,
      "Business Detail": 83,
      "Selling": 60,
      "Accommodating": 20,
      "Humanitarian": 23,
      "Leading/Influencing": 52,
      "Physical Performing": 83
    },
    "fitScore": 40
  },
  {
    "code": "25-2011.00",
    "aptitudeProfile": {
      "Verbal": 48,
      "Numeric": 17,
      "Spatial": 57,
      "ClericalPerception": 67,
      "FormPerception": 32,
      "GeneralLearning": 29
    },
    "interestProfile": {
      "Artistic": 53,
      "Scientific": 52,
      "Plants/Animals": 24,
      "Protective": 32,
      "Mechanical": 57,
      "Industrial": 34,
      "Business Detail": 10,
      "Selling": 81,
      "Accommodating": 36,
      "Humanitarian": 75,
      "Leading/Influencing": 14,
      "Physical Performing": 23
    },
    "fitScore": 41
  },
  {
    "code": "25-2012.00",
    "aptitudeProfile": {
      "Verbal": 71,
      "Numeric": 57,
      "Spatial": 40,
      "ClericalPerception": 79,
      "FormPerception": 36,
      "GeneralLearning": 47
    },
    "interestProfile": {
      "Artistic": 75,
      "Scientific": 68,
      "Plants/Animals": 54,
      "Protective": 36,
      "Mechanical": 40,
      "Industrial": 51,
      "Business Detail": 69,
      "Selling": 82,
      "Accommodating": 43,
      "Humanitarian": 82,
      "Leading/Influencing": 35,
      "Physical Performing": 78
    },
    "fitScore": 57
  },
  {
    "code": "25-2021.00",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 74,
      "Spatial": 59,
      "ClericalPerception": 85,
      "FormPerception": 43,
      "GeneralLearning": 81
    },
    "interestProfile": {
      "Artistic": 81,
      "Scientific": 89,
      "Plants/Animals": 71,
      "Protective": 43,
      "Mechanical": 59,
      "Industrial": 70,
      "Business Detail": 77,
      "Selling": 90,
      "Accommodating": 69,
      "Humanitarian": 83,
      "Leading/Influencing": 62,
      "Physical Performing": 83
    },
    "fitScore": 72
  },
  {
    "code": "25-2022.00",
    "aptitudeProfile": {
      "Verbal": 68,
      "Numeric": 74,
      "Spatial": 51,
      "ClericalPerception": 70,
      "FormPerception": 50,
      "GeneralLearning": 55
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 65,
      "Plants/Animals": 71,
      "Protective": 50,
      "Mechanical": 51,
      "Industrial": 74,
      "Business Detail": 49,
      "Selling": 73,
      "Accommodating": 66,
      "Humanitarian": 84,
      "Leading/Influencing": 38,
      "Physical Performing": 77
    },
    "fitScore": 63
  },
  {
    "code": "25-2023.00",
    "aptitudeProfile": {
      "Verbal": 79,
      "Numeric": 46,
      "Spatial": 74,
      "ClericalPerception": 78,
      "FormPerception": 50,
      "GeneralLearning": 74
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 75,
      "Plants/Animals": 47,
      "Protective": 50,
      "Mechanical": 74,
      "Industrial": 65,
      "Business Detail": 58,
      "Selling": 74,
      "Accommodating": 46,
      "Humanitarian": 88,
      "Leading/Influencing": 59,
      "Physical Performing": 57
    },
    "fitScore": 66
  },
  {
    "code": "25-2031.00",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 66,
      "Spatial": 79,
      "ClericalPerception": 84,
      "FormPerception": 50,
      "GeneralLearning": 76
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 82,
      "Plants/Animals": 70,
      "Protective": 50,
      "Mechanical": 79,
      "Industrial": 78,
      "Business Detail": 45,
      "Selling": 86,
      "Accommodating": 65,
      "Humanitarian": 88,
      "Leading/Influencing": 56,
      "Physical Performing": 66
    },
    "fitScore": 71
  },
  {
    "code": "25-2032.00",
    "aptitudeProfile": {
      "Verbal": 82,
      "Numeric": 70,
      "Spatial": 79,
      "ClericalPerception": 72,
      "FormPerception": 56,
      "GeneralLearning": 74
    },
    "interestProfile": {
      "Artistic": 81,
      "Scientific": 75,
      "Plants/Animals": 73,
      "Protective": 56,
      "Mechanical": 79,
      "Industrial": 78,
      "Business Detail": 69,
      "Selling": 78,
      "Accommodating": 70,
      "Humanitarian": 88,
      "Leading/Influencing": 78,
      "Physical Performing": 69
    },
    "fitScore": 73
  },
  {
    "code": "25-2051.00",
    "aptitudeProfile": {
      "Verbal": 64,
      "Numeric": 23,
      "Spatial": 32,
      "ClericalPerception": 52,
      "FormPerception": 20,
      "GeneralLearning": 78
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 78,
      "Plants/Animals": 16,
      "Protective": 20,
      "Mechanical": 32,
      "Industrial": 52,
      "Business Detail": 15,
      "Selling": 74,
      "Accommodating": 16,
      "Humanitarian": 85,
      "Leading/Influencing": 12,
      "Physical Performing": 47
    },
    "fitScore": 44
  },
  {
    "code": "25-2057.00",
    "aptitudeProfile": {
      "Verbal": 71,
      "Numeric": 67,
      "Spatial": 49,
      "ClericalPerception": 61,
      "FormPerception": 40,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 78,
      "Plants/Animals": 67,
      "Protective": 40,
      "Mechanical": 49,
      "Industrial": 66,
      "Business Detail": 53,
      "Selling": 73,
      "Accommodating": 58,
      "Humanitarian": 84,
      "Leading/Influencing": 38,
      "Physical Performing": 76
    },
    "fitScore": 62
  },
  {
    "code": "25-2058.00",
    "aptitudeProfile": {
      "Verbal": 79,
      "Numeric": 75,
      "Spatial": 61,
      "ClericalPerception": 85,
      "FormPerception": 57,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 82,
      "Plants/Animals": 70,
      "Protective": 57,
      "Mechanical": 61,
      "Industrial": 74,
      "Business Detail": 86,
      "Selling": 85,
      "Accommodating": 70,
      "Humanitarian": 87,
      "Leading/Influencing": 73,
      "Physical Performing": 85
    },
    "fitScore": 74
  },
  {
    "code": "25-2059.01",
    "aptitudeProfile": {
      "Verbal": 67,
      "Numeric": 15,
      "Spatial": 13,
      "ClericalPerception": 74,
      "FormPerception": 57,
      "GeneralLearning": 62
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 70,
      "Plants/Animals": 17,
      "Protective": 57,
      "Mechanical": 13,
      "Industrial": 43,
      "Business Detail": 11,
      "Selling": 79,
      "Accommodating": 32,
      "Humanitarian": 29,
      "Leading/Influencing": 13,
      "Physical Performing": 29
    },
    "fitScore": 44
  },
  {
    "code": "25-3011.00",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 54,
      "Spatial": 13,
      "ClericalPerception": 57,
      "FormPerception": 43,
      "GeneralLearning": 46
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 56,
      "Plants/Animals": 68,
      "Protective": 43,
      "Mechanical": 13,
      "Industrial": 60,
      "Business Detail": 33,
      "Selling": 69,
      "Accommodating": 63,
      "Humanitarian": 80,
      "Leading/Influencing": 46,
      "Physical Performing": 42
    },
    "fitScore": 51
  },
  {
    "code": "25-3021.00",
    "aptitudeProfile": {
      "Verbal": 32,
      "Numeric": 14,
      "Spatial": 44,
      "ClericalPerception": 20,
      "FormPerception": 7,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 49,
      "Scientific": 32,
      "Plants/Animals": 15,
      "Protective": 7,
      "Mechanical": 44,
      "Industrial": 20,
      "Business Detail": 5,
      "Selling": 60,
      "Accommodating": 14,
      "Humanitarian": 54,
      "Leading/Influencing": 5,
      "Physical Performing": 26
    },
    "fitScore": 25
  },
  {
    "code": "25-3041.00",
    "aptitudeProfile": {
      "Verbal": 71,
      "Numeric": 71,
      "Spatial": 18,
      "ClericalPerception": 41,
      "FormPerception": 20,
      "GeneralLearning": 39
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 53,
      "Plants/Animals": 62,
      "Protective": 20,
      "Mechanical": 18,
      "Industrial": 77,
      "Business Detail": 52,
      "Selling": 78,
      "Accommodating": 61,
      "Humanitarian": 89,
      "Leading/Influencing": 33,
      "Physical Performing": 87
    },
    "fitScore": 51
  },
  {
    "code": "25-4011.00",
    "aptitudeProfile": {
      "Verbal": 82,
      "Numeric": 21,
      "Spatial": 38,
      "ClericalPerception": 29,
      "FormPerception": 10,
      "GeneralLearning": 57
    },
    "interestProfile": {
      "Artistic": 74,
      "Scientific": 57,
      "Plants/Animals": 29,
      "Protective": 10,
      "Mechanical": 38,
      "Industrial": 51,
      "Business Detail": 51,
      "Selling": 56,
      "Accommodating": 16,
      "Humanitarian": 90,
      "Leading/Influencing": 59,
      "Physical Performing": 23
    },
    "fitScore": 43
  },
  {
    "code": "25-4012.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 51,
      "Spatial": 49,
      "ClericalPerception": 77,
      "FormPerception": 62,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 83,
      "Plants/Animals": 70,
      "Protective": 62,
      "Mechanical": 49,
      "Industrial": 80,
      "Business Detail": 33,
      "Selling": 83,
      "Accommodating": 76,
      "Humanitarian": 35,
      "Leading/Influencing": 78,
      "Physical Performing": 26
    },
    "fitScore": 65
  },
  {
    "code": "25-4013.00",
    "aptitudeProfile": {
      "Verbal": 58,
      "Numeric": 28,
      "Spatial": 26,
      "ClericalPerception": 73,
      "FormPerception": 64,
      "GeneralLearning": 34
    },
    "interestProfile": {
      "Artistic": 55,
      "Scientific": 48,
      "Plants/Animals": 28,
      "Protective": 64,
      "Mechanical": 26,
      "Industrial": 47,
      "Business Detail": 40,
      "Selling": 62,
      "Accommodating": 49,
      "Humanitarian": 17,
      "Leading/Influencing": 46,
      "Physical Performing": 29
    },
    "fitScore": 45
  },
  {
    "code": "25-4022.00",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 21,
      "Spatial": 4,
      "ClericalPerception": 47,
      "FormPerception": 35,
      "GeneralLearning": 32
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 41,
      "Plants/Animals": 22,
      "Protective": 35,
      "Mechanical": 4,
      "Industrial": 42,
      "Business Detail": 43,
      "Selling": 68,
      "Accommodating": 25,
      "Humanitarian": 24,
      "Leading/Influencing": 36,
      "Physical Performing": 45
    },
    "fitScore": 37
  },
  {
    "code": "25-4031.00",
    "aptitudeProfile": {
      "Verbal": 24,
      "Numeric": 18,
      "Spatial": 7,
      "ClericalPerception": 11,
      "FormPerception": 44,
      "GeneralLearning": 14
    },
    "interestProfile": {
      "Artistic": 31,
      "Scientific": 11,
      "Plants/Animals": 17,
      "Protective": 44,
      "Mechanical": 7,
      "Industrial": 30,
      "Business Detail": 8,
      "Selling": 13,
      "Accommodating": 25,
      "Humanitarian": 23,
      "Leading/Influencing": 6,
      "Physical Performing": 18
    },
    "fitScore": 20
  },
  {
    "code": "25-9021.00",
    "aptitudeProfile": {
      "Verbal": 89,
      "Numeric": 71,
      "Spatial": 49,
      "ClericalPerception": 86,
      "FormPerception": 60,
      "GeneralLearning": 88
    },
    "interestProfile": {
      "Artistic": 90,
      "Scientific": 89,
      "Plants/Animals": 78,
      "Protective": 60,
      "Mechanical": 49,
      "Industrial": 85,
      "Business Detail": 61,
      "Selling": 89,
      "Accommodating": 73,
      "Humanitarian": 45,
      "Leading/Influencing": 82,
      "Physical Performing": 67
    },
    "fitScore": 73
  },
  {
    "code": "25-9031.00",
    "aptitudeProfile": {
      "Verbal": 92,
      "Numeric": 74,
      "Spatial": 86,
      "ClericalPerception": 79,
      "FormPerception": 45,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 92,
      "Scientific": 85,
      "Plants/Animals": 75,
      "Protective": 45,
      "Mechanical": 86,
      "Industrial": 77,
      "Business Detail": 87,
      "Selling": 89,
      "Accommodating": 69,
      "Humanitarian": 90,
      "Leading/Influencing": 82,
      "Physical Performing": 84
    },
    "fitScore": 78
  },
  {
    "code": "25-9042.00",
    "aptitudeProfile": {
      "Verbal": 53,
      "Numeric": 54,
      "Spatial": 68,
      "ClericalPerception": 64,
      "FormPerception": 34,
      "GeneralLearning": 33
    },
    "interestProfile": {
      "Artistic": 56,
      "Scientific": 47,
      "Plants/Animals": 49,
      "Protective": 34,
      "Mechanical": 68,
      "Industrial": 51,
      "Business Detail": 57,
      "Selling": 63,
      "Accommodating": 37,
      "Humanitarian": 73,
      "Leading/Influencing": 41,
      "Physical Performing": 62
    },
    "fitScore": 52
  },
  {
    "code": "25-9044.00",
    "aptitudeProfile": {
      "Verbal": 65,
      "Numeric": 39,
      "Spatial": 19,
      "ClericalPerception": 25,
      "FormPerception": 5,
      "GeneralLearning": 30
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 42,
      "Plants/Animals": 32,
      "Protective": 5,
      "Mechanical": 19,
      "Industrial": 52,
      "Business Detail": 27,
      "Selling": 76,
      "Accommodating": 18,
      "Humanitarian": 86,
      "Leading/Influencing": 11,
      "Physical Performing": 74
    },
    "fitScore": 37
  },
  {
    "code": "27-1011.00",
    "aptitudeProfile": {
      "Verbal": 66,
      "Numeric": 27,
      "Spatial": 100,
      "ClericalPerception": 97,
      "FormPerception": 52,
      "GeneralLearning": 63
    },
    "interestProfile": {
      "Artistic": 69,
      "Scientific": 87,
      "Plants/Animals": 43,
      "Protective": 52,
      "Mechanical": 100,
      "Industrial": 49,
      "Business Detail": 16,
      "Selling": 95,
      "Accommodating": 54,
      "Humanitarian": 79,
      "Leading/Influencing": 39,
      "Physical Performing": 19
    },
    "fitScore": 63
  },
  {
    "code": "27-1012.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 31,
      "Spatial": 99,
      "ClericalPerception": 44,
      "FormPerception": 1,
      "GeneralLearning": 14
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 40,
      "Plants/Animals": 39,
      "Protective": 1,
      "Mechanical": 99,
      "Industrial": 19,
      "Business Detail": 28,
      "Selling": 47,
      "Accommodating": 14,
      "Humanitarian": 44,
      "Leading/Influencing": 25,
      "Physical Performing": 10
    },
    "fitScore": 33
  },
  {
    "code": "27-1013.00",
    "aptitudeProfile": {
      "Verbal": 19,
      "Numeric": 27,
      "Spatial": 100,
      "ClericalPerception": 85,
      "FormPerception": 23,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 15,
      "Scientific": 55,
      "Plants/Animals": 19,
      "Protective": 23,
      "Mechanical": 100,
      "Industrial": 16,
      "Business Detail": 56,
      "Selling": 71,
      "Accommodating": 18,
      "Humanitarian": 43,
      "Leading/Influencing": 30,
      "Physical Performing": 31
    },
    "fitScore": 43
  },
  {
    "code": "27-1014.00",
    "aptitudeProfile": {
      "Verbal": 67,
      "Numeric": 34,
      "Spatial": 100,
      "ClericalPerception": 77,
      "FormPerception": 37,
      "GeneralLearning": 49
    },
    "interestProfile": {
      "Artistic": 72,
      "Scientific": 65,
      "Plants/Animals": 47,
      "Protective": 37,
      "Mechanical": 100,
      "Industrial": 46,
      "Business Detail": 24,
      "Selling": 84,
      "Accommodating": 46,
      "Humanitarian": 80,
      "Leading/Influencing": 28,
      "Physical Performing": 40
    },
    "fitScore": 58
  },
  {
    "code": "27-1021.00",
    "aptitudeProfile": {
      "Verbal": 60,
      "Numeric": 73,
      "Spatial": 50,
      "ClericalPerception": 90,
      "FormPerception": 63,
      "GeneralLearning": 67
    },
    "interestProfile": {
      "Artistic": 55,
      "Scientific": 83,
      "Plants/Animals": 66,
      "Protective": 63,
      "Mechanical": 50,
      "Industrial": 75,
      "Business Detail": 75,
      "Selling": 86,
      "Accommodating": 74,
      "Humanitarian": 21,
      "Leading/Influencing": 66,
      "Physical Performing": 76
    },
    "fitScore": 67
  },
  {
    "code": "27-1022.00",
    "aptitudeProfile": {
      "Verbal": 56,
      "Numeric": 22,
      "Spatial": 100,
      "ClericalPerception": 92,
      "FormPerception": 50,
      "GeneralLearning": 55
    },
    "interestProfile": {
      "Artistic": 64,
      "Scientific": 77,
      "Plants/Animals": 29,
      "Protective": 50,
      "Mechanical": 100,
      "Industrial": 40,
      "Business Detail": 13,
      "Selling": 85,
      "Accommodating": 31,
      "Humanitarian": 74,
      "Leading/Influencing": 20,
      "Physical Performing": 20
    },
    "fitScore": 56
  },
  {
    "code": "27-1023.00",
    "aptitudeProfile": {
      "Verbal": 34,
      "Numeric": 21,
      "Spatial": 59,
      "ClericalPerception": 43,
      "FormPerception": 3,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 39,
      "Scientific": 38,
      "Plants/Animals": 21,
      "Protective": 3,
      "Mechanical": 59,
      "Industrial": 19,
      "Business Detail": 25,
      "Selling": 76,
      "Accommodating": 10,
      "Humanitarian": 9,
      "Leading/Influencing": 34,
      "Physical Performing": 30
    },
    "fitScore": 30
  },
  {
    "code": "27-1024.00",
    "aptitudeProfile": {
      "Verbal": 48,
      "Numeric": 15,
      "Spatial": 94,
      "ClericalPerception": 88,
      "FormPerception": 32,
      "GeneralLearning": 29
    },
    "interestProfile": {
      "Artistic": 51,
      "Scientific": 62,
      "Plants/Animals": 16,
      "Protective": 32,
      "Mechanical": 94,
      "Industrial": 23,
      "Business Detail": 25,
      "Selling": 83,
      "Accommodating": 18,
      "Humanitarian": 54,
      "Leading/Influencing": 31,
      "Physical Performing": 18
    },
    "fitScore": 47
  },
  {
    "code": "27-1025.00",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 67,
      "Spatial": 78,
      "ClericalPerception": 95,
      "FormPerception": 49,
      "GeneralLearning": 46
    },
    "interestProfile": {
      "Artistic": 71,
      "Scientific": 77,
      "Plants/Animals": 72,
      "Protective": 49,
      "Mechanical": 78,
      "Industrial": 80,
      "Business Detail": 70,
      "Selling": 93,
      "Accommodating": 65,
      "Humanitarian": 34,
      "Leading/Influencing": 87,
      "Physical Performing": 55
    },
    "fitScore": 69
  },
  {
    "code": "27-1026.00",
    "aptitudeProfile": {
      "Verbal": 32,
      "Numeric": 15,
      "Spatial": 75,
      "ClericalPerception": 69,
      "FormPerception": 26,
      "GeneralLearning": 24
    },
    "interestProfile": {
      "Artistic": 32,
      "Scientific": 43,
      "Plants/Animals": 17,
      "Protective": 26,
      "Mechanical": 75,
      "Industrial": 14,
      "Business Detail": 30,
      "Selling": 66,
      "Accommodating": 15,
      "Humanitarian": 15,
      "Leading/Influencing": 28,
      "Physical Performing": 21
    },
    "fitScore": 36
  },
  {
    "code": "27-1027.00",
    "aptitudeProfile": {
      "Verbal": 69,
      "Numeric": 63,
      "Spatial": 85,
      "ClericalPerception": 97,
      "FormPerception": 59,
      "GeneralLearning": 58
    },
    "interestProfile": {
      "Artistic": 69,
      "Scientific": 83,
      "Plants/Animals": 61,
      "Protective": 59,
      "Mechanical": 85,
      "Industrial": 79,
      "Business Detail": 49,
      "Selling": 94,
      "Accommodating": 60,
      "Humanitarian": 35,
      "Leading/Influencing": 71,
      "Physical Performing": 57
    },
    "fitScore": 69
  },
  {
    "code": "27-2011.00",
    "aptitudeProfile": {
      "Verbal": 54,
      "Numeric": 4,
      "Spatial": 57,
      "ClericalPerception": 17,
      "FormPerception": 2,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 59,
      "Scientific": 26,
      "Plants/Animals": null,
      "Protective": 2,
      "Mechanical": 57,
      "Industrial": 94,
      "Business Detail": 3,
      "Selling": 67,
      "Accommodating": 14,
      "Humanitarian": 83,
      "Leading/Influencing": 26,
      "Physical Performing": 10
    },
    "fitScore": 32
  },
  {
    "code": "27-2012.00",
    "aptitudeProfile": {
      "Verbal": 82,
      "Numeric": 34,
      "Spatial": 70,
      "ClericalPerception": 92,
      "FormPerception": 81,
      "GeneralLearning": 80
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 87,
      "Plants/Animals": 52,
      "Protective": 81,
      "Mechanical": 70,
      "Industrial": 66,
      "Business Detail": 23,
      "Selling": 89,
      "Accommodating": 72,
      "Humanitarian": 36,
      "Leading/Influencing": 58,
      "Physical Performing": 24
    },
    "fitScore": 68
  },
  {
    "code": "27-2012.03",
    "aptitudeProfile": {
      "Verbal": 89,
      "Numeric": 41,
      "Spatial": 65,
      "ClericalPerception": 76,
      "FormPerception": 26,
      "GeneralLearning": 69
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 84,
      "Plants/Animals": 47,
      "Protective": 26,
      "Mechanical": 65,
      "Industrial": 51,
      "Business Detail": 81,
      "Selling": 93,
      "Accommodating": 47,
      "Humanitarian": 89,
      "Leading/Influencing": 65,
      "Physical Performing": 68
    },
    "fitScore": 64
  },
  {
    "code": "27-2012.04",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 21,
      "Spatial": 64,
      "ClericalPerception": 42,
      "FormPerception": 12,
      "GeneralLearning": 65
    },
    "interestProfile": {
      "Artistic": 74,
      "Scientific": 71,
      "Plants/Animals": 35,
      "Protective": 12,
      "Mechanical": 64,
      "Industrial": 42,
      "Business Detail": 35,
      "Selling": 74,
      "Accommodating": 26,
      "Humanitarian": 84,
      "Leading/Influencing": 49,
      "Physical Performing": 21
    },
    "fitScore": 48
  },
  {
    "code": "27-2012.05",
    "aptitudeProfile": {
      "Verbal": 71,
      "Numeric": 19,
      "Spatial": 34,
      "ClericalPerception": 91,
      "FormPerception": 84,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 71,
      "Scientific": 82,
      "Plants/Animals": 19,
      "Protective": 84,
      "Mechanical": 34,
      "Industrial": 41,
      "Business Detail": 36,
      "Selling": 81,
      "Accommodating": 38,
      "Humanitarian": 21,
      "Leading/Influencing": 46,
      "Physical Performing": 32
    },
    "fitScore": 56
  },
  {
    "code": "27-2021.00",
    "aptitudeProfile": {
      "Verbal": 46,
      "Numeric": 23,
      "Spatial": 38,
      "ClericalPerception": 53,
      "FormPerception": 44,
      "GeneralLearning": 38
    },
    "interestProfile": {
      "Artistic": 39,
      "Scientific": 42,
      "Plants/Animals": 17,
      "Protective": 44,
      "Mechanical": 38,
      "Industrial": 18,
      "Business Detail": 70,
      "Selling": 58,
      "Accommodating": 20,
      "Humanitarian": 17,
      "Leading/Influencing": 53,
      "Physical Performing": 55
    },
    "fitScore": 40
  },
  {
    "code": "27-2022.00",
    "aptitudeProfile": {
      "Verbal": 81,
      "Numeric": 25,
      "Spatial": 60,
      "ClericalPerception": 86,
      "FormPerception": 57,
      "GeneralLearning": 75
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 85,
      "Plants/Animals": 22,
      "Protective": 57,
      "Mechanical": 60,
      "Industrial": 50,
      "Business Detail": 59,
      "Selling": 89,
      "Accommodating": 42,
      "Humanitarian": 33,
      "Leading/Influencing": 52,
      "Physical Performing": 52
    },
    "fitScore": 60
  },
  {
    "code": "27-2023.00",
    "aptitudeProfile": {
      "Verbal": 30,
      "Numeric": 20,
      "Spatial": 46,
      "ClericalPerception": 18,
      "FormPerception": 82,
      "GeneralLearning": 24
    },
    "interestProfile": {
      "Artistic": 33,
      "Scientific": 12,
      "Plants/Animals": 20,
      "Protective": 82,
      "Mechanical": 46,
      "Industrial": 28,
      "Business Detail": 15,
      "Selling": 13,
      "Accommodating": 39,
      "Humanitarian": 26,
      "Leading/Influencing": 37,
      "Physical Performing": 16
    },
    "fitScore": 34
  },
  {
    "code": "27-2031.00",
    "aptitudeProfile": {
      "Verbal": 9,
      "Numeric": 3,
      "Spatial": 30,
      "ClericalPerception": 30,
      "FormPerception": 20,
      "GeneralLearning": 4
    },
    "interestProfile": {
      "Artistic": 13,
      "Scientific": 11,
      "Plants/Animals": 2,
      "Protective": 20,
      "Mechanical": 30,
      "Industrial": 3,
      "Business Detail": 6,
      "Selling": 39,
      "Accommodating": 4,
      "Humanitarian": 12,
      "Leading/Influencing": 1,
      "Physical Performing": 16
    },
    "fitScore": 15
  },
  {
    "code": "27-2032.00",
    "aptitudeProfile": {
      "Verbal": 56,
      "Numeric": 7,
      "Spatial": 93,
      "ClericalPerception": 87,
      "FormPerception": 26,
      "GeneralLearning": 46
    },
    "interestProfile": {
      "Artistic": 52,
      "Scientific": 73,
      "Plants/Animals": 14,
      "Protective": 26,
      "Mechanical": 93,
      "Industrial": 15,
      "Business Detail": 20,
      "Selling": 88,
      "Accommodating": 16,
      "Humanitarian": 43,
      "Leading/Influencing": 22,
      "Physical Performing": 12
    },
    "fitScore": 46
  },
  {
    "code": "27-2041.00",
    "aptitudeProfile": {
      "Verbal": 51,
      "Numeric": 15,
      "Spatial": 7,
      "ClericalPerception": 88,
      "FormPerception": 60,
      "GeneralLearning": 44
    },
    "interestProfile": {
      "Artistic": 56,
      "Scientific": 69,
      "Plants/Animals": 24,
      "Protective": 60,
      "Mechanical": 7,
      "Industrial": 30,
      "Business Detail": 11,
      "Selling": 81,
      "Accommodating": 38,
      "Humanitarian": 16,
      "Leading/Influencing": 22,
      "Physical Performing": 10
    },
    "fitScore": 40
  },
  {
    "code": "27-2042.00",
    "aptitudeProfile": {
      "Verbal": 32,
      "Numeric": 11,
      "Spatial": 68,
      "ClericalPerception": 65,
      "FormPerception": 67,
      "GeneralLearning": 11
    },
    "interestProfile": {
      "Artistic": 48,
      "Scientific": 23,
      "Plants/Animals": 19,
      "Protective": 67,
      "Mechanical": 68,
      "Industrial": 13,
      "Business Detail": 4,
      "Selling": 61,
      "Accommodating": 35,
      "Humanitarian": 45,
      "Leading/Influencing": 5,
      "Physical Performing": 15
    },
    "fitScore": 38
  },
  {
    "code": "27-3011.00",
    "aptitudeProfile": {
      "Verbal": 81,
      "Numeric": 11,
      "Spatial": 3,
      "ClericalPerception": 42,
      "FormPerception": 2,
      "GeneralLearning": 45
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 61,
      "Plants/Animals": 6,
      "Protective": 2,
      "Mechanical": 3,
      "Industrial": 37,
      "Business Detail": 35,
      "Selling": 79,
      "Accommodating": 3,
      "Humanitarian": 28,
      "Leading/Influencing": 19,
      "Physical Performing": 43
    },
    "fitScore": 32
  },
  {
    "code": "27-3023.00",
    "aptitudeProfile": {
      "Verbal": 66,
      "Numeric": 17,
      "Spatial": 30,
      "ClericalPerception": 54,
      "FormPerception": 38,
      "GeneralLearning": 42
    },
    "interestProfile": {
      "Artistic": 69,
      "Scientific": 54,
      "Plants/Animals": 19,
      "Protective": 38,
      "Mechanical": 30,
      "Industrial": 41,
      "Business Detail": 22,
      "Selling": 70,
      "Accommodating": 25,
      "Humanitarian": 85,
      "Leading/Influencing": 19,
      "Physical Performing": 29
    },
    "fitScore": 42
  },
  {
    "code": "27-3031.00",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 17,
      "Spatial": 57,
      "ClericalPerception": 54,
      "FormPerception": 3,
      "GeneralLearning": 72
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 84,
      "Plants/Animals": 20,
      "Protective": 3,
      "Mechanical": 57,
      "Industrial": 47,
      "Business Detail": 57,
      "Selling": 93,
      "Accommodating": 11,
      "Humanitarian": 87,
      "Leading/Influencing": 66,
      "Physical Performing": 37
    },
    "fitScore": 51
  },
  {
    "code": "27-3041.00",
    "aptitudeProfile": {
      "Verbal": 95,
      "Numeric": 18,
      "Spatial": 81,
      "ClericalPerception": 95,
      "FormPerception": 72,
      "GeneralLearning": 51
    },
    "interestProfile": {
      "Artistic": 93,
      "Scientific": 76,
      "Plants/Animals": 19,
      "Protective": 72,
      "Mechanical": 81,
      "Industrial": 82,
      "Business Detail": 33,
      "Selling": 92,
      "Accommodating": 40,
      "Humanitarian": 99,
      "Leading/Influencing": 48,
      "Physical Performing": 28
    },
    "fitScore": 66
  },
  {
    "code": "27-3042.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 11,
      "Spatial": 88,
      "ClericalPerception": 20,
      "FormPerception": 3,
      "GeneralLearning": 57
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 59,
      "Plants/Animals": 7,
      "Protective": 3,
      "Mechanical": 88,
      "Industrial": 36,
      "Business Detail": 55,
      "Selling": 63,
      "Accommodating": 4,
      "Humanitarian": 93,
      "Leading/Influencing": 19,
      "Physical Performing": 51
    },
    "fitScore": 45
  },
  {
    "code": "27-3043.00",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 55,
      "Spatial": 40,
      "ClericalPerception": 56,
      "FormPerception": 4,
      "GeneralLearning": 28
    },
    "interestProfile": {
      "Artistic": 87,
      "Scientific": 60,
      "Plants/Animals": null,
      "Protective": 4,
      "Mechanical": 40,
      "Industrial": 98,
      "Business Detail": 23,
      "Selling": 91,
      "Accommodating": 30,
      "Humanitarian": 90,
      "Leading/Influencing": 32,
      "Physical Performing": 46
    },
    "fitScore": 49
  },
  {
    "code": "27-3043.05",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 3,
      "Spatial": 53,
      "ClericalPerception": 70,
      "FormPerception": 6,
      "GeneralLearning": 37
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 75,
      "Plants/Animals": 7,
      "Protective": 6,
      "Mechanical": 53,
      "Industrial": 43,
      "Business Detail": 2,
      "Selling": 94,
      "Accommodating": 12,
      "Humanitarian": 94,
      "Leading/Influencing": 7,
      "Physical Performing": 4
    },
    "fitScore": 41
  },
  {
    "code": "27-3091.00",
    "aptitudeProfile": {
      "Verbal": 72,
      "Numeric": 12,
      "Spatial": 60,
      "ClericalPerception": 60,
      "FormPerception": 54,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 84,
      "Scientific": 31,
      "Plants/Animals": 10,
      "Protective": 54,
      "Mechanical": 60,
      "Industrial": 38,
      "Business Detail": 8,
      "Selling": 71,
      "Accommodating": 19,
      "Humanitarian": 84,
      "Leading/Influencing": 7,
      "Physical Performing": 37
    },
    "fitScore": 44
  },
  {
    "code": "27-3092.00",
    "aptitudeProfile": {
      "Verbal": 64,
      "Numeric": 4,
      "Spatial": 5,
      "ClericalPerception": 2,
      "FormPerception": 5,
      "GeneralLearning": 7
    },
    "interestProfile": {
      "Artistic": 75,
      "Scientific": 4,
      "Plants/Animals": 9,
      "Protective": 5,
      "Mechanical": 5,
      "Industrial": 9,
      "Business Detail": 45,
      "Selling": 20,
      "Accommodating": 4,
      "Humanitarian": 53,
      "Leading/Influencing": 12,
      "Physical Performing": 89
    },
    "fitScore": 21
  },
  {
    "code": "27-4011.00",
    "aptitudeProfile": {
      "Verbal": 56,
      "Numeric": 25,
      "Spatial": 21,
      "ClericalPerception": 60,
      "FormPerception": 72,
      "GeneralLearning": 40
    },
    "interestProfile": {
      "Artistic": 56,
      "Scientific": 43,
      "Plants/Animals": 25,
      "Protective": 72,
      "Mechanical": 21,
      "Industrial": 31,
      "Business Detail": 45,
      "Selling": 50,
      "Accommodating": 40,
      "Humanitarian": 14,
      "Leading/Influencing": 33,
      "Physical Performing": 40
    },
    "fitScore": 42
  },
  {
    "code": "27-4012.00",
    "aptitudeProfile": {
      "Verbal": 30,
      "Numeric": 40,
      "Spatial": 27,
      "ClericalPerception": 68,
      "FormPerception": 73,
      "GeneralLearning": 31
    },
    "interestProfile": {
      "Artistic": 40,
      "Scientific": 39,
      "Plants/Animals": 33,
      "Protective": 73,
      "Mechanical": 27,
      "Industrial": 47,
      "Business Detail": 15,
      "Selling": 50,
      "Accommodating": 56,
      "Humanitarian": 13,
      "Leading/Influencing": 28,
      "Physical Performing": 33
    },
    "fitScore": 41
  },
  {
    "code": "27-4014.00",
    "aptitudeProfile": {
      "Verbal": 53,
      "Numeric": 25,
      "Spatial": 20,
      "ClericalPerception": 81,
      "FormPerception": 63,
      "GeneralLearning": 28
    },
    "interestProfile": {
      "Artistic": 53,
      "Scientific": 46,
      "Plants/Animals": 24,
      "Protective": 63,
      "Mechanical": 20,
      "Industrial": 30,
      "Business Detail": 42,
      "Selling": 68,
      "Accommodating": 31,
      "Humanitarian": 12,
      "Leading/Influencing": 39,
      "Physical Performing": 35
    },
    "fitScore": 42
  },
  {
    "code": "27-4021.00",
    "aptitudeProfile": {
      "Verbal": 50,
      "Numeric": 15,
      "Spatial": 74,
      "ClericalPerception": 70,
      "FormPerception": 52,
      "GeneralLearning": 24
    },
    "interestProfile": {
      "Artistic": 41,
      "Scientific": 43,
      "Plants/Animals": 15,
      "Protective": 52,
      "Mechanical": 74,
      "Industrial": 18,
      "Business Detail": 55,
      "Selling": 65,
      "Accommodating": 28,
      "Humanitarian": 16,
      "Leading/Influencing": 59,
      "Physical Performing": 21
    },
    "fitScore": 44
  },
  {
    "code": "27-4031.00",
    "aptitudeProfile": {
      "Verbal": 22,
      "Numeric": 17,
      "Spatial": 79,
      "ClericalPerception": 69,
      "FormPerception": 72,
      "GeneralLearning": 26
    },
    "interestProfile": {
      "Artistic": 26,
      "Scientific": 39,
      "Plants/Animals": 17,
      "Protective": 72,
      "Mechanical": 79,
      "Industrial": 22,
      "Business Detail": 12,
      "Selling": 53,
      "Accommodating": 38,
      "Humanitarian": 24,
      "Leading/Influencing": 10,
      "Physical Performing": 20
    },
    "fitScore": 41
  },
  {
    "code": "27-4032.00",
    "aptitudeProfile": {
      "Verbal": 57,
      "Numeric": 13,
      "Spatial": 99,
      "ClericalPerception": 92,
      "FormPerception": 75,
      "GeneralLearning": 36
    },
    "interestProfile": {
      "Artistic": 58,
      "Scientific": 59,
      "Plants/Animals": 17,
      "Protective": 75,
      "Mechanical": 99,
      "Industrial": 24,
      "Business Detail": 24,
      "Selling": 81,
      "Accommodating": 33,
      "Humanitarian": 65,
      "Leading/Influencing": 30,
      "Physical Performing": 20
    },
    "fitScore": 55
  },
  {
    "code": "29-1011.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 37,
      "Spatial": 81,
      "ClericalPerception": 60,
      "FormPerception": 65,
      "GeneralLearning": 88
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 81,
      "Plants/Animals": 41,
      "Protective": 65,
      "Mechanical": 81,
      "Industrial": 62,
      "Business Detail": 62,
      "Selling": 70,
      "Accommodating": 57,
      "Humanitarian": 87,
      "Leading/Influencing": 71,
      "Physical Performing": 49
    },
    "fitScore": 68
  },
  {
    "code": "29-1021.00",
    "aptitudeProfile": {
      "Verbal": 77,
      "Numeric": 55,
      "Spatial": 55,
      "ClericalPerception": 82,
      "FormPerception": 87,
      "GeneralLearning": 95
    },
    "interestProfile": {
      "Artistic": 74,
      "Scientific": 92,
      "Plants/Animals": 77,
      "Protective": 87,
      "Mechanical": 55,
      "Industrial": 80,
      "Business Detail": 29,
      "Selling": 82,
      "Accommodating": 88,
      "Humanitarian": 42,
      "Leading/Influencing": 67,
      "Physical Performing": 35
    },
    "fitScore": 71
  },
  {
    "code": "29-1022.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 61,
      "Spatial": 98,
      "ClericalPerception": 80,
      "FormPerception": 87,
      "GeneralLearning": 92
    },
    "interestProfile": {
      "Artistic": 80,
      "Scientific": 88,
      "Plants/Animals": 71,
      "Protective": 87,
      "Mechanical": 98,
      "Industrial": 77,
      "Business Detail": 65,
      "Selling": 79,
      "Accommodating": 82,
      "Humanitarian": 93,
      "Leading/Influencing": 71,
      "Physical Performing": 66
    },
    "fitScore": 82
  },
  {
    "code": "29-1023.00",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 46,
      "Spatial": 94,
      "ClericalPerception": 69,
      "FormPerception": 48,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 83,
      "Plants/Animals": 50,
      "Protective": 48,
      "Mechanical": 94,
      "Industrial": 52,
      "Business Detail": 60,
      "Selling": 75,
      "Accommodating": 48,
      "Humanitarian": 85,
      "Leading/Influencing": 43,
      "Physical Performing": 65
    },
    "fitScore": 68
  },
  {
    "code": "29-1024.00",
    "aptitudeProfile": {
      "Verbal": 67,
      "Numeric": 24,
      "Spatial": 36,
      "ClericalPerception": 68,
      "FormPerception": 57,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 65,
      "Scientific": 81,
      "Plants/Animals": 41,
      "Protective": 57,
      "Mechanical": 36,
      "Industrial": 40,
      "Business Detail": 28,
      "Selling": 71,
      "Accommodating": 60,
      "Humanitarian": 19,
      "Leading/Influencing": 47,
      "Physical Performing": 21
    },
    "fitScore": 52
  },
  {
    "code": "29-1031.00",
    "aptitudeProfile": {
      "Verbal": 81,
      "Numeric": 79,
      "Spatial": 49,
      "ClericalPerception": 70,
      "FormPerception": 51,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 83,
      "Plants/Animals": 79,
      "Protective": 51,
      "Mechanical": 49,
      "Industrial": 84,
      "Business Detail": 68,
      "Selling": 77,
      "Accommodating": 70,
      "Humanitarian": 91,
      "Leading/Influencing": 63,
      "Physical Performing": 85
    },
    "fitScore": 71
  },
  {
    "code": "29-1041.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 77,
      "Spatial": 86,
      "ClericalPerception": 77,
      "FormPerception": 96,
      "GeneralLearning": 91
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 86,
      "Plants/Animals": 76,
      "Protective": 96,
      "Mechanical": 86,
      "Industrial": 86,
      "Business Detail": 85,
      "Selling": 75,
      "Accommodating": 93,
      "Humanitarian": 93,
      "Leading/Influencing": 84,
      "Physical Performing": 84
    },
    "fitScore": 86
  },
  {
    "code": "29-1051.00",
    "aptitudeProfile": {
      "Verbal": 81,
      "Numeric": 92,
      "Spatial": 32,
      "ClericalPerception": 77,
      "FormPerception": 66,
      "GeneralLearning": 82
    },
    "interestProfile": {
      "Artistic": 87,
      "Scientific": 78,
      "Plants/Animals": 89,
      "Protective": 66,
      "Mechanical": 32,
      "Industrial": 88,
      "Business Detail": 79,
      "Selling": 78,
      "Accommodating": 77,
      "Humanitarian": 91,
      "Leading/Influencing": 60,
      "Physical Performing": 97
    },
    "fitScore": 74
  },
  {
    "code": "29-1071.00",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 73,
      "Spatial": 79,
      "ClericalPerception": 68,
      "FormPerception": 80,
      "GeneralLearning": 93
    },
    "interestProfile": {
      "Artistic": 84,
      "Scientific": 86,
      "Plants/Animals": 73,
      "Protective": 80,
      "Mechanical": 79,
      "Industrial": 85,
      "Business Detail": 50,
      "Selling": 76,
      "Accommodating": 82,
      "Humanitarian": 93,
      "Leading/Influencing": 55,
      "Physical Performing": 81
    },
    "fitScore": 78
  },
  {
    "code": "29-1071.01",
    "aptitudeProfile": {
      "Verbal": 52,
      "Numeric": 73,
      "Spatial": 81,
      "ClericalPerception": 86,
      "FormPerception": 96,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 69,
      "Scientific": 68,
      "Plants/Animals": 75,
      "Protective": 96,
      "Mechanical": 81,
      "Industrial": 72,
      "Business Detail": 23,
      "Selling": 59,
      "Accommodating": 82,
      "Humanitarian": 82,
      "Leading/Influencing": 18,
      "Physical Performing": 78
    },
    "fitScore": 72
  },
  {
    "code": "29-1081.00",
    "aptitudeProfile": {
      "Verbal": 90,
      "Numeric": 60,
      "Spatial": 93,
      "ClericalPerception": 79,
      "FormPerception": 90,
      "GeneralLearning": 96
    },
    "interestProfile": {
      "Artistic": 88,
      "Scientific": 92,
      "Plants/Animals": 70,
      "Protective": 90,
      "Mechanical": 93,
      "Industrial": 83,
      "Business Detail": 62,
      "Selling": 81,
      "Accommodating": 88,
      "Humanitarian": 93,
      "Leading/Influencing": 85,
      "Physical Performing": 53
    },
    "fitScore": 83
  },
  {
    "code": "29-1122.00",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 22,
      "Spatial": 79,
      "ClericalPerception": 88,
      "FormPerception": 47,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 90,
      "Plants/Animals": 30,
      "Protective": 47,
      "Mechanical": 79,
      "Industrial": 47,
      "Business Detail": 23,
      "Selling": 86,
      "Accommodating": 28,
      "Humanitarian": 87,
      "Leading/Influencing": 26,
      "Physical Performing": 27
    },
    "fitScore": 60
  },
  {
    "code": "29-1122.01",
    "aptitudeProfile": {
      "Verbal": 66,
      "Numeric": 18,
      "Spatial": 38,
      "ClericalPerception": 77,
      "FormPerception": 52,
      "GeneralLearning": 58
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 68,
      "Plants/Animals": 30,
      "Protective": 52,
      "Mechanical": 38,
      "Industrial": 46,
      "Business Detail": 4,
      "Selling": 78,
      "Accommodating": 46,
      "Humanitarian": 38,
      "Leading/Influencing": 10,
      "Physical Performing": 17
    },
    "fitScore": 47
  },
  {
    "code": "29-1123.00",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 42,
      "Spatial": 81,
      "ClericalPerception": 70,
      "FormPerception": 54,
      "GeneralLearning": 82
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 79,
      "Plants/Animals": 58,
      "Protective": 54,
      "Mechanical": 81,
      "Industrial": 57,
      "Business Detail": 40,
      "Selling": 73,
      "Accommodating": 52,
      "Humanitarian": 89,
      "Leading/Influencing": 41,
      "Physical Performing": 44
    },
    "fitScore": 65
  },
  {
    "code": "29-1124.00",
    "aptitudeProfile": {
      "Verbal": 61,
      "Numeric": 68,
      "Spatial": 38,
      "ClericalPerception": 61,
      "FormPerception": 61,
      "GeneralLearning": 45
    },
    "interestProfile": {
      "Artistic": 66,
      "Scientific": 49,
      "Plants/Animals": 64,
      "Protective": 61,
      "Mechanical": 38,
      "Industrial": 67,
      "Business Detail": 58,
      "Selling": 63,
      "Accommodating": 63,
      "Humanitarian": 30,
      "Leading/Influencing": 47,
      "Physical Performing": 77
    },
    "fitScore": 56
  },
  {
    "code": "29-1125.00",
    "aptitudeProfile": {
      "Verbal": 77,
      "Numeric": 13,
      "Spatial": 21,
      "ClericalPerception": 62,
      "FormPerception": 52,
      "GeneralLearning": 77
    },
    "interestProfile": {
      "Artistic": 75,
      "Scientific": 74,
      "Plants/Animals": 17,
      "Protective": 52,
      "Mechanical": 21,
      "Industrial": 43,
      "Business Detail": 30,
      "Selling": 70,
      "Accommodating": 27,
      "Humanitarian": 33,
      "Leading/Influencing": 45,
      "Physical Performing": 21
    },
    "fitScore": 46
  },
  {
    "code": "29-1126.00",
    "aptitudeProfile": {
      "Verbal": 50,
      "Numeric": 64,
      "Spatial": 7,
      "ClericalPerception": 69,
      "FormPerception": 74,
      "GeneralLearning": 81
    },
    "interestProfile": {
      "Artistic": 64,
      "Scientific": 71,
      "Plants/Animals": 69,
      "Protective": 74,
      "Mechanical": 7,
      "Industrial": 64,
      "Business Detail": 19,
      "Selling": 53,
      "Accommodating": 65,
      "Humanitarian": 19,
      "Leading/Influencing": 22,
      "Physical Performing": 57
    },
    "fitScore": 53
  },
  {
    "code": "29-1127.00",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 34,
      "Spatial": 51,
      "ClericalPerception": 96,
      "FormPerception": 85,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 93,
      "Scientific": 92,
      "Plants/Animals": 51,
      "Protective": 85,
      "Mechanical": 51,
      "Industrial": 60,
      "Business Detail": 16,
      "Selling": 97,
      "Accommodating": 76,
      "Humanitarian": 94,
      "Leading/Influencing": 14,
      "Physical Performing": 61
    },
    "fitScore": 70
  },
  {
    "code": "29-1128.00",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 61,
      "Spatial": 70,
      "ClericalPerception": 63,
      "FormPerception": 52,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 83,
      "Plants/Animals": 63,
      "Protective": 52,
      "Mechanical": 70,
      "Industrial": 80,
      "Business Detail": 40,
      "Selling": 75,
      "Accommodating": 65,
      "Humanitarian": 90,
      "Leading/Influencing": 53,
      "Physical Performing": 63
    },
    "fitScore": 68
  },
  {
    "code": "29-1129.01",
    "aptitudeProfile": {
      "Verbal": 73,
      "Numeric": 14,
      "Spatial": 86,
      "ClericalPerception": 62,
      "FormPerception": 18,
      "GeneralLearning": 80
    },
    "interestProfile": {
      "Artistic": 78,
      "Scientific": 88,
      "Plants/Animals": 22,
      "Protective": 18,
      "Mechanical": 86,
      "Industrial": 48,
      "Business Detail": 8,
      "Selling": 90,
      "Accommodating": 29,
      "Humanitarian": 84,
      "Leading/Influencing": 25,
      "Physical Performing": 14
    },
    "fitScore": 52
  },
  {
    "code": "29-1129.02",
    "aptitudeProfile": {
      "Verbal": 71,
      "Numeric": 13,
      "Spatial": 61,
      "ClericalPerception": 88,
      "FormPerception": 52,
      "GeneralLearning": 80
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 88,
      "Plants/Animals": 17,
      "Protective": 52,
      "Mechanical": 61,
      "Industrial": 44,
      "Business Detail": 11,
      "Selling": 88,
      "Accommodating": 27,
      "Humanitarian": 87,
      "Leading/Influencing": 15,
      "Physical Performing": 21
    },
    "fitScore": 55
  },
  {
    "code": "29-1131.00",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 81,
      "Spatial": 81,
      "ClericalPerception": 52,
      "FormPerception": 61,
      "GeneralLearning": 90
    },
    "interestProfile": {
      "Artistic": 80,
      "Scientific": 83,
      "Plants/Animals": 79,
      "Protective": 61,
      "Mechanical": 81,
      "Industrial": 88,
      "Business Detail": 80,
      "Selling": 72,
      "Accommodating": 83,
      "Humanitarian": 93,
      "Leading/Influencing": 80,
      "Physical Performing": 86
    },
    "fitScore": 78
  },
  {
    "code": "29-1141.00",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 73,
      "Spatial": 22,
      "ClericalPerception": 77,
      "FormPerception": 84,
      "GeneralLearning": 91
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 85,
      "Plants/Animals": 76,
      "Protective": 84,
      "Mechanical": 22,
      "Industrial": 76,
      "Business Detail": 65,
      "Selling": 74,
      "Accommodating": 82,
      "Humanitarian": 24,
      "Leading/Influencing": 69,
      "Physical Performing": 75
    },
    "fitScore": 69
  },
  {
    "code": "29-1141.01",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 60,
      "Spatial": 64,
      "ClericalPerception": 65,
      "FormPerception": 59,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 78,
      "Plants/Animals": 53,
      "Protective": 59,
      "Mechanical": 64,
      "Industrial": 76,
      "Business Detail": 55,
      "Selling": 68,
      "Accommodating": 57,
      "Humanitarian": 90,
      "Leading/Influencing": 52,
      "Physical Performing": 74
    },
    "fitScore": 67
  },
  {
    "code": "29-1141.02",
    "aptitudeProfile": {
      "Verbal": 85,
      "Numeric": 60,
      "Spatial": 44,
      "ClericalPerception": 77,
      "FormPerception": 63,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 87,
      "Plants/Animals": 58,
      "Protective": 63,
      "Mechanical": 44,
      "Industrial": 74,
      "Business Detail": 65,
      "Selling": 85,
      "Accommodating": 59,
      "Humanitarian": 88,
      "Leading/Influencing": 64,
      "Physical Performing": 77
    },
    "fitScore": 70
  },
  {
    "code": "29-1141.03",
    "aptitudeProfile": {
      "Verbal": 75,
      "Numeric": 75,
      "Spatial": 79,
      "ClericalPerception": 98,
      "FormPerception": 100,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 86,
      "Plants/Animals": 70,
      "Protective": 100,
      "Mechanical": 79,
      "Industrial": 76,
      "Business Detail": 71,
      "Selling": 85,
      "Accommodating": 92,
      "Humanitarian": 87,
      "Leading/Influencing": 60,
      "Physical Performing": 88
    },
    "fitScore": 83
  },
  {
    "code": "29-1141.04",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 76,
      "Spatial": 53,
      "ClericalPerception": 83,
      "FormPerception": 76,
      "GeneralLearning": 90
    },
    "interestProfile": {
      "Artistic": 84,
      "Scientific": 88,
      "Plants/Animals": 77,
      "Protective": 76,
      "Mechanical": 53,
      "Industrial": 82,
      "Business Detail": 81,
      "Selling": 84,
      "Accommodating": 79,
      "Humanitarian": 91,
      "Leading/Influencing": 81,
      "Physical Performing": 83
    },
    "fitScore": 79
  },
  {
    "code": "29-1151.00",
    "aptitudeProfile": {
      "Verbal": 84,
      "Numeric": 89,
      "Spatial": 91,
      "ClericalPerception": 94,
      "FormPerception": 88,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 84,
      "Scientific": 87,
      "Plants/Animals": 82,
      "Protective": 88,
      "Mechanical": 91,
      "Industrial": 88,
      "Business Detail": 92,
      "Selling": 87,
      "Accommodating": 82,
      "Humanitarian": 91,
      "Leading/Influencing": 84,
      "Physical Performing": 96
    },
    "fitScore": 88
  },
  {
    "code": "29-1161.00",
    "aptitudeProfile": {
      "Verbal": 82,
      "Numeric": 56,
      "Spatial": 85,
      "ClericalPerception": 77,
      "FormPerception": 75,
      "GeneralLearning": 90
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 84,
      "Plants/Animals": 59,
      "Protective": 75,
      "Mechanical": 85,
      "Industrial": 70,
      "Business Detail": 47,
      "Selling": 77,
      "Accommodating": 65,
      "Humanitarian": 88,
      "Leading/Influencing": 46,
      "Physical Performing": 71
    },
    "fitScore": 74
  },
  {
    "code": "29-1171.00",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 76,
      "Spatial": 79,
      "ClericalPerception": 80,
      "FormPerception": 79,
      "GeneralLearning": 94
    },
    "interestProfile": {
      "Artistic": 87,
      "Scientific": 91,
      "Plants/Animals": 74,
      "Protective": 79,
      "Mechanical": 79,
      "Industrial": 86,
      "Business Detail": 75,
      "Selling": 81,
      "Accommodating": 79,
      "Humanitarian": 93,
      "Leading/Influencing": 75,
      "Physical Performing": 83
    },
    "fitScore": 82
  },
  {
    "code": "29-1181.00",
    "aptitudeProfile": {
      "Verbal": 88,
      "Numeric": 60,
      "Spatial": 53,
      "ClericalPerception": 73,
      "FormPerception": 77,
      "GeneralLearning": 91
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 84,
      "Plants/Animals": 60,
      "Protective": 77,
      "Mechanical": 53,
      "Industrial": 84,
      "Business Detail": 64,
      "Selling": 76,
      "Accommodating": 73,
      "Humanitarian": 94,
      "Leading/Influencing": 78,
      "Physical Performing": 69
    },
    "fitScore": 74
  },
  {
    "code": "29-1211.00",
    "aptitudeProfile": {
      "Verbal": 88,
      "Numeric": 72,
      "Spatial": 64,
      "ClericalPerception": 97,
      "FormPerception": 99,
      "GeneralLearning": 97
    },
    "interestProfile": {
      "Artistic": 91,
      "Scientific": 94,
      "Plants/Animals": 77,
      "Protective": 99,
      "Mechanical": 64,
      "Industrial": 85,
      "Business Detail": 56,
      "Selling": 89,
      "Accommodating": 92,
      "Humanitarian": 91,
      "Leading/Influencing": 73,
      "Physical Performing": 82
    },
    "fitScore": 85
  },
  {
    "code": "29-1213.00",
    "aptitudeProfile": {
      "Verbal": 88,
      "Numeric": 50,
      "Spatial": 72,
      "ClericalPerception": 71,
      "FormPerception": 80,
      "GeneralLearning": 95
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 90,
      "Plants/Animals": 63,
      "Protective": 80,
      "Mechanical": 72,
      "Industrial": 61,
      "Business Detail": 74,
      "Selling": 76,
      "Accommodating": 74,
      "Humanitarian": 89,
      "Leading/Influencing": 73,
      "Physical Performing": 62
    },
    "fitScore": 75
  },
  {
    "code": "29-1215.00",
    "aptitudeProfile": {
      "Verbal": 92,
      "Numeric": 63,
      "Spatial": 47,
      "ClericalPerception": 71,
      "FormPerception": 79,
      "GeneralLearning": 95
    },
    "interestProfile": {
      "Artistic": 97,
      "Scientific": 89,
      "Plants/Animals": 64,
      "Protective": 79,
      "Mechanical": 47,
      "Industrial": 84,
      "Business Detail": 34,
      "Selling": 92,
      "Accommodating": 74,
      "Humanitarian": 95,
      "Leading/Influencing": 35,
      "Physical Performing": 91
    },
    "fitScore": 74
  },
  {
    "code": "29-1216.00",
    "aptitudeProfile": {
      "Verbal": 93,
      "Numeric": 75,
      "Spatial": 79,
      "ClericalPerception": 90,
      "FormPerception": 91,
      "GeneralLearning": 96
    },
    "interestProfile": {
      "Artistic": 90,
      "Scientific": 94,
      "Plants/Animals": 76,
      "Protective": 91,
      "Mechanical": 79,
      "Industrial": 84,
      "Business Detail": 89,
      "Selling": 87,
      "Accommodating": 85,
      "Humanitarian": 94,
      "Leading/Influencing": 89,
      "Physical Performing": 87
    },
    "fitScore": 87
  },
  {
    "code": "29-1217.00",
    "aptitudeProfile": {
      "Verbal": 91,
      "Numeric": 80,
      "Spatial": 98,
      "ClericalPerception": 99,
      "FormPerception": 99,
      "GeneralLearning": 99
    },
    "interestProfile": {
      "Artistic": 91,
      "Scientific": 98,
      "Plants/Animals": 83,
      "Protective": 99,
      "Mechanical": 98,
      "Industrial": 87,
      "Business Detail": 76,
      "Selling": 95,
      "Accommodating": 95,
      "Humanitarian": 95,
      "Leading/Influencing": 73,
      "Physical Performing": 90
    },
    "fitScore": 92
  },
  {
    "code": "29-1218.00",
    "aptitudeProfile": {
      "Verbal": 91,
      "Numeric": 62,
      "Spatial": 72,
      "ClericalPerception": 75,
      "FormPerception": 76,
      "GeneralLearning": 98
    },
    "interestProfile": {
      "Artistic": 91,
      "Scientific": 94,
      "Plants/Animals": 63,
      "Protective": 76,
      "Mechanical": 72,
      "Industrial": 85,
      "Business Detail": 60,
      "Selling": 80,
      "Accommodating": 71,
      "Humanitarian": 96,
      "Leading/Influencing": 65,
      "Physical Performing": 74
    },
    "fitScore": 78
  },
  {
    "code": "29-1221.00",
    "aptitudeProfile": {
      "Verbal": 95,
      "Numeric": 55,
      "Spatial": 30,
      "ClericalPerception": 69,
      "FormPerception": 71,
      "GeneralLearning": 98
    },
    "interestProfile": {
      "Artistic": 97,
      "Scientific": 93,
      "Plants/Animals": 63,
      "Protective": 71,
      "Mechanical": 30,
      "Industrial": 74,
      "Business Detail": 47,
      "Selling": 93,
      "Accommodating": 67,
      "Humanitarian": 94,
      "Leading/Influencing": 45,
      "Physical Performing": 89
    },
    "fitScore": 71
  },
  {
    "code": "29-1222.00",
    "aptitudeProfile": {
      "Verbal": 92,
      "Numeric": 63,
      "Spatial": 81,
      "ClericalPerception": 75,
      "FormPerception": 94,
      "GeneralLearning": 99
    },
    "interestProfile": {
      "Artistic": 92,
      "Scientific": 96,
      "Plants/Animals": 77,
      "Protective": 94,
      "Mechanical": 81,
      "Industrial": 91,
      "Business Detail": 39,
      "Selling": 85,
      "Accommodating": 93,
      "Humanitarian": 97,
      "Leading/Influencing": 74,
      "Physical Performing": 57
    },
    "fitScore": 83
  },
  {
    "code": "29-1223.00",
    "aptitudeProfile": {
      "Verbal": 92,
      "Numeric": 47,
      "Spatial": 40,
      "ClericalPerception": 76,
      "FormPerception": 64,
      "GeneralLearning": 93
    },
    "interestProfile": {
      "Artistic": 93,
      "Scientific": 92,
      "Plants/Animals": 61,
      "Protective": 64,
      "Mechanical": 40,
      "Industrial": 73,
      "Business Detail": 41,
      "Selling": 93,
      "Accommodating": 75,
      "Humanitarian": 94,
      "Leading/Influencing": 55,
      "Physical Performing": 65
    },
    "fitScore": 70
  },
  {
    "code": "29-1224.00",
    "aptitudeProfile": {
      "Verbal": 91,
      "Numeric": 65,
      "Spatial": 96,
      "ClericalPerception": 87,
      "FormPerception": 99,
      "GeneralLearning": 98
    },
    "interestProfile": {
      "Artistic": 94,
      "Scientific": 93,
      "Plants/Animals": 77,
      "Protective": 99,
      "Mechanical": 96,
      "Industrial": 87,
      "Business Detail": 30,
      "Selling": 82,
      "Accommodating": 95,
      "Humanitarian": 95,
      "Leading/Influencing": 53,
      "Physical Performing": 67
    },
    "fitScore": 85
  },
  {
    "code": "29-1229.01",
    "aptitudeProfile": {
      "Verbal": 92,
      "Numeric": 69,
      "Spatial": 64,
      "ClericalPerception": 94,
      "FormPerception": 81,
      "GeneralLearning": 95
    },
    "interestProfile": {
      "Artistic": 89,
      "Scientific": 96,
      "Plants/Animals": 79,
      "Protective": 81,
      "Mechanical": 64,
      "Industrial": 87,
      "Business Detail": 71,
      "Selling": 94,
      "Accommodating": 84,
      "Humanitarian": 97,
      "Leading/Influencing": 79,
      "Physical Performing": 75
    },
    "fitScore": 83
  },
  {
    "code": "29-1229.02",
    "aptitudeProfile": {
      "Verbal": 90,
      "Numeric": 68,
      "Spatial": 86,
      "ClericalPerception": 82,
      "FormPerception": 91,
      "GeneralLearning": 98
    },
    "interestProfile": {
      "Artistic": 91,
      "Scientific": 94,
      "Plants/Animals": 78,
      "Protective": 91,
      "Mechanical": 86,
      "Industrial": 87,
      "Business Detail": 47,
      "Selling": 85,
      "Accommodating": 89,
      "Humanitarian": 94,
      "Leading/Influencing": 71,
      "Physical Performing": 67
    },
    "fitScore": 84
  },
  {
    "code": "29-1229.03",
    "aptitudeProfile": {
      "Verbal": 96,
      "Numeric": 64,
      "Spatial": 15,
      "ClericalPerception": 87,
      "FormPerception": 89,
      "GeneralLearning": 97
    },
    "interestProfile": {
      "Artistic": 93,
      "Scientific": 94,
      "Plants/Animals": 64,
      "Protective": 89,
      "Mechanical": 15,
      "Industrial": 87,
      "Business Detail": 87,
      "Selling": 88,
      "Accommodating": 80,
      "Humanitarian": 33,
      "Leading/Influencing": 90,
      "Physical Performing": 81
    },
    "fitScore": 75
  },
  {
    "code": "29-1229.04",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 67,
      "Spatial": 94,
      "ClericalPerception": 88,
      "FormPerception": 77,
      "GeneralLearning": 94
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 93,
      "Plants/Animals": 68,
      "Protective": 77,
      "Mechanical": 94,
      "Industrial": 84,
      "Business Detail": 72,
      "Selling": 88,
      "Accommodating": 74,
      "Humanitarian": 92,
      "Leading/Influencing": 83,
      "Physical Performing": 72
    },
    "fitScore": 83
  },
  {
    "code": "29-1229.05",
    "aptitudeProfile": {
      "Verbal": 95,
      "Numeric": 83,
      "Spatial": 92,
      "ClericalPerception": 97,
      "FormPerception": 90,
      "GeneralLearning": 99
    },
    "interestProfile": {
      "Artistic": 93,
      "Scientific": 99,
      "Plants/Animals": 85,
      "Protective": 90,
      "Mechanical": 92,
      "Industrial": 94,
      "Business Detail": 87,
      "Selling": 98,
      "Accommodating": 94,
      "Humanitarian": 97,
      "Leading/Influencing": 91,
      "Physical Performing": 90
    },
    "fitScore": 93
  },
  {
    "code": "29-1229.06",
    "aptitudeProfile": {
      "Verbal": 95,
      "Numeric": 44,
      "Spatial": 96,
      "ClericalPerception": 92,
      "FormPerception": 91,
      "GeneralLearning": 95
    },
    "interestProfile": {
      "Artistic": 94,
      "Scientific": 94,
      "Plants/Animals": 51,
      "Protective": 91,
      "Mechanical": 96,
      "Industrial": 82,
      "Business Detail": 53,
      "Selling": 94,
      "Accommodating": 78,
      "Humanitarian": 97,
      "Leading/Influencing": 70,
      "Physical Performing": 65
    },
    "fitScore": 83
  },
  {
    "code": "29-1241.00",
    "aptitudeProfile": {
      "Verbal": 92,
      "Numeric": 76,
      "Spatial": 42,
      "ClericalPerception": 81,
      "FormPerception": 96,
      "GeneralLearning": 96
    },
    "interestProfile": {
      "Artistic": 90,
      "Scientific": 92,
      "Plants/Animals": 77,
      "Protective": 96,
      "Mechanical": 42,
      "Industrial": 92,
      "Business Detail": 78,
      "Selling": 80,
      "Accommodating": 93,
      "Humanitarian": 51,
      "Leading/Influencing": 87,
      "Physical Performing": 80
    },
    "fitScore": 80
  },
  {
    "code": "29-1291.00",
    "aptitudeProfile": {
      "Verbal": 57,
      "Numeric": 15,
      "Spatial": 79,
      "ClericalPerception": 54,
      "FormPerception": 47,
      "GeneralLearning": 77
    },
    "interestProfile": {
      "Artistic": 57,
      "Scientific": 75,
      "Plants/Animals": 22,
      "Protective": 47,
      "Mechanical": 79,
      "Industrial": 30,
      "Business Detail": 20,
      "Selling": 66,
      "Accommodating": 33,
      "Humanitarian": 68,
      "Leading/Influencing": 35,
      "Physical Performing": 16
    },
    "fitScore": 50
  },
  {
    "code": "29-1292.00",
    "aptitudeProfile": {
      "Verbal": 24,
      "Numeric": 14,
      "Spatial": 81,
      "ClericalPerception": 56,
      "FormPerception": 65,
      "GeneralLearning": 22
    },
    "interestProfile": {
      "Artistic": 41,
      "Scientific": 29,
      "Plants/Animals": 20,
      "Protective": 65,
      "Mechanical": 81,
      "Industrial": 16,
      "Business Detail": 2,
      "Selling": 47,
      "Accommodating": 32,
      "Humanitarian": 45,
      "Leading/Influencing": 3,
      "Physical Performing": 14
    },
    "fitScore": 38
  },
  {
    "code": "29-1299.01",
    "aptitudeProfile": {
      "Verbal": 89,
      "Numeric": 62,
      "Spatial": 79,
      "ClericalPerception": 88,
      "FormPerception": 83,
      "GeneralLearning": 95
    },
    "interestProfile": {
      "Artistic": 85,
      "Scientific": 94,
      "Plants/Animals": 69,
      "Protective": 83,
      "Mechanical": 79,
      "Industrial": 83,
      "Business Detail": 66,
      "Selling": 88,
      "Accommodating": 81,
      "Humanitarian": 95,
      "Leading/Influencing": 75,
      "Physical Performing": 65
    },
    "fitScore": 82
  },
  {
    "code": "29-1299.02",
    "aptitudeProfile": {
      "Verbal": 70,
      "Numeric": 42,
      "Spatial": 81,
      "ClericalPerception": 77,
      "FormPerception": 81,
      "GeneralLearning": 90
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 84,
      "Plants/Animals": 33,
      "Protective": 81,
      "Mechanical": 81,
      "Industrial": 69,
      "Business Detail": 18,
      "Selling": 75,
      "Accommodating": 55,
      "Humanitarian": 81,
      "Leading/Influencing": 29,
      "Physical Performing": 57
    },
    "fitScore": 68
  },
  {
    "code": "29-2011.00",
    "aptitudeProfile": {
      "Verbal": 49,
      "Numeric": 71,
      "Spatial": 86,
      "ClericalPerception": 52,
      "FormPerception": 84,
      "GeneralLearning": 77
    },
    "interestProfile": {
      "Artistic": 54,
      "Scientific": 63,
      "Plants/Animals": 76,
      "Protective": 84,
      "Mechanical": 86,
      "Industrial": 75,
      "Business Detail": 32,
      "Selling": 49,
      "Accommodating": 82,
      "Humanitarian": 81,
      "Leading/Influencing": 42,
      "Physical Performing": 62
    },
    "fitScore": 68
  },
  {
    "code": "29-2011.01",
    "aptitudeProfile": {
      "Verbal": 67,
      "Numeric": 70,
      "Spatial": 81,
      "ClericalPerception": 71,
      "FormPerception": 91,
      "GeneralLearning": 82
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 74,
      "Plants/Animals": 75,
      "Protective": 91,
      "Mechanical": 81,
      "Industrial": 80,
      "Business Detail": 28,
      "Selling": 65,
      "Accommodating": 88,
      "Humanitarian": 87,
      "Leading/Influencing": 40,
      "Physical Performing": 63
    },
    "fitScore": 74
  },
  {
    "code": "29-2011.02",
    "aptitudeProfile": {
      "Verbal": 43,
      "Numeric": 32,
      "Spatial": 75,
      "ClericalPerception": 42,
      "FormPerception": 87,
      "GeneralLearning": 76
    },
    "interestProfile": {
      "Artistic": 51,
      "Scientific": 62,
      "Plants/Animals": 33,
      "Protective": 87,
      "Mechanical": 75,
      "Industrial": 66,
      "Business Detail": 7,
      "Selling": 51,
      "Accommodating": 78,
      "Humanitarian": 83,
      "Leading/Influencing": 20,
      "Physical Performing": 32
    },
    "fitScore": 57
  },
  {
    "code": "29-2011.04",
    "aptitudeProfile": {
      "Verbal": 46,
      "Numeric": 37,
      "Spatial": 72,
      "ClericalPerception": 42,
      "FormPerception": 57,
      "GeneralLearning": 30
    },
    "interestProfile": {
      "Artistic": 49,
      "Scientific": 33,
      "Plants/Animals": 37,
      "Protective": 57,
      "Mechanical": 72,
      "Industrial": 45,
      "Business Detail": 31,
      "Selling": 38,
      "Accommodating": 46,
      "Humanitarian": 70,
      "Leading/Influencing": 32,
      "Physical Performing": 34
    },
    "fitScore": 46
  },
  {
    "code": "29-2012.00",
    "aptitudeProfile": {
      "Verbal": 36,
      "Numeric": 71,
      "Spatial": 79,
      "ClericalPerception": 57,
      "FormPerception": 67,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 47,
      "Scientific": 29,
      "Plants/Animals": 74,
      "Protective": 67,
      "Mechanical": 79,
      "Industrial": 53,
      "Business Detail": 35,
      "Selling": 49,
      "Accommodating": 73,
      "Humanitarian": 66,
      "Leading/Influencing": 22,
      "Physical Performing": 68
    },
    "fitScore": 55
  },
  {
    "code": "29-2031.00",
    "aptitudeProfile": {
      "Verbal": 52,
      "Numeric": 49,
      "Spatial": 68,
      "ClericalPerception": 77,
      "FormPerception": 88,
      "GeneralLearning": 65
    },
    "interestProfile": {
      "Artistic": 61,
      "Scientific": 60,
      "Plants/Animals": 51,
      "Protective": 88,
      "Mechanical": 68,
      "Industrial": 58,
      "Business Detail": 22,
      "Selling": 59,
      "Accommodating": 66,
      "Humanitarian": 77,
      "Leading/Influencing": 26,
      "Physical Performing": 52
    },
    "fitScore": 62
  },
  {
    "code": "29-2032.00",
    "aptitudeProfile": {
      "Verbal": 58,
      "Numeric": 29,
      "Spatial": 86,
      "ClericalPerception": 66,
      "FormPerception": 83,
      "GeneralLearning": 47
    },
    "interestProfile": {
      "Artistic": 68,
      "Scientific": 49,
      "Plants/Animals": 27,
      "Protective": 83,
      "Mechanical": 86,
      "Industrial": 44,
      "Business Detail": 22,
      "Selling": 61,
      "Accommodating": 57,
      "Humanitarian": 80,
      "Leading/Influencing": 14,
      "Physical Performing": 49
    },
    "fitScore": 57
  },
  {
    "code": "29-2033.00",
    "aptitudeProfile": {
      "Verbal": 59,
      "Numeric": 81,
      "Spatial": 81,
      "ClericalPerception": 58,
      "FormPerception": 64,
      "GeneralLearning": 52
    },
    "interestProfile": {
      "Artistic": 66,
      "Scientific": 51,
      "Plants/Animals": 81,
      "Protective": 64,
      "Mechanical": 81,
      "Industrial": 71,
      "Business Detail": 59,
      "Selling": 60,
      "Accommodating": 74,
      "Humanitarian": 72,
      "Leading/Influencing": 58,
      "Physical Performing": 81
    },
    "fitScore": 67
  },
  {
    "code": "29-2034.00",
    "aptitudeProfile": {
      "Verbal": 49,
      "Numeric": 26,
      "Spatial": 48,
      "ClericalPerception": 38,
      "FormPerception": 78,
      "GeneralLearning": 55
    },
    "interestProfile": {
      "Artistic": 53,
      "Scientific": 39,
      "Plants/Animals": 24,
      "Protective": 78,
      "Mechanical": 48,
      "Industrial": 31,
      "Business Detail": 33,
      "Selling": 38,
      "Accommodating": 39,
      "Humanitarian": 27,
      "Leading/Influencing": 20,
      "Physical Performing": 52
    },
    "fitScore": 45
  },
  {
    "code": "29-2035.00",
    "aptitudeProfile": {
      "Verbal": 62,
      "Numeric": 41,
      "Spatial": 81,
      "ClericalPerception": 62,
      "FormPerception": 75,
      "GeneralLearning": 35
    },
    "interestProfile": {
      "Artistic": 70,
      "Scientific": 38,
      "Plants/Animals": 43,
      "Protective": 75,
      "Mechanical": 81,
      "Industrial": 66,
      "Business Detail": 18,
      "Selling": 58,
      "Accommodating": 53,
      "Humanitarian": 84,
      "Leading/Influencing": 29,
      "Physical Performing": 44
    },
    "fitScore": 57
  },
  {
    "code": "29-2036.00",
    "aptitudeProfile": {
      "Verbal": 70,
      "Numeric": 93,
      "Spatial": 93,
      "ClericalPerception": 78,
      "FormPerception": 80,
      "GeneralLearning": 93
    },
    "interestProfile": {
      "Artistic": 81,
      "Scientific": 88,
      "Plants/Animals": 91,
      "Protective": 80,
      "Mechanical": 93,
      "Industrial": 93,
      "Business Detail": 55,
      "Selling": 75,
      "Accommodating": 91,
      "Humanitarian": 91,
      "Leading/Influencing": 51,
      "Physical Performing": 93
    },
    "fitScore": 83
  },
  {
    "code": "29-2051.00",
    "aptitudeProfile": {
      "Verbal": 50,
      "Numeric": 75,
      "Spatial": 14,
      "ClericalPerception": 59,
      "FormPerception": 49,
      "GeneralLearning": 42
    },
    "interestProfile": {
      "Artistic": 41,
      "Scientific": 51,
      "Plants/Animals": 69,
      "Protective": 49,
      "Mechanical": 14,
      "Industrial": 49,
      "Business Detail": 93,
      "Selling": 61,
      "Accommodating": 65,
      "Humanitarian": 9,
      "Leading/Influencing": 89,
      "Physical Performing": 79
    },
    "fitScore": 52
  },
  {
    "code": "29-2052.00",
    "aptitudeProfile": {
      "Verbal": 59,
      "Numeric": 78,
      "Spatial": 19,
      "ClericalPerception": 40,
      "FormPerception": 64,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 62,
      "Scientific": 19,
      "Plants/Animals": 75,
      "Protective": 64,
      "Mechanical": 19,
      "Industrial": 72,
      "Business Detail": 65,
      "Selling": 39,
      "Accommodating": 59,
      "Humanitarian": 77,
      "Leading/Influencing": 60,
      "Physical Performing": 81
    },
    "fitScore": 52
  },
  {
    "code": "29-2053.00",
    "aptitudeProfile": {
      "Verbal": 58,
      "Numeric": 11,
      "Spatial": 5,
      "ClericalPerception": 43,
      "FormPerception": 37,
      "GeneralLearning": 68
    },
    "interestProfile": {
      "Artistic": 63,
      "Scientific": 62,
      "Plants/Animals": 15,
      "Protective": 37,
      "Mechanical": 5,
      "Industrial": 37,
      "Business Detail": 9,
      "Selling": 59,
      "Accommodating": 20,
      "Humanitarian": 21,
      "Leading/Influencing": 16,
      "Physical Performing": 17
    },
    "fitScore": 34
  },
  {
    "code": "29-2055.00",
    "aptitudeProfile": {
      "Verbal": 27,
      "Numeric": 46,
      "Spatial": 86,
      "ClericalPerception": 76,
      "FormPerception": 85,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 33,
      "Scientific": 28,
      "Plants/Animals": 57,
      "Protective": 85,
      "Mechanical": 86,
      "Industrial": 40,
      "Business Detail": 15,
      "Selling": 58,
      "Accommodating": 53,
      "Humanitarian": 49,
      "Leading/Influencing": 30,
      "Physical Performing": 37
    },
    "fitScore": 52
  },
  {
    "code": "29-2056.00",
    "aptitudeProfile": {
      "Verbal": 46,
      "Numeric": 69,
      "Spatial": 72,
      "ClericalPerception": 60,
      "FormPerception": 70,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 53,
      "Scientific": 70,
      "Plants/Animals": 72,
      "Protective": 70,
      "Mechanical": 72,
      "Industrial": 60,
      "Business Detail": 41,
      "Selling": 51,
      "Accommodating": 72,
      "Humanitarian": 74,
      "Leading/Influencing": 34,
      "Physical Performing": 64
    },
    "fitScore": 64
  },
  {
    "code": "29-2057.00",
    "aptitudeProfile": {
      "Verbal": 38,
      "Numeric": 49,
      "Spatial": 25,
      "ClericalPerception": 8,
      "FormPerception": 12,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 52,
      "Scientific": 22,
      "Plants/Animals": 45,
      "Protective": 12,
      "Mechanical": 25,
      "Industrial": 37,
      "Business Detail": 29,
      "Selling": 39,
      "Accommodating": 38,
      "Humanitarian": 53,
      "Leading/Influencing": 21,
      "Physical Performing": 61
    },
    "fitScore": 31
  },
  {
    "code": "29-2061.00",
    "aptitudeProfile": {
      "Verbal": 71,
      "Numeric": 60,
      "Spatial": 64,
      "ClericalPerception": 55,
      "FormPerception": 59,
      "GeneralLearning": 72
    },
    "interestProfile": {
      "Artistic": 69,
      "Scientific": 66,
      "Plants/Animals": 63,
      "Protective": 59,
      "Mechanical": 64,
      "Industrial": 71,
      "Business Detail": 55,
      "Selling": 60,
      "Accommodating": 57,
      "Humanitarian": 81,
      "Leading/Influencing": 71,
      "Physical Performing": 55
    },
    "fitScore": 64
  },
  {
    "code": "29-2081.00",
    "aptitudeProfile": {
      "Verbal": 70,
      "Numeric": 76,
      "Spatial": 79,
      "ClericalPerception": 57,
      "FormPerception": 49,
      "GeneralLearning": 33
    },
    "interestProfile": {
      "Artistic": 66,
      "Scientific": 38,
      "Plants/Animals": 69,
      "Protective": 49,
      "Mechanical": 79,
      "Industrial": 70,
      "Business Detail": 87,
      "Selling": 57,
      "Accommodating": 53,
      "Humanitarian": 80,
      "Leading/Influencing": 78,
      "Physical Performing": 85
    },
    "fitScore": 64
  },
  {
    "code": "29-2091.00",
    "aptitudeProfile": {
      "Verbal": 86,
      "Numeric": 62,
      "Spatial": 60,
      "ClericalPerception": 69,
      "FormPerception": 43,
      "GeneralLearning": 88
    },
    "interestProfile": {
      "Artistic": 82,
      "Scientific": 86,
      "Plants/Animals": 55,
      "Protective": 43,
      "Mechanical": 60,
      "Industrial": 83,
      "Business Detail": 78,
      "Selling": 81,
      "Accommodating": 60,
      "Humanitarian": 27,
      "Leading/Influencing": 89,
      "Physical Performing": 70
    },
    "fitScore": 68
  },
  {
    "code": "29-2092.00",
    "aptitudeProfile": {
      "Verbal": 58,
      "Numeric": 32,
      "Spatial": 79,
      "ClericalPerception": 44,
      "FormPerception": 70,
      "GeneralLearning": 34
    },
    "interestProfile": {
      "Artistic": 53,
      "Scientific": 32,
      "Plants/Animals": 29,
      "Protective": 70,
      "Mechanical": 79,
      "Industrial": 29,
      "Business Detail": 67,
      "Selling": 47,
      "Accommodating": 41,
      "Humanitarian": 56,
      "Leading/Influencing": 62,
      "Physical Performing": 51
    },
    "fitScore": 52
  },
  {
    "code": "29-2099.01",
    "aptitudeProfile": {
      "Verbal": 63,
      "Numeric": 39,
      "Spatial": 79,
      "ClericalPerception": 51,
      "FormPerception": 76,
      "GeneralLearning": 80
    },
    "interestProfile": {
      "Artistic": 64,
      "Scientific": 65,
      "Plants/Animals": 35,
      "Protective": 76,
      "Mechanical": 79,
      "Industrial": 50,
      "Business Detail": 48,
      "Selling": 44,
      "Accommodating": 59,
      "Humanitarian": 81,
      "Leading/Influencing": 34,
      "Physical Performing": 58
    },
    "fitScore": 61
  },
  {
    "code": "29-2099.05",
    "aptitudeProfile": {
      "Verbal": 50,
      "Numeric": 54,
      "Spatial": 51,
      "ClericalPerception": 51,
      "FormPerception": 70,
      "GeneralLearning": 37
    },
    "interestProfile": {
      "Artistic": 57,
      "Scientific": 37,
      "Plants/Animals": 56,
      "Protective": 70,
      "Mechanical": 51,
      "Industrial": 43,
      "Business Detail": 44,
      "Selling": 49,
      "Accommodating": 65,
      "Humanitarian": 56,
      "Leading/Influencing": 45,
      "Physical Performing": 55
    },
    "fitScore": 52
  },
  {
    "code": "29-2099.08",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 24,
      "Spatial": 12,
      "ClericalPerception": 44,
      "FormPerception": 37,
      "GeneralLearning": 62
    },
    "interestProfile": {
      "Artistic": 74,
      "Scientific": 60,
      "Plants/Animals": 25,
      "Protective": 37,
      "Mechanical": 12,
      "Industrial": 42,
      "Business Detail": 51,
      "Selling": 71,
      "Accommodating": 30,
      "Humanitarian": 83,
      "Leading/Influencing": 43,
      "Physical Performing": 52
    },
    "fitScore": 45
  },
  {
    "code": "29-9091.00",
    "aptitudeProfile": {
      "Verbal": 67,
      "Numeric": 17,
      "Spatial": 80,
      "ClericalPerception": 69,
      "FormPerception": 70,
      "GeneralLearning": 76
    },
    "interestProfile": {
      "Artistic": 67,
      "Scientific": 74,
      "Plants/Animals": 17,
      "Protective": 70,
      "Mechanical": 80,
      "Industrial": 43,
      "Business Detail": 29,
      "Selling": 58,
      "Accommodating": 37,
      "Humanitarian": 80,
      "Leading/Influencing": 37,
      "Physical Performing": 20
    },
    "fitScore": 57
  },
  {
    "code": "29-9092.00",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 76,
      "Spatial": 59,
      "ClericalPerception": 68,
      "FormPerception": 65,
      "GeneralLearning": 92
    },
    "interestProfile": {
      "Artistic": 88,
      "Scientific": 86,
      "Plants/Animals": 76,
      "Protective": 65,
      "Mechanical": 59,
      "Industrial": 80,
      "Business Detail": 41,
      "Selling": 75,
      "Accommodating": 79,
      "Humanitarian": 93,
      "Leading/Influencing": 22,
      "Physical Performing": 87
    },
    "fitScore": 72
  },
  {
    "code": "29-9093.00",
    "aptitudeProfile": {
      "Verbal": 53,
      "Numeric": 41,
      "Spatial": 92,
      "ClericalPerception": 77,
      "FormPerception": 90,
      "GeneralLearning": 54
    },
    "interestProfile": {
      "Artistic": 61,
      "Scientific": 51,
      "Plants/Animals": 52,
      "Protective": 90,
      "Mechanical": 92,
      "Industrial": 55,
      "Business Detail": 14,
      "Selling": 61,
      "Accommodating": 61,
      "Humanitarian": 76,
      "Leading/Influencing": 27,
      "Physical Performing": 38
    },
    "fitScore": 62
  },
  {
    "code": "29-9099.01",
    "aptitudeProfile": {
      "Verbal": 68,
      "Numeric": 22,
      "Spatial": 64,
      "ClericalPerception": 69,
      "FormPerception": 72,
      "GeneralLearning": 89
    },
    "interestProfile": {
      "Artistic": 72,
      "Scientific": 83,
      "Plants/Animals": 31,
      "Protective": 72,
      "Mechanical": 64,
      "Industrial": 48,
      "Business Detail": 16,
      "Selling": 69,
      "Accommodating": 47,
      "Humanitarian": 78,
      "Leading/Influencing": 38,
      "Physical Performing": 21
    },
    "fitScore": 59
  },
  {
    "code": "31-1121.00",
    "aptitudeProfile": {
      "Verbal": 31,
      "Numeric": 16,
      "Spatial": 23,
      "ClericalPerception": 39,
      "FormPerception": 34,
      "GeneralLearning": 35
    },
    "interestProfile": {
      "Artistic": 38,
      "Scientific": 41,
      "Plants/Animals": 21,
      "Protective": 34,
      "Mechanical": 23,
      "Industrial": 28,
      "Business Detail": 6,
      "Selling": 52,
      "Accommodating": 27,
      "Humanitarian": 16,
      "Leading/Influencing": 17,
      "Physical Performing": 11
    },
    "fitScore": 28
  },
  {
    "code": "31-1122.00",
    "aptitudeProfile": {
      "Verbal": 31,
      "Numeric": 13,
      "Spatial": 6,
      "ClericalPerception": 7,
      "FormPerception": 7,
      "GeneralLearning": 22
    },
    "interestProfile": {
      "Artistic": 38,
      "Scientific": 18,
      "Plants/Animals": 17,
      "Protective": 7,
      "Mechanical": 6,
      "Industrial": 13,
      "Business Detail": 11,
      "Selling": 29,
      "Accommodating": 9,
      "Humanitarian": 8,
      "Leading/Influencing": 19,
      "Physical Performing": 15
    },
    "fitScore": 15
  },
  {
    "code": "31-1131.00",
    "aptitudeProfile": {
      "Verbal": 39,
      "Numeric": 17,
      "Spatial": 13,
      "ClericalPerception": 3,
      "FormPerception": 5,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 39,
      "Scientific": 14,
      "Plants/Animals": 21,
      "Protective": 5,
      "Mechanical": 13,
      "Industrial": 20,
      "Business Detail": 26,
      "Selling": 24,
      "Accommodating": 10,
      "Humanitarian": 47,
      "Leading/Influencing": 37,
      "Physical Performing": 21
    },
    "fitScore": 20
  },
  {
    "code": "31-1132.00",
    "aptitudeProfile": {
      "Verbal": 8,
      "Numeric": 4,
      "Spatial": 6,
      "ClericalPerception": 2,
      "FormPerception": 3,
      "GeneralLearning": 10
    },
    "interestProfile": {
      "Artistic": 16,
      "Scientific": 8,
      "Plants/Animals": 9,
      "Protective": 3,
      "Mechanical": 6,
      "Industrial": 3,
      "Business Detail": 1,
      "Selling": 12,
      "Accommodating": 3,
      "Humanitarian": 5,
      "Leading/Influencing": 3,
      "Physical Performing": 1
    },
    "fitScore": 6
  },
  {
    "code": "31-1133.00",
    "aptitudeProfile": {
      "Verbal": 39,
      "Numeric": 14,
      "Spatial": 16,
      "ClericalPerception": 58,
      "FormPerception": 64,
      "GeneralLearning": 51
    },
    "interestProfile": {
      "Artistic": 53,
      "Scientific": 50,
      "Plants/Animals": 20,
      "Protective": 64,
      "Mechanical": 16,
      "Industrial": 21,
      "Business Detail": 5,
      "Selling": 53,
      "Accommodating": 31,
      "Humanitarian": 18,
      "Leading/Influencing": 13,
      "Physical Performing": 13
    },
    "fitScore": 35
  },
  {
    "code": "31-2011.00",
    "aptitudeProfile": {
      "Verbal": 62,
      "Numeric": 14,
      "Spatial": 11,
      "ClericalPerception": 59,
      "FormPerception": 28,
      "GeneralLearning": 39
    },
    "interestProfile": {
      "Artistic": 69,
      "Scientific": 48,
      "Plants/Animals": 17,
      "Protective": 28,
      "Mechanical": 11,
      "Industrial": 40,
      "Business Detail": 11,
      "Selling": 69,
      "Accommodating": 14,
      "Humanitarian": 19,
      "Leading/Influencing": 23,
      "Physical Performing": 19
    },
    "fitScore": 33
  },
  {
    "code": "31-2012.00",
    "aptitudeProfile": {
      "Verbal": 30,
      "Numeric": 15,
      "Spatial": 3,
      "ClericalPerception": 16,
      "FormPerception": 10,
      "GeneralLearning": 24
    },
    "interestProfile": {
      "Artistic": 35,
      "Scientific": 28,
      "Plants/Animals": 15,
      "Protective": 10,
      "Mechanical": 3,
      "Industrial": 19,
      "Business Detail": 15,
      "Selling": 44,
      "Accommodating": 12,
      "Humanitarian": 10,
      "Leading/Influencing": 14,
      "Physical Performing": 24
    },
    "fitScore": 18
  },
  {
    "code": "31-2021.00",
    "aptitudeProfile": {
      "Verbal": 53,
      "Numeric": 19,
      "Spatial": 86,
      "ClericalPerception": 66,
      "FormPerception": 52,
      "GeneralLearning": 36
    },
    "interestProfile": {
      "Artistic": 63,
      "Scientific": 43,
      "Plants/Animals": 18,
      "Protective": 52,
      "Mechanical": 86,
      "Industrial": 32,
      "Business Detail": 16,
      "Selling": 64,
      "Accommodating": 21,
      "Humanitarian": 61,
      "Leading/Influencing": 22,
      "Physical Performing": 31
    },
    "fitScore": 47
  },
  {
    "code": "31-2022.00",
    "aptitudeProfile": {
      "Verbal": 15,
      "Numeric": 14,
      "Spatial": 27,
      "ClericalPerception": 10,
      "FormPerception": 28,
      "GeneralLearning": 14
    },
    "interestProfile": {
      "Artistic": 19,
      "Scientific": 11,
      "Plants/Animals": 16,
      "Protective": 28,
      "Mechanical": 27,
      "Industrial": 18,
      "Business Detail": 6,
      "Selling": 12,
      "Accommodating": 15,
      "Humanitarian": 47,
      "Leading/Influencing": 8,
      "Physical Performing": 10
    },
    "fitScore": 18
  },
  {
    "code": "31-9011.00",
    "aptitudeProfile": {
      "Verbal": 29,
      "Numeric": 6,
      "Spatial": 12,
      "ClericalPerception": 8,
      "FormPerception": 2,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 34,
      "Scientific": 26,
      "Plants/Animals": 9,
      "Protective": 2,
      "Mechanical": 12,
      "Industrial": 14,
      "Business Detail": 4,
      "Selling": 39,
      "Accommodating": 6,
      "Humanitarian": 43,
      "Leading/Influencing": 16,
      "Physical Performing": 4
    },
    "fitScore": 15
  },
  {
    "code": "31-9091.00",
    "aptitudeProfile": {
      "Verbal": 53,
      "Numeric": 17,
      "Spatial": 7,
      "ClericalPerception": 41,
      "FormPerception": 21,
      "GeneralLearning": 28
    },
    "interestProfile": {
      "Artistic": 51,
      "Scientific": 31,
      "Plants/Animals": 27,
      "Protective": 21,
      "Mechanical": 7,
      "Industrial": 25,
      "Business Detail": 26,
      "Selling": 50,
      "Accommodating": 12,
      "Humanitarian": 11,
      "Leading/Influencing": 48,
      "Physical Performing": 15
    },
    "fitScore": 27
  },
  {
    "code": "31-9092.00",
    "aptitudeProfile": {
      "Verbal": 67,
      "Numeric": 49,
      "Spatial": 6,
      "ClericalPerception": 52,
      "FormPerception": 68,
      "GeneralLearning": 42
    },
    "interestProfile": {
      "Artistic": 73,
      "Scientific": 41,
      "Plants/Animals": 66,
      "Protective": 68,
      "Mechanical": 6,
      "Industrial": 62,
      "Business Detail": 23,
      "Selling": 55,
      "Accommodating": 65,
      "Humanitarian": 21,
      "Leading/Influencing": 43,
      "Physical Performing": 36
    },
    "fitScore": 47
  },
  {
    "code": "31-9093.00",
    "aptitudeProfile": {
      "Verbal": 21,
      "Numeric": 22,
      "Spatial": 43,
      "ClericalPerception": 24,
      "FormPerception": 73,
      "GeneralLearning": 22
    },
    "interestProfile": {
      "Artistic": 27,
      "Scientific": 13,
      "Plants/Animals": 18,
      "Protective": 73,
      "Mechanical": 43,
      "Industrial": 24,
      "Business Detail": 14,
      "Selling": 14,
      "Accommodating": 27,
      "Humanitarian": 17,
      "Leading/Influencing": 15,
      "Physical Performing": 26
    },
    "fitScore": 30
  },
  {
    "code": "31-9094.00",
    "aptitudeProfile": {
      "Verbal": 66,
      "Numeric": 6,
      "Spatial": 2,
      "ClericalPerception": 11,
      "FormPerception": 56,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 80,
      "Scientific": 9,
      "Plants/Animals": 12,
      "Protective": 56,
      "Mechanical": 2,
      "Industrial": 33,
      "Business Detail": 1,
      "Selling": 31,
      "Accommodating": 18,
      "Humanitarian": 87,
      "Leading/Influencing": 2,
      "Physical Performing": 20
    },
    "fitScore": 28
  },
  {
    "code": "31-9095.00",
    "aptitudeProfile": {
      "Verbal": 33,
      "Numeric": 45,
      "Spatial": 3,
      "ClericalPerception": 7,
      "FormPerception": 22,
      "GeneralLearning": 12
    },
    "interestProfile": {
      "Artistic": 37,
      "Scientific": 7,
      "Plants/Animals": 55,
      "Protective": 22,
      "Mechanical": 3,
      "Industrial": 37,
      "Business Detail": 25,
      "Selling": 19,
      "Accommodating": 32,
      "Humanitarian": 10,
      "Leading/Influencing": 33,
      "Physical Performing": 43
    },
    "fitScore": 24
  },
  {
    "code": "31-9096.00",
    "aptitudeProfile": {
      "Verbal": 21,
      "Numeric": 50,
      "Spatial": 26,
      "ClericalPerception": 11,
      "FormPerception": 40,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 25,
      "Scientific": 16,
      "Plants/Animals": 53,
      "Protective": 40,
      "Mechanical": 26,
      "Industrial": 41,
      "Business Detail": 22,
      "Selling": 15,
      "Accommodating": 53,
      "Humanitarian": 48,
      "Leading/Influencing": 32,
      "Physical Performing": 28
    },
    "fitScore": 31
  },
  {
    "code": "31-9097.00",
    "aptitudeProfile": {
      "Verbal": 38,
      "Numeric": 20,
      "Spatial": 51,
      "ClericalPerception": 35,
      "FormPerception": 70,
      "GeneralLearning": 31
    },
    "interestProfile": {
      "Artistic": 40,
      "Scientific": 26,
      "Plants/Animals": 24,
      "Protective": 70,
      "Mechanical": 51,
      "Industrial": 23,
      "Business Detail": 21,
      "Selling": 25,
      "Accommodating": 41,
      "Humanitarian": 49,
      "Leading/Influencing": 30,
      "Physical Performing": 15
    },
    "fitScore": 38
  },
  {
    "code": "31-9099.01",
    "aptitudeProfile": {
      "Verbal": 62,
      "Numeric": 11,
      "Spatial": 26,
      "ClericalPerception": 54,
      "FormPerception": 46,
      "GeneralLearning": 50
    },
    "interestProfile": {
      "Artistic": 74,
      "Scientific": 53,
      "Plants/Animals": 23,
      "Protective": 46,
      "Mechanical": 26,
      "Industrial": 39,
      "Business Detail": 2,
      "Selling": 64,
      "Accommodating": 28,
      "Humanitarian": 80,
      "Leading/Influencing": 9,
      "Physical Performing": 9
    },
    "fitScore": 40
  },
  {
    "code": "31-9099.02",
    "aptitudeProfile": {
      "Verbal": 49,
      "Numeric": 15,
      "Spatial": 25,
      "ClericalPerception": 40,
      "FormPerception": 64,
      "GeneralLearning": 24
    },
    "interestProfile": {
      "Artistic": 47,
      "Scientific": 23,
      "Plants/Animals": 21,
      "Protective": 64,
      "Mechanical": 25,
      "Industrial": 36,
      "Business Detail": 15,
      "Selling": 35,
      "Accommodating": 32,
      "Humanitarian": 24,
      "Leading/Influencing": 25,
      "Physical Performing": 14
    },
    "fitScore": 33
  },
  {
    "code": "33-1011.00",
    "aptitudeProfile": {
      "Verbal": 80,
      "Numeric": 25,
      "Spatial": 24,
      "ClericalPerception": 71,
      "FormPerception": 76,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 72,
      "Scientific": 73,
      "Plants/Animals": 28,
      "Protective": 76,
      "Mechanical": 24,
      "Industrial": 43,
      "Business Detail": 69,
      "Selling": 63,
      "Accommodating": 38,
      "Humanitarian": 39,
      "Leading/Influencing": 72,
      "Physical Performing": 39
    },
    "fitScore": 56
  },
  {
    "code": "33-1012.00",
    "aptitudeProfile": {
      "Verbal": 83,
      "Numeric": 34,
      "Spatial": 50,
      "ClericalPerception": 73,
      "FormPerception": 74,
      "GeneralLearning": 81
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 78,
      "Plants/Animals": 50,
      "Protective": 74,
      "Mechanical": 50,
      "Industrial": 62,
      "Business Detail": 49,
      "Selling": 70,
      "Accommodating": 64,
      "Humanitarian": 48,
      "Leading/Influencing": 77,
      "Physical Performing": 24
    },
    "fitScore": 63
  },
  {
    "code": "33-1021.00",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 47,
      "Spatial": 73,
      "ClericalPerception": 93,
      "FormPerception": 81,
      "GeneralLearning": 70
    },
    "interestProfile": {
      "Artistic": 71,
      "Scientific": 77,
      "Plants/Animals": 48,
      "Protective": 81,
      "Mechanical": 73,
      "Industrial": 53,
      "Business Detail": 79,
      "Selling": 83,
      "Accommodating": 57,
      "Humanitarian": 43,
      "Leading/Influencing": 82,
      "Physical Performing": 60
    },
    "fitScore": 71
  },
  {
    "code": "33-2011.00",
    "aptitudeProfile": {
      "Verbal": 48,
      "Numeric": 55,
      "Spatial": 95,
      "ClericalPerception": 80,
      "FormPerception": 95,
      "GeneralLearning": 69
    },
    "interestProfile": {
      "Artistic": 47,
      "Scientific": 63,
      "Plants/Animals": 54,
      "Protective": 95,
      "Mechanical": 95,
      "Industrial": 40,
      "Business Detail": 66,
      "Selling": 58,
      "Accommodating": 78,
      "Humanitarian": 51,
      "Leading/Influencing": 68,
      "Physical Performing": 60
    },
    "fitScore": 69
  },
  {
    "code": "33-2021.00",
    "aptitudeProfile": {
      "Verbal": 68,
      "Numeric": 41,
      "Spatial": 56,
      "ClericalPerception": 66,
      "FormPerception": 84,
      "GeneralLearning": 77
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 73,
      "Plants/Animals": 39,
      "Protective": 84,
      "Mechanical": 56,
      "Industrial": 46,
      "Business Detail": 42,
      "Selling": 68,
      "Accommodating": 66,
      "Humanitarian": 37,
      "Leading/Influencing": 49,
      "Physical Performing": 51
    },
    "fitScore": 61
  },
  {
    "code": "33-2022.00",
    "aptitudeProfile": {
      "Verbal": 63,
      "Numeric": 40,
      "Spatial": 56,
      "ClericalPerception": 72,
      "FormPerception": 93,
      "GeneralLearning": 58
    },
    "interestProfile": {
      "Artistic": 55,
      "Scientific": 55,
      "Plants/Animals": 46,
      "Protective": 93,
      "Mechanical": 56,
      "Industrial": 25,
      "Business Detail": 78,
      "Selling": 54,
      "Accommodating": 70,
      "Humanitarian": 30,
      "Leading/Influencing": 74,
      "Physical Performing": 49
    },
    "fitScore": 60
  },
  {
    "code": "33-3011.00",
    "aptitudeProfile": {
      "Verbal": 21,
      "Numeric": 3,
      "Spatial": 4,
      "ClericalPerception": 2,
      "FormPerception": 8,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 24,
      "Scientific": 11,
      "Plants/Animals": 2,
      "Protective": 8,
      "Mechanical": 4,
      "Industrial": 5,
      "Business Detail": 9,
      "Selling": 10,
      "Accommodating": 2,
      "Humanitarian": 11,
      "Leading/Influencing": 7,
      "Physical Performing": 7
    },
    "fitScore": 9
  },
  {
    "code": "33-3012.00",
    "aptitudeProfile": {
      "Verbal": 56,
      "Numeric": 21,
      "Spatial": 50,
      "ClericalPerception": 58,
      "FormPerception": 76,
      "GeneralLearning": 69
    },
    "interestProfile": {
      "Artistic": 47,
      "Scientific": 62,
      "Plants/Animals": 19,
      "Protective": 76,
      "Mechanical": 50,
      "Industrial": 34,
      "Business Detail": 56,
      "Selling": 57,
      "Accommodating": 37,
      "Humanitarian": 35,
      "Leading/Influencing": 48,
      "Physical Performing": 43
    },
    "fitScore": 51
  },
  {
    "code": "33-3021.00",
    "aptitudeProfile": {
      "Verbal": 79,
      "Numeric": 31,
      "Spatial": 79,
      "ClericalPerception": 90,
      "FormPerception": 93,
      "GeneralLearning": 94
    },
    "interestProfile": {
      "Artistic": 79,
      "Scientific": 92,
      "Plants/Animals": 39,
      "Protective": 93,
      "Mechanical": 79,
      "Industrial": 52,
      "Business Detail": 43,
      "Selling": 88,
      "Accommodating": 74,
      "Humanitarian": 85,
      "Leading/Influencing": 47,
      "Physical Performing": 52
    },
    "fitScore": 73
  },
  {
    "code": "33-3021.02",
    "aptitudeProfile": {
      "Verbal": 62,
      "Numeric": 39,
      "Spatial": 31,
      "ClericalPerception": 77,
      "FormPerception": 92,
      "GeneralLearning": 83
    },
    "interestProfile": {
      "Artistic": 71,
      "Scientific": 78,
      "Plants/Animals": 49,
      "Protective": 92,
      "Mechanical": 31,
      "Industrial": 43,
      "Business Detail": 25,
      "Selling": 68,
      "Accommodating": 81,
      "Humanitarian": 32,
      "Leading/Influencing": 19,
      "Physical Performing": 48
    },
    "fitScore": 59
  },
  {
    "code": "33-3021.06",
    "aptitudeProfile": {
      "Verbal": 81,
      "Numeric": 54,
      "Spatial": 70,
      "ClericalPerception": 83,
      "FormPerception": 95,
      "GeneralLearning": 94
    },
    "interestProfile": {
      "Artistic": 86,
      "Scientific": 91,
      "Plants/Animals": 62,
      "Protective": 95,
      "Mechanical": 70,
      "Industrial": 83,
      "Business Detail": 22,
      "Selling": 84,
      "Accommodating": 92,
      "Humanitarian": 95,
      "Leading/Influencing": 39,
      "Physical Performing": 54
    },
    "fitScore": 76
  },
  {
    "code": "33-3031.00",
    "aptitudeProfile": {
      "Verbal": 66,
      "Numeric": 41,
      "Spatial": 74,
      "ClericalPerception": 52,
      "FormPerception": 71,
      "GeneralLearning": 81
    },
    "interestProfile": {
      "Artistic": 68,
      "Scientific": 73,
      "Plants/Animals": 34,
      "Protective": 71,
      "Mechanical": 74,
      "Industrial": 61,
      "Business Detail": 45,
      "Selling": 64,
      "Accommodating": 56,
      "Humanitarian": 64,
      "Leading/Influencing": 55,
      "Physical Performing": 57
    },
    "fitScore": 62
  },
  {
    "code": "33-3041.00",
    "aptitudeProfile": {
      "Verbal": 21,
      "Numeric": 16,
      "Spatial": 34,
      "ClericalPerception": 14,
      "FormPerception": 21,
      "GeneralLearning": 16
    },
    "interestProfile": {
      "Artistic": 25,
      "Scientific": 11,
      "Plants/Animals": 14,
      "Protective": 21,
      "Mechanical": 34,
      "Industrial": 17,
      "Business Detail": 18,
      "Selling": 8,
      "Accommodating": 7,
      "Humanitarian": 30,
      "Leading/Influencing": 18,
      "Physical Performing": 13
    },
    "fitScore": 19
  },
  {
    "code": "33-3051.00",
    "aptitudeProfile": {
      "Verbal": 75,
      "Numeric": 24,
      "Spatial": 68,
      "ClericalPerception": 72,
      "FormPerception": 90,
      "GeneralLearning": 93
    },
    "interestProfile": {
      "Artistic": 75,
      "Scientific": 85,
      "Plants/Animals": 30,
      "Protective": 90,
      "Mechanical": 68,
      "Industrial": 43,
      "Business Detail": 36,
      "Selling": 78,
      "Accommodating": 59,
      "Humanitarian": 55,
      "Leading/Influencing": 52,
      "Physical Performing": 43
    },
    "fitScore": 65
  },
  {
    "code": "33-3051.04",
    "aptitudeProfile": {
      "Verbal": 65,
      "Numeric": 25,
      "Spatial": 20,
      "ClericalPerception": 70,
      "FormPerception": 88,
      "GeneralLearning": 83
    },
    "interestProfile": {
      "Artistic": 70,
      "Scientific": 73,
      "Plants/Animals": 33,
      "Protective": 88,
      "Mechanical": 20,
      "Industrial": 51,
      "Business Detail": 15,
      "Selling": 58,
      "Accommodating": 58,
      "Humanitarian": 33,
      "Leading/Influencing": 24,
      "Physical Performing": 28
    },
    "fitScore": 52
  },
  {
    "code": "33-3052.00",
    "aptitudeProfile": {
      "Verbal": 58,
      "Numeric": 20,
      "Spatial": 62,
      "ClericalPerception": 65,
      "FormPerception": 81,
      "GeneralLearning": 76
    },
    "interestProfile": {
      "Artistic": 61,
      "Scientific": 70,
      "Plants/Animals": 19,
      "Protective": 81,
      "Mechanical": 62,
      "Industrial": 19,
      "Business Detail": 47,
      "Selling": 63,
      "Accommodating": 48,
      "Humanitarian": 36,
      "Leading/Influencing": 43,
      "Physical Performing": 40
    },
    "fitScore": 55
  },
  {
    "code": "33-9011.00",
    "aptitudeProfile": {
      "Verbal": 51,
      "Numeric": 9,
      "Spatial": 16,
      "ClericalPerception": 23,
      "FormPerception": 23,
      "GeneralLearning": 51
    },
    "interestProfile": {
      "Artistic": 53,
      "Scientific": 49,
      "Plants/Animals": 10,
      "Protective": 23,
      "Mechanical": 16,
      "Industrial": 13,
      "Business Detail": 28,
      "Selling": 57,
      "Accommodating": 21,
      "Humanitarian": 21,
      "Leading/Influencing": 31,
      "Physical Performing": 22
    },
    "fitScore": 29
  },
  {
    "code": "33-9021.00",
    "aptitudeProfile": {
      "Verbal": 77,
      "Numeric": 27,
      "Spatial": 12,
      "ClericalPerception": 69,
      "FormPerception": 77,
      "GeneralLearning": 86
    },
    "interestProfile": {
      "Artistic": 74,
      "Scientific": 80,
      "Plants/Animals": 39,
      "Protective": 77,
      "Mechanical": 12,
      "Industrial": 52,
      "Business Detail": 37,
      "Selling": 66,
      "Accommodating": 60,
      "Humanitarian": 32,
      "Leading/Influencing": 54,
      "Physical Performing": 27
    },
    "fitScore": 54
  },
  {
    "code": "33-9031.00",
    "aptitudeProfile": {
      "Verbal": 47,
      "Numeric": 32,
      "Spatial": 4,
      "ClericalPerception": 42,
      "FormPerception": 95,
      "GeneralLearning": 62
    },
    "interestProfile": {
      "Artistic": 47,
      "Scientific": 40,
      "Plants/Animals": 16,
      "Protective": 95,
      "Mechanical": 4,
      "Industrial": 25,
      "Business Detail": 74,
      "Selling": 26,
      "Accommodating": 52,
      "Humanitarian": 11,
      "Leading/Influencing": 36,
      "Physical Performing": 74
    },
    "fitScore": 44
  },
  {
    "code": "33-9032.00",
    "aptitudeProfile": {
      "Verbal": 35,
      "Numeric": 8,
      "Spatial": 34,
      "ClericalPerception": 20,
      "FormPerception": 65,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 23,
      "Scientific": 17,
      "Plants/Animals": 10,
      "Protective": 65,
      "Mechanical": 34,
      "Industrial": 13,
      "Business Detail": 94,
      "Selling": 19,
      "Accommodating": 26,
      "Humanitarian": 25,
      "Leading/Influencing": 58,
      "Physical Performing": 62
    },
    "fitScore": 34
  },
  {
    "code": "33-9091.00",
    "aptitudeProfile": {
      "Verbal": 4,
      "Numeric": 1,
      "Spatial": 6,
      "ClericalPerception": 1,
      "FormPerception": 1,
      "GeneralLearning": 12
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 5,
      "Plants/Animals": 1,
      "Protective": 1,
      "Mechanical": 6,
      "Industrial": 1,
      "Business Detail": 0,
      "Selling": 5,
      "Accommodating": 0,
      "Humanitarian": 7,
      "Leading/Influencing": 1,
      "Physical Performing": 1
    },
    "fitScore": 4
  },
  {
    "code": "33-9092.00",
    "aptitudeProfile": {
      "Verbal": 16,
      "Numeric": 3,
      "Spatial": 13,
      "ClericalPerception": 26,
      "FormPerception": 74,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 17,
      "Scientific": 16,
      "Plants/Animals": 3,
      "Protective": 74,
      "Mechanical": 13,
      "Industrial": 4,
      "Business Detail": 8,
      "Selling": 13,
      "Accommodating": 15,
      "Humanitarian": 17,
      "Leading/Influencing": 5,
      "Physical Performing": 5
    },
    "fitScore": 21
  },
  {
    "code": "33-9093.00",
    "aptitudeProfile": {
      "Verbal": 20,
      "Numeric": 7,
      "Spatial": 61,
      "ClericalPerception": 50,
      "FormPerception": 94,
      "GeneralLearning": 51
    },
    "interestProfile": {
      "Artistic": 25,
      "Scientific": 38,
      "Plants/Animals": 13,
      "Protective": 94,
      "Mechanical": 61,
      "Industrial": 13,
      "Business Detail": 2,
      "Selling": 22,
      "Accommodating": 48,
      "Humanitarian": 42,
      "Leading/Influencing": 9,
      "Physical Performing": 3
    },
    "fitScore": 39
  },
  {
    "code": "33-9099.02",
    "aptitudeProfile": {
      "Verbal": 52,
      "Numeric": 46,
      "Spatial": 32,
      "ClericalPerception": 38,
      "FormPerception": 63,
      "GeneralLearning": 61
    },
    "interestProfile": {
      "Artistic": 47,
      "Scientific": 53,
      "Plants/Animals": 40,
      "Protective": 63,
      "Mechanical": 32,
      "Industrial": 46,
      "Business Detail": 67,
      "Selling": 50,
      "Accommodating": 55,
      "Humanitarian": 27,
      "Leading/Influencing": 72,
      "Physical Performing": 55
    },
    "fitScore": 50
  },
  {
    "code": "35-1011.00",
    "aptitudeProfile": {
      "Verbal": 59,
      "Numeric": 84,
      "Spatial": 31,
      "ClericalPerception": 83,
      "FormPerception": 70,
      "GeneralLearning": 71
    },
    "interestProfile": {
      "Artistic": 50,
      "Scientific": 73,
      "Plants/Animals": 81,
      "Protective": 70,
      "Mechanical": 31,
      "Industrial": 56,
      "Business Detail": 95,
      "Selling": 73,
      "Accommodating": 73,
      "Humanitarian": 12,
      "Leading/Influencing": 95,
      "Physical Performing": 86
    },
    "fitScore": 66
  },
  {
    "code": "35-1012.00",
    "aptitudeProfile": {
      "Verbal": 54,
      "Numeric": 71,
      "Spatial": 24,
      "ClericalPerception": 51,
      "FormPerception": 36,
      "GeneralLearning": 45
    },
    "interestProfile": {
      "Artistic": 47,
      "Scientific": 49,
      "Plants/Animals": 74,
      "Protective": 36,
      "Mechanical": 24,
      "Industrial": 62,
      "Business Detail": 73,
      "Selling": 62,
      "Accommodating": 58,
      "Humanitarian": 16,
      "Leading/Influencing": 83,
      "Physical Performing": 64
    },
    "fitScore": 50
  },
  {
    "code": "35-2011.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 7,
      "Spatial": 9,
      "ClericalPerception": 1,
      "FormPerception": 1,
      "GeneralLearning": 4
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 4,
      "Plants/Animals": 12,
      "Protective": 1,
      "Mechanical": 9,
      "Industrial": 8,
      "Business Detail": 14,
      "Selling": 11,
      "Accommodating": 2,
      "Humanitarian": 23,
      "Leading/Influencing": 38,
      "Physical Performing": 3
    },
    "fitScore": 9
  },
  {
    "code": "35-2012.00",
    "aptitudeProfile": {
      "Verbal": 21,
      "Numeric": 61,
      "Spatial": 83,
      "ClericalPerception": 22,
      "FormPerception": 13,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 17,
      "Scientific": 20,
      "Plants/Animals": 54,
      "Protective": 13,
      "Mechanical": 83,
      "Industrial": 38,
      "Business Detail": 69,
      "Selling": 14,
      "Accommodating": 22,
      "Humanitarian": 35,
      "Leading/Influencing": 71,
      "Physical Performing": 38
    },
    "fitScore": 38
  },
  {
    "code": "35-2013.00",
    "aptitudeProfile": {
      "Verbal": 18,
      "Numeric": 28,
      "Spatial": 55,
      "ClericalPerception": 53,
      "FormPerception": 15,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 13,
      "Scientific": 37,
      "Plants/Animals": 22,
      "Protective": 15,
      "Mechanical": 55,
      "Industrial": 21,
      "Business Detail": 51,
      "Selling": 34,
      "Accommodating": 11,
      "Humanitarian": 42,
      "Leading/Influencing": 42,
      "Physical Performing": 19
    },
    "fitScore": 31
  },
  {
    "code": "35-2014.00",
    "aptitudeProfile": {
      "Verbal": 10,
      "Numeric": 41,
      "Spatial": 19,
      "ClericalPerception": 53,
      "FormPerception": 56,
      "GeneralLearning": 12
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 19,
      "Plants/Animals": 44,
      "Protective": 56,
      "Mechanical": 19,
      "Industrial": 22,
      "Business Detail": 35,
      "Selling": 17,
      "Accommodating": 36,
      "Humanitarian": 7,
      "Leading/Influencing": 40,
      "Physical Performing": 13
    },
    "fitScore": 29
  },
  {
    "code": "35-2015.00",
    "aptitudeProfile": {
      "Verbal": 12,
      "Numeric": 22,
      "Spatial": 49,
      "ClericalPerception": 10,
      "FormPerception": 30,
      "GeneralLearning": 5
    },
    "interestProfile": {
      "Artistic": 10,
      "Scientific": 6,
      "Plants/Animals": 22,
      "Protective": 30,
      "Mechanical": 49,
      "Industrial": 15,
      "Business Detail": 27,
      "Selling": 14,
      "Accommodating": 21,
      "Humanitarian": 39,
      "Leading/Influencing": 19,
      "Physical Performing": 25
    },
    "fitScore": 22
  },
  {
    "code": "35-2021.00",
    "aptitudeProfile": {
      "Verbal": 2,
      "Numeric": 9,
      "Spatial": 5,
      "ClericalPerception": 0,
      "FormPerception": 1,
      "GeneralLearning": 2
    },
    "interestProfile": {
      "Artistic": 2,
      "Scientific": 2,
      "Plants/Animals": 11,
      "Protective": 1,
      "Mechanical": 5,
      "Industrial": 7,
      "Business Detail": 5,
      "Selling": 3,
      "Accommodating": 3,
      "Humanitarian": 7,
      "Leading/Influencing": 7,
      "Physical Performing": 17
    },
    "fitScore": 5
  },
  {
    "code": "35-3011.00",
    "aptitudeProfile": {
      "Verbal": 30,
      "Numeric": 33,
      "Spatial": 51,
      "ClericalPerception": 38,
      "FormPerception": 36,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 35,
      "Scientific": 23,
      "Plants/Animals": 34,
      "Protective": 36,
      "Mechanical": 51,
      "Industrial": 22,
      "Business Detail": 33,
      "Selling": 44,
      "Accommodating": 27,
      "Humanitarian": 42,
      "Leading/Influencing": 29,
      "Physical Performing": 38
    },
    "fitScore": 34
  },
  {
    "code": "35-3023.00",
    "aptitudeProfile": {
      "Verbal": 6,
      "Numeric": 32,
      "Spatial": 3,
      "ClericalPerception": 1,
      "FormPerception": 3,
      "GeneralLearning": 1
    },
    "interestProfile": {
      "Artistic": 5,
      "Scientific": 1,
      "Plants/Animals": 26,
      "Protective": 3,
      "Mechanical": 3,
      "Industrial": 9,
      "Business Detail": 51,
      "Selling": 6,
      "Accommodating": 8,
      "Humanitarian": 4,
      "Leading/Influencing": 35,
      "Physical Performing": 31
    },
    "fitScore": 11
  },
  {
    "code": "35-3023.01",
    "aptitudeProfile": {
      "Verbal": 20,
      "Numeric": 22,
      "Spatial": 38,
      "ClericalPerception": 26,
      "FormPerception": 34,
      "GeneralLearning": 7
    },
    "interestProfile": {
      "Artistic": 26,
      "Scientific": 11,
      "Plants/Animals": 28,
      "Protective": 34,
      "Mechanical": 38,
      "Industrial": 17,
      "Business Detail": 12,
      "Selling": 31,
      "Accommodating": 21,
      "Humanitarian": 39,
      "Leading/Influencing": 15,
      "Physical Performing": 18
    },
    "fitScore": 24
  },
  {
    "code": "35-3031.00",
    "aptitudeProfile": {
      "Verbal": 17,
      "Numeric": 18,
      "Spatial": 3,
      "ClericalPerception": 2,
      "FormPerception": 4,
      "GeneralLearning": 9
    },
    "interestProfile": {
      "Artistic": 22,
      "Scientific": 8,
      "Plants/Animals": 16,
      "Protective": 4,
      "Mechanical": 3,
      "Industrial": 11,
      "Business Detail": 22,
      "Selling": 18,
      "Accommodating": 9,
      "Humanitarian": 6,
      "Leading/Influencing": 20,
      "Physical Performing": 27
    },
    "fitScore": 11
  },
  {
    "code": "35-3041.00",
    "aptitudeProfile": {
      "Verbal": 11,
      "Numeric": 17,
      "Spatial": 4,
      "ClericalPerception": 1,
      "FormPerception": 2,
      "GeneralLearning": 7
    },
    "interestProfile": {
      "Artistic": 10,
      "Scientific": 6,
      "Plants/Animals": 15,
      "Protective": 2,
      "Mechanical": 4,
      "Industrial": 9,
      "Business Detail": 28,
      "Selling": 8,
      "Accommodating": 4,
      "Humanitarian": 6,
      "Leading/Influencing": 19,
      "Physical Performing": 20
    },
    "fitScore": 9
  },
  {
    "code": "35-9011.00",
    "aptitudeProfile": {
      "Verbal": 2,
      "Numeric": 6,
      "Spatial": 5,
      "ClericalPerception": 1,
      "FormPerception": 1,
      "GeneralLearning": 2
    },
    "interestProfile": {
      "Artistic": 2,
      "Scientific": 3,
      "Plants/Animals": 11,
      "Protective": 1,
      "Mechanical": 5,
      "Industrial": 3,
      "Business Detail": 5,
      "Selling": 4,
      "Accommodating": 3,
      "Humanitarian": 3,
      "Leading/Influencing": 12,
      "Physical Performing": 1
    },
    "fitScore": 4
  },
  {
    "code": "35-9021.00",
    "aptitudeProfile": {
      "Verbal": 2,
      "Numeric": 7,
      "Spatial": 11,
      "ClericalPerception": 2,
      "FormPerception": 1,
      "GeneralLearning": 0
    },
    "interestProfile": {
      "Artistic": 1,
      "Scientific": 1,
      "Plants/Animals": 10,
      "Protective": 1,
      "Mechanical": 11,
      "Industrial": 2,
      "Business Detail": 78,
      "Selling": 3,
      "Accommodating": 3,
      "Humanitarian": 5,
      "Leading/Influencing": 39,
      "Physical Performing": 7
    },
    "fitScore": 9
  },
  {
    "code": "35-9031.00",
    "aptitudeProfile": {
      "Verbal": 19,
      "Numeric": 23,
      "Spatial": 11,
      "ClericalPerception": 0,
      "FormPerception": 2,
      "GeneralLearning": 11
    },
    "interestProfile": {
      "Artistic": 22,
      "Scientific": 6,
      "Plants/Animals": 21,
      "Protective": 2,
      "Mechanical": 11,
      "Industrial": 13,
      "Business Detail": 29,
      "Selling": 12,
      "Accommodating": 11,
      "Humanitarian": 30,
      "Leading/Influencing": 22,
      "Physical Performing": 35
    },
    "fitScore": 14
  },
  {
    "code": "37-1011.00",
    "aptitudeProfile": {
      "Verbal": 41,
      "Numeric": 26,
      "Spatial": 8,
      "ClericalPerception": 21,
      "FormPerception": 15,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 34,
      "Scientific": 25,
      "Plants/Animals": 33,
      "Protective": 15,
      "Mechanical": 8,
      "Industrial": 20,
      "Business Detail": 50,
      "Selling": 37,
      "Accommodating": 17,
      "Humanitarian": 13,
      "Leading/Influencing": 58,
      "Physical Performing": 21
    },
    "fitScore": 25
  },
  {
    "code": "37-1012.00",
    "aptitudeProfile": {
      "Verbal": 56,
      "Numeric": 61,
      "Spatial": 58,
      "ClericalPerception": 71,
      "FormPerception": 75,
      "GeneralLearning": 24
    },
    "interestProfile": {
      "Artistic": 49,
      "Scientific": 34,
      "Plants/Animals": 45,
      "Protective": 75,
      "Mechanical": 58,
      "Industrial": 50,
      "Business Detail": 88,
      "Selling": 63,
      "Accommodating": 50,
      "Humanitarian": 22,
      "Leading/Influencing": 86,
      "Physical Performing": 79
    },
    "fitScore": 58
  },
  {
    "code": "37-2011.00",
    "aptitudeProfile": {
      "Verbal": 5,
      "Numeric": 1,
      "Spatial": 26,
      "ClericalPerception": 1,
      "FormPerception": 2,
      "GeneralLearning": 4
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 4,
      "Plants/Animals": 2,
      "Protective": 2,
      "Mechanical": 26,
      "Industrial": 1,
      "Business Detail": 48,
      "Selling": 4,
      "Accommodating": 1,
      "Humanitarian": 17,
      "Leading/Influencing": 9,
      "Physical Performing": 15
    },
    "fitScore": 9
  },
  {
    "code": "37-2012.00",
    "aptitudeProfile": {
      "Verbal": 4,
      "Numeric": 6,
      "Spatial": 12,
      "ClericalPerception": 1,
      "FormPerception": 1,
      "GeneralLearning": 3
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 3,
      "Plants/Animals": 10,
      "Protective": 1,
      "Mechanical": 12,
      "Industrial": 5,
      "Business Detail": 6,
      "Selling": 3,
      "Accommodating": 3,
      "Humanitarian": 19,
      "Leading/Influencing": 12,
      "Physical Performing": 1
    },
    "fitScore": 6
  },
  {
    "code": "37-2021.00",
    "aptitudeProfile": {
      "Verbal": 32,
      "Numeric": 45,
      "Spatial": 71,
      "ClericalPerception": 52,
      "FormPerception": 71,
      "GeneralLearning": 48
    },
    "interestProfile": {
      "Artistic": 45,
      "Scientific": 47,
      "Plants/Animals": 59,
      "Protective": 71,
      "Mechanical": 71,
      "Industrial": 34,
      "Business Detail": 12,
      "Selling": 46,
      "Accommodating": 66,
      "Humanitarian": 30,
      "Leading/Influencing": 28,
      "Physical Performing": 24
    },
    "fitScore": 49
  },
  {
    "code": "37-3011.00",
    "aptitudeProfile": {
      "Verbal": 1,
      "Numeric": 6,
      "Spatial": 48,
      "ClericalPerception": 2,
      "FormPerception": 9,
      "GeneralLearning": 6
    },
    "interestProfile": {
      "Artistic": 1,
      "Scientific": 5,
      "Plants/Animals": 4,
      "Protective": 9,
      "Mechanical": 48,
      "Industrial": 2,
      "Business Detail": 17,
      "Selling": 3,
      "Accommodating": 3,
      "Humanitarian": 8,
      "Leading/Influencing": 7,
      "Physical Performing": 7
    },
    "fitScore": 11
  },
  {
    "code": "37-3012.00",
    "aptitudeProfile": {
      "Verbal": 20,
      "Numeric": 41,
      "Spatial": 36,
      "ClericalPerception": 13,
      "FormPerception": 14,
      "GeneralLearning": 22
    },
    "interestProfile": {
      "Artistic": 14,
      "Scientific": 21,
      "Plants/Animals": 46,
      "Protective": 14,
      "Mechanical": 36,
      "Industrial": 20,
      "Business Detail": 58,
      "Selling": 15,
      "Accommodating": 18,
      "Humanitarian": 19,
      "Leading/Influencing": 47,
      "Physical Performing": 27
    },
    "fitScore": 26
  },
  {
    "code": "37-3013.00",
    "aptitudeProfile": {
      "Verbal": 9,
      "Numeric": 9,
      "Spatial": 86,
      "ClericalPerception": 13,
      "FormPerception": 34,
      "GeneralLearning": 26
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 23,
      "Plants/Animals": 8,
      "Protective": 34,
      "Mechanical": 86,
      "Industrial": 6,
      "Business Detail": 10,
      "Selling": 24,
      "Accommodating": 20,
      "Humanitarian": 29,
      "Leading/Influencing": 9,
      "Physical Performing": 13
    },
    "fitScore": 26
  },
  {
    "code": "39-1013.00",
    "aptitudeProfile": {
      "Verbal": 67,
      "Numeric": 65,
      "Spatial": 11,
      "ClericalPerception": 33,
      "FormPerception": 50,
      "GeneralLearning": 47
    },
    "interestProfile": {
      "Artistic": 58,
      "Scientific": 41,
      "Plants/Animals": 57,
      "Protective": 50,
      "Mechanical": 11,
      "Industrial": 54,
      "Business Detail": 90,
      "Selling": 47,
      "Accommodating": 51,
      "Humanitarian": 22,
      "Leading/Influencing": 78,
      "Physical Performing": 81
    },
    "fitScore": 49
  },
  {
    "code": "39-1022.00",
    "aptitudeProfile": {
      "Verbal": 72,
      "Numeric": 20,
      "Spatial": 19,
      "ClericalPerception": 39,
      "FormPerception": 20,
      "GeneralLearning": 37
    },
    "interestProfile": {
      "Artistic": 61,
      "Scientific": 44,
      "Plants/Animals": 19,
      "Protective": 20,
      "Mechanical": 19,
      "Industrial": 39,
      "Business Detail": 68,
      "Selling": 62,
      "Accommodating": 18,
      "Humanitarian": 74,
      "Leading/Influencing": 74,
      "Physical Performing": 36
    },
    "fitScore": 40
  },
  {
    "code": "39-2011.00",
    "aptitudeProfile": {
      "Verbal": 27,
      "Numeric": 11,
      "Spatial": 31,
      "ClericalPerception": 60,
      "FormPerception": 45,
      "GeneralLearning": 24
    },
    "interestProfile": {
      "Artistic": 28,
      "Scientific": 37,
      "Plants/Animals": 15,
      "Protective": 45,
      "Mechanical": 31,
      "Industrial": 11,
      "Business Detail": 18,
      "Selling": 47,
      "Accommodating": 21,
      "Humanitarian": 17,
      "Leading/Influencing": 24,
      "Physical Performing": 8
    },
    "fitScore": 29
  },
  {
    "code": "39-2021.00",
    "aptitudeProfile": {
      "Verbal": 11,
      "Numeric": 14,
      "Spatial": 3,
      "ClericalPerception": 1,
      "FormPerception": 7,
      "GeneralLearning": 17
    },
    "interestProfile": {
      "Artistic": 10,
      "Scientific": 11,
      "Plants/Animals": 14,
      "Protective": 7,
      "Mechanical": 3,
      "Industrial": 15,
      "Business Detail": 12,
      "Selling": 7,
      "Accommodating": 11,
      "Humanitarian": 8,
      "Leading/Influencing": 13,
      "Physical Performing": 10
    },
    "fitScore": 9
  },
  {
    "code": "39-3011.00",
    "aptitudeProfile": {
      "Verbal": 17,
      "Numeric": 68,
      "Spatial": 34,
      "ClericalPerception": 14,
      "FormPerception": 44,
      "GeneralLearning": 17
    },
    "interestProfile": {
      "Artistic": 17,
      "Scientific": 11,
      "Plants/Animals": 63,
      "Protective": 44,
      "Mechanical": 34,
      "Industrial": 31,
      "Business Detail": 66,
      "Selling": 18,
      "Accommodating": 47,
      "Humanitarian": 37,
      "Leading/Influencing": 40,
      "Physical Performing": 77
    },
    "fitScore": 36
  },
  {
    "code": "39-3012.00",
    "aptitudeProfile": {
      "Verbal": 25,
      "Numeric": 76,
      "Spatial": 14,
      "ClericalPerception": 12,
      "FormPerception": 21,
      "GeneralLearning": 19
    },
    "interestProfile": {
      "Artistic": 38,
      "Scientific": 13,
      "Plants/Animals": 71,
      "Protective": 21,
      "Mechanical": 14,
      "Industrial": 39,
      "Business Detail": 51,
      "Selling": 27,
      "Accommodating": 39,
      "Humanitarian": 32,
      "Leading/Influencing": 40,
      "Physical Performing": 82
    },
    "fitScore": 33
  },
  {
    "code": "39-3021.00",
    "aptitudeProfile": {
      "Verbal": 14,
      "Numeric": 4,
      "Spatial": 13,
      "ClericalPerception": 14,
      "FormPerception": 49,
      "GeneralLearning": 8
    },
    "interestProfile": {
      "Artistic": 12,
      "Scientific": 6,
      "Plants/Animals": 2,
      "Protective": 49,
      "Mechanical": 13,
      "Industrial": 5,
      "Business Detail": 18,
      "Selling": 6,
      "Accommodating": 4,
      "Humanitarian": 9,
      "Leading/Influencing": 6,
      "Physical Performing": 9
    },
    "fitScore": 14
  },
  {
    "code": "39-3031.00",
    "aptitudeProfile": {
      "Verbal": 7,
      "Numeric": 10,
      "Spatial": 3,
      "ClericalPerception": 8,
      "FormPerception": 14,
      "GeneralLearning": 7
    },
    "interestProfile": {
      "Artistic": 8,
      "Scientific": 7,
      "Plants/Animals": 10,
      "Protective": 14,
      "Mechanical": 3,
      "Industrial": 7,
      "Business Detail": 9,
      "Selling": 8,
      "Accommodating": 7,
      "Humanitarian": 6,
      "Leading/Influencing": 9,
      "Physical Performing": 6
    },
    "fitScore": 8
  },
  {
    "code": "39-3091.00",
    "aptitudeProfile": {
      "Verbal": 14,
      "Numeric": 15,
      "Spatial": 3,
      "ClericalPerception": 1,
      "FormPerception": 2,
      "GeneralLearning": 5
    },
    "interestProfile": {
      "Artistic": 20,
      "Scientific": 5,
      "Plants/Animals": 16,
      "Protective": 2,
      "Mechanical": 3,
      "Industrial": 5,
      "Business Detail": 18,
      "Selling": 13,
      "Accommodating": 5,
      "Humanitarian": 3,
      "Leading/Influencing": 19,
      "Physical Performing": 17
    },
    "fitScore": 9
  },
  {
    "code": "39-3092.00",
    "aptitudeProfile": {
      "Verbal": 26,
      "Numeric": 8,
      "Spatial": 53,
      "ClericalPerception": 31,
      "FormPerception": 9,
      "GeneralLearning": 16
    },
    "interestProfile": {
      "Artistic": 27,
      "Scientific": 30,
      "Plants/Animals": 5,
      "Protective": 9,
      "Mechanical": 53,
      "Industrial": 6,
      "Business Detail": 39,
      "Selling": 55,
      "Accommodating": 5,
      "Humanitarian": 38,
      "Leading/Influencing": 11,
      "Physical Performing": 34
    },
    "fitScore": 25
  },
  {
    "code": "39-3093.00",
    "aptitudeProfile": {
      "Verbal": 7,
      "Numeric": 2,
      "Spatial": 0,
      "ClericalPerception": 0,
      "FormPerception": 0,
      "GeneralLearning": 5
    },
    "interestProfile": {
      "Artistic": 13,
      "Scientific": 4,
      "Plants/Animals": 1,
      "Protective": 0,
      "Mechanical": 0,
      "Industrial": 2,
      "Business Detail": 3,
      "Selling": 6,
      "Accommodating": 1,
      "Humanitarian": 21,
      "Leading/Influencing": 1,
      "Physical Performing": 5
    },
    "fitScore": 4
  },
  {
    "code": "39-4011.00",
    "aptitudeProfile": {
      "Verbal": 32,
      "Numeric": 16,
      "Spatial": 48,
      "ClericalPerception": 20,
      "FormPerception": 20,
      "GeneralLearning": 27
    },
    "interestProfile": {
      "Artistic": 29,
      "Scientific": 31,
      "Plants/Animals": 13,
      "Protective": 20,
      "Mechanical": 48,
      "Industrial": 18,
      "Business Detail": 37,
      "Selling": 41,
      "Accommodating": 17,
      "Humanitarian": 18,
      "Leading/Influencing": 36,
      "Physical Performing": 25
    },
    "fitScore": 28
  },
  {
    "code": "39-4021.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 9,
      "Spatial": 14,
      "ClericalPerception": 1,
      "FormPerception": 0,
      "GeneralLearning": 7
    },
    "interestProfile": {
      "Artistic": 18,
      "Scientific": 7,
      "Plants/Animals": 8,
      "Protective": 0,
      "Mechanical": 14,
      "Industrial": 6,
      "Business Detail": 11,
      "Selling": 11,
      "Accommodating": 1,
      "Humanitarian": 13,
      "Leading/Influencing": 5,
      "Physical Performing": 12
    },
    "fitScore": 8
  },
  {
    "code": "39-4031.00",
    "aptitudeProfile": {
      "Verbal": 54,
      "Numeric": 52,
      "Spatial": 43,
      "ClericalPerception": 25,
      "FormPerception": 13,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 47,
      "Scientific": 35,
      "Plants/Animals": 55,
      "Protective": 13,
      "Mechanical": 43,
      "Industrial": 51,
      "Business Detail": 61,
      "Selling": 58,
      "Accommodating": 45,
      "Humanitarian": 28,
      "Leading/Influencing": 77,
      "Physical Performing": 40
    },
    "fitScore": 41
  },
  {
    "code": "39-5011.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 11,
      "Spatial": 86,
      "ClericalPerception": 5,
      "FormPerception": 1,
      "GeneralLearning": 10
    },
    "interestProfile": {
      "Artistic": 12,
      "Scientific": 15,
      "Plants/Animals": 6,
      "Protective": 1,
      "Mechanical": 86,
      "Industrial": 6,
      "Business Detail": 35,
      "Selling": 31,
      "Accommodating": 2,
      "Humanitarian": 24,
      "Leading/Influencing": 20,
      "Physical Performing": 26
    },
    "fitScore": 22
  },
  {
    "code": "39-5012.00",
    "aptitudeProfile": {
      "Verbal": 26,
      "Numeric": 21,
      "Spatial": 99,
      "ClericalPerception": 55,
      "FormPerception": 36,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 27,
      "Scientific": 34,
      "Plants/Animals": 26,
      "Protective": 36,
      "Mechanical": 99,
      "Industrial": 24,
      "Business Detail": 17,
      "Selling": 58,
      "Accommodating": 35,
      "Humanitarian": 42,
      "Leading/Influencing": 37,
      "Physical Performing": 13
    },
    "fitScore": 40
  },
  {
    "code": "39-5091.00",
    "aptitudeProfile": {
      "Verbal": 42,
      "Numeric": 11,
      "Spatial": 97,
      "ClericalPerception": 65,
      "FormPerception": 39,
      "GeneralLearning": 28
    },
    "interestProfile": {
      "Artistic": 37,
      "Scientific": 42,
      "Plants/Animals": 22,
      "Protective": 39,
      "Mechanical": 97,
      "Industrial": 23,
      "Business Detail": 15,
      "Selling": 64,
      "Accommodating": 23,
      "Humanitarian": 55,
      "Leading/Influencing": 44,
      "Physical Performing": 6
    },
    "fitScore": 43
  },
  {
    "code": "39-5092.00",
    "aptitudeProfile": {
      "Verbal": 3,
      "Numeric": 6,
      "Spatial": 40,
      "ClericalPerception": 2,
      "FormPerception": 1,
      "GeneralLearning": 3
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 4,
      "Plants/Animals": 3,
      "Protective": 1,
      "Mechanical": 40,
      "Industrial": 6,
      "Business Detail": 12,
      "Selling": 4,
      "Accommodating": 1,
      "Humanitarian": 24,
      "Leading/Influencing": 9,
      "Physical Performing": 4
    },
    "fitScore": 9
  },
  {
    "code": "39-5093.00",
    "aptitudeProfile": {
      "Verbal": 6,
      "Numeric": 3,
      "Spatial": 9,
      "ClericalPerception": 0,
      "FormPerception": 1,
      "GeneralLearning": 5
    },
    "interestProfile": {
      "Artistic": 10,
      "Scientific": 3,
      "Plants/Animals": 3,
      "Protective": 1,
      "Mechanical": 9,
      "Industrial": 3,
      "Business Detail": 2,
      "Selling": 7,
      "Accommodating": 2,
      "Humanitarian": 17,
      "Leading/Influencing": 2,
      "Physical Performing": 5
    },
    "fitScore": 5
  },
  {
    "code": "39-5094.00",
    "aptitudeProfile": {
      "Verbal": 29,
      "Numeric": 2,
      "Spatial": 26,
      "ClericalPerception": 16,
      "FormPerception": 7,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 41,
      "Scientific": 26,
      "Plants/Animals": 2,
      "Protective": 7,
      "Mechanical": 26,
      "Industrial": 7,
      "Business Detail": 3,
      "Selling": 53,
      "Accommodating": 3,
      "Humanitarian": 48,
      "Leading/Influencing": 2,
      "Physical Performing": 10
    },
    "fitScore": 18
  },
  {
    "code": "39-6011.00",
    "aptitudeProfile": {
      "Verbal": 16,
      "Numeric": 14,
      "Spatial": 39,
      "ClericalPerception": 13,
      "FormPerception": 10,
      "GeneralLearning": 7
    },
    "interestProfile": {
      "Artistic": 24,
      "Scientific": 9,
      "Plants/Animals": 15,
      "Protective": 10,
      "Mechanical": 39,
      "Industrial": 12,
      "Business Detail": 8,
      "Selling": 22,
      "Accommodating": 7,
      "Humanitarian": 26,
      "Leading/Influencing": 8,
      "Physical Performing": 16
    },
    "fitScore": 16
  },
  {
    "code": "39-6012.00",
    "aptitudeProfile": {
      "Verbal": 46,
      "Numeric": 19,
      "Spatial": 4,
      "ClericalPerception": 24,
      "FormPerception": 5,
      "GeneralLearning": 29
    },
    "interestProfile": {
      "Artistic": 46,
      "Scientific": 41,
      "Plants/Animals": 19,
      "Protective": 5,
      "Mechanical": 4,
      "Industrial": 17,
      "Business Detail": 43,
      "Selling": 68,
      "Accommodating": 11,
      "Humanitarian": 9,
      "Leading/Influencing": 43,
      "Physical Performing": 36
    },
    "fitScore": 25
  },
  {
    "code": "39-7011.00",
    "aptitudeProfile": {
      "Verbal": 29,
      "Numeric": 6,
      "Spatial": 7,
      "ClericalPerception": 1,
      "FormPerception": 1,
      "GeneralLearning": 12
    },
    "interestProfile": {
      "Artistic": 42,
      "Scientific": 11,
      "Plants/Animals": 10,
      "Protective": 1,
      "Mechanical": 7,
      "Industrial": 13,
      "Business Detail": 2,
      "Selling": 34,
      "Accommodating": 5,
      "Humanitarian": 15,
      "Leading/Influencing": 7,
      "Physical Performing": 8
    },
    "fitScore": 11
  },
  {
    "code": "39-7012.00",
    "aptitudeProfile": {
      "Verbal": 53,
      "Numeric": 28,
      "Spatial": 58,
      "ClericalPerception": 47,
      "FormPerception": 36,
      "GeneralLearning": 28
    },
    "interestProfile": {
      "Artistic": 60,
      "Scientific": 35,
      "Plants/Animals": 36,
      "Protective": 36,
      "Mechanical": 58,
      "Industrial": 41,
      "Business Detail": 18,
      "Selling": 61,
      "Accommodating": 26,
      "Humanitarian": 40,
      "Leading/Influencing": 44,
      "Physical Performing": 23
    },
    "fitScore": 41
  },
  {
    "code": "39-9011.00",
    "aptitudeProfile": {
      "Verbal": 30,
      "Numeric": 16,
      "Spatial": 68,
      "ClericalPerception": 42,
      "FormPerception": 35,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 37,
      "Scientific": 31,
      "Plants/Animals": 16,
      "Protective": 35,
      "Mechanical": 68,
      "Industrial": 18,
      "Business Detail": 14,
      "Selling": 57,
      "Accommodating": 23,
      "Humanitarian": 42,
      "Leading/Influencing": 20,
      "Physical Performing": 22
    },
    "fitScore": 34
  },
  {
    "code": "39-9011.01",
    "aptitudeProfile": {
      "Verbal": 27,
      "Numeric": 6,
      "Spatial": 32,
      "ClericalPerception": 37,
      "FormPerception": 26,
      "GeneralLearning": 50
    },
    "interestProfile": {
      "Artistic": 47,
      "Scientific": 55,
      "Plants/Animals": 7,
      "Protective": 26,
      "Mechanical": 32,
      "Industrial": 7,
      "Business Detail": 4,
      "Selling": 66,
      "Accommodating": 9,
      "Humanitarian": 18,
      "Leading/Influencing": 1,
      "Physical Performing": 26
    },
    "fitScore": 27
  },
  {
    "code": "39-9031.00",
    "aptitudeProfile": {
      "Verbal": 19,
      "Numeric": 5,
      "Spatial": 7,
      "ClericalPerception": 18,
      "FormPerception": 1,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 26,
      "Scientific": 30,
      "Plants/Animals": 6,
      "Protective": 1,
      "Mechanical": 7,
      "Industrial": 7,
      "Business Detail": 5,
      "Selling": 39,
      "Accommodating": 2,
      "Humanitarian": 11,
      "Leading/Influencing": 5,
      "Physical Performing": 5
    },
    "fitScore": 12
  },
  {
    "code": "39-9032.00",
    "aptitudeProfile": {
      "Verbal": 46,
      "Numeric": 28,
      "Spatial": 57,
      "ClericalPerception": 47,
      "FormPerception": 21,
      "GeneralLearning": 25
    },
    "interestProfile": {
      "Artistic": 51,
      "Scientific": 37,
      "Plants/Animals": 24,
      "Protective": 21,
      "Mechanical": 57,
      "Industrial": 22,
      "Business Detail": 44,
      "Selling": 68,
      "Accommodating": 21,
      "Humanitarian": 49,
      "Leading/Influencing": 31,
      "Physical Performing": 54
    },
    "fitScore": 39
  },
  {
    "code": "39-9041.00",
    "aptitudeProfile": {
      "Verbal": 63,
      "Numeric": 14,
      "Spatial": 9,
      "ClericalPerception": 28,
      "FormPerception": 15,
      "GeneralLearning": 31
    },
    "interestProfile": {
      "Artistic": 54,
      "Scientific": 37,
      "Plants/Animals": 17,
      "Protective": 15,
      "Mechanical": 9,
      "Industrial": 20,
      "Business Detail": 59,
      "Selling": 59,
      "Accommodating": 15,
      "Humanitarian": 12,
      "Leading/Influencing": 72,
      "Physical Performing": 24
    },
    "fitScore": 30
  },
  {
    "code": "41-1011.00",
    "aptitudeProfile": {
      "Verbal": 58,
      "Numeric": 63,
      "Spatial": 44,
      "ClericalPerception": 46,
      "FormPerception": 36,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 43,
      "Scientific": 34,
      "Plants/Animals": 63,
      "Protective": 36,
      "Mechanical": 44,
      "Industrial": 46,
      "Business Detail": 92,
      "Selling": 59,
      "Accommodating": 50,
      "Humanitarian": 51,
      "Leading/Influencing": 95,
      "Physical Performing": 62
    },
    "fitScore": 51
  },
  {
    "code": "41-1012.00",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 72,
      "Spatial": 72,
      "ClericalPerception": 73,
      "FormPerception": 32,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 68,
      "Scientific": 79,
      "Plants/Animals": 79,
      "Protective": 32,
      "Mechanical": 72,
      "Industrial": 72,
      "Business Detail": 82,
      "Selling": 81,
      "Accommodating": 65,
      "Humanitarian": 77,
      "Leading/Influencing": 92,
      "Physical Performing": 61
    },
    "fitScore": 69
  },
  {
    "code": "41-2011.00",
    "aptitudeProfile": {
      "Verbal": 16,
      "Numeric": 40,
      "Spatial": 6,
      "ClericalPerception": 3,
      "FormPerception": 3,
      "GeneralLearning": 5
    },
    "interestProfile": {
      "Artistic": 18,
      "Scientific": 4,
      "Plants/Animals": 40,
      "Protective": 3,
      "Mechanical": 6,
      "Industrial": 22,
      "Business Detail": 32,
      "Selling": 11,
      "Accommodating": 9,
      "Humanitarian": 28,
      "Leading/Influencing": 40,
      "Physical Performing": 27
    },
    "fitScore": 16
  },
  {
    "code": "41-2012.00",
    "aptitudeProfile": {
      "Verbal": 11,
      "Numeric": 74,
      "Spatial": 19,
      "ClericalPerception": 24,
      "FormPerception": 43,
      "GeneralLearning": 15
    },
    "interestProfile": {
      "Artistic": 21,
      "Scientific": 12,
      "Plants/Animals": 78,
      "Protective": 43,
      "Mechanical": 19,
      "Industrial": 43,
      "Business Detail": 15,
      "Selling": 14,
      "Accommodating": 52,
      "Humanitarian": 47,
      "Leading/Influencing": 9,
      "Physical Performing": 53
    },
    "fitScore": 32
  },
  {
    "code": "41-2021.00",
    "aptitudeProfile": {
      "Verbal": 42,
      "Numeric": 45,
      "Spatial": 3,
      "ClericalPerception": 21,
      "FormPerception": 30,
      "GeneralLearning": 12
    },
    "interestProfile": {
      "Artistic": 44,
      "Scientific": 14,
      "Plants/Animals": 59,
      "Protective": 30,
      "Mechanical": 3,
      "Industrial": 29,
      "Business Detail": 43,
      "Selling": 42,
      "Accommodating": 40,
      "Humanitarian": 12,
      "Leading/Influencing": 40,
      "Physical Performing": 47
    },
    "fitScore": 30
  },
  {
    "code": "41-2022.00",
    "aptitudeProfile": {
      "Verbal": 69,
      "Numeric": 61,
      "Spatial": 28,
      "ClericalPerception": 51,
      "FormPerception": 63,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 59,
      "Scientific": 27,
      "Plants/Animals": 62,
      "Protective": 63,
      "Mechanical": 28,
      "Industrial": 55,
      "Business Detail": 86,
      "Selling": 52,
      "Accommodating": 55,
      "Humanitarian": 24,
      "Leading/Influencing": 87,
      "Physical Performing": 66
    },
    "fitScore": 52
  },
  {
    "code": "41-2031.00",
    "aptitudeProfile": {
      "Verbal": 35,
      "Numeric": 47,
      "Spatial": 42,
      "ClericalPerception": 28,
      "FormPerception": 7,
      "GeneralLearning": 12
    },
    "interestProfile": {
      "Artistic": 39,
      "Scientific": 21,
      "Plants/Animals": 50,
      "Protective": 7,
      "Mechanical": 42,
      "Industrial": 30,
      "Business Detail": 43,
      "Selling": 51,
      "Accommodating": 21,
      "Humanitarian": 43,
      "Leading/Influencing": 45,
      "Physical Performing": 46
    },
    "fitScore": 33
  },
  {
    "code": "41-3011.00",
    "aptitudeProfile": {
      "Verbal": 65,
      "Numeric": 68,
      "Spatial": 15,
      "ClericalPerception": 70,
      "FormPerception": 42,
      "GeneralLearning": 28
    },
    "interestProfile": {
      "Artistic": 70,
      "Scientific": 47,
      "Plants/Animals": 63,
      "Protective": 42,
      "Mechanical": 15,
      "Industrial": 55,
      "Business Detail": 72,
      "Selling": 77,
      "Accommodating": 55,
      "Humanitarian": 14,
      "Leading/Influencing": 61,
      "Physical Performing": 79
    },
    "fitScore": 51
  },
  {
    "code": "41-3021.00",
    "aptitudeProfile": {
      "Verbal": 75,
      "Numeric": 77,
      "Spatial": 11,
      "ClericalPerception": 35,
      "FormPerception": 32,
      "GeneralLearning": 32
    },
    "interestProfile": {
      "Artistic": 73,
      "Scientific": 38,
      "Plants/Animals": 78,
      "Protective": 32,
      "Mechanical": 11,
      "Industrial": 80,
      "Business Detail": 74,
      "Selling": 60,
      "Accommodating": 68,
      "Humanitarian": 87,
      "Leading/Influencing": 77,
      "Physical Performing": 75
    },
    "fitScore": 53
  },
  {
    "code": "41-3031.00",
    "aptitudeProfile": {
      "Verbal": 67,
      "Numeric": 86,
      "Spatial": 15,
      "ClericalPerception": 73,
      "FormPerception": 50,
      "GeneralLearning": 62
    },
    "interestProfile": {
      "Artistic": 65,
      "Scientific": 69,
      "Plants/Animals": 87,
      "Protective": 50,
      "Mechanical": 15,
      "Industrial": 71,
      "Business Detail": 84,
      "Selling": 78,
      "Accommodating": 77,
      "Humanitarian": 70,
      "Leading/Influencing": 85,
      "Physical Performing": 84
    },
    "fitScore": 64
  },
  {
    "code": "41-3041.00",
    "aptitudeProfile": {
      "Verbal": 60,
      "Numeric": 46,
      "Spatial": 26,
      "ClericalPerception": 23,
      "FormPerception": 6,
      "GeneralLearning": 24
    },
    "interestProfile": {
      "Artistic": 58,
      "Scientific": 36,
      "Plants/Animals": 67,
      "Protective": 6,
      "Mechanical": 26,
      "Industrial": 73,
      "Business Detail": 15,
      "Selling": 67,
      "Accommodating": 36,
      "Humanitarian": 86,
      "Leading/Influencing": 56,
      "Physical Performing": 20
    },
    "fitScore": 38
  },
  {
    "code": "41-4011.00",
    "aptitudeProfile": {
      "Verbal": 79,
      "Numeric": 67,
      "Spatial": 44,
      "ClericalPerception": 46,
      "FormPerception": 23,
      "GeneralLearning": 38
    },
    "interestProfile": {
      "Artistic": 81,
      "Scientific": 50,
      "Plants/Animals": 70,
      "Protective": 23,
      "Mechanical": 44,
      "Industrial": 71,
      "Business Detail": 61,
      "Selling": 75,
      "Accommodating": 53,
      "Humanitarian": 81,
      "Leading/Influencing": 69,
      "Physical Performing": 67
    },
    "fitScore": 56
  },
  {
    "code": "41-4011.07",
    "aptitudeProfile": {
      "Verbal": 62,
      "Numeric": 71,
      "Spatial": 28,
      "ClericalPerception": 40,
      "FormPerception": 40,
      "GeneralLearning": 35
    },
    "interestProfile": {
      "Artistic": 62,
      "Scientific": 42,
      "Plants/Animals": 69,
      "Protective": 40,
      "Mechanical": 28,
      "Industrial": 62,
      "Business Detail": 74,
      "Selling": 63,
      "Accommodating": 65,
      "Humanitarian": 23,
      "Leading/Influencing": 65,
      "Physical Performing": 79
    },
    "fitScore": 51
  },
  {
    "code": "41-4012.00",
    "aptitudeProfile": {
      "Verbal": 62,
      "Numeric": 53,
      "Spatial": 4,
      "ClericalPerception": 25,
      "FormPerception": 4,
      "GeneralLearning": 22
    },
    "interestProfile": {
      "Artistic": 67,
      "Scientific": 35,
      "Plants/Animals": 38,
      "Protective": 4,
      "Mechanical": 4,
      "Industrial": 36,
      "Business Detail": 79,
      "Selling": 64,
      "Accommodating": 19,
      "Humanitarian": 15,
      "Leading/Influencing": 40,
      "Physical Performing": 84
    },
    "fitScore": 34
  },
  {
    "code": "41-9011.00",
    "aptitudeProfile": {
      "Verbal": 29,
      "Numeric": 17,
      "Spatial": 15,
      "ClericalPerception": 38,
      "FormPerception": 26,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 38,
      "Scientific": 26,
      "Plants/Animals": 22,
      "Protective": 26,
      "Mechanical": 15,
      "Industrial": 24,
      "Business Detail": 6,
      "Selling": 49,
      "Accommodating": 18,
      "Humanitarian": 10,
      "Leading/Influencing": 10,
      "Physical Performing": 18
    },
    "fitScore": 23
  },
  {
    "code": "41-9012.00",
    "aptitudeProfile": {
      "Verbal": 1,
      "Numeric": 2,
      "Spatial": 5,
      "ClericalPerception": 0,
      "FormPerception": 0,
      "GeneralLearning": 0
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 1,
      "Plants/Animals": 3,
      "Protective": 0,
      "Mechanical": 5,
      "Industrial": 12,
      "Business Detail": 0,
      "Selling": 5,
      "Accommodating": 0,
      "Humanitarian": 5,
      "Leading/Influencing": 1,
      "Physical Performing": 12
    },
    "fitScore": 3
  },
  {
    "code": "41-9021.00",
    "aptitudeProfile": {
      "Verbal": 79,
      "Numeric": 55,
      "Spatial": 2,
      "ClericalPerception": 10,
      "FormPerception": 3,
      "GeneralLearning": 49
    },
    "interestProfile": {
      "Artistic": 70,
      "Scientific": 44,
      "Plants/Animals": 44,
      "Protective": 3,
      "Mechanical": 2,
      "Industrial": 75,
      "Business Detail": 84,
      "Selling": 52,
      "Accommodating": 31,
      "Humanitarian": 21,
      "Leading/Influencing": 90,
      "Physical Performing": 66
    },
    "fitScore": 41
  },
  {
    "code": "41-9022.00",
    "aptitudeProfile": {
      "Verbal": 70,
      "Numeric": 76,
      "Spatial": 33,
      "ClericalPerception": 40,
      "FormPerception": 39,
      "GeneralLearning": 34
    },
    "interestProfile": {
      "Artistic": 65,
      "Scientific": 42,
      "Plants/Animals": 73,
      "Protective": 39,
      "Mechanical": 33,
      "Industrial": 70,
      "Business Detail": 85,
      "Selling": 64,
      "Accommodating": 70,
      "Humanitarian": 26,
      "Leading/Influencing": 91,
      "Physical Performing": 74
    },
    "fitScore": 55
  },
  {
    "code": "41-9031.00",
    "aptitudeProfile": {
      "Verbal": 88,
      "Numeric": 88,
      "Spatial": 82,
      "ClericalPerception": 85,
      "FormPerception": 46,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 83,
      "Scientific": 89,
      "Plants/Animals": 88,
      "Protective": 46,
      "Mechanical": 82,
      "Industrial": 87,
      "Business Detail": 94,
      "Selling": 89,
      "Accommodating": 74,
      "Humanitarian": 91,
      "Leading/Influencing": 92,
      "Physical Performing": 91
    },
    "fitScore": 81
  },
  {
    "code": "41-9041.00",
    "aptitudeProfile": {
      "Verbal": 38,
      "Numeric": 4,
      "Spatial": 1,
      "ClericalPerception": 0,
      "FormPerception": 0,
      "GeneralLearning": 6
    },
    "interestProfile": {
      "Artistic": 38,
      "Scientific": 7,
      "Plants/Animals": 4,
      "Protective": 0,
      "Mechanical": 1,
      "Industrial": 7,
      "Business Detail": 20,
      "Selling": 30,
      "Accommodating": 1,
      "Humanitarian": 55,
      "Leading/Influencing": 8,
      "Physical Performing": 24
    },
    "fitScore": 12
  },
  {
    "code": "41-9091.00",
    "aptitudeProfile": {
      "Verbal": 35,
      "Numeric": 13,
      "Spatial": 7,
      "ClericalPerception": 2,
      "FormPerception": 0,
      "GeneralLearning": 10
    },
    "interestProfile": {
      "Artistic": 40,
      "Scientific": 19,
      "Plants/Animals": 17,
      "Protective": 0,
      "Mechanical": 7,
      "Industrial": 10,
      "Business Detail": 22,
      "Selling": 52,
      "Accommodating": 5,
      "Humanitarian": 39,
      "Leading/Influencing": 20,
      "Physical Performing": 20
    },
    "fitScore": 16
  },
  {
    "code": "43-1011.00",
    "aptitudeProfile": {
      "Verbal": 87,
      "Numeric": 56,
      "Spatial": 59,
      "ClericalPerception": 61,
      "FormPerception": 28,
      "GeneralLearning": 55
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 64,
      "Plants/Animals": 59,
      "Protective": 28,
      "Mechanical": 59,
      "Industrial": 71,
      "Business Detail": 86,
      "Selling": 78,
      "Accommodating": 46,
      "Humanitarian": 86,
      "Leading/Influencing": 94,
      "Physical Performing": 58
    },
    "fitScore": 62
  },
  {
    "code": "43-2011.00",
    "aptitudeProfile": {
      "Verbal": 35,
      "Numeric": 11,
      "Spatial": 6,
      "ClericalPerception": 6,
      "FormPerception": 11,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 44,
      "Scientific": 9,
      "Plants/Animals": 9,
      "Protective": 11,
      "Mechanical": 6,
      "Industrial": 11,
      "Business Detail": 21,
      "Selling": 24,
      "Accommodating": 4,
      "Humanitarian": 40,
      "Leading/Influencing": 14,
      "Physical Performing": 36
    },
    "fitScore": 16
  },
  {
    "code": "43-2021.00",
    "aptitudeProfile": {
      "Verbal": 28,
      "Numeric": 6,
      "Spatial": 1,
      "ClericalPerception": 1,
      "FormPerception": 7,
      "GeneralLearning": 11
    },
    "interestProfile": {
      "Artistic": 37,
      "Scientific": 6,
      "Plants/Animals": 11,
      "Protective": 7,
      "Mechanical": 1,
      "Industrial": 10,
      "Business Detail": 3,
      "Selling": 17,
      "Accommodating": 9,
      "Humanitarian": 40,
      "Leading/Influencing": 8,
      "Physical Performing": 8
    },
    "fitScore": 11
  },
  {
    "code": "43-3011.00",
    "aptitudeProfile": {
      "Verbal": 53,
      "Numeric": 58,
      "Spatial": 18,
      "ClericalPerception": 22,
      "FormPerception": 19,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 55,
      "Scientific": 16,
      "Plants/Animals": 57,
      "Protective": 19,
      "Mechanical": 18,
      "Industrial": 41,
      "Business Detail": 66,
      "Selling": 35,
      "Accommodating": 32,
      "Humanitarian": 53,
      "Leading/Influencing": 62,
      "Physical Performing": 58
    },
    "fitScore": 37
  },
  {
    "code": "43-3021.00",
    "aptitudeProfile": {
      "Verbal": 47,
      "Numeric": 77,
      "Spatial": 6,
      "ClericalPerception": 7,
      "FormPerception": 34,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 39,
      "Scientific": 15,
      "Plants/Animals": 75,
      "Protective": 34,
      "Mechanical": 6,
      "Industrial": 73,
      "Business Detail": 73,
      "Selling": 11,
      "Accommodating": 57,
      "Humanitarian": 71,
      "Leading/Influencing": 82,
      "Physical Performing": 50
    },
    "fitScore": 41
  },
  {
    "code": "43-3031.00",
    "aptitudeProfile": {
      "Verbal": 53,
      "Numeric": 93,
      "Spatial": 11,
      "ClericalPerception": 15,
      "FormPerception": 46,
      "GeneralLearning": 22
    },
    "interestProfile": {
      "Artistic": 62,
      "Scientific": 14,
      "Plants/Animals": 97,
      "Protective": 46,
      "Mechanical": 11,
      "Industrial": 72,
      "Business Detail": 62,
      "Selling": 27,
      "Accommodating": 89,
      "Humanitarian": 60,
      "Leading/Influencing": 70,
      "Physical Performing": 80
    },
    "fitScore": 49
  },
  {
    "code": "43-3041.00",
    "aptitudeProfile": {
      "Verbal": 34,
      "Numeric": 87,
      "Spatial": 9,
      "ClericalPerception": 16,
      "FormPerception": 28,
      "GeneralLearning": 24
    },
    "interestProfile": {
      "Artistic": 39,
      "Scientific": 16,
      "Plants/Animals": 92,
      "Protective": 28,
      "Mechanical": 9,
      "Industrial": 53,
      "Business Detail": 61,
      "Selling": 23,
      "Accommodating": 63,
      "Humanitarian": 42,
      "Leading/Influencing": 68,
      "Physical Performing": 70
    },
    "fitScore": 40
  },
  {
    "code": "43-3051.00",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 92,
      "Spatial": 11,
      "ClericalPerception": 14,
      "FormPerception": 40,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 63,
      "Scientific": 15,
      "Plants/Animals": 92,
      "Protective": 40,
      "Mechanical": 11,
      "Industrial": 82,
      "Business Detail": 97,
      "Selling": 24,
      "Accommodating": 77,
      "Humanitarian": 82,
      "Leading/Influencing": 94,
      "Physical Performing": 90
    },
    "fitScore": 53
  },
  {
    "code": "43-3061.00",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 67,
      "Spatial": 7,
      "ClericalPerception": 33,
      "FormPerception": 12,
      "GeneralLearning": 45
    },
    "interestProfile": {
      "Artistic": 70,
      "Scientific": 44,
      "Plants/Animals": 64,
      "Protective": 12,
      "Mechanical": 7,
      "Industrial": 76,
      "Business Detail": 74,
      "Selling": 53,
      "Accommodating": 40,
      "Humanitarian": 87,
      "Leading/Influencing": 76,
      "Physical Performing": 71
    },
    "fitScore": 48
  },
  {
    "code": "43-3071.00",
    "aptitudeProfile": {
      "Verbal": 40,
      "Numeric": 83,
      "Spatial": 18,
      "ClericalPerception": 50,
      "FormPerception": 52,
      "GeneralLearning": 22
    },
    "interestProfile": {
      "Artistic": 47,
      "Scientific": 27,
      "Plants/Animals": 92,
      "Protective": 52,
      "Mechanical": 18,
      "Industrial": 50,
      "Business Detail": 51,
      "Selling": 52,
      "Accommodating": 67,
      "Humanitarian": 49,
      "Leading/Influencing": 55,
      "Physical Performing": 68
    },
    "fitScore": 48
  },
  {
    "code": "43-4011.00",
    "aptitudeProfile": {
      "Verbal": 51,
      "Numeric": 81,
      "Spatial": 18,
      "ClericalPerception": 28,
      "FormPerception": 42,
      "GeneralLearning": 32
    },
    "interestProfile": {
      "Artistic": 65,
      "Scientific": 30,
      "Plants/Animals": 84,
      "Protective": 42,
      "Mechanical": 18,
      "Industrial": 76,
      "Business Detail": 30,
      "Selling": 44,
      "Accommodating": 68,
      "Humanitarian": 79,
      "Leading/Influencing": 31,
      "Physical Performing": 75
    },
    "fitScore": 48
  },
  {
    "code": "43-4021.00",
    "aptitudeProfile": {
      "Verbal": 67,
      "Numeric": 61,
      "Spatial": 13,
      "ClericalPerception": 34,
      "FormPerception": 21,
      "GeneralLearning": 26
    },
    "interestProfile": {
      "Artistic": 70,
      "Scientific": 35,
      "Plants/Animals": 56,
      "Protective": 21,
      "Mechanical": 13,
      "Industrial": 65,
      "Business Detail": 61,
      "Selling": 54,
      "Accommodating": 42,
      "Humanitarian": 80,
      "Leading/Influencing": 53,
      "Physical Performing": 65
    },
    "fitScore": 44
  },
  {
    "code": "43-4031.00",
    "aptitudeProfile": {
      "Verbal": 55,
      "Numeric": 37,
      "Spatial": 6,
      "ClericalPerception": 11,
      "FormPerception": 22,
      "GeneralLearning": 35
    },
    "interestProfile": {
      "Artistic": 52,
      "Scientific": 30,
      "Plants/Animals": 40,
      "Protective": 22,
      "Mechanical": 6,
      "Industrial": 38,
      "Business Detail": 55,
      "Selling": 35,
      "Accommodating": 38,
      "Humanitarian": 64,
      "Leading/Influencing": 56,
      "Physical Performing": 41
    },
    "fitScore": 34
  },
  {
    "code": "43-4041.00",
    "aptitudeProfile": {
      "Verbal": 45,
      "Numeric": 57,
      "Spatial": 6,
      "ClericalPerception": 6,
      "FormPerception": 20,
      "GeneralLearning": 31
    },
    "interestProfile": {
      "Artistic": 39,
      "Scientific": 22,
      "Plants/Animals": 51,
      "Protective": 20,
      "Mechanical": 6,
      "Industrial": 50,
      "Business Detail": 71,
      "Selling": 20,
      "Accommodating": 43,
      "Humanitarian": 72,
      "Leading/Influencing": 52,
      "Physical Performing": 64
    },
    "fitScore": 35
  },
  {
    "code": "43-4051.00",
    "aptitudeProfile": {
      "Verbal": 60,
      "Numeric": 45,
      "Spatial": 19,
      "ClericalPerception": 19,
      "FormPerception": 22,
      "GeneralLearning": 28
    },
    "interestProfile": {
      "Artistic": 60,
      "Scientific": 30,
      "Plants/Animals": 44,
      "Protective": 22,
      "Mechanical": 19,
      "Industrial": 32,
      "Business Detail": 71,
      "Selling": 54,
      "Accommodating": 45,
      "Humanitarian": 59,
      "Leading/Influencing": 54,
      "Physical Performing": 68
    },
    "fitScore": 39
  },
  {
    "code": "43-4061.00",
    "aptitudeProfile": {
      "Verbal": 82,
      "Numeric": 43,
      "Spatial": 18,
      "ClericalPerception": 16,
      "FormPerception": 13,
      "GeneralLearning": 62
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 54,
      "Plants/Animals": 41,
      "Protective": 13,
      "Mechanical": 18,
      "Industrial": 52,
      "Business Detail": 79,
      "Selling": 53,
      "Accommodating": 39,
      "Humanitarian": 84,
      "Leading/Influencing": 67,
      "Physical Performing": 65
    },
    "fitScore": 46
  },
  {
    "code": "43-4071.00",
    "aptitudeProfile": {
      "Verbal": 49,
      "Numeric": 24,
      "Spatial": 18,
      "ClericalPerception": 70,
      "FormPerception": 81,
      "GeneralLearning": 16
    },
    "interestProfile": {
      "Artistic": 53,
      "Scientific": 22,
      "Plants/Animals": 19,
      "Protective": 81,
      "Mechanical": 18,
      "Industrial": 34,
      "Business Detail": 33,
      "Selling": 45,
      "Accommodating": 28,
      "Humanitarian": 72,
      "Leading/Influencing": 19,
      "Physical Performing": 45
    },
    "fitScore": 41
  },
  {
    "code": "43-4081.00",
    "aptitudeProfile": {
      "Verbal": 37,
      "Numeric": 49,
      "Spatial": 5,
      "ClericalPerception": 18,
      "FormPerception": 4,
      "GeneralLearning": 15
    },
    "interestProfile": {
      "Artistic": 39,
      "Scientific": 24,
      "Plants/Animals": 54,
      "Protective": 4,
      "Mechanical": 5,
      "Industrial": 34,
      "Business Detail": 47,
      "Selling": 53,
      "Accommodating": 23,
      "Humanitarian": 13,
      "Leading/Influencing": 50,
      "Physical Performing": 48
    },
    "fitScore": 27
  },
  {
    "code": "43-4111.00",
    "aptitudeProfile": {
      "Verbal": 56,
      "Numeric": 37,
      "Spatial": 11,
      "ClericalPerception": 3,
      "FormPerception": 3,
      "GeneralLearning": 32
    },
    "interestProfile": {
      "Artistic": 58,
      "Scientific": 25,
      "Plants/Animals": 28,
      "Protective": 3,
      "Mechanical": 11,
      "Industrial": 38,
      "Business Detail": 58,
      "Selling": 32,
      "Accommodating": 14,
      "Humanitarian": 69,
      "Leading/Influencing": 38,
      "Physical Performing": 61
    },
    "fitScore": 30
  },
  {
    "code": "43-4121.00",
    "aptitudeProfile": {
      "Verbal": 26,
      "Numeric": 16,
      "Spatial": 15,
      "ClericalPerception": 17,
      "FormPerception": 45,
      "GeneralLearning": 11
    },
    "interestProfile": {
      "Artistic": 35,
      "Scientific": 9,
      "Plants/Animals": 17,
      "Protective": 45,
      "Mechanical": 15,
      "Industrial": 26,
      "Business Detail": 7,
      "Selling": 11,
      "Accommodating": 18,
      "Humanitarian": 18,
      "Leading/Influencing": 10,
      "Physical Performing": 11
    },
    "fitScore": 20
  },
  {
    "code": "43-4131.00",
    "aptitudeProfile": {
      "Verbal": 73,
      "Numeric": 78,
      "Spatial": 55,
      "ClericalPerception": 51,
      "FormPerception": 44,
      "GeneralLearning": 62
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 60,
      "Plants/Animals": 81,
      "Protective": 44,
      "Mechanical": 55,
      "Industrial": 80,
      "Business Detail": 58,
      "Selling": 68,
      "Accommodating": 71,
      "Humanitarian": 84,
      "Leading/Influencing": 69,
      "Physical Performing": 74
    },
    "fitScore": 64
  },
  {
    "code": "43-4141.00",
    "aptitudeProfile": {
      "Verbal": 54,
      "Numeric": 72,
      "Spatial": 12,
      "ClericalPerception": 23,
      "FormPerception": 17,
      "GeneralLearning": 27
    },
    "interestProfile": {
      "Artistic": 57,
      "Scientific": 26,
      "Plants/Animals": 71,
      "Protective": 17,
      "Mechanical": 12,
      "Industrial": 62,
      "Business Detail": 61,
      "Selling": 45,
      "Accommodating": 43,
      "Humanitarian": 69,
      "Leading/Influencing": 59,
      "Physical Performing": 75
    },
    "fitScore": 42
  },
  {
    "code": "43-4151.00",
    "aptitudeProfile": {
      "Verbal": 59,
      "Numeric": 70,
      "Spatial": 19,
      "ClericalPerception": 43,
      "FormPerception": 66,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 60,
      "Scientific": 22,
      "Plants/Animals": 59,
      "Protective": 66,
      "Mechanical": 19,
      "Industrial": 63,
      "Business Detail": 75,
      "Selling": 41,
      "Accommodating": 49,
      "Humanitarian": 68,
      "Leading/Influencing": 70,
      "Physical Performing": 80
    },
    "fitScore": 51
  },
  {
    "code": "43-4161.00",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 18,
      "Spatial": 13,
      "ClericalPerception": 27,
      "FormPerception": 23,
      "GeneralLearning": 24
    },
    "interestProfile": {
      "Artistic": 72,
      "Scientific": 30,
      "Plants/Animals": 17,
      "Protective": 23,
      "Mechanical": 13,
      "Industrial": 47,
      "Business Detail": 45,
      "Selling": 56,
      "Accommodating": 19,
      "Humanitarian": 87,
      "Leading/Influencing": 43,
      "Physical Performing": 38
    },
    "fitScore": 36
  },
  {
    "code": "43-4171.00",
    "aptitudeProfile": {
      "Verbal": 41,
      "Numeric": 28,
      "Spatial": 16,
      "ClericalPerception": 19,
      "FormPerception": 15,
      "GeneralLearning": 7
    },
    "interestProfile": {
      "Artistic": 54,
      "Scientific": 10,
      "Plants/Animals": 36,
      "Protective": 15,
      "Mechanical": 16,
      "Industrial": 18,
      "Business Detail": 19,
      "Selling": 36,
      "Accommodating": 18,
      "Humanitarian": 48,
      "Leading/Influencing": 13,
      "Physical Performing": 36
    },
    "fitScore": 24
  },
  {
    "code": "43-4181.00",
    "aptitudeProfile": {
      "Verbal": 41,
      "Numeric": 41,
      "Spatial": 18,
      "ClericalPerception": 40,
      "FormPerception": 36,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 55,
      "Scientific": 29,
      "Plants/Animals": 41,
      "Protective": 36,
      "Mechanical": 18,
      "Industrial": 48,
      "Business Detail": 13,
      "Selling": 55,
      "Accommodating": 41,
      "Humanitarian": 64,
      "Leading/Influencing": 19,
      "Physical Performing": 42
    },
    "fitScore": 36
  },
  {
    "code": "43-5011.00",
    "aptitudeProfile": {
      "Verbal": 65,
      "Numeric": 40,
      "Spatial": 6,
      "ClericalPerception": 26,
      "FormPerception": 45,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 61,
      "Scientific": 17,
      "Plants/Animals": 49,
      "Protective": 45,
      "Mechanical": 6,
      "Industrial": 31,
      "Business Detail": 68,
      "Selling": 39,
      "Accommodating": 36,
      "Humanitarian": 13,
      "Leading/Influencing": 73,
      "Physical Performing": 44
    },
    "fitScore": 37
  },
  {
    "code": "43-5011.01",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 79,
      "Spatial": 23,
      "ClericalPerception": 70,
      "FormPerception": 72,
      "GeneralLearning": 35
    },
    "interestProfile": {
      "Artistic": 61,
      "Scientific": 42,
      "Plants/Animals": 78,
      "Protective": 72,
      "Mechanical": 23,
      "Industrial": 70,
      "Business Detail": 95,
      "Selling": 58,
      "Accommodating": 73,
      "Humanitarian": 21,
      "Leading/Influencing": 96,
      "Physical Performing": 76
    },
    "fitScore": 61
  },
  {
    "code": "43-5021.00",
    "aptitudeProfile": {
      "Verbal": 16,
      "Numeric": 14,
      "Spatial": 48,
      "ClericalPerception": 15,
      "FormPerception": 21,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 29,
      "Scientific": 9,
      "Plants/Animals": 17,
      "Protective": 21,
      "Mechanical": 48,
      "Industrial": 27,
      "Business Detail": 1,
      "Selling": 12,
      "Accommodating": 8,
      "Humanitarian": 32,
      "Leading/Influencing": 8,
      "Physical Performing": 5
    },
    "fitScore": 20
  },
  {
    "code": "43-5031.00",
    "aptitudeProfile": {
      "Verbal": 64,
      "Numeric": 10,
      "Spatial": 38,
      "ClericalPerception": 70,
      "FormPerception": 68,
      "GeneralLearning": 59
    },
    "interestProfile": {
      "Artistic": 67,
      "Scientific": 59,
      "Plants/Animals": 17,
      "Protective": 68,
      "Mechanical": 38,
      "Industrial": 33,
      "Business Detail": 11,
      "Selling": 71,
      "Accommodating": 28,
      "Humanitarian": 74,
      "Leading/Influencing": 26,
      "Physical Performing": 17
    },
    "fitScore": 47
  },
  {
    "code": "43-5032.00",
    "aptitudeProfile": {
      "Verbal": 71,
      "Numeric": 22,
      "Spatial": 26,
      "ClericalPerception": 49,
      "FormPerception": 42,
      "GeneralLearning": 42
    },
    "interestProfile": {
      "Artistic": 63,
      "Scientific": 43,
      "Plants/Animals": 29,
      "Protective": 42,
      "Mechanical": 26,
      "Industrial": 38,
      "Business Detail": 54,
      "Selling": 57,
      "Accommodating": 27,
      "Humanitarian": 75,
      "Leading/Influencing": 66,
      "Physical Performing": 29
    },
    "fitScore": 44
  },
  {
    "code": "43-5041.00",
    "aptitudeProfile": {
      "Verbal": 14,
      "Numeric": 42,
      "Spatial": 28,
      "ClericalPerception": 22,
      "FormPerception": 41,
      "GeneralLearning": 9
    },
    "interestProfile": {
      "Artistic": 15,
      "Scientific": 7,
      "Plants/Animals": 46,
      "Protective": 41,
      "Mechanical": 28,
      "Industrial": 24,
      "Business Detail": 29,
      "Selling": 8,
      "Accommodating": 28,
      "Humanitarian": 23,
      "Leading/Influencing": 23,
      "Physical Performing": 25
    },
    "fitScore": 25
  },
  {
    "code": "43-5051.00",
    "aptitudeProfile": {
      "Verbal": 39,
      "Numeric": 65,
      "Spatial": 18,
      "ClericalPerception": 14,
      "FormPerception": 40,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 44,
      "Scientific": 12,
      "Plants/Animals": 71,
      "Protective": 40,
      "Mechanical": 18,
      "Industrial": 40,
      "Business Detail": 51,
      "Selling": 22,
      "Accommodating": 46,
      "Humanitarian": 48,
      "Leading/Influencing": 51,
      "Physical Performing": 64
    },
    "fitScore": 38
  },
  {
    "code": "43-5052.00",
    "aptitudeProfile": {
      "Verbal": 9,
      "Numeric": 6,
      "Spatial": 17,
      "ClericalPerception": 6,
      "FormPerception": 31,
      "GeneralLearning": 8
    },
    "interestProfile": {
      "Artistic": 8,
      "Scientific": 5,
      "Plants/Animals": 5,
      "Protective": 31,
      "Mechanical": 17,
      "Industrial": 4,
      "Business Detail": 15,
      "Selling": 4,
      "Accommodating": 7,
      "Humanitarian": 17,
      "Leading/Influencing": 9,
      "Physical Performing": 6
    },
    "fitScore": 12
  },
  {
    "code": "43-5053.00",
    "aptitudeProfile": {
      "Verbal": 7,
      "Numeric": 7,
      "Spatial": 13,
      "ClericalPerception": 15,
      "FormPerception": 29,
      "GeneralLearning": 11
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 7,
      "Plants/Animals": 12,
      "Protective": 29,
      "Mechanical": 13,
      "Industrial": 13,
      "Business Detail": 1,
      "Selling": 3,
      "Accommodating": 7,
      "Humanitarian": 39,
      "Leading/Influencing": 5,
      "Physical Performing": 1
    },
    "fitScore": 13
  },
  {
    "code": "43-5061.00",
    "aptitudeProfile": {
      "Verbal": 62,
      "Numeric": 50,
      "Spatial": 51,
      "ClericalPerception": 49,
      "FormPerception": 49,
      "GeneralLearning": 34
    },
    "interestProfile": {
      "Artistic": 56,
      "Scientific": 35,
      "Plants/Animals": 57,
      "Protective": 49,
      "Mechanical": 51,
      "Industrial": 57,
      "Business Detail": 59,
      "Selling": 48,
      "Accommodating": 45,
      "Humanitarian": 74,
      "Leading/Influencing": 72,
      "Physical Performing": 43
    },
    "fitScore": 52
  },
  {
    "code": "43-5071.00",
    "aptitudeProfile": {
      "Verbal": 19,
      "Numeric": 34,
      "Spatial": 21,
      "ClericalPerception": 43,
      "FormPerception": 35,
      "GeneralLearning": 16
    },
    "interestProfile": {
      "Artistic": 16,
      "Scientific": 20,
      "Plants/Animals": 32,
      "Protective": 35,
      "Mechanical": 21,
      "Industrial": 26,
      "Business Detail": 40,
      "Selling": 16,
      "Accommodating": 18,
      "Humanitarian": 19,
      "Leading/Influencing": 34,
      "Physical Performing": 19
    },
    "fitScore": 26
  },
  {
    "code": "43-5111.00",
    "aptitudeProfile": {
      "Verbal": 27,
      "Numeric": 72,
      "Spatial": 12,
      "ClericalPerception": 30,
      "FormPerception": 79,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 25,
      "Scientific": 14,
      "Plants/Animals": 73,
      "Protective": 79,
      "Mechanical": 12,
      "Industrial": 49,
      "Business Detail": 64,
      "Selling": 9,
      "Accommodating": 72,
      "Humanitarian": 13,
      "Leading/Influencing": 60,
      "Physical Performing": 48
    },
    "fitScore": 42
  },
  {
    "code": "43-6011.00",
    "aptitudeProfile": {
      "Verbal": 77,
      "Numeric": 47,
      "Spatial": 28,
      "ClericalPerception": 68,
      "FormPerception": 66,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 32,
      "Plants/Animals": 60,
      "Protective": 66,
      "Mechanical": 28,
      "Industrial": 70,
      "Business Detail": 34,
      "Selling": 63,
      "Accommodating": 63,
      "Humanitarian": 87,
      "Leading/Influencing": 59,
      "Physical Performing": 35
    },
    "fitScore": 54
  },
  {
    "code": "43-6012.00",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 18,
      "Spatial": 26,
      "ClericalPerception": 18,
      "FormPerception": 4,
      "GeneralLearning": 14
    },
    "interestProfile": {
      "Artistic": 74,
      "Scientific": 21,
      "Plants/Animals": 22,
      "Protective": 4,
      "Mechanical": 26,
      "Industrial": 51,
      "Business Detail": 23,
      "Selling": 54,
      "Accommodating": 7,
      "Humanitarian": 87,
      "Leading/Influencing": 34,
      "Physical Performing": 26
    },
    "fitScore": 31
  },
  {
    "code": "43-6013.00",
    "aptitudeProfile": {
      "Verbal": 59,
      "Numeric": 25,
      "Spatial": 13,
      "ClericalPerception": 2,
      "FormPerception": 2,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 61,
      "Scientific": 15,
      "Plants/Animals": 21,
      "Protective": 2,
      "Mechanical": 13,
      "Industrial": 30,
      "Business Detail": 50,
      "Selling": 28,
      "Accommodating": 7,
      "Humanitarian": 64,
      "Leading/Influencing": 40,
      "Physical Performing": 51
    },
    "fitScore": 26
  },
  {
    "code": "43-6014.00",
    "aptitudeProfile": {
      "Verbal": 77,
      "Numeric": 21,
      "Spatial": 18,
      "ClericalPerception": 6,
      "FormPerception": 2,
      "GeneralLearning": 16
    },
    "interestProfile": {
      "Artistic": 76,
      "Scientific": 16,
      "Plants/Animals": 17,
      "Protective": 2,
      "Mechanical": 18,
      "Industrial": 40,
      "Business Detail": 55,
      "Selling": 38,
      "Accommodating": 4,
      "Humanitarian": 83,
      "Leading/Influencing": 37,
      "Physical Performing": 52
    },
    "fitScore": 30
  },
  {
    "code": "43-9021.00",
    "aptitudeProfile": {
      "Verbal": 30,
      "Numeric": 28,
      "Spatial": 32,
      "ClericalPerception": 39,
      "FormPerception": 69,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 29,
      "Scientific": 11,
      "Plants/Animals": 26,
      "Protective": 69,
      "Mechanical": 32,
      "Industrial": 32,
      "Business Detail": 28,
      "Selling": 13,
      "Accommodating": 31,
      "Humanitarian": 71,
      "Leading/Influencing": 15,
      "Physical Performing": 30
    },
    "fitScore": 34
  },
  {
    "code": "43-9022.00",
    "aptitudeProfile": {
      "Verbal": 30,
      "Numeric": 25,
      "Spatial": 40,
      "ClericalPerception": 15,
      "FormPerception": 36,
      "GeneralLearning": 9
    },
    "interestProfile": {
      "Artistic": 34,
      "Scientific": 6,
      "Plants/Animals": 29,
      "Protective": 36,
      "Mechanical": 40,
      "Industrial": 50,
      "Business Detail": 6,
      "Selling": 8,
      "Accommodating": 20,
      "Humanitarian": 68,
      "Leading/Influencing": 26,
      "Physical Performing": 7
    },
    "fitScore": 27
  },
  {
    "code": "43-9031.00",
    "aptitudeProfile": {
      "Verbal": 42,
      "Numeric": 21,
      "Spatial": 58,
      "ClericalPerception": 98,
      "FormPerception": 86,
      "GeneralLearning": 34
    },
    "interestProfile": {
      "Artistic": 50,
      "Scientific": 61,
      "Plants/Animals": 24,
      "Protective": 86,
      "Mechanical": 58,
      "Industrial": 40,
      "Business Detail": 9,
      "Selling": 79,
      "Accommodating": 33,
      "Humanitarian": 21,
      "Leading/Influencing": 7,
      "Physical Performing": 25
    },
    "fitScore": 49
  },
  {
    "code": "43-9041.00",
    "aptitudeProfile": {
      "Verbal": 37,
      "Numeric": 45,
      "Spatial": 9,
      "ClericalPerception": 18,
      "FormPerception": 28,
      "GeneralLearning": 25
    },
    "interestProfile": {
      "Artistic": 44,
      "Scientific": 21,
      "Plants/Animals": 53,
      "Protective": 28,
      "Mechanical": 9,
      "Industrial": 42,
      "Business Detail": 22,
      "Selling": 23,
      "Accommodating": 35,
      "Humanitarian": 68,
      "Leading/Influencing": 21,
      "Physical Performing": 34
    },
    "fitScore": 30
  },
  {
    "code": "43-9051.00",
    "aptitudeProfile": {
      "Verbal": 17,
      "Numeric": 23,
      "Spatial": 9,
      "ClericalPerception": 11,
      "FormPerception": 27,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 15,
      "Scientific": 9,
      "Plants/Animals": 18,
      "Protective": 27,
      "Mechanical": 9,
      "Industrial": 19,
      "Business Detail": 30,
      "Selling": 6,
      "Accommodating": 12,
      "Humanitarian": 11,
      "Leading/Influencing": 11,
      "Physical Performing": 17
    },
    "fitScore": 16
  },
  {
    "code": "43-9061.00",
    "aptitudeProfile": {
      "Verbal": 54,
      "Numeric": 39,
      "Spatial": 18,
      "ClericalPerception": 23,
      "FormPerception": 25,
      "GeneralLearning": 16
    },
    "interestProfile": {
      "Artistic": 55,
      "Scientific": 19,
      "Plants/Animals": 56,
      "Protective": 25,
      "Mechanical": 18,
      "Industrial": 40,
      "Business Detail": 30,
      "Selling": 35,
      "Accommodating": 43,
      "Humanitarian": 77,
      "Leading/Influencing": 27,
      "Physical Performing": 31
    },
    "fitScore": 34
  },
  {
    "code": "43-9071.00",
    "aptitudeProfile": {
      "Verbal": 14,
      "Numeric": 45,
      "Spatial": 66,
      "ClericalPerception": 12,
      "FormPerception": 26,
      "GeneralLearning": 7
    },
    "interestProfile": {
      "Artistic": 19,
      "Scientific": 6,
      "Plants/Animals": 55,
      "Protective": 26,
      "Mechanical": 66,
      "Industrial": 29,
      "Business Detail": 13,
      "Selling": 6,
      "Accommodating": 33,
      "Humanitarian": 45,
      "Leading/Influencing": 13,
      "Physical Performing": 16
    },
    "fitScore": 28
  },
  {
    "code": "43-9081.00",
    "aptitudeProfile": {
      "Verbal": 63,
      "Numeric": 5,
      "Spatial": 12,
      "ClericalPerception": 14,
      "FormPerception": 38,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 68,
      "Scientific": 8,
      "Plants/Animals": 4,
      "Protective": 38,
      "Mechanical": 12,
      "Industrial": 45,
      "Business Detail": 4,
      "Selling": 16,
      "Accommodating": 9,
      "Humanitarian": 93,
      "Leading/Influencing": 6,
      "Physical Performing": 12
    },
    "fitScore": 25
  },
  {
    "code": "43-9111.00",
    "aptitudeProfile": {
      "Verbal": 67,
      "Numeric": 100,
      "Spatial": 70,
      "ClericalPerception": 72,
      "FormPerception": 71,
      "GeneralLearning": 65
    },
    "interestProfile": {
      "Artistic": 71,
      "Scientific": 68,
      "Plants/Animals": 100,
      "Protective": 71,
      "Mechanical": 70,
      "Industrial": 98,
      "Business Detail": 81,
      "Selling": 68,
      "Accommodating": 99,
      "Humanitarian": 80,
      "Leading/Influencing": 96,
      "Physical Performing": 90
    },
    "fitScore": 78
  },
  {
    "code": "45-1011.00",
    "aptitudeProfile": {
      "Verbal": 55,
      "Numeric": 56,
      "Spatial": 69,
      "ClericalPerception": 66,
      "FormPerception": 66,
      "GeneralLearning": 44
    },
    "interestProfile": {
      "Artistic": 41,
      "Scientific": 48,
      "Plants/Animals": 54,
      "Protective": 66,
      "Mechanical": 69,
      "Industrial": 63,
      "Business Detail": 76,
      "Selling": 56,
      "Accommodating": 57,
      "Humanitarian": 42,
      "Leading/Influencing": 89,
      "Physical Performing": 48
    },
    "fitScore": 59
  },
  {
    "code": "45-2011.00",
    "aptitudeProfile": {
      "Verbal": 59,
      "Numeric": 48,
      "Spatial": 40,
      "ClericalPerception": 64,
      "FormPerception": 92,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 52,
      "Scientific": 66,
      "Plants/Animals": 38,
      "Protective": 92,
      "Mechanical": 40,
      "Industrial": 63,
      "Business Detail": 66,
      "Selling": 47,
      "Accommodating": 70,
      "Humanitarian": 36,
      "Leading/Influencing": 66,
      "Physical Performing": 60
    },
    "fitScore": 61
  },
  {
    "code": "45-2021.00",
    "aptitudeProfile": {
      "Verbal": 15,
      "Numeric": 33,
      "Spatial": 16,
      "ClericalPerception": 5,
      "FormPerception": 31,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 8,
      "Scientific": 12,
      "Plants/Animals": 27,
      "Protective": 31,
      "Mechanical": 16,
      "Industrial": 16,
      "Business Detail": 73,
      "Selling": 4,
      "Accommodating": 31,
      "Humanitarian": 11,
      "Leading/Influencing": 54,
      "Physical Performing": 25
    },
    "fitScore": 23
  },
  {
    "code": "45-2041.00",
    "aptitudeProfile": {
      "Verbal": 1,
      "Numeric": 4,
      "Spatial": 1,
      "ClericalPerception": 1,
      "FormPerception": 2,
      "GeneralLearning": 1
    },
    "interestProfile": {
      "Artistic": 1,
      "Scientific": 3,
      "Plants/Animals": 4,
      "Protective": 2,
      "Mechanical": 1,
      "Industrial": 1,
      "Business Detail": 3,
      "Selling": 22,
      "Accommodating": 2,
      "Humanitarian": 8,
      "Leading/Influencing": 2,
      "Physical Performing": 3
    },
    "fitScore": 3
  },
  {
    "code": "45-2091.00",
    "aptitudeProfile": {
      "Verbal": 2,
      "Numeric": 9,
      "Spatial": 51,
      "ClericalPerception": 18,
      "FormPerception": 36,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 4,
      "Scientific": 11,
      "Plants/Animals": 4,
      "Protective": 36,
      "Mechanical": 51,
      "Industrial": 2,
      "Business Detail": 9,
      "Selling": 11,
      "Accommodating": 6,
      "Humanitarian": 10,
      "Leading/Influencing": 3,
      "Physical Performing": 17
    },
    "fitScore": 18
  },
  {
    "code": "45-2092.00",
    "aptitudeProfile": {
      "Verbal": 10,
      "Numeric": 21,
      "Spatial": 60,
      "ClericalPerception": 12,
      "FormPerception": 14,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 16,
      "Plants/Animals": 22,
      "Protective": 14,
      "Mechanical": 60,
      "Industrial": 12,
      "Business Detail": 18,
      "Selling": 12,
      "Accommodating": 21,
      "Humanitarian": 24,
      "Leading/Influencing": 18,
      "Physical Performing": 9
    },
    "fitScore": 21
  },
  {
    "code": "45-2093.00",
    "aptitudeProfile": {
      "Verbal": 18,
      "Numeric": 24,
      "Spatial": 55,
      "ClericalPerception": 27,
      "FormPerception": 55,
      "GeneralLearning": 29
    },
    "interestProfile": {
      "Artistic": 14,
      "Scientific": 25,
      "Plants/Animals": 19,
      "Protective": 55,
      "Mechanical": 55,
      "Industrial": 16,
      "Business Detail": 48,
      "Selling": 19,
      "Accommodating": 27,
      "Humanitarian": 26,
      "Leading/Influencing": 33,
      "Physical Performing": 30
    },
    "fitScore": 33
  },
  {
    "code": "45-3031.00",
    "aptitudeProfile": {
      "Verbal": 3,
      "Numeric": 3,
      "Spatial": 43,
      "ClericalPerception": 8,
      "FormPerception": 23,
      "GeneralLearning": 11
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 9,
      "Plants/Animals": 3,
      "Protective": 23,
      "Mechanical": 43,
      "Industrial": 1,
      "Business Detail": 8,
      "Selling": 5,
      "Accommodating": 43,
      "Humanitarian": 13,
      "Leading/Influencing": 3,
      "Physical Performing": 2
    },
    "fitScore": 14
  },
  {
    "code": "45-4011.00",
    "aptitudeProfile": {
      "Verbal": 21,
      "Numeric": 15,
      "Spatial": 76,
      "ClericalPerception": 46,
      "FormPerception": 68,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 18,
      "Scientific": 23,
      "Plants/Animals": 15,
      "Protective": 68,
      "Mechanical": 76,
      "Industrial": 17,
      "Business Detail": 24,
      "Selling": 29,
      "Accommodating": 30,
      "Humanitarian": 33,
      "Leading/Influencing": 32,
      "Physical Performing": 13
    },
    "fitScore": 36
  },
  {
    "code": "45-4021.00",
    "aptitudeProfile": {
      "Verbal": 1,
      "Numeric": 19,
      "Spatial": 86,
      "ClericalPerception": 16,
      "FormPerception": 76,
      "GeneralLearning": 10
    },
    "interestProfile": {
      "Artistic": 2,
      "Scientific": 7,
      "Plants/Animals": 27,
      "Protective": 76,
      "Mechanical": 86,
      "Industrial": 4,
      "Business Detail": 6,
      "Selling": 3,
      "Accommodating": 41,
      "Humanitarian": 15,
      "Leading/Influencing": 15,
      "Physical Performing": 2
    },
    "fitScore": 29
  },
  {
    "code": "45-4022.00",
    "aptitudeProfile": {
      "Verbal": 3,
      "Numeric": 18,
      "Spatial": 88,
      "ClericalPerception": 20,
      "FormPerception": 59,
      "GeneralLearning": 10
    },
    "interestProfile": {
      "Artistic": 4,
      "Scientific": 7,
      "Plants/Animals": 32,
      "Protective": 59,
      "Mechanical": 88,
      "Industrial": 11,
      "Business Detail": 2,
      "Selling": 4,
      "Accommodating": 32,
      "Humanitarian": 27,
      "Leading/Influencing": 14,
      "Physical Performing": 1
    },
    "fitScore": 28
  },
  {
    "code": "45-4023.00",
    "aptitudeProfile": {
      "Verbal": 23,
      "Numeric": 68,
      "Spatial": 49,
      "ClericalPerception": 43,
      "FormPerception": 76,
      "GeneralLearning": 29
    },
    "interestProfile": {
      "Artistic": 24,
      "Scientific": 26,
      "Plants/Animals": 75,
      "Protective": 76,
      "Mechanical": 49,
      "Industrial": 34,
      "Business Detail": 52,
      "Selling": 19,
      "Accommodating": 74,
      "Humanitarian": 18,
      "Leading/Influencing": 54,
      "Physical Performing": 40
    },
    "fitScore": 47
  },
  {
    "code": "47-1011.00",
    "aptitudeProfile": {
      "Verbal": 62,
      "Numeric": 69,
      "Spatial": 58,
      "ClericalPerception": 65,
      "FormPerception": 57,
      "GeneralLearning": 39
    },
    "interestProfile": {
      "Artistic": 48,
      "Scientific": 45,
      "Plants/Animals": 74,
      "Protective": 57,
      "Mechanical": 58,
      "Industrial": 55,
      "Business Detail": 89,
      "Selling": 63,
      "Accommodating": 65,
      "Humanitarian": 31,
      "Leading/Influencing": 91,
      "Physical Performing": 68
    },
    "fitScore": 60
  },
  {
    "code": "47-1011.03",
    "aptitudeProfile": {
      "Verbal": 71,
      "Numeric": 61,
      "Spatial": 60,
      "ClericalPerception": 55,
      "FormPerception": 60,
      "GeneralLearning": 53
    },
    "interestProfile": {
      "Artistic": 65,
      "Scientific": 52,
      "Plants/Animals": 64,
      "Protective": 60,
      "Mechanical": 60,
      "Industrial": 63,
      "Business Detail": 74,
      "Selling": 55,
      "Accommodating": 63,
      "Humanitarian": 31,
      "Leading/Influencing": 83,
      "Physical Performing": 54
    },
    "fitScore": 60
  },
  {
    "code": "47-2011.00",
    "aptitudeProfile": {
      "Verbal": 19,
      "Numeric": 52,
      "Spatial": 67,
      "ClericalPerception": 57,
      "FormPerception": 63,
      "GeneralLearning": 56
    },
    "interestProfile": {
      "Artistic": 20,
      "Scientific": 53,
      "Plants/Animals": 34,
      "Protective": 63,
      "Mechanical": 67,
      "Industrial": 24,
      "Business Detail": 71,
      "Selling": 32,
      "Accommodating": 41,
      "Humanitarian": 22,
      "Leading/Influencing": 22,
      "Physical Performing": 73
    },
    "fitScore": 48
  },
  {
    "code": "47-2021.00",
    "aptitudeProfile": {
      "Verbal": 9,
      "Numeric": 65,
      "Spatial": 79,
      "ClericalPerception": 16,
      "FormPerception": 41,
      "GeneralLearning": 15
    },
    "interestProfile": {
      "Artistic": 7,
      "Scientific": 12,
      "Plants/Animals": 58,
      "Protective": 41,
      "Mechanical": 79,
      "Industrial": 35,
      "Business Detail": 61,
      "Selling": 7,
      "Accommodating": 46,
      "Humanitarian": 15,
      "Leading/Influencing": 66,
      "Physical Performing": 32
    },
    "fitScore": 38
  },
  {
    "code": "47-2022.00",
    "aptitudeProfile": {
      "Verbal": 7,
      "Numeric": 61,
      "Spatial": 67,
      "ClericalPerception": 18,
      "FormPerception": 21,
      "GeneralLearning": 17
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 20,
      "Plants/Animals": 35,
      "Protective": 21,
      "Mechanical": 67,
      "Industrial": 27,
      "Business Detail": 47,
      "Selling": 18,
      "Accommodating": 26,
      "Humanitarian": 18,
      "Leading/Influencing": 13,
      "Physical Performing": 70
    },
    "fitScore": 31
  },
  {
    "code": "47-2031.00",
    "aptitudeProfile": {
      "Verbal": 32,
      "Numeric": 77,
      "Spatial": 95,
      "ClericalPerception": 48,
      "FormPerception": 67,
      "GeneralLearning": 42
    },
    "interestProfile": {
      "Artistic": 20,
      "Scientific": 39,
      "Plants/Animals": 64,
      "Protective": 67,
      "Mechanical": 95,
      "Industrial": 55,
      "Business Detail": 93,
      "Selling": 27,
      "Accommodating": 66,
      "Humanitarian": 34,
      "Leading/Influencing": 91,
      "Physical Performing": 68
    },
    "fitScore": 60
  },
  {
    "code": "47-2041.00",
    "aptitudeProfile": {
      "Verbal": 9,
      "Numeric": 68,
      "Spatial": 70,
      "ClericalPerception": 21,
      "FormPerception": 42,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 6,
      "Scientific": 15,
      "Plants/Animals": 62,
      "Protective": 42,
      "Mechanical": 70,
      "Industrial": 34,
      "Business Detail": 70,
      "Selling": 12,
      "Accommodating": 55,
      "Humanitarian": 14,
      "Leading/Influencing": 79,
      "Physical Performing": 33
    },
    "fitScore": 39
  },
  {
    "code": "47-2042.00",
    "aptitudeProfile": {
      "Verbal": 8,
      "Numeric": 28,
      "Spatial": 28,
      "ClericalPerception": 4,
      "FormPerception": 2,
      "GeneralLearning": 14
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 15,
      "Plants/Animals": 8,
      "Protective": 2,
      "Mechanical": 28,
      "Industrial": 7,
      "Business Detail": 56,
      "Selling": 19,
      "Accommodating": 3,
      "Humanitarian": 5,
      "Leading/Influencing": 16,
      "Physical Performing": 64
    },
    "fitScore": 17
  },
  {
    "code": "47-2043.00",
    "aptitudeProfile": {
      "Verbal": 5,
      "Numeric": 20,
      "Spatial": 36,
      "ClericalPerception": 7,
      "FormPerception": 13,
      "GeneralLearning": 6
    },
    "interestProfile": {
      "Artistic": 4,
      "Scientific": 5,
      "Plants/Animals": 14,
      "Protective": 13,
      "Mechanical": 36,
      "Industrial": 7,
      "Business Detail": 41,
      "Selling": 6,
      "Accommodating": 8,
      "Humanitarian": 10,
      "Leading/Influencing": 21,
      "Physical Performing": 20
    },
    "fitScore": 15
  },
  {
    "code": "47-2044.00",
    "aptitudeProfile": {
      "Verbal": 9,
      "Numeric": 63,
      "Spatial": 85,
      "ClericalPerception": 26,
      "FormPerception": 23,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 20,
      "Plants/Animals": 56,
      "Protective": 23,
      "Mechanical": 85,
      "Industrial": 42,
      "Business Detail": 40,
      "Selling": 15,
      "Accommodating": 37,
      "Humanitarian": 20,
      "Leading/Influencing": 50,
      "Physical Performing": 31
    },
    "fitScore": 37
  },
  {
    "code": "47-2051.00",
    "aptitudeProfile": {
      "Verbal": 3,
      "Numeric": 39,
      "Spatial": 71,
      "ClericalPerception": 16,
      "FormPerception": 44,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 12,
      "Plants/Animals": 29,
      "Protective": 44,
      "Mechanical": 71,
      "Industrial": 15,
      "Business Detail": 27,
      "Selling": 6,
      "Accommodating": 30,
      "Humanitarian": 12,
      "Leading/Influencing": 30,
      "Physical Performing": 21
    },
    "fitScore": 28
  },
  {
    "code": "47-2053.00",
    "aptitudeProfile": {
      "Verbal": 2,
      "Numeric": 32,
      "Spatial": 45,
      "ClericalPerception": 28,
      "FormPerception": 37,
      "GeneralLearning": 6
    },
    "interestProfile": {
      "Artistic": 1,
      "Scientific": 8,
      "Plants/Animals": 19,
      "Protective": 37,
      "Mechanical": 45,
      "Industrial": 6,
      "Business Detail": 59,
      "Selling": 7,
      "Accommodating": 15,
      "Humanitarian": 5,
      "Leading/Influencing": 46,
      "Physical Performing": 22
    },
    "fitScore": 24
  },
  {
    "code": "47-2061.00",
    "aptitudeProfile": {
      "Verbal": 6,
      "Numeric": 10,
      "Spatial": 53,
      "ClericalPerception": 7,
      "FormPerception": 7,
      "GeneralLearning": 12
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 10,
      "Plants/Animals": 11,
      "Protective": 7,
      "Mechanical": 53,
      "Industrial": 9,
      "Business Detail": 5,
      "Selling": 11,
      "Accommodating": 7,
      "Humanitarian": 18,
      "Leading/Influencing": 6,
      "Physical Performing": 7
    },
    "fitScore": 14
  },
  {
    "code": "47-2071.00",
    "aptitudeProfile": {
      "Verbal": 2,
      "Numeric": 19,
      "Spatial": 80,
      "ClericalPerception": 4,
      "FormPerception": 24,
      "GeneralLearning": 10
    },
    "interestProfile": {
      "Artistic": 2,
      "Scientific": 5,
      "Plants/Animals": 16,
      "Protective": 24,
      "Mechanical": 80,
      "Industrial": 7,
      "Business Detail": 18,
      "Selling": 2,
      "Accommodating": 11,
      "Humanitarian": 23,
      "Leading/Influencing": 11,
      "Physical Performing": 12
    },
    "fitScore": 20
  },
  {
    "code": "47-2072.00",
    "aptitudeProfile": {
      "Verbal": 4,
      "Numeric": 28,
      "Spatial": 88,
      "ClericalPerception": 12,
      "FormPerception": 26,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 11,
      "Plants/Animals": 14,
      "Protective": 26,
      "Mechanical": 88,
      "Industrial": 7,
      "Business Detail": 62,
      "Selling": 4,
      "Accommodating": 10,
      "Humanitarian": 27,
      "Leading/Influencing": 25,
      "Physical Performing": 37
    },
    "fitScore": 28
  },
  {
    "code": "47-2073.00",
    "aptitudeProfile": {
      "Verbal": 9,
      "Numeric": 18,
      "Spatial": 87,
      "ClericalPerception": 30,
      "FormPerception": 53,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 8,
      "Scientific": 14,
      "Plants/Animals": 14,
      "Protective": 53,
      "Mechanical": 87,
      "Industrial": 11,
      "Business Detail": 30,
      "Selling": 9,
      "Accommodating": 17,
      "Humanitarian": 34,
      "Leading/Influencing": 17,
      "Physical Performing": 19
    },
    "fitScore": 31
  },
  {
    "code": "47-2081.00",
    "aptitudeProfile": {
      "Verbal": 11,
      "Numeric": 37,
      "Spatial": 68,
      "ClericalPerception": 32,
      "FormPerception": 37,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 15,
      "Plants/Animals": 26,
      "Protective": 37,
      "Mechanical": 68,
      "Industrial": 16,
      "Business Detail": 59,
      "Selling": 11,
      "Accommodating": 23,
      "Humanitarian": 17,
      "Leading/Influencing": 36,
      "Physical Performing": 33
    },
    "fitScore": 31
  },
  {
    "code": "47-2082.00",
    "aptitudeProfile": {
      "Verbal": 2,
      "Numeric": 4,
      "Spatial": 21,
      "ClericalPerception": 1,
      "FormPerception": 2,
      "GeneralLearning": 7
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 6,
      "Plants/Animals": 2,
      "Protective": 2,
      "Mechanical": 21,
      "Industrial": 1,
      "Business Detail": 8,
      "Selling": 4,
      "Accommodating": 1,
      "Humanitarian": 7,
      "Leading/Influencing": 3,
      "Physical Performing": 4
    },
    "fitScore": 6
  },
  {
    "code": "47-2111.00",
    "aptitudeProfile": {
      "Verbal": 42,
      "Numeric": 74,
      "Spatial": 75,
      "ClericalPerception": 66,
      "FormPerception": 76,
      "GeneralLearning": 80
    },
    "interestProfile": {
      "Artistic": 36,
      "Scientific": 73,
      "Plants/Animals": 76,
      "Protective": 76,
      "Mechanical": 75,
      "Industrial": 54,
      "Business Detail": 77,
      "Selling": 55,
      "Accommodating": 79,
      "Humanitarian": 24,
      "Leading/Influencing": 84,
      "Physical Performing": 62
    },
    "fitScore": 67
  },
  {
    "code": "47-2121.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 35,
      "Spatial": 43,
      "ClericalPerception": 6,
      "FormPerception": 4,
      "GeneralLearning": 17
    },
    "interestProfile": {
      "Artistic": 7,
      "Scientific": 15,
      "Plants/Animals": 27,
      "Protective": 4,
      "Mechanical": 43,
      "Industrial": 17,
      "Business Detail": 70,
      "Selling": 9,
      "Accommodating": 11,
      "Humanitarian": 16,
      "Leading/Influencing": 42,
      "Physical Performing": 34
    },
    "fitScore": 22
  },
  {
    "code": "47-2131.00",
    "aptitudeProfile": {
      "Verbal": 5,
      "Numeric": 21,
      "Spatial": 70,
      "ClericalPerception": 26,
      "FormPerception": 40,
      "GeneralLearning": 4
    },
    "interestProfile": {
      "Artistic": 5,
      "Scientific": 6,
      "Plants/Animals": 22,
      "Protective": 40,
      "Mechanical": 70,
      "Industrial": 11,
      "Business Detail": 18,
      "Selling": 7,
      "Accommodating": 21,
      "Humanitarian": 18,
      "Leading/Influencing": 23,
      "Physical Performing": 5
    },
    "fitScore": 24
  },
  {
    "code": "47-2132.00",
    "aptitudeProfile": {
      "Verbal": 17,
      "Numeric": 39,
      "Spatial": 42,
      "ClericalPerception": 11,
      "FormPerception": 21,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 7,
      "Scientific": 11,
      "Plants/Animals": 21,
      "Protective": 21,
      "Mechanical": 42,
      "Industrial": 13,
      "Business Detail": 94,
      "Selling": 8,
      "Accommodating": 16,
      "Humanitarian": 14,
      "Leading/Influencing": 70,
      "Physical Performing": 52
    },
    "fitScore": 27
  },
  {
    "code": "47-2141.00",
    "aptitudeProfile": {
      "Verbal": 15,
      "Numeric": 22,
      "Spatial": 30,
      "ClericalPerception": 1,
      "FormPerception": 3,
      "GeneralLearning": 14
    },
    "interestProfile": {
      "Artistic": 8,
      "Scientific": 10,
      "Plants/Animals": 16,
      "Protective": 3,
      "Mechanical": 30,
      "Industrial": 15,
      "Business Detail": 64,
      "Selling": 6,
      "Accommodating": 9,
      "Humanitarian": 14,
      "Leading/Influencing": 56,
      "Physical Performing": 17
    },
    "fitScore": 17
  },
  {
    "code": "47-2142.00",
    "aptitudeProfile": {
      "Verbal": 5,
      "Numeric": 18,
      "Spatial": 37,
      "ClericalPerception": 3,
      "FormPerception": 8,
      "GeneralLearning": 10
    },
    "interestProfile": {
      "Artistic": 4,
      "Scientific": 6,
      "Plants/Animals": 8,
      "Protective": 8,
      "Mechanical": 37,
      "Industrial": 5,
      "Business Detail": 58,
      "Selling": 2,
      "Accommodating": 3,
      "Humanitarian": 8,
      "Leading/Influencing": 26,
      "Physical Performing": 25
    },
    "fitScore": 15
  },
  {
    "code": "47-2151.00",
    "aptitudeProfile": {
      "Verbal": 19,
      "Numeric": 36,
      "Spatial": 58,
      "ClericalPerception": 15,
      "FormPerception": 29,
      "GeneralLearning": 14
    },
    "interestProfile": {
      "Artistic": 17,
      "Scientific": 11,
      "Plants/Animals": 19,
      "Protective": 29,
      "Mechanical": 58,
      "Industrial": 16,
      "Business Detail": 70,
      "Selling": 17,
      "Accommodating": 17,
      "Humanitarian": 20,
      "Leading/Influencing": 31,
      "Physical Performing": 67
    },
    "fitScore": 30
  },
  {
    "code": "47-2152.00",
    "aptitudeProfile": {
      "Verbal": 18,
      "Numeric": 57,
      "Spatial": 85,
      "ClericalPerception": 46,
      "FormPerception": 67,
      "GeneralLearning": 47
    },
    "interestProfile": {
      "Artistic": 13,
      "Scientific": 40,
      "Plants/Animals": 43,
      "Protective": 67,
      "Mechanical": 85,
      "Industrial": 28,
      "Business Detail": 81,
      "Selling": 19,
      "Accommodating": 49,
      "Humanitarian": 29,
      "Leading/Influencing": 66,
      "Physical Performing": 53
    },
    "fitScore": 51
  },
  {
    "code": "47-2152.04",
    "aptitudeProfile": {
      "Verbal": 39,
      "Numeric": 50,
      "Spatial": 69,
      "ClericalPerception": 57,
      "FormPerception": 74,
      "GeneralLearning": 19
    },
    "interestProfile": {
      "Artistic": 32,
      "Scientific": 27,
      "Plants/Animals": 56,
      "Protective": 74,
      "Mechanical": 69,
      "Industrial": 43,
      "Business Detail": 55,
      "Selling": 44,
      "Accommodating": 64,
      "Humanitarian": 31,
      "Leading/Influencing": 60,
      "Physical Performing": 38
    },
    "fitScore": 50
  },
  {
    "code": "47-2161.00",
    "aptitudeProfile": {
      "Verbal": 10,
      "Numeric": 22,
      "Spatial": 50,
      "ClericalPerception": 20,
      "FormPerception": 21,
      "GeneralLearning": 9
    },
    "interestProfile": {
      "Artistic": 7,
      "Scientific": 12,
      "Plants/Animals": 18,
      "Protective": 21,
      "Mechanical": 50,
      "Industrial": 9,
      "Business Detail": 48,
      "Selling": 10,
      "Accommodating": 16,
      "Humanitarian": 12,
      "Leading/Influencing": 35,
      "Physical Performing": 13
    },
    "fitScore": 21
  },
  {
    "code": "47-2171.00",
    "aptitudeProfile": {
      "Verbal": 5,
      "Numeric": 35,
      "Spatial": 65,
      "ClericalPerception": 13,
      "FormPerception": 32,
      "GeneralLearning": 11
    },
    "interestProfile": {
      "Artistic": 2,
      "Scientific": 11,
      "Plants/Animals": 19,
      "Protective": 32,
      "Mechanical": 65,
      "Industrial": 14,
      "Business Detail": 74,
      "Selling": 6,
      "Accommodating": 22,
      "Humanitarian": 17,
      "Leading/Influencing": 58,
      "Physical Performing": 27
    },
    "fitScore": 28
  },
  {
    "code": "47-2181.00",
    "aptitudeProfile": {
      "Verbal": 9,
      "Numeric": 28,
      "Spatial": 46,
      "ClericalPerception": 19,
      "FormPerception": 35,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 7,
      "Scientific": 14,
      "Plants/Animals": 17,
      "Protective": 35,
      "Mechanical": 46,
      "Industrial": 15,
      "Business Detail": 48,
      "Selling": 14,
      "Accommodating": 12,
      "Humanitarian": 13,
      "Leading/Influencing": 33,
      "Physical Performing": 38
    },
    "fitScore": 25
  },
  {
    "code": "47-2211.00",
    "aptitudeProfile": {
      "Verbal": 16,
      "Numeric": 77,
      "Spatial": 86,
      "ClericalPerception": 37,
      "FormPerception": 68,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 20,
      "Plants/Animals": 72,
      "Protective": 68,
      "Mechanical": 86,
      "Industrial": 49,
      "Business Detail": 74,
      "Selling": 13,
      "Accommodating": 73,
      "Humanitarian": 26,
      "Leading/Influencing": 71,
      "Physical Performing": 48
    },
    "fitScore": 51
  },
  {
    "code": "47-2221.00",
    "aptitudeProfile": {
      "Verbal": 11,
      "Numeric": 44,
      "Spatial": 95,
      "ClericalPerception": 58,
      "FormPerception": 57,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 10,
      "Scientific": 25,
      "Plants/Animals": 40,
      "Protective": 57,
      "Mechanical": 95,
      "Industrial": 14,
      "Business Detail": 59,
      "Selling": 26,
      "Accommodating": 31,
      "Humanitarian": 25,
      "Leading/Influencing": 29,
      "Physical Performing": 42
    },
    "fitScore": 43
  },
  {
    "code": "47-2231.00",
    "aptitudeProfile": {
      "Verbal": 29,
      "Numeric": 56,
      "Spatial": 81,
      "ClericalPerception": 39,
      "FormPerception": 57,
      "GeneralLearning": 24
    },
    "interestProfile": {
      "Artistic": 14,
      "Scientific": 21,
      "Plants/Animals": 32,
      "Protective": 57,
      "Mechanical": 81,
      "Industrial": 34,
      "Business Detail": 96,
      "Selling": 16,
      "Accommodating": 31,
      "Humanitarian": 23,
      "Leading/Influencing": 89,
      "Physical Performing": 66
    },
    "fitScore": 47
  },
  {
    "code": "47-3011.00",
    "aptitudeProfile": {
      "Verbal": 1,
      "Numeric": 29,
      "Spatial": 72,
      "ClericalPerception": 9,
      "FormPerception": 38,
      "GeneralLearning": 6
    },
    "interestProfile": {
      "Artistic": 2,
      "Scientific": 5,
      "Plants/Animals": 25,
      "Protective": 38,
      "Mechanical": 72,
      "Industrial": 8,
      "Business Detail": 15,
      "Selling": 3,
      "Accommodating": 27,
      "Humanitarian": 15,
      "Leading/Influencing": 9,
      "Physical Performing": 15
    },
    "fitScore": 23
  },
  {
    "code": "47-3012.00",
    "aptitudeProfile": {
      "Verbal": 6,
      "Numeric": 49,
      "Spatial": 55,
      "ClericalPerception": 6,
      "FormPerception": 7,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 4,
      "Scientific": 12,
      "Plants/Animals": 28,
      "Protective": 7,
      "Mechanical": 55,
      "Industrial": 19,
      "Business Detail": 79,
      "Selling": 7,
      "Accommodating": 11,
      "Humanitarian": 16,
      "Leading/Influencing": 45,
      "Physical Performing": 54
    },
    "fitScore": 25
  },
  {
    "code": "47-3013.00",
    "aptitudeProfile": {
      "Verbal": 12,
      "Numeric": 36,
      "Spatial": 44,
      "ClericalPerception": 6,
      "FormPerception": 13,
      "GeneralLearning": 17
    },
    "interestProfile": {
      "Artistic": 6,
      "Scientific": 13,
      "Plants/Animals": 24,
      "Protective": 13,
      "Mechanical": 44,
      "Industrial": 8,
      "Business Detail": 85,
      "Selling": 9,
      "Accommodating": 16,
      "Humanitarian": 10,
      "Leading/Influencing": 58,
      "Physical Performing": 45
    },
    "fitScore": 24
  },
  {
    "code": "47-3014.00",
    "aptitudeProfile": {
      "Verbal": 1,
      "Numeric": 16,
      "Spatial": 31,
      "ClericalPerception": 4,
      "FormPerception": 7,
      "GeneralLearning": 4
    },
    "interestProfile": {
      "Artistic": 2,
      "Scientific": 4,
      "Plants/Animals": null,
      "Protective": 7,
      "Mechanical": 31,
      "Industrial": 3,
      "Business Detail": 5,
      "Selling": 3,
      "Accommodating": 11,
      "Humanitarian": 6,
      "Leading/Influencing": 13,
      "Physical Performing": 2
    },
    "fitScore": 9
  },
  {
    "code": "47-3015.00",
    "aptitudeProfile": {
      "Verbal": 4,
      "Numeric": 31,
      "Spatial": 53,
      "ClericalPerception": 1,
      "FormPerception": 1,
      "GeneralLearning": 8
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 7,
      "Plants/Animals": 18,
      "Protective": 1,
      "Mechanical": 53,
      "Industrial": 6,
      "Business Detail": 62,
      "Selling": 8,
      "Accommodating": 7,
      "Humanitarian": 8,
      "Leading/Influencing": 31,
      "Physical Performing": 42
    },
    "fitScore": 18
  },
  {
    "code": "47-3016.00",
    "aptitudeProfile": {
      "Verbal": 5,
      "Numeric": 37,
      "Spatial": 79,
      "ClericalPerception": 26,
      "FormPerception": 55,
      "GeneralLearning": 7
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 10,
      "Plants/Animals": 24,
      "Protective": 55,
      "Mechanical": 79,
      "Industrial": 8,
      "Business Detail": 74,
      "Selling": 8,
      "Accommodating": 34,
      "Humanitarian": 17,
      "Leading/Influencing": 46,
      "Physical Performing": 33
    },
    "fitScore": 34
  },
  {
    "code": "47-4011.00",
    "aptitudeProfile": {
      "Verbal": 78,
      "Numeric": 73,
      "Spatial": 53,
      "ClericalPerception": 65,
      "FormPerception": 70,
      "GeneralLearning": 83
    },
    "interestProfile": {
      "Artistic": 74,
      "Scientific": 76,
      "Plants/Animals": 69,
      "Protective": 70,
      "Mechanical": 53,
      "Industrial": 82,
      "Business Detail": 76,
      "Selling": 59,
      "Accommodating": 70,
      "Humanitarian": 44,
      "Leading/Influencing": 82,
      "Physical Performing": 70
    },
    "fitScore": 70
  },
  {
    "code": "47-4011.01",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 93,
      "Spatial": 53,
      "ClericalPerception": 83,
      "FormPerception": 77,
      "GeneralLearning": 73
    },
    "interestProfile": {
      "Artistic": 77,
      "Scientific": 77,
      "Plants/Animals": 95,
      "Protective": 77,
      "Mechanical": 53,
      "Industrial": 86,
      "Business Detail": 79,
      "Selling": 78,
      "Accommodating": 94,
      "Humanitarian": 41,
      "Leading/Influencing": 79,
      "Physical Performing": 88
    },
    "fitScore": 76
  },
  {
    "code": "47-4021.00",
    "aptitudeProfile": {
      "Verbal": 30,
      "Numeric": 38,
      "Spatial": 66,
      "ClericalPerception": 55,
      "FormPerception": 65,
      "GeneralLearning": 53
    },
    "interestProfile": {
      "Artistic": 27,
      "Scientific": 51,
      "Plants/Animals": 29,
      "Protective": 65,
      "Mechanical": 66,
      "Industrial": 24,
      "Business Detail": 64,
      "Selling": 44,
      "Accommodating": 48,
      "Humanitarian": 23,
      "Leading/Influencing": 41,
      "Physical Performing": 55
    },
    "fitScore": 48
  },
  {
    "code": "47-4031.00",
    "aptitudeProfile": {
      "Verbal": 7,
      "Numeric": 34,
      "Spatial": 54,
      "ClericalPerception": 3,
      "FormPerception": 9,
      "GeneralLearning": 10
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 7,
      "Plants/Animals": 19,
      "Protective": 9,
      "Mechanical": 54,
      "Industrial": 11,
      "Business Detail": 80,
      "Selling": 4,
      "Accommodating": 10,
      "Humanitarian": 13,
      "Leading/Influencing": 68,
      "Physical Performing": 29
    },
    "fitScore": 23
  },
  {
    "code": "47-4041.00",
    "aptitudeProfile": {
      "Verbal": 47,
      "Numeric": 30,
      "Spatial": 64,
      "ClericalPerception": 60,
      "FormPerception": 66,
      "GeneralLearning": 47
    },
    "interestProfile": {
      "Artistic": 46,
      "Scientific": 48,
      "Plants/Animals": 35,
      "Protective": 66,
      "Mechanical": 64,
      "Industrial": 19,
      "Business Detail": 55,
      "Selling": 53,
      "Accommodating": 41,
      "Humanitarian": 22,
      "Leading/Influencing": 45,
      "Physical Performing": 42
    },
    "fitScore": 49
  },
  {
    "code": "47-4051.00",
    "aptitudeProfile": {
      "Verbal": 11,
      "Numeric": 23,
      "Spatial": 81,
      "ClericalPerception": 18,
      "FormPerception": 67,
      "GeneralLearning": 16
    },
    "interestProfile": {
      "Artistic": 10,
      "Scientific": 11,
      "Plants/Animals": 21,
      "Protective": 67,
      "Mechanical": 81,
      "Industrial": 12,
      "Business Detail": 30,
      "Selling": 10,
      "Accommodating": 36,
      "Humanitarian": 28,
      "Leading/Influencing": 24,
      "Physical Performing": 21
    },
    "fitScore": 33
  },
  {
    "code": "47-4061.00",
    "aptitudeProfile": {
      "Verbal": 8,
      "Numeric": 26,
      "Spatial": 88,
      "ClericalPerception": 46,
      "FormPerception": 88,
      "GeneralLearning": 19
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 18,
      "Plants/Animals": 18,
      "Protective": 88,
      "Mechanical": 88,
      "Industrial": 8,
      "Business Detail": 43,
      "Selling": 12,
      "Accommodating": 44,
      "Humanitarian": 19,
      "Leading/Influencing": 33,
      "Physical Performing": 21
    },
    "fitScore": 40
  },
  {
    "code": "47-4071.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 36,
      "Spatial": 72,
      "ClericalPerception": 37,
      "FormPerception": 81,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 20,
      "Plants/Animals": 29,
      "Protective": 81,
      "Mechanical": 72,
      "Industrial": 20,
      "Business Detail": 48,
      "Selling": 21,
      "Accommodating": 48,
      "Humanitarian": 25,
      "Leading/Influencing": 42,
      "Physical Performing": 36
    },
    "fitScore": 41
  },
  {
    "code": "47-4091.00",
    "aptitudeProfile": {
      "Verbal": 23,
      "Numeric": 18,
      "Spatial": 70,
      "ClericalPerception": 29,
      "FormPerception": 21,
      "GeneralLearning": 22
    },
    "interestProfile": {
      "Artistic": 26,
      "Scientific": 24,
      "Plants/Animals": 21,
      "Protective": 21,
      "Mechanical": 70,
      "Industrial": 11,
      "Business Detail": 22,
      "Selling": 31,
      "Accommodating": 14,
      "Humanitarian": 23,
      "Leading/Influencing": 26,
      "Physical Performing": 16
    },
    "fitScore": 28
  },
  {
    "code": "47-4099.03",
    "aptitudeProfile": {
      "Verbal": 24,
      "Numeric": 57,
      "Spatial": 59,
      "ClericalPerception": 57,
      "FormPerception": 64,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 17,
      "Scientific": 28,
      "Plants/Animals": 52,
      "Protective": 64,
      "Mechanical": 59,
      "Industrial": 38,
      "Business Detail": 73,
      "Selling": 34,
      "Accommodating": 62,
      "Humanitarian": 21,
      "Leading/Influencing": 75,
      "Physical Performing": 39
    },
    "fitScore": 47
  },
  {
    "code": "47-5011.00",
    "aptitudeProfile": {
      "Verbal": 15,
      "Numeric": 44,
      "Spatial": 81,
      "ClericalPerception": 44,
      "FormPerception": 90,
      "GeneralLearning": 32
    },
    "interestProfile": {
      "Artistic": 16,
      "Scientific": 24,
      "Plants/Animals": 39,
      "Protective": 90,
      "Mechanical": 81,
      "Industrial": 23,
      "Business Detail": 42,
      "Selling": 15,
      "Accommodating": 58,
      "Humanitarian": 28,
      "Leading/Influencing": 30,
      "Physical Performing": 38
    },
    "fitScore": 46
  },
  {
    "code": "47-5012.00",
    "aptitudeProfile": {
      "Verbal": 37,
      "Numeric": 52,
      "Spatial": 58,
      "ClericalPerception": 46,
      "FormPerception": 68,
      "GeneralLearning": 42
    },
    "interestProfile": {
      "Artistic": 36,
      "Scientific": 35,
      "Plants/Animals": 43,
      "Protective": 68,
      "Mechanical": 58,
      "Industrial": 26,
      "Business Detail": 76,
      "Selling": 31,
      "Accommodating": 44,
      "Humanitarian": 25,
      "Leading/Influencing": 45,
      "Physical Performing": 69
    },
    "fitScore": 48
  },
  {
    "code": "47-5013.00",
    "aptitudeProfile": {
      "Verbal": 25,
      "Numeric": 69,
      "Spatial": 80,
      "ClericalPerception": 61,
      "FormPerception": 83,
      "GeneralLearning": 28
    },
    "interestProfile": {
      "Artistic": 21,
      "Scientific": 27,
      "Plants/Animals": 62,
      "Protective": 83,
      "Mechanical": 80,
      "Industrial": 35,
      "Business Detail": 80,
      "Selling": 22,
      "Accommodating": 64,
      "Humanitarian": 32,
      "Leading/Influencing": 61,
      "Physical Performing": 65
    },
    "fitScore": 55
  },
  {
    "code": "47-5022.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 23,
      "Spatial": 96,
      "ClericalPerception": 16,
      "FormPerception": 64,
      "GeneralLearning": 17
    },
    "interestProfile": {
      "Artistic": 15,
      "Scientific": 11,
      "Plants/Animals": 20,
      "Protective": 64,
      "Mechanical": 96,
      "Industrial": 22,
      "Business Detail": 14,
      "Selling": 6,
      "Accommodating": 31,
      "Humanitarian": 55,
      "Leading/Influencing": 16,
      "Physical Performing": 13
    },
    "fitScore": 34
  },
  {
    "code": "47-5023.00",
    "aptitudeProfile": {
      "Verbal": 18,
      "Numeric": 27,
      "Spatial": 81,
      "ClericalPerception": 67,
      "FormPerception": 82,
      "GeneralLearning": 28
    },
    "interestProfile": {
      "Artistic": 16,
      "Scientific": 28,
      "Plants/Animals": 21,
      "Protective": 82,
      "Mechanical": 81,
      "Industrial": 13,
      "Business Detail": 50,
      "Selling": 21,
      "Accommodating": 34,
      "Humanitarian": 24,
      "Leading/Influencing": 40,
      "Physical Performing": 26
    },
    "fitScore": 43
  },
  {
    "code": "47-5032.00",
    "aptitudeProfile": {
      "Verbal": 37,
      "Numeric": 60,
      "Spatial": 60,
      "ClericalPerception": 67,
      "FormPerception": 88,
      "GeneralLearning": 78
    },
    "interestProfile": {
      "Artistic": 33,
      "Scientific": 64,
      "Plants/Animals": 49,
      "Protective": 88,
      "Mechanical": 60,
      "Industrial": 40,
      "Business Detail": 76,
      "Selling": 46,
      "Accommodating": 63,
      "Humanitarian": 25,
      "Leading/Influencing": 57,
      "Physical Performing": 77
    },
    "fitScore": 61
  },
  {
    "code": "47-5041.00",
    "aptitudeProfile": {
      "Verbal": 5,
      "Numeric": 13,
      "Spatial": 78,
      "ClericalPerception": 39,
      "FormPerception": 76,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 4,
      "Scientific": 20,
      "Plants/Animals": 9,
      "Protective": 76,
      "Mechanical": 78,
      "Industrial": 8,
      "Business Detail": 23,
      "Selling": 8,
      "Accommodating": 25,
      "Humanitarian": 26,
      "Leading/Influencing": 17,
      "Physical Performing": 8
    },
    "fitScore": 32
  },
  {
    "code": "47-5043.00",
    "aptitudeProfile": {
      "Verbal": 5,
      "Numeric": 12,
      "Spatial": 82,
      "ClericalPerception": 13,
      "FormPerception": 38,
      "GeneralLearning": 14
    },
    "interestProfile": {
      "Artistic": 4,
      "Scientific": 12,
      "Plants/Animals": 13,
      "Protective": 38,
      "Mechanical": 82,
      "Industrial": 6,
      "Business Detail": 11,
      "Selling": 7,
      "Accommodating": 17,
      "Humanitarian": 23,
      "Leading/Influencing": 21,
      "Physical Performing": 3
    },
    "fitScore": 24
  },
  {
    "code": "47-5044.00",
    "aptitudeProfile": {
      "Verbal": 6,
      "Numeric": 9,
      "Spatial": 76,
      "ClericalPerception": 18,
      "FormPerception": 52,
      "GeneralLearning": 12
    },
    "interestProfile": {
      "Artistic": 5,
      "Scientific": 8,
      "Plants/Animals": 11,
      "Protective": 52,
      "Mechanical": 76,
      "Industrial": 10,
      "Business Detail": 6,
      "Selling": 4,
      "Accommodating": 14,
      "Humanitarian": 29,
      "Leading/Influencing": 9,
      "Physical Performing": 3
    },
    "fitScore": 24
  },
  {
    "code": "47-5051.00",
    "aptitudeProfile": {
      "Verbal": 4,
      "Numeric": 14,
      "Spatial": 55,
      "ClericalPerception": 4,
      "FormPerception": 32,
      "GeneralLearning": 9
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 5,
      "Plants/Animals": 10,
      "Protective": 32,
      "Mechanical": 55,
      "Industrial": 7,
      "Business Detail": 23,
      "Selling": 2,
      "Accommodating": 12,
      "Humanitarian": 16,
      "Leading/Influencing": 12,
      "Physical Performing": 11
    },
    "fitScore": 18
  },
  {
    "code": "47-5071.00",
    "aptitudeProfile": {
      "Verbal": 2,
      "Numeric": 15,
      "Spatial": 50,
      "ClericalPerception": 12,
      "FormPerception": 56,
      "GeneralLearning": 10
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 7,
      "Plants/Animals": 12,
      "Protective": 56,
      "Mechanical": 50,
      "Industrial": 3,
      "Business Detail": 10,
      "Selling": 5,
      "Accommodating": 21,
      "Humanitarian": 7,
      "Leading/Influencing": 6,
      "Physical Performing": 11
    },
    "fitScore": 20
  },
  {
    "code": "47-5081.00",
    "aptitudeProfile": {
      "Verbal": 7,
      "Numeric": 32,
      "Spatial": 88,
      "ClericalPerception": 38,
      "FormPerception": 65,
      "GeneralLearning": 19
    },
    "interestProfile": {
      "Artistic": 6,
      "Scientific": 18,
      "Plants/Animals": 24,
      "Protective": 65,
      "Mechanical": 88,
      "Industrial": 20,
      "Business Detail": 37,
      "Selling": 13,
      "Accommodating": 35,
      "Humanitarian": 33,
      "Leading/Influencing": 38,
      "Physical Performing": 21
    },
    "fitScore": 37
  },
  {
    "code": "49-1011.00",
    "aptitudeProfile": {
      "Verbal": 75,
      "Numeric": 68,
      "Spatial": 51,
      "ClericalPerception": 75,
      "FormPerception": 83,
      "GeneralLearning": 78
    },
    "interestProfile": {
      "Artistic": 66,
      "Scientific": 74,
      "Plants/Animals": 73,
      "Protective": 83,
      "Mechanical": 51,
      "Industrial": 69,
      "Business Detail": 82,
      "Selling": 66,
      "Accommodating": 78,
      "Humanitarian": 29,
      "Leading/Influencing": 91,
      "Physical Performing": 61
    },
    "fitScore": 70
  },
  {
    "code": "49-2011.00",
    "aptitudeProfile": {
      "Verbal": 21,
      "Numeric": 9,
      "Spatial": 66,
      "ClericalPerception": 51,
      "FormPerception": 46,
      "GeneralLearning": 24
    },
    "interestProfile": {
      "Artistic": 40,
      "Scientific": 30,
      "Plants/Animals": 13,
      "Protective": 46,
      "Mechanical": 66,
      "Industrial": 16,
      "Business Detail": 1,
      "Selling": 46,
      "Accommodating": 16,
      "Humanitarian": 21,
      "Leading/Influencing": 1,
      "Physical Performing": 10
    },
    "fitScore": 31
  },
  {
    "code": "49-2021.00",
    "aptitudeProfile": {
      "Verbal": 30,
      "Numeric": 52,
      "Spatial": 64,
      "ClericalPerception": 64,
      "FormPerception": 58,
      "GeneralLearning": 32
    },
    "interestProfile": {
      "Artistic": 22,
      "Scientific": 37,
      "Plants/Animals": 47,
      "Protective": 58,
      "Mechanical": 64,
      "Industrial": 47,
      "Business Detail": 62,
      "Selling": 33,
      "Accommodating": 48,
      "Humanitarian": 28,
      "Leading/Influencing": 72,
      "Physical Performing": 33
    },
    "fitScore": 48
  },
  {
    "code": "49-2022.00",
    "aptitudeProfile": {
      "Verbal": 34,
      "Numeric": 49,
      "Spatial": 80,
      "ClericalPerception": 77,
      "FormPerception": 87,
      "GeneralLearning": 48
    },
    "interestProfile": {
      "Artistic": 32,
      "Scientific": 51,
      "Plants/Animals": 48,
      "Protective": 87,
      "Mechanical": 80,
      "Industrial": 35,
      "Business Detail": 56,
      "Selling": 59,
      "Accommodating": 72,
      "Humanitarian": 38,
      "Leading/Influencing": 33,
      "Physical Performing": 67
    },
    "fitScore": 59
  },
  {
    "code": "49-2091.00",
    "aptitudeProfile": {
      "Verbal": 48,
      "Numeric": 41,
      "Spatial": 42,
      "ClericalPerception": 58,
      "FormPerception": 60,
      "GeneralLearning": 64
    },
    "interestProfile": {
      "Artistic": 61,
      "Scientific": 60,
      "Plants/Animals": 34,
      "Protective": 60,
      "Mechanical": 42,
      "Industrial": 27,
      "Business Detail": 43,
      "Selling": 52,
      "Accommodating": 45,
      "Humanitarian": 15,
      "Leading/Influencing": 16,
      "Physical Performing": 66
    },
    "fitScore": 48
  },
  {
    "code": "49-2092.00",
    "aptitudeProfile": {
      "Verbal": 18,
      "Numeric": 48,
      "Spatial": 56,
      "ClericalPerception": 64,
      "FormPerception": 74,
      "GeneralLearning": 33
    },
    "interestProfile": {
      "Artistic": 16,
      "Scientific": 38,
      "Plants/Animals": 46,
      "Protective": 74,
      "Mechanical": 56,
      "Industrial": 34,
      "Business Detail": 43,
      "Selling": 28,
      "Accommodating": 59,
      "Humanitarian": 16,
      "Leading/Influencing": 51,
      "Physical Performing": 25
    },
    "fitScore": 45
  },
  {
    "code": "49-2093.00",
    "aptitudeProfile": {
      "Verbal": 18,
      "Numeric": 45,
      "Spatial": 29,
      "ClericalPerception": 15,
      "FormPerception": 37,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 17,
      "Scientific": 20,
      "Plants/Animals": 28,
      "Protective": 37,
      "Mechanical": 29,
      "Industrial": 23,
      "Business Detail": 70,
      "Selling": 16,
      "Accommodating": 33,
      "Humanitarian": 13,
      "Leading/Influencing": 26,
      "Physical Performing": 65
    },
    "fitScore": 30
  },
  {
    "code": "49-2094.00",
    "aptitudeProfile": {
      "Verbal": 39,
      "Numeric": 68,
      "Spatial": 38,
      "ClericalPerception": 81,
      "FormPerception": 90,
      "GeneralLearning": 52
    },
    "interestProfile": {
      "Artistic": 30,
      "Scientific": 54,
      "Plants/Animals": 66,
      "Protective": 90,
      "Mechanical": 38,
      "Industrial": 49,
      "Business Detail": 81,
      "Selling": 55,
      "Accommodating": 78,
      "Humanitarian": 14,
      "Leading/Influencing": 76,
      "Physical Performing": 69
    },
    "fitScore": 60
  },
  {
    "code": "49-2095.00",
    "aptitudeProfile": {
      "Verbal": 42,
      "Numeric": 68,
      "Spatial": 44,
      "ClericalPerception": 54,
      "FormPerception": 75,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 46,
      "Scientific": 26,
      "Plants/Animals": 65,
      "Protective": 75,
      "Mechanical": 44,
      "Industrial": 36,
      "Business Detail": 72,
      "Selling": 40,
      "Accommodating": 70,
      "Humanitarian": 24,
      "Leading/Influencing": 28,
      "Physical Performing": 83
    },
    "fitScore": 51
  },
  {
    "code": "49-2096.00",
    "aptitudeProfile": {
      "Verbal": 24,
      "Numeric": 43,
      "Spatial": 74,
      "ClericalPerception": 58,
      "FormPerception": 56,
      "GeneralLearning": 50
    },
    "interestProfile": {
      "Artistic": 24,
      "Scientific": 52,
      "Plants/Animals": 30,
      "Protective": 56,
      "Mechanical": 74,
      "Industrial": 26,
      "Business Detail": 62,
      "Selling": 45,
      "Accommodating": 38,
      "Humanitarian": 20,
      "Leading/Influencing": 31,
      "Physical Performing": 63
    },
    "fitScore": 47
  },
  {
    "code": "49-2097.00",
    "aptitudeProfile": {
      "Verbal": 22,
      "Numeric": 37,
      "Spatial": 74,
      "ClericalPerception": 46,
      "FormPerception": 60,
      "GeneralLearning": 26
    },
    "interestProfile": {
      "Artistic": 17,
      "Scientific": 30,
      "Plants/Animals": 38,
      "Protective": 60,
      "Mechanical": 74,
      "Industrial": 27,
      "Business Detail": 48,
      "Selling": 24,
      "Accommodating": 47,
      "Humanitarian": 22,
      "Leading/Influencing": 41,
      "Physical Performing": 25
    },
    "fitScore": 41
  },
  {
    "code": "49-2098.00",
    "aptitudeProfile": {
      "Verbal": 25,
      "Numeric": 25,
      "Spatial": 60,
      "ClericalPerception": 43,
      "FormPerception": 56,
      "GeneralLearning": 35
    },
    "interestProfile": {
      "Artistic": 30,
      "Scientific": 32,
      "Plants/Animals": 21,
      "Protective": 56,
      "Mechanical": 60,
      "Industrial": 23,
      "Business Detail": 22,
      "Selling": 37,
      "Accommodating": 27,
      "Humanitarian": 23,
      "Leading/Influencing": 15,
      "Physical Performing": 38
    },
    "fitScore": 36
  },
  {
    "code": "49-3011.00",
    "aptitudeProfile": {
      "Verbal": 51,
      "Numeric": 42,
      "Spatial": 65,
      "ClericalPerception": 71,
      "FormPerception": 89,
      "GeneralLearning": 65
    },
    "interestProfile": {
      "Artistic": 50,
      "Scientific": 60,
      "Plants/Animals": 38,
      "Protective": 89,
      "Mechanical": 65,
      "Industrial": 49,
      "Business Detail": 48,
      "Selling": 38,
      "Accommodating": 69,
      "Humanitarian": 39,
      "Leading/Influencing": 30,
      "Physical Performing": 43
    },
    "fitScore": 58
  },
  {
    "code": "49-3021.00",
    "aptitudeProfile": {
      "Verbal": 9,
      "Numeric": 28,
      "Spatial": 68,
      "ClericalPerception": 51,
      "FormPerception": 57,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 10,
      "Scientific": 21,
      "Plants/Animals": 22,
      "Protective": 57,
      "Mechanical": 68,
      "Industrial": 16,
      "Business Detail": 25,
      "Selling": 29,
      "Accommodating": 32,
      "Humanitarian": 16,
      "Leading/Influencing": 14,
      "Physical Performing": 27
    },
    "fitScore": 33
  },
  {
    "code": "49-3022.00",
    "aptitudeProfile": {
      "Verbal": 7,
      "Numeric": 12,
      "Spatial": 42,
      "ClericalPerception": 4,
      "FormPerception": 5,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 6,
      "Scientific": 10,
      "Plants/Animals": 12,
      "Protective": 5,
      "Mechanical": 42,
      "Industrial": 7,
      "Business Detail": 19,
      "Selling": 4,
      "Accommodating": 4,
      "Humanitarian": 9,
      "Leading/Influencing": 24,
      "Physical Performing": 4
    },
    "fitScore": 13
  },
  {
    "code": "49-3023.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 25,
      "Spatial": 81,
      "ClericalPerception": 72,
      "FormPerception": 87,
      "GeneralLearning": 74
    },
    "interestProfile": {
      "Artistic": 18,
      "Scientific": 65,
      "Plants/Animals": 24,
      "Protective": 87,
      "Mechanical": 81,
      "Industrial": 17,
      "Business Detail": 14,
      "Selling": 34,
      "Accommodating": 45,
      "Humanitarian": 23,
      "Leading/Influencing": 15,
      "Physical Performing": 18
    },
    "fitScore": 48
  },
  {
    "code": "49-3031.00",
    "aptitudeProfile": {
      "Verbal": 14,
      "Numeric": 25,
      "Spatial": 62,
      "ClericalPerception": 53,
      "FormPerception": 70,
      "GeneralLearning": 42
    },
    "interestProfile": {
      "Artistic": 12,
      "Scientific": 41,
      "Plants/Animals": 16,
      "Protective": 70,
      "Mechanical": 62,
      "Industrial": 14,
      "Business Detail": 49,
      "Selling": 24,
      "Accommodating": 31,
      "Humanitarian": 16,
      "Leading/Influencing": 24,
      "Physical Performing": 32
    },
    "fitScore": 38
  },
  {
    "code": "49-3041.00",
    "aptitudeProfile": {
      "Verbal": 22,
      "Numeric": 50,
      "Spatial": 82,
      "ClericalPerception": 44,
      "FormPerception": 70,
      "GeneralLearning": 36
    },
    "interestProfile": {
      "Artistic": 18,
      "Scientific": 33,
      "Plants/Animals": 43,
      "Protective": 70,
      "Mechanical": 82,
      "Industrial": 39,
      "Business Detail": 54,
      "Selling": 23,
      "Accommodating": 51,
      "Humanitarian": 24,
      "Leading/Influencing": 56,
      "Physical Performing": 36
    },
    "fitScore": 47
  },
  {
    "code": "49-3042.00",
    "aptitudeProfile": {
      "Verbal": 11,
      "Numeric": 61,
      "Spatial": 86,
      "ClericalPerception": 68,
      "FormPerception": 86,
      "GeneralLearning": 42
    },
    "interestProfile": {
      "Artistic": 15,
      "Scientific": 41,
      "Plants/Animals": 59,
      "Protective": 86,
      "Mechanical": 86,
      "Industrial": 47,
      "Business Detail": 18,
      "Selling": 22,
      "Accommodating": 70,
      "Humanitarian": 31,
      "Leading/Influencing": 18,
      "Physical Performing": 32
    },
    "fitScore": 51
  },
  {
    "code": "49-3043.00",
    "aptitudeProfile": {
      "Verbal": 11,
      "Numeric": 28,
      "Spatial": 62,
      "ClericalPerception": 68,
      "FormPerception": 87,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 7,
      "Scientific": 25,
      "Plants/Animals": 25,
      "Protective": 87,
      "Mechanical": 62,
      "Industrial": 16,
      "Business Detail": 49,
      "Selling": 13,
      "Accommodating": 43,
      "Humanitarian": 17,
      "Leading/Influencing": 37,
      "Physical Performing": 14
    },
    "fitScore": 39
  },
  {
    "code": "49-3051.00",
    "aptitudeProfile": {
      "Verbal": 15,
      "Numeric": 32,
      "Spatial": 51,
      "ClericalPerception": 23,
      "FormPerception": 59,
      "GeneralLearning": 66
    },
    "interestProfile": {
      "Artistic": 14,
      "Scientific": 45,
      "Plants/Animals": 21,
      "Protective": 59,
      "Mechanical": 51,
      "Industrial": 15,
      "Business Detail": 57,
      "Selling": 13,
      "Accommodating": 33,
      "Humanitarian": 13,
      "Leading/Influencing": 35,
      "Physical Performing": 39
    },
    "fitScore": 37
  },
  {
    "code": "49-3052.00",
    "aptitudeProfile": {
      "Verbal": 14,
      "Numeric": 32,
      "Spatial": 59,
      "ClericalPerception": 37,
      "FormPerception": 26,
      "GeneralLearning": 70
    },
    "interestProfile": {
      "Artistic": 23,
      "Scientific": 68,
      "Plants/Animals": 24,
      "Protective": 26,
      "Mechanical": 59,
      "Industrial": 22,
      "Business Detail": 16,
      "Selling": 57,
      "Accommodating": 27,
      "Humanitarian": 18,
      "Leading/Influencing": 7,
      "Physical Performing": 49
    },
    "fitScore": 36
  },
  {
    "code": "49-3053.00",
    "aptitudeProfile": {
      "Verbal": 11,
      "Numeric": 19,
      "Spatial": 62,
      "ClericalPerception": 37,
      "FormPerception": 52,
      "GeneralLearning": 25
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 27,
      "Plants/Animals": 19,
      "Protective": 52,
      "Mechanical": 62,
      "Industrial": 13,
      "Business Detail": 27,
      "Selling": 18,
      "Accommodating": 32,
      "Humanitarian": 13,
      "Leading/Influencing": 23,
      "Physical Performing": 11
    },
    "fitScore": 30
  },
  {
    "code": "49-3091.00",
    "aptitudeProfile": {
      "Verbal": 27,
      "Numeric": 29,
      "Spatial": 56,
      "ClericalPerception": 33,
      "FormPerception": 33,
      "GeneralLearning": 16
    },
    "interestProfile": {
      "Artistic": 21,
      "Scientific": 22,
      "Plants/Animals": 23,
      "Protective": 33,
      "Mechanical": 56,
      "Industrial": 18,
      "Business Detail": 64,
      "Selling": 29,
      "Accommodating": 21,
      "Humanitarian": 9,
      "Leading/Influencing": 47,
      "Physical Performing": 35
    },
    "fitScore": 32
  },
  {
    "code": "49-3092.00",
    "aptitudeProfile": {
      "Verbal": 30,
      "Numeric": 10,
      "Spatial": 51,
      "ClericalPerception": 50,
      "FormPerception": 72,
      "GeneralLearning": 38
    },
    "interestProfile": {
      "Artistic": 34,
      "Scientific": 36,
      "Plants/Animals": 12,
      "Protective": 72,
      "Mechanical": 51,
      "Industrial": 15,
      "Business Detail": 12,
      "Selling": 41,
      "Accommodating": 29,
      "Humanitarian": 16,
      "Leading/Influencing": 21,
      "Physical Performing": 12
    },
    "fitScore": 36
  },
  {
    "code": "49-3093.00",
    "aptitudeProfile": {
      "Verbal": 7,
      "Numeric": 18,
      "Spatial": 28,
      "ClericalPerception": 4,
      "FormPerception": 7,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 6,
      "Scientific": 11,
      "Plants/Animals": 15,
      "Protective": 7,
      "Mechanical": 28,
      "Industrial": 6,
      "Business Detail": 34,
      "Selling": 6,
      "Accommodating": 9,
      "Humanitarian": 10,
      "Leading/Influencing": 29,
      "Physical Performing": 10
    },
    "fitScore": 14
  },
  {
    "code": "49-9011.00",
    "aptitudeProfile": {
      "Verbal": 17,
      "Numeric": 33,
      "Spatial": 64,
      "ClericalPerception": 35,
      "FormPerception": 40,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 17,
      "Scientific": 23,
      "Plants/Animals": 22,
      "Protective": 40,
      "Mechanical": 64,
      "Industrial": 32,
      "Business Detail": 31,
      "Selling": 22,
      "Accommodating": 30,
      "Humanitarian": 25,
      "Leading/Influencing": 30,
      "Physical Performing": 24
    },
    "fitScore": 32
  },
  {
    "code": "49-9012.00",
    "aptitudeProfile": {
      "Verbal": 29,
      "Numeric": 31,
      "Spatial": 42,
      "ClericalPerception": 57,
      "FormPerception": 63,
      "GeneralLearning": 32
    },
    "interestProfile": {
      "Artistic": 30,
      "Scientific": 36,
      "Plants/Animals": 25,
      "Protective": 63,
      "Mechanical": 42,
      "Industrial": 17,
      "Business Detail": 52,
      "Selling": 42,
      "Accommodating": 36,
      "Humanitarian": 16,
      "Leading/Influencing": 26,
      "Physical Performing": 51
    },
    "fitScore": 39
  },
  {
    "code": "49-9021.00",
    "aptitudeProfile": {
      "Verbal": 31,
      "Numeric": 45,
      "Spatial": 71,
      "ClericalPerception": 53,
      "FormPerception": 74,
      "GeneralLearning": 63
    },
    "interestProfile": {
      "Artistic": 25,
      "Scientific": 55,
      "Plants/Animals": 35,
      "Protective": 74,
      "Mechanical": 71,
      "Industrial": 42,
      "Business Detail": 61,
      "Selling": 40,
      "Accommodating": 53,
      "Humanitarian": 27,
      "Leading/Influencing": 55,
      "Physical Performing": 52
    },
    "fitScore": 53
  },
  {
    "code": "49-9031.00",
    "aptitudeProfile": {
      "Verbal": 33,
      "Numeric": 35,
      "Spatial": 56,
      "ClericalPerception": 56,
      "FormPerception": 57,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 29,
      "Scientific": 30,
      "Plants/Animals": 42,
      "Protective": 57,
      "Mechanical": 56,
      "Industrial": 20,
      "Business Detail": 52,
      "Selling": 42,
      "Accommodating": 41,
      "Humanitarian": 17,
      "Leading/Influencing": 44,
      "Physical Performing": 31
    },
    "fitScore": 41
  },
  {
    "code": "49-9041.00",
    "aptitudeProfile": {
      "Verbal": 11,
      "Numeric": 36,
      "Spatial": 64,
      "ClericalPerception": 56,
      "FormPerception": 57,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 13,
      "Scientific": 29,
      "Plants/Animals": 29,
      "Protective": 57,
      "Mechanical": 64,
      "Industrial": 24,
      "Business Detail": 24,
      "Selling": 21,
      "Accommodating": 40,
      "Humanitarian": 16,
      "Leading/Influencing": 20,
      "Physical Performing": 21
    },
    "fitScore": 35
  },
  {
    "code": "49-9043.00",
    "aptitudeProfile": {
      "Verbal": 15,
      "Numeric": 20,
      "Spatial": 53,
      "ClericalPerception": 43,
      "FormPerception": 64,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 10,
      "Scientific": 20,
      "Plants/Animals": 17,
      "Protective": 64,
      "Mechanical": 53,
      "Industrial": 15,
      "Business Detail": 44,
      "Selling": 11,
      "Accommodating": 28,
      "Humanitarian": 18,
      "Leading/Influencing": 32,
      "Physical Performing": 11
    },
    "fitScore": 31
  },
  {
    "code": "49-9044.00",
    "aptitudeProfile": {
      "Verbal": 21,
      "Numeric": 74,
      "Spatial": 92,
      "ClericalPerception": 52,
      "FormPerception": 75,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 16,
      "Scientific": 25,
      "Plants/Animals": 58,
      "Protective": 75,
      "Mechanical": 92,
      "Industrial": 34,
      "Business Detail": 91,
      "Selling": 25,
      "Accommodating": 62,
      "Humanitarian": 27,
      "Leading/Influencing": 61,
      "Physical Performing": 82
    },
    "fitScore": 55
  },
  {
    "code": "49-9045.00",
    "aptitudeProfile": {
      "Verbal": 8,
      "Numeric": 18,
      "Spatial": 47,
      "ClericalPerception": 17,
      "FormPerception": 36,
      "GeneralLearning": 17
    },
    "interestProfile": {
      "Artistic": 12,
      "Scientific": 13,
      "Plants/Animals": 19,
      "Protective": 36,
      "Mechanical": 47,
      "Industrial": 12,
      "Business Detail": 7,
      "Selling": 10,
      "Accommodating": 17,
      "Humanitarian": 17,
      "Leading/Influencing": 4,
      "Physical Performing": 14
    },
    "fitScore": 21
  },
  {
    "code": "49-9051.00",
    "aptitudeProfile": {
      "Verbal": 17,
      "Numeric": 20,
      "Spatial": 82,
      "ClericalPerception": 50,
      "FormPerception": 67,
      "GeneralLearning": 53
    },
    "interestProfile": {
      "Artistic": 16,
      "Scientific": 49,
      "Plants/Animals": 15,
      "Protective": 67,
      "Mechanical": 82,
      "Industrial": 16,
      "Business Detail": 31,
      "Selling": 40,
      "Accommodating": 30,
      "Humanitarian": 34,
      "Leading/Influencing": 19,
      "Physical Performing": 34
    },
    "fitScore": 42
  },
  {
    "code": "49-9052.00",
    "aptitudeProfile": {
      "Verbal": 24,
      "Numeric": 22,
      "Spatial": 58,
      "ClericalPerception": 37,
      "FormPerception": 64,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 26,
      "Scientific": 20,
      "Plants/Animals": 22,
      "Protective": 64,
      "Mechanical": 58,
      "Industrial": 13,
      "Business Detail": 31,
      "Selling": 27,
      "Accommodating": 28,
      "Humanitarian": 21,
      "Leading/Influencing": 21,
      "Physical Performing": 29
    },
    "fitScore": 34
  },
  {
    "code": "49-9061.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 37,
      "Spatial": 100,
      "ClericalPerception": 26,
      "FormPerception": 44,
      "GeneralLearning": 26
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 22,
      "Plants/Animals": 44,
      "Protective": 44,
      "Mechanical": 100,
      "Industrial": 33,
      "Business Detail": 19,
      "Selling": 10,
      "Accommodating": 32,
      "Humanitarian": 52,
      "Leading/Influencing": 26,
      "Physical Performing": 11
    },
    "fitScore": 37
  },
  {
    "code": "49-9062.00",
    "aptitudeProfile": {
      "Verbal": 18,
      "Numeric": 61,
      "Spatial": 60,
      "ClericalPerception": 53,
      "FormPerception": 66,
      "GeneralLearning": 39
    },
    "interestProfile": {
      "Artistic": 23,
      "Scientific": 39,
      "Plants/Animals": 65,
      "Protective": 66,
      "Mechanical": 60,
      "Industrial": 51,
      "Business Detail": 19,
      "Selling": 25,
      "Accommodating": 62,
      "Humanitarian": 20,
      "Leading/Influencing": 30,
      "Physical Performing": 26
    },
    "fitScore": 45
  },
  {
    "code": "49-9063.00",
    "aptitudeProfile": {
      "Verbal": 17,
      "Numeric": 22,
      "Spatial": 99,
      "ClericalPerception": 41,
      "FormPerception": 64,
      "GeneralLearning": 53
    },
    "interestProfile": {
      "Artistic": 15,
      "Scientific": 48,
      "Plants/Animals": 19,
      "Protective": 64,
      "Mechanical": 99,
      "Industrial": 16,
      "Business Detail": 33,
      "Selling": 25,
      "Accommodating": 36,
      "Humanitarian": 42,
      "Leading/Influencing": 24,
      "Physical Performing": 20
    },
    "fitScore": 43
  },
  {
    "code": "49-9064.00",
    "aptitudeProfile": {
      "Verbal": 17,
      "Numeric": 17,
      "Spatial": 95,
      "ClericalPerception": 29,
      "FormPerception": 35,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 18,
      "Plants/Animals": 16,
      "Protective": 35,
      "Mechanical": 95,
      "Industrial": 14,
      "Business Detail": 50,
      "Selling": 15,
      "Accommodating": 20,
      "Humanitarian": 35,
      "Leading/Influencing": 53,
      "Physical Performing": 8
    },
    "fitScore": 33
  },
  {
    "code": "49-9071.00",
    "aptitudeProfile": {
      "Verbal": 17,
      "Numeric": 41,
      "Spatial": 67,
      "ClericalPerception": 32,
      "FormPerception": 70,
      "GeneralLearning": 29
    },
    "interestProfile": {
      "Artistic": 23,
      "Scientific": 23,
      "Plants/Animals": 35,
      "Protective": 70,
      "Mechanical": 67,
      "Industrial": 26,
      "Business Detail": 25,
      "Selling": 16,
      "Accommodating": 48,
      "Humanitarian": 19,
      "Leading/Influencing": 14,
      "Physical Performing": 37
    },
    "fitScore": 38
  },
  {
    "code": "49-9081.00",
    "aptitudeProfile": {
      "Verbal": 35,
      "Numeric": 34,
      "Spatial": 62,
      "ClericalPerception": 62,
      "FormPerception": 77,
      "GeneralLearning": 48
    },
    "interestProfile": {
      "Artistic": 31,
      "Scientific": 46,
      "Plants/Animals": 23,
      "Protective": 77,
      "Mechanical": 62,
      "Industrial": 29,
      "Business Detail": 64,
      "Selling": 47,
      "Accommodating": 41,
      "Humanitarian": 23,
      "Leading/Influencing": 45,
      "Physical Performing": 58
    },
    "fitScore": 49
  },
  {
    "code": "49-9091.00",
    "aptitudeProfile": {
      "Verbal": 11,
      "Numeric": 20,
      "Spatial": 49,
      "ClericalPerception": 10,
      "FormPerception": 36,
      "GeneralLearning": 22
    },
    "interestProfile": {
      "Artistic": 12,
      "Scientific": 15,
      "Plants/Animals": 27,
      "Protective": 36,
      "Mechanical": 49,
      "Industrial": 14,
      "Business Detail": 10,
      "Selling": 6,
      "Accommodating": 21,
      "Humanitarian": 14,
      "Leading/Influencing": 11,
      "Physical Performing": 7
    },
    "fitScore": 22
  },
  {
    "code": "49-9092.00",
    "aptitudeProfile": {
      "Verbal": 40,
      "Numeric": 31,
      "Spatial": 90,
      "ClericalPerception": 84,
      "FormPerception": 92,
      "GeneralLearning": 56
    },
    "interestProfile": {
      "Artistic": 50,
      "Scientific": 56,
      "Plants/Animals": 25,
      "Protective": 92,
      "Mechanical": 90,
      "Industrial": 27,
      "Business Detail": 31,
      "Selling": 67,
      "Accommodating": 47,
      "Humanitarian": 49,
      "Leading/Influencing": 16,
      "Physical Performing": 63
    },
    "fitScore": 58
  },
  {
    "code": "49-9094.00",
    "aptitudeProfile": {
      "Verbal": 25,
      "Numeric": 41,
      "Spatial": 63,
      "ClericalPerception": 25,
      "FormPerception": 55,
      "GeneralLearning": 29
    },
    "interestProfile": {
      "Artistic": 22,
      "Scientific": 24,
      "Plants/Animals": 36,
      "Protective": 55,
      "Mechanical": 63,
      "Industrial": 27,
      "Business Detail": 55,
      "Selling": 13,
      "Accommodating": 48,
      "Humanitarian": 18,
      "Leading/Influencing": 50,
      "Physical Performing": 28
    },
    "fitScore": 38
  },
  {
    "code": "49-9095.00",
    "aptitudeProfile": {
      "Verbal": 26,
      "Numeric": 59,
      "Spatial": 98,
      "ClericalPerception": 78,
      "FormPerception": 80,
      "GeneralLearning": 36
    },
    "interestProfile": {
      "Artistic": 26,
      "Scientific": 48,
      "Plants/Animals": 51,
      "Protective": 80,
      "Mechanical": 98,
      "Industrial": 40,
      "Business Detail": 61,
      "Selling": 53,
      "Accommodating": 62,
      "Humanitarian": 47,
      "Leading/Influencing": 48,
      "Physical Performing": 60
    },
    "fitScore": 60
  },
  {
    "code": "49-9096.00",
    "aptitudeProfile": {
      "Verbal": 17,
      "Numeric": 9,
      "Spatial": 69,
      "ClericalPerception": 29,
      "FormPerception": 49,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 10,
      "Scientific": 15,
      "Plants/Animals": 3,
      "Protective": 49,
      "Mechanical": 69,
      "Industrial": 7,
      "Business Detail": 67,
      "Selling": 12,
      "Accommodating": 6,
      "Humanitarian": 22,
      "Leading/Influencing": 25,
      "Physical Performing": 32
    },
    "fitScore": 29
  },
  {
    "code": "49-9097.00",
    "aptitudeProfile": {
      "Verbal": 8,
      "Numeric": 40,
      "Spatial": 92,
      "ClericalPerception": 24,
      "FormPerception": 92,
      "GeneralLearning": 38
    },
    "interestProfile": {
      "Artistic": 13,
      "Scientific": 22,
      "Plants/Animals": 43,
      "Protective": 92,
      "Mechanical": 92,
      "Industrial": 25,
      "Business Detail": 11,
      "Selling": 6,
      "Accommodating": 74,
      "Humanitarian": 30,
      "Leading/Influencing": 12,
      "Physical Performing": 17
    },
    "fitScore": 43
  },
  {
    "code": "49-9098.00",
    "aptitudeProfile": {
      "Verbal": 5,
      "Numeric": 25,
      "Spatial": 54,
      "ClericalPerception": 12,
      "FormPerception": 56,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 4,
      "Scientific": 9,
      "Plants/Animals": 15,
      "Protective": 56,
      "Mechanical": 54,
      "Industrial": 7,
      "Business Detail": 41,
      "Selling": 6,
      "Accommodating": 27,
      "Humanitarian": 12,
      "Leading/Influencing": 14,
      "Physical Performing": 36
    },
    "fitScore": 25
  },
  {
    "code": "49-9099.01",
    "aptitudeProfile": {
      "Verbal": 27,
      "Numeric": 68,
      "Spatial": 69,
      "ClericalPerception": 85,
      "FormPerception": 94,
      "GeneralLearning": 44
    },
    "interestProfile": {
      "Artistic": 20,
      "Scientific": 43,
      "Plants/Animals": 70,
      "Protective": 94,
      "Mechanical": 69,
      "Industrial": 49,
      "Business Detail": 68,
      "Selling": 25,
      "Accommodating": 75,
      "Humanitarian": 26,
      "Leading/Influencing": 69,
      "Physical Performing": 39
    },
    "fitScore": 59
  },
  {
    "code": "51-1011.00",
    "aptitudeProfile": {
      "Verbal": 75,
      "Numeric": 63,
      "Spatial": 45,
      "ClericalPerception": 77,
      "FormPerception": 67,
      "GeneralLearning": 66
    },
    "interestProfile": {
      "Artistic": 67,
      "Scientific": 67,
      "Plants/Animals": 72,
      "Protective": 67,
      "Mechanical": 45,
      "Industrial": 48,
      "Business Detail": 86,
      "Selling": 69,
      "Accommodating": 68,
      "Humanitarian": 26,
      "Leading/Influencing": 83,
      "Physical Performing": 66
    },
    "fitScore": 65
  },
  {
    "code": "51-2011.00",
    "aptitudeProfile": {
      "Verbal": 18,
      "Numeric": 44,
      "Spatial": 67,
      "ClericalPerception": 58,
      "FormPerception": 57,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 17,
      "Scientific": 29,
      "Plants/Animals": 30,
      "Protective": 57,
      "Mechanical": 67,
      "Industrial": 32,
      "Business Detail": 50,
      "Selling": 28,
      "Accommodating": 32,
      "Humanitarian": 18,
      "Leading/Influencing": 40,
      "Physical Performing": 39
    },
    "fitScore": 40
  },
  {
    "code": "51-2021.00",
    "aptitudeProfile": {
      "Verbal": 14,
      "Numeric": 19,
      "Spatial": 6,
      "ClericalPerception": 9,
      "FormPerception": 28,
      "GeneralLearning": 12
    },
    "interestProfile": {
      "Artistic": 6,
      "Scientific": 8,
      "Plants/Animals": 7,
      "Protective": 28,
      "Mechanical": 6,
      "Industrial": 7,
      "Business Detail": 87,
      "Selling": 4,
      "Accommodating": 6,
      "Humanitarian": 7,
      "Leading/Influencing": 40,
      "Physical Performing": 41
    },
    "fitScore": 18
  },
  {
    "code": "51-2022.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 14,
      "Spatial": 31,
      "ClericalPerception": 35,
      "FormPerception": 34,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 18,
      "Scientific": 22,
      "Plants/Animals": 14,
      "Protective": 34,
      "Mechanical": 31,
      "Industrial": 24,
      "Business Detail": 3,
      "Selling": 26,
      "Accommodating": 12,
      "Humanitarian": 12,
      "Leading/Influencing": 5,
      "Physical Performing": 11
    },
    "fitScore": 21
  },
  {
    "code": "51-2023.00",
    "aptitudeProfile": {
      "Verbal": 8,
      "Numeric": 18,
      "Spatial": 93,
      "ClericalPerception": 16,
      "FormPerception": 55,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 14,
      "Plants/Animals": 17,
      "Protective": 55,
      "Mechanical": 93,
      "Industrial": 16,
      "Business Detail": 5,
      "Selling": 5,
      "Accommodating": 29,
      "Humanitarian": 42,
      "Leading/Influencing": 3,
      "Physical Performing": 9
    },
    "fitScore": 30
  },
  {
    "code": "51-2031.00",
    "aptitudeProfile": {
      "Verbal": 10,
      "Numeric": 21,
      "Spatial": 64,
      "ClericalPerception": 24,
      "FormPerception": 64,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 7,
      "Scientific": 14,
      "Plants/Animals": 17,
      "Protective": 64,
      "Mechanical": 64,
      "Industrial": 19,
      "Business Detail": 34,
      "Selling": 6,
      "Accommodating": 28,
      "Humanitarian": 20,
      "Leading/Influencing": 22,
      "Physical Performing": 15
    },
    "fitScore": 30
  },
  {
    "code": "51-2041.00",
    "aptitudeProfile": {
      "Verbal": 8,
      "Numeric": 30,
      "Spatial": 52,
      "ClericalPerception": 2,
      "FormPerception": 4,
      "GeneralLearning": 14
    },
    "interestProfile": {
      "Artistic": 7,
      "Scientific": 9,
      "Plants/Animals": 20,
      "Protective": 4,
      "Mechanical": 52,
      "Industrial": 17,
      "Business Detail": 47,
      "Selling": 3,
      "Accommodating": 8,
      "Humanitarian": 15,
      "Leading/Influencing": 22,
      "Physical Performing": 25
    },
    "fitScore": 19
  },
  {
    "code": "51-2051.00",
    "aptitudeProfile": {
      "Verbal": 23,
      "Numeric": 33,
      "Spatial": 58,
      "ClericalPerception": 50,
      "FormPerception": 72,
      "GeneralLearning": 16
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 22,
      "Plants/Animals": 35,
      "Protective": 72,
      "Mechanical": 58,
      "Industrial": 23,
      "Business Detail": 67,
      "Selling": 21,
      "Accommodating": 48,
      "Humanitarian": 17,
      "Leading/Influencing": 74,
      "Physical Performing": 15
    },
    "fitScore": 40
  },
  {
    "code": "51-2061.00",
    "aptitudeProfile": {
      "Verbal": 5,
      "Numeric": 24,
      "Spatial": 35,
      "ClericalPerception": 11,
      "FormPerception": 23,
      "GeneralLearning": 14
    },
    "interestProfile": {
      "Artistic": 8,
      "Scientific": 14,
      "Plants/Animals": 20,
      "Protective": 23,
      "Mechanical": 35,
      "Industrial": 9,
      "Business Detail": 13,
      "Selling": 10,
      "Accommodating": 25,
      "Humanitarian": 8,
      "Leading/Influencing": 4,
      "Physical Performing": 21
    },
    "fitScore": 17
  },
  {
    "code": "51-2092.00",
    "aptitudeProfile": {
      "Verbal": 18,
      "Numeric": 19,
      "Spatial": 27,
      "ClericalPerception": 22,
      "FormPerception": 23,
      "GeneralLearning": 19
    },
    "interestProfile": {
      "Artistic": 15,
      "Scientific": 16,
      "Plants/Animals": 12,
      "Protective": 23,
      "Mechanical": 27,
      "Industrial": 14,
      "Business Detail": 47,
      "Selling": 11,
      "Accommodating": 7,
      "Humanitarian": 10,
      "Leading/Influencing": 25,
      "Physical Performing": 25
    },
    "fitScore": 20
  },
  {
    "code": "51-3011.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 30,
      "Spatial": 81,
      "ClericalPerception": 51,
      "FormPerception": 53,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 12,
      "Scientific": 20,
      "Plants/Animals": 24,
      "Protective": 53,
      "Mechanical": 81,
      "Industrial": 18,
      "Business Detail": 38,
      "Selling": 26,
      "Accommodating": 26,
      "Humanitarian": 34,
      "Leading/Influencing": 29,
      "Physical Performing": 28
    },
    "fitScore": 36
  },
  {
    "code": "51-3021.00",
    "aptitudeProfile": {
      "Verbal": 8,
      "Numeric": 32,
      "Spatial": 17,
      "ClericalPerception": 13,
      "FormPerception": 29,
      "GeneralLearning": 8
    },
    "interestProfile": {
      "Artistic": 7,
      "Scientific": 9,
      "Plants/Animals": 44,
      "Protective": 29,
      "Mechanical": 17,
      "Industrial": 24,
      "Business Detail": 11,
      "Selling": 8,
      "Accommodating": 31,
      "Humanitarian": 9,
      "Leading/Influencing": 18,
      "Physical Performing": 7
    },
    "fitScore": 18
  },
  {
    "code": "51-3022.00",
    "aptitudeProfile": {
      "Verbal": 9,
      "Numeric": 36,
      "Spatial": 21,
      "ClericalPerception": 4,
      "FormPerception": 10,
      "GeneralLearning": 6
    },
    "interestProfile": {
      "Artistic": 6,
      "Scientific": 5,
      "Plants/Animals": 19,
      "Protective": 10,
      "Mechanical": 21,
      "Industrial": 8,
      "Business Detail": 78,
      "Selling": 4,
      "Accommodating": 10,
      "Humanitarian": 5,
      "Leading/Influencing": 48,
      "Physical Performing": 39
    },
    "fitScore": 18
  },
  {
    "code": "51-3023.00",
    "aptitudeProfile": {
      "Verbal": 1,
      "Numeric": 10,
      "Spatial": 15,
      "ClericalPerception": 1,
      "FormPerception": 1,
      "GeneralLearning": 3
    },
    "interestProfile": {
      "Artistic": 1,
      "Scientific": 2,
      "Plants/Animals": 8,
      "Protective": 1,
      "Mechanical": 15,
      "Industrial": 1,
      "Business Detail": 14,
      "Selling": 2,
      "Accommodating": 2,
      "Humanitarian": 4,
      "Leading/Influencing": 4,
      "Physical Performing": 9
    },
    "fitScore": 5
  },
  {
    "code": "51-3091.00",
    "aptitudeProfile": {
      "Verbal": 8,
      "Numeric": 4,
      "Spatial": 15,
      "ClericalPerception": 25,
      "FormPerception": 68,
      "GeneralLearning": 10
    },
    "interestProfile": {
      "Artistic": 12,
      "Scientific": 8,
      "Plants/Animals": 4,
      "Protective": 68,
      "Mechanical": 15,
      "Industrial": 7,
      "Business Detail": 2,
      "Selling": 6,
      "Accommodating": 9,
      "Humanitarian": 8,
      "Leading/Influencing": 1,
      "Physical Performing": 5
    },
    "fitScore": 17
  },
  {
    "code": "51-3092.00",
    "aptitudeProfile": {
      "Verbal": 20,
      "Numeric": 41,
      "Spatial": 18,
      "ClericalPerception": 26,
      "FormPerception": 50,
      "GeneralLearning": 12
    },
    "interestProfile": {
      "Artistic": 14,
      "Scientific": 11,
      "Plants/Animals": 31,
      "Protective": 50,
      "Mechanical": 18,
      "Industrial": 39,
      "Business Detail": 54,
      "Selling": 10,
      "Accommodating": 26,
      "Humanitarian": 18,
      "Leading/Influencing": 61,
      "Physical Performing": 26
    },
    "fitScore": 29
  },
  {
    "code": "51-3093.00",
    "aptitudeProfile": {
      "Verbal": 21,
      "Numeric": 15,
      "Spatial": 4,
      "ClericalPerception": 9,
      "FormPerception": 20,
      "GeneralLearning": 12
    },
    "interestProfile": {
      "Artistic": 15,
      "Scientific": 8,
      "Plants/Animals": 21,
      "Protective": 20,
      "Mechanical": 4,
      "Industrial": 17,
      "Business Detail": 24,
      "Selling": 7,
      "Accommodating": 10,
      "Humanitarian": 8,
      "Leading/Influencing": 36,
      "Physical Performing": 6
    },
    "fitScore": 14
  },
  {
    "code": "51-4021.00",
    "aptitudeProfile": {
      "Verbal": 7,
      "Numeric": 42,
      "Spatial": 41,
      "ClericalPerception": 16,
      "FormPerception": 67,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 5,
      "Scientific": 9,
      "Plants/Animals": 28,
      "Protective": 67,
      "Mechanical": 41,
      "Industrial": 26,
      "Business Detail": 48,
      "Selling": 4,
      "Accommodating": 34,
      "Humanitarian": 14,
      "Leading/Influencing": 36,
      "Physical Performing": 30
    },
    "fitScore": 30
  },
  {
    "code": "51-4022.00",
    "aptitudeProfile": {
      "Verbal": 22,
      "Numeric": 35,
      "Spatial": 43,
      "ClericalPerception": 26,
      "FormPerception": 52,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 20,
      "Scientific": 14,
      "Plants/Animals": 20,
      "Protective": 52,
      "Mechanical": 43,
      "Industrial": 21,
      "Business Detail": 66,
      "Selling": 12,
      "Accommodating": 22,
      "Humanitarian": 17,
      "Leading/Influencing": 31,
      "Physical Performing": 52
    },
    "fitScore": 32
  },
  {
    "code": "51-4023.00",
    "aptitudeProfile": {
      "Verbal": 18,
      "Numeric": 32,
      "Spatial": 51,
      "ClericalPerception": 39,
      "FormPerception": 77,
      "GeneralLearning": 25
    },
    "interestProfile": {
      "Artistic": 17,
      "Scientific": 19,
      "Plants/Animals": 36,
      "Protective": 77,
      "Mechanical": 51,
      "Industrial": 26,
      "Business Detail": 24,
      "Selling": 9,
      "Accommodating": 46,
      "Humanitarian": 19,
      "Leading/Influencing": 36,
      "Physical Performing": 11
    },
    "fitScore": 36
  },
  {
    "code": "51-4031.00",
    "aptitudeProfile": {
      "Verbal": 8,
      "Numeric": 34,
      "Spatial": 51,
      "ClericalPerception": 23,
      "FormPerception": 60,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 10,
      "Scientific": 13,
      "Plants/Animals": 30,
      "Protective": 60,
      "Mechanical": 51,
      "Industrial": 23,
      "Business Detail": 19,
      "Selling": 4,
      "Accommodating": 31,
      "Humanitarian": 16,
      "Leading/Influencing": 16,
      "Physical Performing": 16
    },
    "fitScore": 28
  },
  {
    "code": "51-4032.00",
    "aptitudeProfile": {
      "Verbal": 18,
      "Numeric": 70,
      "Spatial": 51,
      "ClericalPerception": 42,
      "FormPerception": 56,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 14,
      "Scientific": 19,
      "Plants/Animals": 50,
      "Protective": 56,
      "Mechanical": 51,
      "Industrial": 34,
      "Business Detail": 88,
      "Selling": 14,
      "Accommodating": 43,
      "Humanitarian": 18,
      "Leading/Influencing": 46,
      "Physical Performing": 76
    },
    "fitScore": 42
  },
  {
    "code": "51-4033.00",
    "aptitudeProfile": {
      "Verbal": 11,
      "Numeric": 49,
      "Spatial": 39,
      "ClericalPerception": 36,
      "FormPerception": 77,
      "GeneralLearning": 19
    },
    "interestProfile": {
      "Artistic": 7,
      "Scientific": 15,
      "Plants/Animals": 47,
      "Protective": 77,
      "Mechanical": 39,
      "Industrial": 42,
      "Business Detail": 36,
      "Selling": 7,
      "Accommodating": 57,
      "Humanitarian": 13,
      "Leading/Influencing": 52,
      "Physical Performing": 15
    },
    "fitScore": 36
  },
  {
    "code": "51-4034.00",
    "aptitudeProfile": {
      "Verbal": 14,
      "Numeric": 36,
      "Spatial": 39,
      "ClericalPerception": 19,
      "FormPerception": 50,
      "GeneralLearning": 14
    },
    "interestProfile": {
      "Artistic": 8,
      "Scientific": 10,
      "Plants/Animals": 32,
      "Protective": 50,
      "Mechanical": 39,
      "Industrial": 18,
      "Business Detail": 66,
      "Selling": 6,
      "Accommodating": 32,
      "Humanitarian": 13,
      "Leading/Influencing": 45,
      "Physical Performing": 28
    },
    "fitScore": 29
  },
  {
    "code": "51-4035.00",
    "aptitudeProfile": {
      "Verbal": 12,
      "Numeric": 58,
      "Spatial": 40,
      "ClericalPerception": 33,
      "FormPerception": 50,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 21,
      "Plants/Animals": 52,
      "Protective": 50,
      "Mechanical": 40,
      "Industrial": 30,
      "Business Detail": 57,
      "Selling": 14,
      "Accommodating": 51,
      "Humanitarian": 11,
      "Leading/Influencing": 46,
      "Physical Performing": 39
    },
    "fitScore": 35
  },
  {
    "code": "51-4041.00",
    "aptitudeProfile": {
      "Verbal": 9,
      "Numeric": 68,
      "Spatial": 58,
      "ClericalPerception": 47,
      "FormPerception": 64,
      "GeneralLearning": 25
    },
    "interestProfile": {
      "Artistic": 12,
      "Scientific": 27,
      "Plants/Animals": 66,
      "Protective": 64,
      "Mechanical": 58,
      "Industrial": 38,
      "Business Detail": 27,
      "Selling": 17,
      "Accommodating": 65,
      "Humanitarian": 16,
      "Leading/Influencing": 24,
      "Physical Performing": 37
    },
    "fitScore": 41
  },
  {
    "code": "51-4051.00",
    "aptitudeProfile": {
      "Verbal": 14,
      "Numeric": 39,
      "Spatial": 56,
      "ClericalPerception": 20,
      "FormPerception": 68,
      "GeneralLearning": 19
    },
    "interestProfile": {
      "Artistic": 8,
      "Scientific": 11,
      "Plants/Animals": 41,
      "Protective": 68,
      "Mechanical": 56,
      "Industrial": 30,
      "Business Detail": 45,
      "Selling": 3,
      "Accommodating": 44,
      "Humanitarian": 23,
      "Leading/Influencing": 57,
      "Physical Performing": 11
    },
    "fitScore": 35
  },
  {
    "code": "51-4052.00",
    "aptitudeProfile": {
      "Verbal": 3,
      "Numeric": 11,
      "Spatial": 35,
      "ClericalPerception": 19,
      "FormPerception": 64,
      "GeneralLearning": 10
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 7,
      "Plants/Animals": 14,
      "Protective": 64,
      "Mechanical": 35,
      "Industrial": 9,
      "Business Detail": 3,
      "Selling": 4,
      "Accommodating": 21,
      "Humanitarian": 13,
      "Leading/Influencing": 5,
      "Physical Performing": 3
    },
    "fitScore": 19
  },
  {
    "code": "51-4061.00",
    "aptitudeProfile": {
      "Verbal": 12,
      "Numeric": 61,
      "Spatial": 53,
      "ClericalPerception": 30,
      "FormPerception": 63,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 17,
      "Scientific": 18,
      "Plants/Animals": 46,
      "Protective": 63,
      "Mechanical": 53,
      "Industrial": 32,
      "Business Detail": 40,
      "Selling": 15,
      "Accommodating": 51,
      "Humanitarian": 9,
      "Leading/Influencing": 19,
      "Physical Performing": 59
    },
    "fitScore": 38
  },
  {
    "code": "51-4062.00",
    "aptitudeProfile": {
      "Verbal": 12,
      "Numeric": 44,
      "Spatial": 42,
      "ClericalPerception": 49,
      "FormPerception": 37,
      "GeneralLearning": 19
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 26,
      "Plants/Animals": 35,
      "Protective": 37,
      "Mechanical": 42,
      "Industrial": 26,
      "Business Detail": 43,
      "Selling": 18,
      "Accommodating": 26,
      "Humanitarian": 12,
      "Leading/Influencing": 26,
      "Physical Performing": 30
    },
    "fitScore": 31
  },
  {
    "code": "51-4071.00",
    "aptitudeProfile": {
      "Verbal": 3,
      "Numeric": 17,
      "Spatial": 40,
      "ClericalPerception": 5,
      "FormPerception": 18,
      "GeneralLearning": 5
    },
    "interestProfile": {
      "Artistic": 2,
      "Scientific": 4,
      "Plants/Animals": 13,
      "Protective": 18,
      "Mechanical": 40,
      "Industrial": 4,
      "Business Detail": 40,
      "Selling": 3,
      "Accommodating": 9,
      "Humanitarian": 6,
      "Leading/Influencing": 31,
      "Physical Performing": 11
    },
    "fitScore": 15
  },
  {
    "code": "51-4072.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 32,
      "Spatial": 32,
      "ClericalPerception": 31,
      "FormPerception": 73,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 13,
      "Scientific": 14,
      "Plants/Animals": 28,
      "Protective": 73,
      "Mechanical": 32,
      "Industrial": 24,
      "Business Detail": 27,
      "Selling": 7,
      "Accommodating": 36,
      "Humanitarian": 14,
      "Leading/Influencing": 18,
      "Physical Performing": 21
    },
    "fitScore": 30
  },
  {
    "code": "51-4081.00",
    "aptitudeProfile": {
      "Verbal": 14,
      "Numeric": 44,
      "Spatial": 63,
      "ClericalPerception": 53,
      "FormPerception": 63,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 15,
      "Scientific": 24,
      "Plants/Animals": 35,
      "Protective": 63,
      "Mechanical": 63,
      "Industrial": 22,
      "Business Detail": 45,
      "Selling": 24,
      "Accommodating": 44,
      "Humanitarian": 16,
      "Leading/Influencing": 18,
      "Physical Performing": 45
    },
    "fitScore": 39
  },
  {
    "code": "51-4111.00",
    "aptitudeProfile": {
      "Verbal": 14,
      "Numeric": 61,
      "Spatial": 69,
      "ClericalPerception": 51,
      "FormPerception": 31,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 18,
      "Scientific": 28,
      "Plants/Animals": 52,
      "Protective": 31,
      "Mechanical": 69,
      "Industrial": 36,
      "Business Detail": 40,
      "Selling": 28,
      "Accommodating": 46,
      "Humanitarian": 13,
      "Leading/Influencing": 31,
      "Physical Performing": 46
    },
    "fitScore": 39
  },
  {
    "code": "51-4121.00",
    "aptitudeProfile": {
      "Verbal": 2,
      "Numeric": 21,
      "Spatial": 46,
      "ClericalPerception": 17,
      "FormPerception": 42,
      "GeneralLearning": 14
    },
    "interestProfile": {
      "Artistic": 2,
      "Scientific": 14,
      "Plants/Animals": 16,
      "Protective": 42,
      "Mechanical": 46,
      "Industrial": 8,
      "Business Detail": 17,
      "Selling": 8,
      "Accommodating": 25,
      "Humanitarian": 10,
      "Leading/Influencing": 13,
      "Physical Performing": 13
    },
    "fitScore": 21
  },
  {
    "code": "51-4122.00",
    "aptitudeProfile": {
      "Verbal": 16,
      "Numeric": 15,
      "Spatial": 47,
      "ClericalPerception": 19,
      "FormPerception": 57,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 7,
      "Scientific": 12,
      "Plants/Animals": 12,
      "Protective": 57,
      "Mechanical": 47,
      "Industrial": 18,
      "Business Detail": 51,
      "Selling": 4,
      "Accommodating": 20,
      "Humanitarian": 14,
      "Leading/Influencing": 56,
      "Physical Performing": 6
    },
    "fitScore": 27
  },
  {
    "code": "51-4191.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 56,
      "Spatial": 56,
      "ClericalPerception": 26,
      "FormPerception": 80,
      "GeneralLearning": 17
    },
    "interestProfile": {
      "Artistic": 14,
      "Scientific": 10,
      "Plants/Animals": 49,
      "Protective": 80,
      "Mechanical": 56,
      "Industrial": 39,
      "Business Detail": 39,
      "Selling": 4,
      "Accommodating": 58,
      "Humanitarian": 18,
      "Leading/Influencing": 47,
      "Physical Performing": 25
    },
    "fitScore": 39
  },
  {
    "code": "51-4192.00",
    "aptitudeProfile": {
      "Verbal": 18,
      "Numeric": 84,
      "Spatial": 75,
      "ClericalPerception": 58,
      "FormPerception": 74,
      "GeneralLearning": 24
    },
    "interestProfile": {
      "Artistic": 14,
      "Scientific": 28,
      "Plants/Animals": 78,
      "Protective": 74,
      "Mechanical": 75,
      "Industrial": 50,
      "Business Detail": 83,
      "Selling": 19,
      "Accommodating": 76,
      "Humanitarian": 16,
      "Leading/Influencing": 74,
      "Physical Performing": 60
    },
    "fitScore": 55
  },
  {
    "code": "51-4193.00",
    "aptitudeProfile": {
      "Verbal": 17,
      "Numeric": 25,
      "Spatial": 12,
      "ClericalPerception": 30,
      "FormPerception": 64,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 15,
      "Scientific": 16,
      "Plants/Animals": 13,
      "Protective": 64,
      "Mechanical": 12,
      "Industrial": 15,
      "Business Detail": 57,
      "Selling": 15,
      "Accommodating": 24,
      "Humanitarian": 12,
      "Leading/Influencing": 19,
      "Physical Performing": 48
    },
    "fitScore": 27
  },
  {
    "code": "51-4194.00",
    "aptitudeProfile": {
      "Verbal": 8,
      "Numeric": 69,
      "Spatial": 37,
      "ClericalPerception": 42,
      "FormPerception": 83,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 8,
      "Scientific": 13,
      "Plants/Animals": 69,
      "Protective": 83,
      "Mechanical": 37,
      "Industrial": 36,
      "Business Detail": 43,
      "Selling": 7,
      "Accommodating": 74,
      "Humanitarian": 8,
      "Leading/Influencing": 35,
      "Physical Performing": 33
    },
    "fitScore": 40
  },
  {
    "code": "51-5111.00",
    "aptitudeProfile": {
      "Verbal": 15,
      "Numeric": 29,
      "Spatial": 95,
      "ClericalPerception": 46,
      "FormPerception": 61,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 16,
      "Scientific": 26,
      "Plants/Animals": 20,
      "Protective": 61,
      "Mechanical": 95,
      "Industrial": 16,
      "Business Detail": 42,
      "Selling": 17,
      "Accommodating": 35,
      "Humanitarian": 42,
      "Leading/Influencing": 16,
      "Physical Performing": 31
    },
    "fitScore": 40
  },
  {
    "code": "51-5112.00",
    "aptitudeProfile": {
      "Verbal": 12,
      "Numeric": 19,
      "Spatial": 23,
      "ClericalPerception": 44,
      "FormPerception": 63,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 15,
      "Scientific": 23,
      "Plants/Animals": 17,
      "Protective": 63,
      "Mechanical": 23,
      "Industrial": 21,
      "Business Detail": 8,
      "Selling": 17,
      "Accommodating": 27,
      "Humanitarian": 9,
      "Leading/Influencing": 7,
      "Physical Performing": 12
    },
    "fitScore": 25
  },
  {
    "code": "51-5113.00",
    "aptitudeProfile": {
      "Verbal": 28,
      "Numeric": 22,
      "Spatial": 58,
      "ClericalPerception": 34,
      "FormPerception": 56,
      "GeneralLearning": 25
    },
    "interestProfile": {
      "Artistic": 22,
      "Scientific": 23,
      "Plants/Animals": 16,
      "Protective": 56,
      "Mechanical": 58,
      "Industrial": 21,
      "Business Detail": 53,
      "Selling": 21,
      "Accommodating": 24,
      "Humanitarian": 19,
      "Leading/Influencing": 46,
      "Physical Performing": 26
    },
    "fitScore": 35
  },
  {
    "code": "51-6011.00",
    "aptitudeProfile": {
      "Verbal": 5,
      "Numeric": 7,
      "Spatial": 32,
      "ClericalPerception": 3,
      "FormPerception": 8,
      "GeneralLearning": 7
    },
    "interestProfile": {
      "Artistic": 4,
      "Scientific": 6,
      "Plants/Animals": 4,
      "Protective": 8,
      "Mechanical": 32,
      "Industrial": 4,
      "Business Detail": 20,
      "Selling": 5,
      "Accommodating": 4,
      "Humanitarian": 24,
      "Leading/Influencing": 6,
      "Physical Performing": 9
    },
    "fitScore": 10
  },
  {
    "code": "51-6021.00",
    "aptitudeProfile": {
      "Verbal": 0,
      "Numeric": 4,
      "Spatial": 18,
      "ClericalPerception": 1,
      "FormPerception": 4,
      "GeneralLearning": 1
    },
    "interestProfile": {
      "Artistic": 0,
      "Scientific": 2,
      "Plants/Animals": 3,
      "Protective": 4,
      "Mechanical": 18,
      "Industrial": 1,
      "Business Detail": 7,
      "Selling": 1,
      "Accommodating": 2,
      "Humanitarian": 5,
      "Leading/Influencing": 4,
      "Physical Performing": 1
    },
    "fitScore": 4
  },
  {
    "code": "51-6031.00",
    "aptitudeProfile": {
      "Verbal": 2,
      "Numeric": 12,
      "Spatial": 86,
      "ClericalPerception": 6,
      "FormPerception": 40,
      "GeneralLearning": 11
    },
    "interestProfile": {
      "Artistic": 2,
      "Scientific": 6,
      "Plants/Animals": 14,
      "Protective": 40,
      "Mechanical": 86,
      "Industrial": 7,
      "Business Detail": 2,
      "Selling": 1,
      "Accommodating": 17,
      "Humanitarian": 19,
      "Leading/Influencing": 3,
      "Physical Performing": 2
    },
    "fitScore": 21
  },
  {
    "code": "51-6041.00",
    "aptitudeProfile": {
      "Verbal": 6,
      "Numeric": 6,
      "Spatial": 18,
      "ClericalPerception": 2,
      "FormPerception": 4,
      "GeneralLearning": 14
    },
    "interestProfile": {
      "Artistic": 5,
      "Scientific": 10,
      "Plants/Animals": 12,
      "Protective": 4,
      "Mechanical": 18,
      "Industrial": 8,
      "Business Detail": 0,
      "Selling": 5,
      "Accommodating": 6,
      "Humanitarian": 6,
      "Leading/Influencing": 2,
      "Physical Performing": 1
    },
    "fitScore": 7
  },
  {
    "code": "51-6042.00",
    "aptitudeProfile": {
      "Verbal": 8,
      "Numeric": 12,
      "Spatial": 17,
      "ClericalPerception": 24,
      "FormPerception": 45,
      "GeneralLearning": 8
    },
    "interestProfile": {
      "Artistic": 4,
      "Scientific": 7,
      "Plants/Animals": 16,
      "Protective": 45,
      "Mechanical": 17,
      "Industrial": 17,
      "Business Detail": 14,
      "Selling": 5,
      "Accommodating": 16,
      "Humanitarian": 10,
      "Leading/Influencing": 26,
      "Physical Performing": 2
    },
    "fitScore": 17
  },
  {
    "code": "51-6051.00",
    "aptitudeProfile": {
      "Verbal": 2,
      "Numeric": 14,
      "Spatial": 92,
      "ClericalPerception": 16,
      "FormPerception": 17,
      "GeneralLearning": 3
    },
    "interestProfile": {
      "Artistic": 1,
      "Scientific": 5,
      "Plants/Animals": 16,
      "Protective": 17,
      "Mechanical": 92,
      "Industrial": 7,
      "Business Detail": 19,
      "Selling": 4,
      "Accommodating": 11,
      "Humanitarian": 17,
      "Leading/Influencing": 29,
      "Physical Performing": 1
    },
    "fitScore": 21
  },
  {
    "code": "51-6052.00",
    "aptitudeProfile": {
      "Verbal": 17,
      "Numeric": 17,
      "Spatial": 100,
      "ClericalPerception": 34,
      "FormPerception": 22,
      "GeneralLearning": 5
    },
    "interestProfile": {
      "Artistic": 16,
      "Scientific": 14,
      "Plants/Animals": 13,
      "Protective": 22,
      "Mechanical": 100,
      "Industrial": 7,
      "Business Detail": 47,
      "Selling": 44,
      "Accommodating": 12,
      "Humanitarian": 23,
      "Leading/Influencing": 28,
      "Physical Performing": 34
    },
    "fitScore": 31
  },
  {
    "code": "51-6061.00",
    "aptitudeProfile": {
      "Verbal": 6,
      "Numeric": 29,
      "Spatial": 36,
      "ClericalPerception": 39,
      "FormPerception": 70,
      "GeneralLearning": 17
    },
    "interestProfile": {
      "Artistic": 7,
      "Scientific": 17,
      "Plants/Animals": 36,
      "Protective": 70,
      "Mechanical": 36,
      "Industrial": 25,
      "Business Detail": 7,
      "Selling": 11,
      "Accommodating": 41,
      "Humanitarian": 12,
      "Leading/Influencing": 19,
      "Physical Performing": 5
    },
    "fitScore": 28
  },
  {
    "code": "51-6062.00",
    "aptitudeProfile": {
      "Verbal": 4,
      "Numeric": 22,
      "Spatial": 36,
      "ClericalPerception": 16,
      "FormPerception": 59,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 5,
      "Scientific": 9,
      "Plants/Animals": 16,
      "Protective": 59,
      "Mechanical": 36,
      "Industrial": 13,
      "Business Detail": 15,
      "Selling": 4,
      "Accommodating": 24,
      "Humanitarian": 9,
      "Leading/Influencing": 10,
      "Physical Performing": 13
    },
    "fitScore": 21
  },
  {
    "code": "51-6063.00",
    "aptitudeProfile": {
      "Verbal": 5,
      "Numeric": 7,
      "Spatial": 86,
      "ClericalPerception": 9,
      "FormPerception": 40,
      "GeneralLearning": 8
    },
    "interestProfile": {
      "Artistic": 7,
      "Scientific": 5,
      "Plants/Animals": 10,
      "Protective": 40,
      "Mechanical": 86,
      "Industrial": 6,
      "Business Detail": 2,
      "Selling": 4,
      "Accommodating": 13,
      "Humanitarian": 26,
      "Leading/Influencing": 4,
      "Physical Performing": 3
    },
    "fitScore": 22
  },
  {
    "code": "51-6064.00",
    "aptitudeProfile": {
      "Verbal": 4,
      "Numeric": 19,
      "Spatial": 17,
      "ClericalPerception": 16,
      "FormPerception": 64,
      "GeneralLearning": 8
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 6,
      "Plants/Animals": 16,
      "Protective": 64,
      "Mechanical": 17,
      "Industrial": 7,
      "Business Detail": 39,
      "Selling": 2,
      "Accommodating": 27,
      "Humanitarian": 4,
      "Leading/Influencing": 32,
      "Physical Performing": 7
    },
    "fitScore": 20
  },
  {
    "code": "51-6091.00",
    "aptitudeProfile": {
      "Verbal": 14,
      "Numeric": 26,
      "Spatial": 44,
      "ClericalPerception": 30,
      "FormPerception": 65,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 15,
      "Scientific": 19,
      "Plants/Animals": 22,
      "Protective": 65,
      "Mechanical": 44,
      "Industrial": 13,
      "Business Detail": 34,
      "Selling": 16,
      "Accommodating": 36,
      "Humanitarian": 15,
      "Leading/Influencing": 16,
      "Physical Performing": 33
    },
    "fitScore": 31
  },
  {
    "code": "51-6092.00",
    "aptitudeProfile": {
      "Verbal": 33,
      "Numeric": 90,
      "Spatial": 100,
      "ClericalPerception": 88,
      "FormPerception": 79,
      "GeneralLearning": 47
    },
    "interestProfile": {
      "Artistic": 37,
      "Scientific": 59,
      "Plants/Animals": 93,
      "Protective": 79,
      "Mechanical": 100,
      "Industrial": 56,
      "Business Detail": 71,
      "Selling": 53,
      "Accommodating": 89,
      "Humanitarian": 49,
      "Leading/Influencing": 63,
      "Physical Performing": 68
    },
    "fitScore": 70
  },
  {
    "code": "51-6093.00",
    "aptitudeProfile": {
      "Verbal": 9,
      "Numeric": 38,
      "Spatial": 74,
      "ClericalPerception": 51,
      "FormPerception": 55,
      "GeneralLearning": 14
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 23,
      "Plants/Animals": 45,
      "Protective": 55,
      "Mechanical": 74,
      "Industrial": 33,
      "Business Detail": 9,
      "Selling": 20,
      "Accommodating": 46,
      "Humanitarian": 20,
      "Leading/Influencing": 15,
      "Physical Performing": 9
    },
    "fitScore": 35
  },
  {
    "code": "51-7011.00",
    "aptitudeProfile": {
      "Verbal": 8,
      "Numeric": 72,
      "Spatial": 72,
      "ClericalPerception": 56,
      "FormPerception": 55,
      "GeneralLearning": 19
    },
    "interestProfile": {
      "Artistic": 12,
      "Scientific": 26,
      "Plants/Animals": 58,
      "Protective": 55,
      "Mechanical": 72,
      "Industrial": 37,
      "Business Detail": 48,
      "Selling": 21,
      "Accommodating": 54,
      "Humanitarian": 15,
      "Leading/Influencing": 28,
      "Physical Performing": 57
    },
    "fitScore": 44
  },
  {
    "code": "51-7021.00",
    "aptitudeProfile": {
      "Verbal": 7,
      "Numeric": 15,
      "Spatial": 35,
      "ClericalPerception": 41,
      "FormPerception": 68,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 22,
      "Plants/Animals": 15,
      "Protective": 68,
      "Mechanical": 35,
      "Industrial": 10,
      "Business Detail": 9,
      "Selling": 15,
      "Accommodating": 29,
      "Humanitarian": 6,
      "Leading/Influencing": 7,
      "Physical Performing": 8
    },
    "fitScore": 25
  },
  {
    "code": "51-7031.00",
    "aptitudeProfile": {
      "Verbal": 23,
      "Numeric": 52,
      "Spatial": 53,
      "ClericalPerception": 58,
      "FormPerception": 63,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 18,
      "Scientific": 26,
      "Plants/Animals": 50,
      "Protective": 63,
      "Mechanical": 53,
      "Industrial": 24,
      "Business Detail": 71,
      "Selling": 36,
      "Accommodating": 52,
      "Humanitarian": 12,
      "Leading/Influencing": 51,
      "Physical Performing": 50
    },
    "fitScore": 43
  },
  {
    "code": "51-7032.00",
    "aptitudeProfile": {
      "Verbal": 20,
      "Numeric": 77,
      "Spatial": 45,
      "ClericalPerception": 52,
      "FormPerception": 56,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 13,
      "Scientific": 23,
      "Plants/Animals": 67,
      "Protective": 56,
      "Mechanical": 45,
      "Industrial": 50,
      "Business Detail": 87,
      "Selling": 23,
      "Accommodating": 61,
      "Humanitarian": 13,
      "Leading/Influencing": 78,
      "Physical Performing": 64
    },
    "fitScore": 47
  },
  {
    "code": "51-7041.00",
    "aptitudeProfile": {
      "Verbal": 1,
      "Numeric": 15,
      "Spatial": 32,
      "ClericalPerception": 8,
      "FormPerception": 44,
      "GeneralLearning": 16
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 8,
      "Plants/Animals": 17,
      "Protective": 44,
      "Mechanical": 32,
      "Industrial": 6,
      "Business Detail": 2,
      "Selling": 2,
      "Accommodating": 18,
      "Humanitarian": 7,
      "Leading/Influencing": 1,
      "Physical Performing": 5
    },
    "fitScore": 16
  },
  {
    "code": "51-7042.00",
    "aptitudeProfile": {
      "Verbal": 5,
      "Numeric": 30,
      "Spatial": 43,
      "ClericalPerception": 19,
      "FormPerception": 67,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 7,
      "Scientific": 9,
      "Plants/Animals": 23,
      "Protective": 67,
      "Mechanical": 43,
      "Industrial": 20,
      "Business Detail": 10,
      "Selling": 9,
      "Accommodating": 27,
      "Humanitarian": 10,
      "Leading/Influencing": 9,
      "Physical Performing": 26
    },
    "fitScore": 26
  },
  {
    "code": "51-8011.00",
    "aptitudeProfile": {
      "Verbal": 63,
      "Numeric": 73,
      "Spatial": 79,
      "ClericalPerception": 95,
      "FormPerception": 98,
      "GeneralLearning": 79
    },
    "interestProfile": {
      "Artistic": 72,
      "Scientific": 73,
      "Plants/Animals": 74,
      "Protective": 98,
      "Mechanical": 79,
      "Industrial": 72,
      "Business Detail": 44,
      "Selling": 63,
      "Accommodating": 83,
      "Humanitarian": 86,
      "Leading/Influencing": 30,
      "Physical Performing": 79
    },
    "fitScore": 76
  },
  {
    "code": "51-8012.00",
    "aptitudeProfile": {
      "Verbal": 57,
      "Numeric": 68,
      "Spatial": 26,
      "ClericalPerception": 69,
      "FormPerception": 72,
      "GeneralLearning": 76
    },
    "interestProfile": {
      "Artistic": 63,
      "Scientific": 68,
      "Plants/Animals": 63,
      "Protective": 72,
      "Mechanical": 26,
      "Industrial": 61,
      "Business Detail": 55,
      "Selling": 55,
      "Accommodating": 61,
      "Humanitarian": 20,
      "Leading/Influencing": 44,
      "Physical Performing": 74
    },
    "fitScore": 58
  },
  {
    "code": "51-8013.00",
    "aptitudeProfile": {
      "Verbal": 31,
      "Numeric": 16,
      "Spatial": 44,
      "ClericalPerception": 66,
      "FormPerception": 84,
      "GeneralLearning": 55
    },
    "interestProfile": {
      "Artistic": 38,
      "Scientific": 46,
      "Plants/Animals": 19,
      "Protective": 84,
      "Mechanical": 44,
      "Industrial": 18,
      "Business Detail": 12,
      "Selling": 47,
      "Accommodating": 32,
      "Humanitarian": 20,
      "Leading/Influencing": 15,
      "Physical Performing": 24
    },
    "fitScore": 41
  },
  {
    "code": "51-8013.03",
    "aptitudeProfile": {
      "Verbal": 17,
      "Numeric": 40,
      "Spatial": 52,
      "ClericalPerception": 62,
      "FormPerception": 74,
      "GeneralLearning": 28
    },
    "interestProfile": {
      "Artistic": 17,
      "Scientific": 27,
      "Plants/Animals": 30,
      "Protective": 74,
      "Mechanical": 52,
      "Industrial": 38,
      "Business Detail": 32,
      "Selling": 16,
      "Accommodating": 32,
      "Humanitarian": 18,
      "Leading/Influencing": 44,
      "Physical Performing": 19
    },
    "fitScore": 39
  },
  {
    "code": "51-8013.04",
    "aptitudeProfile": {
      "Verbal": 42,
      "Numeric": 82,
      "Spatial": 68,
      "ClericalPerception": 77,
      "FormPerception": 88,
      "GeneralLearning": 57
    },
    "interestProfile": {
      "Artistic": 33,
      "Scientific": 51,
      "Plants/Animals": 70,
      "Protective": 88,
      "Mechanical": 68,
      "Industrial": 59,
      "Business Detail": 94,
      "Selling": 41,
      "Accommodating": 70,
      "Humanitarian": 27,
      "Leading/Influencing": 84,
      "Physical Performing": 87
    },
    "fitScore": 67
  },
  {
    "code": "51-8021.00",
    "aptitudeProfile": {
      "Verbal": 29,
      "Numeric": 29,
      "Spatial": 44,
      "ClericalPerception": 62,
      "FormPerception": 74,
      "GeneralLearning": 31
    },
    "interestProfile": {
      "Artistic": 30,
      "Scientific": 30,
      "Plants/Animals": 22,
      "Protective": 74,
      "Mechanical": 44,
      "Industrial": 22,
      "Business Detail": 45,
      "Selling": 31,
      "Accommodating": 28,
      "Humanitarian": 21,
      "Leading/Influencing": 28,
      "Physical Performing": 44
    },
    "fitScore": 40
  },
  {
    "code": "51-8031.00",
    "aptitudeProfile": {
      "Verbal": 46,
      "Numeric": 73,
      "Spatial": 37,
      "ClericalPerception": 73,
      "FormPerception": 76,
      "GeneralLearning": 42
    },
    "interestProfile": {
      "Artistic": 48,
      "Scientific": 41,
      "Plants/Animals": 66,
      "Protective": 76,
      "Mechanical": 37,
      "Industrial": 52,
      "Business Detail": 75,
      "Selling": 47,
      "Accommodating": 58,
      "Humanitarian": 20,
      "Leading/Influencing": 73,
      "Physical Performing": 73
    },
    "fitScore": 57
  },
  {
    "code": "51-8091.00",
    "aptitudeProfile": {
      "Verbal": 28,
      "Numeric": 54,
      "Spatial": 21,
      "ClericalPerception": 57,
      "FormPerception": 88,
      "GeneralLearning": 47
    },
    "interestProfile": {
      "Artistic": 38,
      "Scientific": 33,
      "Plants/Animals": 64,
      "Protective": 88,
      "Mechanical": 21,
      "Industrial": 48,
      "Business Detail": 14,
      "Selling": 23,
      "Accommodating": 63,
      "Humanitarian": 16,
      "Leading/Influencing": 21,
      "Physical Performing": 33
    },
    "fitScore": 44
  },
  {
    "code": "51-8092.00",
    "aptitudeProfile": {
      "Verbal": 19,
      "Numeric": 61,
      "Spatial": 53,
      "ClericalPerception": 91,
      "FormPerception": 98,
      "GeneralLearning": 28
    },
    "interestProfile": {
      "Artistic": 22,
      "Scientific": 32,
      "Plants/Animals": 59,
      "Protective": 98,
      "Mechanical": 53,
      "Industrial": 47,
      "Business Detail": 32,
      "Selling": 29,
      "Accommodating": 71,
      "Humanitarian": 22,
      "Leading/Influencing": 38,
      "Physical Performing": 36
    },
    "fitScore": 52
  },
  {
    "code": "51-8093.00",
    "aptitudeProfile": {
      "Verbal": 34,
      "Numeric": 61,
      "Spatial": 61,
      "ClericalPerception": 75,
      "FormPerception": 99,
      "GeneralLearning": 35
    },
    "interestProfile": {
      "Artistic": 21,
      "Scientific": 27,
      "Plants/Animals": 65,
      "Protective": 99,
      "Mechanical": 61,
      "Industrial": 51,
      "Business Detail": 73,
      "Selling": 14,
      "Accommodating": 89,
      "Humanitarian": 35,
      "Leading/Influencing": 74,
      "Physical Performing": 33
    },
    "fitScore": 57
  },
  {
    "code": "51-8099.01",
    "aptitudeProfile": {
      "Verbal": 35,
      "Numeric": 57,
      "Spatial": 64,
      "ClericalPerception": 76,
      "FormPerception": 88,
      "GeneralLearning": 39
    },
    "interestProfile": {
      "Artistic": 39,
      "Scientific": 39,
      "Plants/Animals": 64,
      "Protective": 88,
      "Mechanical": 64,
      "Industrial": 62,
      "Business Detail": 20,
      "Selling": 34,
      "Accommodating": 67,
      "Humanitarian": 38,
      "Leading/Influencing": 38,
      "Physical Performing": 28
    },
    "fitScore": 54
  },
  {
    "code": "51-9011.00",
    "aptitudeProfile": {
      "Verbal": 53,
      "Numeric": 59,
      "Spatial": 52,
      "ClericalPerception": 69,
      "FormPerception": 90,
      "GeneralLearning": 28
    },
    "interestProfile": {
      "Artistic": 50,
      "Scientific": 25,
      "Plants/Animals": 46,
      "Protective": 90,
      "Mechanical": 52,
      "Industrial": 56,
      "Business Detail": 73,
      "Selling": 34,
      "Accommodating": 60,
      "Humanitarian": 27,
      "Leading/Influencing": 73,
      "Physical Performing": 66
    },
    "fitScore": 56
  },
  {
    "code": "51-9012.00",
    "aptitudeProfile": {
      "Verbal": 10,
      "Numeric": 43,
      "Spatial": 48,
      "ClericalPerception": 61,
      "FormPerception": 92,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 12,
      "Scientific": 14,
      "Plants/Animals": 46,
      "Protective": 92,
      "Mechanical": 48,
      "Industrial": 33,
      "Business Detail": 15,
      "Selling": 10,
      "Accommodating": 54,
      "Humanitarian": 18,
      "Leading/Influencing": 22,
      "Physical Performing": 17
    },
    "fitScore": 39
  },
  {
    "code": "51-9021.00",
    "aptitudeProfile": {
      "Verbal": 16,
      "Numeric": 35,
      "Spatial": 60,
      "ClericalPerception": 15,
      "FormPerception": 74,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 9,
      "Plants/Animals": 30,
      "Protective": 74,
      "Mechanical": 60,
      "Industrial": 26,
      "Business Detail": 57,
      "Selling": 3,
      "Accommodating": 40,
      "Humanitarian": 23,
      "Leading/Influencing": 55,
      "Physical Performing": 18
    },
    "fitScore": 35
  },
  {
    "code": "51-9022.00",
    "aptitudeProfile": {
      "Verbal": 7,
      "Numeric": 17,
      "Spatial": 41,
      "ClericalPerception": 43,
      "FormPerception": 60,
      "GeneralLearning": 7
    },
    "interestProfile": {
      "Artistic": 8,
      "Scientific": 12,
      "Plants/Animals": 12,
      "Protective": 60,
      "Mechanical": 41,
      "Industrial": 12,
      "Business Detail": 13,
      "Selling": 16,
      "Accommodating": 21,
      "Humanitarian": 12,
      "Leading/Influencing": 10,
      "Physical Performing": 12
    },
    "fitScore": 24
  },
  {
    "code": "51-9023.00",
    "aptitudeProfile": {
      "Verbal": 18,
      "Numeric": 23,
      "Spatial": 28,
      "ClericalPerception": 34,
      "FormPerception": 61,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 14,
      "Scientific": 15,
      "Plants/Animals": 19,
      "Protective": 61,
      "Mechanical": 28,
      "Industrial": 28,
      "Business Detail": 18,
      "Selling": 10,
      "Accommodating": 22,
      "Humanitarian": 20,
      "Leading/Influencing": 18,
      "Physical Performing": 12
    },
    "fitScore": 26
  },
  {
    "code": "51-9031.00",
    "aptitudeProfile": {
      "Verbal": 3,
      "Numeric": 11,
      "Spatial": 55,
      "ClericalPerception": 5,
      "FormPerception": 17,
      "GeneralLearning": 6
    },
    "interestProfile": {
      "Artistic": 5,
      "Scientific": 5,
      "Plants/Animals": 10,
      "Protective": 17,
      "Mechanical": 55,
      "Industrial": 8,
      "Business Detail": 3,
      "Selling": 4,
      "Accommodating": 9,
      "Humanitarian": 28,
      "Leading/Influencing": 2,
      "Physical Performing": 5
    },
    "fitScore": 14
  },
  {
    "code": "51-9032.00",
    "aptitudeProfile": {
      "Verbal": 17,
      "Numeric": 42,
      "Spatial": 54,
      "ClericalPerception": 48,
      "FormPerception": 65,
      "GeneralLearning": 22
    },
    "interestProfile": {
      "Artistic": 16,
      "Scientific": 22,
      "Plants/Animals": 35,
      "Protective": 65,
      "Mechanical": 54,
      "Industrial": 33,
      "Business Detail": 36,
      "Selling": 21,
      "Accommodating": 39,
      "Humanitarian": 16,
      "Leading/Influencing": 33,
      "Physical Performing": 32
    },
    "fitScore": 37
  },
  {
    "code": "51-9041.00",
    "aptitudeProfile": {
      "Verbal": 12,
      "Numeric": 25,
      "Spatial": 48,
      "ClericalPerception": 57,
      "FormPerception": 85,
      "GeneralLearning": 19
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 13,
      "Plants/Animals": 22,
      "Protective": 85,
      "Mechanical": 48,
      "Industrial": 17,
      "Business Detail": 27,
      "Selling": 6,
      "Accommodating": 25,
      "Humanitarian": 14,
      "Leading/Influencing": 18,
      "Physical Performing": 17
    },
    "fitScore": 33
  },
  {
    "code": "51-9051.00",
    "aptitudeProfile": {
      "Verbal": 20,
      "Numeric": 20,
      "Spatial": 14,
      "ClericalPerception": 17,
      "FormPerception": 30,
      "GeneralLearning": 16
    },
    "interestProfile": {
      "Artistic": 23,
      "Scientific": 10,
      "Plants/Animals": 17,
      "Protective": 30,
      "Mechanical": 14,
      "Industrial": 24,
      "Business Detail": 17,
      "Selling": 9,
      "Accommodating": 9,
      "Humanitarian": 17,
      "Leading/Influencing": 20,
      "Physical Performing": 17
    },
    "fitScore": 18
  },
  {
    "code": "51-9061.00",
    "aptitudeProfile": {
      "Verbal": 21,
      "Numeric": 44,
      "Spatial": 28,
      "ClericalPerception": 49,
      "FormPerception": 87,
      "GeneralLearning": 15
    },
    "interestProfile": {
      "Artistic": 29,
      "Scientific": 14,
      "Plants/Animals": 35,
      "Protective": 87,
      "Mechanical": 28,
      "Industrial": 36,
      "Business Detail": 25,
      "Selling": 19,
      "Accommodating": 58,
      "Humanitarian": 12,
      "Leading/Influencing": 22,
      "Physical Performing": 41
    },
    "fitScore": 37
  },
  {
    "code": "51-9071.00",
    "aptitudeProfile": {
      "Verbal": 16,
      "Numeric": 32,
      "Spatial": 87,
      "ClericalPerception": 33,
      "FormPerception": 37,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 18,
      "Scientific": 20,
      "Plants/Animals": 33,
      "Protective": 37,
      "Mechanical": 87,
      "Industrial": 19,
      "Business Detail": 27,
      "Selling": 30,
      "Accommodating": 27,
      "Humanitarian": 37,
      "Leading/Influencing": 21,
      "Physical Performing": 25
    },
    "fitScore": 34
  },
  {
    "code": "51-9071.06",
    "aptitudeProfile": {
      "Verbal": 12,
      "Numeric": 58,
      "Spatial": 89,
      "ClericalPerception": 26,
      "FormPerception": 63,
      "GeneralLearning": 19
    },
    "interestProfile": {
      "Artistic": 10,
      "Scientific": 19,
      "Plants/Animals": 63,
      "Protective": 63,
      "Mechanical": 89,
      "Industrial": 35,
      "Business Detail": 38,
      "Selling": 13,
      "Accommodating": 69,
      "Humanitarian": 35,
      "Leading/Influencing": 49,
      "Physical Performing": 21
    },
    "fitScore": 43
  },
  {
    "code": "51-9081.00",
    "aptitudeProfile": {
      "Verbal": 27,
      "Numeric": 14,
      "Spatial": 63,
      "ClericalPerception": 57,
      "FormPerception": 65,
      "GeneralLearning": 25
    },
    "interestProfile": {
      "Artistic": 14,
      "Scientific": 31,
      "Plants/Animals": 17,
      "Protective": 65,
      "Mechanical": 63,
      "Industrial": 25,
      "Business Detail": 39,
      "Selling": 28,
      "Accommodating": 29,
      "Humanitarian": 18,
      "Leading/Influencing": 56,
      "Physical Performing": 6
    },
    "fitScore": 37
  },
  {
    "code": "51-9082.00",
    "aptitudeProfile": {
      "Verbal": 44,
      "Numeric": 59,
      "Spatial": 100,
      "ClericalPerception": 50,
      "FormPerception": 49,
      "GeneralLearning": 58
    },
    "interestProfile": {
      "Artistic": 41,
      "Scientific": 55,
      "Plants/Animals": 65,
      "Protective": 49,
      "Mechanical": 100,
      "Industrial": 61,
      "Business Detail": 43,
      "Selling": 54,
      "Accommodating": 60,
      "Humanitarian": 73,
      "Leading/Influencing": 56,
      "Physical Performing": 49
    },
    "fitScore": 59
  },
  {
    "code": "51-9083.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 33,
      "Spatial": 91,
      "ClericalPerception": 18,
      "FormPerception": 60,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 14,
      "Plants/Animals": 22,
      "Protective": 60,
      "Mechanical": 91,
      "Industrial": 19,
      "Business Detail": 50,
      "Selling": 5,
      "Accommodating": 30,
      "Humanitarian": 40,
      "Leading/Influencing": 25,
      "Physical Performing": 30
    },
    "fitScore": 36
  },
  {
    "code": "51-9111.00",
    "aptitudeProfile": {
      "Verbal": 11,
      "Numeric": 27,
      "Spatial": 46,
      "ClericalPerception": 29,
      "FormPerception": 68,
      "GeneralLearning": 12
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 10,
      "Plants/Animals": 22,
      "Protective": 68,
      "Mechanical": 46,
      "Industrial": 16,
      "Business Detail": 35,
      "Selling": 8,
      "Accommodating": 33,
      "Humanitarian": 16,
      "Leading/Influencing": 21,
      "Physical Performing": 21
    },
    "fitScore": 29
  },
  {
    "code": "51-9123.00",
    "aptitudeProfile": {
      "Verbal": 4,
      "Numeric": 8,
      "Spatial": 26,
      "ClericalPerception": 1,
      "FormPerception": 2,
      "GeneralLearning": 8
    },
    "interestProfile": {
      "Artistic": 5,
      "Scientific": 6,
      "Plants/Animals": 10,
      "Protective": 2,
      "Mechanical": 26,
      "Industrial": 6,
      "Business Detail": 3,
      "Selling": 5,
      "Accommodating": 5,
      "Humanitarian": 25,
      "Leading/Influencing": 4,
      "Physical Performing": 2
    },
    "fitScore": 8
  },
  {
    "code": "51-9124.00",
    "aptitudeProfile": {
      "Verbal": 4,
      "Numeric": 12,
      "Spatial": 57,
      "ClericalPerception": 25,
      "FormPerception": 75,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 7,
      "Scientific": 10,
      "Plants/Animals": 16,
      "Protective": 75,
      "Mechanical": 57,
      "Industrial": 9,
      "Business Detail": 1,
      "Selling": 5,
      "Accommodating": 32,
      "Humanitarian": 14,
      "Leading/Influencing": 3,
      "Physical Performing": 17
    },
    "fitScore": 26
  },
  {
    "code": "51-9141.00",
    "aptitudeProfile": {
      "Verbal": 27,
      "Numeric": 18,
      "Spatial": 21,
      "ClericalPerception": 30,
      "FormPerception": 51,
      "GeneralLearning": 30
    },
    "interestProfile": {
      "Artistic": 31,
      "Scientific": 23,
      "Plants/Animals": 15,
      "Protective": 51,
      "Mechanical": 21,
      "Industrial": 22,
      "Business Detail": 20,
      "Selling": 15,
      "Accommodating": 18,
      "Humanitarian": 14,
      "Leading/Influencing": 9,
      "Physical Performing": 24
    },
    "fitScore": 26
  },
  {
    "code": "51-9151.00",
    "aptitudeProfile": {
      "Verbal": 21,
      "Numeric": 23,
      "Spatial": 90,
      "ClericalPerception": 44,
      "FormPerception": 77,
      "GeneralLearning": 28
    },
    "interestProfile": {
      "Artistic": 31,
      "Scientific": 26,
      "Plants/Animals": 38,
      "Protective": 77,
      "Mechanical": 90,
      "Industrial": 24,
      "Business Detail": 4,
      "Selling": 27,
      "Accommodating": 51,
      "Humanitarian": 55,
      "Leading/Influencing": 6,
      "Physical Performing": 12
    },
    "fitScore": 42
  },
  {
    "code": "51-9161.00",
    "aptitudeProfile": {
      "Verbal": 19,
      "Numeric": 79,
      "Spatial": 66,
      "ClericalPerception": 72,
      "FormPerception": 79,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 17,
      "Scientific": 29,
      "Plants/Animals": 71,
      "Protective": 79,
      "Mechanical": 66,
      "Industrial": 38,
      "Business Detail": 83,
      "Selling": 33,
      "Accommodating": 67,
      "Humanitarian": 19,
      "Leading/Influencing": 57,
      "Physical Performing": 75
    },
    "fitScore": 54
  },
  {
    "code": "51-9162.00",
    "aptitudeProfile": {
      "Verbal": 28,
      "Numeric": 90,
      "Spatial": 35,
      "ClericalPerception": 90,
      "FormPerception": 92,
      "GeneralLearning": 34
    },
    "interestProfile": {
      "Artistic": 25,
      "Scientific": 41,
      "Plants/Animals": 91,
      "Protective": 92,
      "Mechanical": 35,
      "Industrial": 68,
      "Business Detail": 74,
      "Selling": 37,
      "Accommodating": 90,
      "Humanitarian": 11,
      "Leading/Influencing": 75,
      "Physical Performing": 65
    },
    "fitScore": 60
  },
  {
    "code": "51-9191.00",
    "aptitudeProfile": {
      "Verbal": 14,
      "Numeric": 38,
      "Spatial": 43,
      "ClericalPerception": 18,
      "FormPerception": 72,
      "GeneralLearning": 17
    },
    "interestProfile": {
      "Artistic": 14,
      "Scientific": 9,
      "Plants/Animals": 36,
      "Protective": 72,
      "Mechanical": 43,
      "Industrial": 26,
      "Business Detail": 29,
      "Selling": 5,
      "Accommodating": 43,
      "Humanitarian": 13,
      "Leading/Influencing": 31,
      "Physical Performing": 21
    },
    "fitScore": 31
  },
  {
    "code": "51-9192.00",
    "aptitudeProfile": {
      "Verbal": 2,
      "Numeric": 9,
      "Spatial": 10,
      "ClericalPerception": 19,
      "FormPerception": 35,
      "GeneralLearning": 6
    },
    "interestProfile": {
      "Artistic": 2,
      "Scientific": 5,
      "Plants/Animals": 12,
      "Protective": 35,
      "Mechanical": 10,
      "Industrial": 7,
      "Business Detail": 4,
      "Selling": 3,
      "Accommodating": 8,
      "Humanitarian": 7,
      "Leading/Influencing": 6,
      "Physical Performing": 2
    },
    "fitScore": 11
  },
  {
    "code": "51-9193.00",
    "aptitudeProfile": {
      "Verbal": 18,
      "Numeric": 43,
      "Spatial": 33,
      "ClericalPerception": 69,
      "FormPerception": 66,
      "GeneralLearning": 29
    },
    "interestProfile": {
      "Artistic": 14,
      "Scientific": 33,
      "Plants/Animals": 47,
      "Protective": 66,
      "Mechanical": 33,
      "Industrial": 26,
      "Business Detail": 48,
      "Selling": 17,
      "Accommodating": 33,
      "Humanitarian": 15,
      "Leading/Influencing": 46,
      "Physical Performing": 17
    },
    "fitScore": 38
  },
  {
    "code": "51-9194.00",
    "aptitudeProfile": {
      "Verbal": 19,
      "Numeric": 20,
      "Spatial": 31,
      "ClericalPerception": 53,
      "FormPerception": 42,
      "GeneralLearning": 17
    },
    "interestProfile": {
      "Artistic": 17,
      "Scientific": 26,
      "Plants/Animals": 16,
      "Protective": 42,
      "Mechanical": 31,
      "Industrial": 17,
      "Business Detail": 35,
      "Selling": 34,
      "Accommodating": 18,
      "Humanitarian": 12,
      "Leading/Influencing": 24,
      "Physical Performing": 22
    },
    "fitScore": 27
  },
  {
    "code": "51-9195.00",
    "aptitudeProfile": {
      "Verbal": 11,
      "Numeric": 15,
      "Spatial": 45,
      "ClericalPerception": 24,
      "FormPerception": 34,
      "GeneralLearning": 14
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 15,
      "Plants/Animals": 14,
      "Protective": 34,
      "Mechanical": 45,
      "Industrial": 11,
      "Business Detail": 22,
      "Selling": 12,
      "Accommodating": 12,
      "Humanitarian": 16,
      "Leading/Influencing": 18,
      "Physical Performing": 10
    },
    "fitScore": 21
  },
  {
    "code": "51-9195.03",
    "aptitudeProfile": {
      "Verbal": 10,
      "Numeric": 35,
      "Spatial": 41,
      "ClericalPerception": 28,
      "FormPerception": 28,
      "GeneralLearning": 17
    },
    "interestProfile": {
      "Artistic": 6,
      "Scientific": 21,
      "Plants/Animals": 21,
      "Protective": 28,
      "Mechanical": 41,
      "Industrial": 16,
      "Business Detail": 71,
      "Selling": 13,
      "Accommodating": 18,
      "Humanitarian": 11,
      "Leading/Influencing": 38,
      "Physical Performing": 37
    },
    "fitScore": 27
  },
  {
    "code": "51-9195.04",
    "aptitudeProfile": {
      "Verbal": 9,
      "Numeric": 47,
      "Spatial": 55,
      "ClericalPerception": 75,
      "FormPerception": 73,
      "GeneralLearning": 12
    },
    "interestProfile": {
      "Artistic": 8,
      "Scientific": 21,
      "Plants/Animals": 45,
      "Protective": 73,
      "Mechanical": 55,
      "Industrial": 30,
      "Business Detail": 32,
      "Selling": 21,
      "Accommodating": 44,
      "Humanitarian": 11,
      "Leading/Influencing": 28,
      "Physical Performing": 22
    },
    "fitScore": 39
  },
  {
    "code": "51-9195.05",
    "aptitudeProfile": {
      "Verbal": 14,
      "Numeric": 21,
      "Spatial": 60,
      "ClericalPerception": 50,
      "FormPerception": 35,
      "GeneralLearning": 21
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 31,
      "Plants/Animals": 13,
      "Protective": 35,
      "Mechanical": 60,
      "Industrial": 12,
      "Business Detail": 54,
      "Selling": 23,
      "Accommodating": 16,
      "Humanitarian": 10,
      "Leading/Influencing": 39,
      "Physical Performing": 18
    },
    "fitScore": 30
  },
  {
    "code": "51-9196.00",
    "aptitudeProfile": {
      "Verbal": 5,
      "Numeric": 27,
      "Spatial": 19,
      "ClericalPerception": 16,
      "FormPerception": 44,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 7,
      "Scientific": 11,
      "Plants/Animals": 16,
      "Protective": 44,
      "Mechanical": 19,
      "Industrial": 11,
      "Business Detail": 27,
      "Selling": 6,
      "Accommodating": 20,
      "Humanitarian": 7,
      "Leading/Influencing": 9,
      "Physical Performing": 27
    },
    "fitScore": 19
  },
  {
    "code": "51-9197.00",
    "aptitudeProfile": {
      "Verbal": 4,
      "Numeric": 10,
      "Spatial": 30,
      "ClericalPerception": 9,
      "FormPerception": 28,
      "GeneralLearning": 10
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 8,
      "Plants/Animals": 11,
      "Protective": 28,
      "Mechanical": 30,
      "Industrial": 3,
      "Business Detail": 28,
      "Selling": 4,
      "Accommodating": 11,
      "Humanitarian": 5,
      "Leading/Influencing": 26,
      "Physical Performing": 4
    },
    "fitScore": 14
  },
  {
    "code": "51-9198.00",
    "aptitudeProfile": {
      "Verbal": 3,
      "Numeric": 17,
      "Spatial": 25,
      "ClericalPerception": 11,
      "FormPerception": 24,
      "GeneralLearning": 9
    },
    "interestProfile": {
      "Artistic": 4,
      "Scientific": 5,
      "Plants/Animals": 14,
      "Protective": 24,
      "Mechanical": 25,
      "Industrial": 7,
      "Business Detail": 8,
      "Selling": 2,
      "Accommodating": 7,
      "Humanitarian": 8,
      "Leading/Influencing": 4,
      "Physical Performing": 10
    },
    "fitScore": 12
  },
  {
    "code": "53-1041.00",
    "aptitudeProfile": {
      "Verbal": 53,
      "Numeric": 72,
      "Spatial": 67,
      "ClericalPerception": 80,
      "FormPerception": 86,
      "GeneralLearning": 37
    },
    "interestProfile": {
      "Artistic": 45,
      "Scientific": 44,
      "Plants/Animals": 70,
      "Protective": 86,
      "Mechanical": 67,
      "Industrial": 53,
      "Business Detail": 86,
      "Selling": 62,
      "Accommodating": 74,
      "Humanitarian": 25,
      "Leading/Influencing": 89,
      "Physical Performing": 73
    },
    "fitScore": 65
  },
  {
    "code": "53-1042.00",
    "aptitudeProfile": {
      "Verbal": 56,
      "Numeric": 35,
      "Spatial": 43,
      "ClericalPerception": 32,
      "FormPerception": 19,
      "GeneralLearning": 51
    },
    "interestProfile": {
      "Artistic": 59,
      "Scientific": 51,
      "Plants/Animals": 32,
      "Protective": 19,
      "Mechanical": 43,
      "Industrial": 27,
      "Business Detail": 58,
      "Selling": 59,
      "Accommodating": 23,
      "Humanitarian": 22,
      "Leading/Influencing": 47,
      "Physical Performing": 58
    },
    "fitScore": 40
  },
  {
    "code": "53-1042.01",
    "aptitudeProfile": {
      "Verbal": 59,
      "Numeric": 63,
      "Spatial": 13,
      "ClericalPerception": 30,
      "FormPerception": 24,
      "GeneralLearning": 47
    },
    "interestProfile": {
      "Artistic": 46,
      "Scientific": 47,
      "Plants/Animals": 59,
      "Protective": 24,
      "Mechanical": 13,
      "Industrial": 49,
      "Business Detail": 91,
      "Selling": 52,
      "Accommodating": 46,
      "Humanitarian": 25,
      "Leading/Influencing": 82,
      "Physical Performing": 73
    },
    "fitScore": 45
  },
  {
    "code": "53-1043.00",
    "aptitudeProfile": {
      "Verbal": 79,
      "Numeric": 77,
      "Spatial": 42,
      "ClericalPerception": 58,
      "FormPerception": 63,
      "GeneralLearning": 54
    },
    "interestProfile": {
      "Artistic": 67,
      "Scientific": 55,
      "Plants/Animals": 71,
      "Protective": 63,
      "Mechanical": 42,
      "Industrial": 58,
      "Business Detail": 99,
      "Selling": 63,
      "Accommodating": 68,
      "Humanitarian": 31,
      "Leading/Influencing": 93,
      "Physical Performing": 91
    },
    "fitScore": 65
  },
  {
    "code": "53-2011.00",
    "aptitudeProfile": {
      "Verbal": 69,
      "Numeric": 81,
      "Spatial": 100,
      "ClericalPerception": 98,
      "FormPerception": 100,
      "GeneralLearning": 90
    },
    "interestProfile": {
      "Artistic": 68,
      "Scientific": 82,
      "Plants/Animals": 86,
      "Protective": 100,
      "Mechanical": 100,
      "Industrial": 83,
      "Business Detail": 63,
      "Selling": 70,
      "Accommodating": 96,
      "Humanitarian": 88,
      "Leading/Influencing": 78,
      "Physical Performing": 74
    },
    "fitScore": 86
  },
  {
    "code": "53-2012.00",
    "aptitudeProfile": {
      "Verbal": 60,
      "Numeric": 57,
      "Spatial": 99,
      "ClericalPerception": 97,
      "FormPerception": 100,
      "GeneralLearning": 85
    },
    "interestProfile": {
      "Artistic": 68,
      "Scientific": 78,
      "Plants/Animals": 63,
      "Protective": 100,
      "Mechanical": 99,
      "Industrial": 68,
      "Business Detail": 27,
      "Selling": 66,
      "Accommodating": 85,
      "Humanitarian": 82,
      "Leading/Influencing": 38,
      "Physical Performing": 54
    },
    "fitScore": 76
  },
  {
    "code": "53-2021.00",
    "aptitudeProfile": {
      "Verbal": 74,
      "Numeric": 73,
      "Spatial": 66,
      "ClericalPerception": 100,
      "FormPerception": 100,
      "GeneralLearning": 95
    },
    "interestProfile": {
      "Artistic": 84,
      "Scientific": 93,
      "Plants/Animals": 80,
      "Protective": 100,
      "Mechanical": 66,
      "Industrial": 71,
      "Business Detail": 40,
      "Selling": 93,
      "Accommodating": 98,
      "Humanitarian": 29,
      "Leading/Influencing": 45,
      "Physical Performing": 85
    },
    "fitScore": 79
  },
  {
    "code": "53-2022.00",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 35,
      "Spatial": 65,
      "ClericalPerception": 72,
      "FormPerception": 83,
      "GeneralLearning": 80
    },
    "interestProfile": {
      "Artistic": 72,
      "Scientific": 71,
      "Plants/Animals": 38,
      "Protective": 83,
      "Mechanical": 65,
      "Industrial": 44,
      "Business Detail": 65,
      "Selling": 59,
      "Accommodating": 62,
      "Humanitarian": 46,
      "Leading/Influencing": 55,
      "Physical Performing": 53
    },
    "fitScore": 64
  },
  {
    "code": "53-2031.00",
    "aptitudeProfile": {
      "Verbal": 35,
      "Numeric": 13,
      "Spatial": 18,
      "ClericalPerception": 54,
      "FormPerception": 67,
      "GeneralLearning": 43
    },
    "interestProfile": {
      "Artistic": 39,
      "Scientific": 39,
      "Plants/Animals": 18,
      "Protective": 67,
      "Mechanical": 18,
      "Industrial": 20,
      "Business Detail": 11,
      "Selling": 46,
      "Accommodating": 26,
      "Humanitarian": 52,
      "Leading/Influencing": 21,
      "Physical Performing": 15
    },
    "fitScore": 35
  },
  {
    "code": "53-3011.00",
    "aptitudeProfile": {
      "Verbal": 39,
      "Numeric": 14,
      "Spatial": 86,
      "ClericalPerception": 53,
      "FormPerception": 65,
      "GeneralLearning": 31
    },
    "interestProfile": {
      "Artistic": 38,
      "Scientific": 33,
      "Plants/Animals": 13,
      "Protective": 65,
      "Mechanical": 86,
      "Industrial": 17,
      "Business Detail": 36,
      "Selling": 49,
      "Accommodating": 24,
      "Humanitarian": 48,
      "Leading/Influencing": 35,
      "Physical Performing": 29
    },
    "fitScore": 44
  },
  {
    "code": "53-3031.00",
    "aptitudeProfile": {
      "Verbal": 30,
      "Numeric": 38,
      "Spatial": 38,
      "ClericalPerception": 19,
      "FormPerception": 36,
      "GeneralLearning": 17
    },
    "interestProfile": {
      "Artistic": 32,
      "Scientific": 14,
      "Plants/Animals": 39,
      "Protective": 36,
      "Mechanical": 38,
      "Industrial": 29,
      "Business Detail": 35,
      "Selling": 23,
      "Accommodating": 27,
      "Humanitarian": 29,
      "Leading/Influencing": 43,
      "Physical Performing": 35
    },
    "fitScore": 31
  },
  {
    "code": "53-3032.00",
    "aptitudeProfile": {
      "Verbal": 10,
      "Numeric": 17,
      "Spatial": 98,
      "ClericalPerception": 12,
      "FormPerception": 55,
      "GeneralLearning": 17
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 10,
      "Plants/Animals": 16,
      "Protective": 55,
      "Mechanical": 98,
      "Industrial": 16,
      "Business Detail": 19,
      "Selling": 5,
      "Accommodating": 26,
      "Humanitarian": 63,
      "Leading/Influencing": 16,
      "Physical Performing": 10
    },
    "fitScore": 32
  },
  {
    "code": "53-3033.00",
    "aptitudeProfile": {
      "Verbal": 12,
      "Numeric": 19,
      "Spatial": 92,
      "ClericalPerception": 25,
      "FormPerception": 26,
      "GeneralLearning": 17
    },
    "interestProfile": {
      "Artistic": 13,
      "Scientific": 15,
      "Plants/Animals": 21,
      "Protective": 26,
      "Mechanical": 92,
      "Industrial": 24,
      "Business Detail": 9,
      "Selling": 9,
      "Accommodating": 11,
      "Humanitarian": 55,
      "Leading/Influencing": 16,
      "Physical Performing": 6
    },
    "fitScore": 28
  },
  {
    "code": "53-3052.00",
    "aptitudeProfile": {
      "Verbal": 12,
      "Numeric": 11,
      "Spatial": 89,
      "ClericalPerception": 8,
      "FormPerception": 45,
      "GeneralLearning": 8
    },
    "interestProfile": {
      "Artistic": 13,
      "Scientific": 5,
      "Plants/Animals": 11,
      "Protective": 45,
      "Mechanical": 89,
      "Industrial": 9,
      "Business Detail": 13,
      "Selling": 4,
      "Accommodating": 15,
      "Humanitarian": 45,
      "Leading/Influencing": 18,
      "Physical Performing": 5
    },
    "fitScore": 26
  },
  {
    "code": "53-4011.00",
    "aptitudeProfile": {
      "Verbal": 36,
      "Numeric": 31,
      "Spatial": 89,
      "ClericalPerception": 57,
      "FormPerception": 98,
      "GeneralLearning": 38
    },
    "interestProfile": {
      "Artistic": 38,
      "Scientific": 23,
      "Plants/Animals": 43,
      "Protective": 98,
      "Mechanical": 89,
      "Industrial": 44,
      "Business Detail": 13,
      "Selling": 20,
      "Accommodating": 72,
      "Humanitarian": 55,
      "Leading/Influencing": 36,
      "Physical Performing": 16
    },
    "fitScore": 52
  },
  {
    "code": "53-4013.00",
    "aptitudeProfile": {
      "Verbal": 34,
      "Numeric": 18,
      "Spatial": 89,
      "ClericalPerception": 46,
      "FormPerception": 75,
      "GeneralLearning": 24
    },
    "interestProfile": {
      "Artistic": 32,
      "Scientific": 23,
      "Plants/Animals": 17,
      "Protective": 75,
      "Mechanical": 89,
      "Industrial": 27,
      "Business Detail": 28,
      "Selling": 42,
      "Accommodating": 33,
      "Humanitarian": 45,
      "Leading/Influencing": 46,
      "Physical Performing": 26
    },
    "fitScore": 44
  },
  {
    "code": "53-4022.00",
    "aptitudeProfile": {
      "Verbal": 17,
      "Numeric": 15,
      "Spatial": 65,
      "ClericalPerception": 54,
      "FormPerception": 85,
      "GeneralLearning": 30
    },
    "interestProfile": {
      "Artistic": 25,
      "Scientific": 24,
      "Plants/Animals": 20,
      "Protective": 85,
      "Mechanical": 65,
      "Industrial": 19,
      "Business Detail": 3,
      "Selling": 24,
      "Accommodating": 30,
      "Humanitarian": 30,
      "Leading/Influencing": 6,
      "Physical Performing": 12
    },
    "fitScore": 36
  },
  {
    "code": "53-4031.00",
    "aptitudeProfile": {
      "Verbal": 36,
      "Numeric": 31,
      "Spatial": 74,
      "ClericalPerception": 52,
      "FormPerception": 70,
      "GeneralLearning": 44
    },
    "interestProfile": {
      "Artistic": 46,
      "Scientific": 39,
      "Plants/Animals": 35,
      "Protective": 70,
      "Mechanical": 74,
      "Industrial": 29,
      "Business Detail": 17,
      "Selling": 44,
      "Accommodating": 41,
      "Humanitarian": 31,
      "Leading/Influencing": 23,
      "Physical Performing": 33
    },
    "fitScore": 46
  },
  {
    "code": "53-4041.00",
    "aptitudeProfile": {
      "Verbal": 19,
      "Numeric": 21,
      "Spatial": 79,
      "ClericalPerception": 36,
      "FormPerception": 94,
      "GeneralLearning": 33
    },
    "interestProfile": {
      "Artistic": 22,
      "Scientific": 18,
      "Plants/Animals": 38,
      "Protective": 94,
      "Mechanical": 79,
      "Industrial": 27,
      "Business Detail": 3,
      "Selling": 8,
      "Accommodating": 57,
      "Humanitarian": 42,
      "Leading/Influencing": 18,
      "Physical Performing": 3
    },
    "fitScore": 41
  },
  {
    "code": "53-5011.00",
    "aptitudeProfile": {
      "Verbal": 24,
      "Numeric": 33,
      "Spatial": 89,
      "ClericalPerception": 65,
      "FormPerception": 96,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 23,
      "Scientific": 19,
      "Plants/Animals": 33,
      "Protective": 96,
      "Mechanical": 89,
      "Industrial": 25,
      "Business Detail": 35,
      "Selling": 28,
      "Accommodating": 62,
      "Humanitarian": 39,
      "Leading/Influencing": 44,
      "Physical Performing": 33
    },
    "fitScore": 49
  },
  {
    "code": "53-5021.00",
    "aptitudeProfile": {
      "Verbal": 53,
      "Numeric": 42,
      "Spatial": 99,
      "ClericalPerception": 77,
      "FormPerception": 94,
      "GeneralLearning": 59
    },
    "interestProfile": {
      "Artistic": 57,
      "Scientific": 52,
      "Plants/Animals": 46,
      "Protective": 94,
      "Mechanical": 99,
      "Industrial": 33,
      "Business Detail": 48,
      "Selling": 48,
      "Accommodating": 65,
      "Humanitarian": 70,
      "Leading/Influencing": 50,
      "Physical Performing": 44
    },
    "fitScore": 65
  },
  {
    "code": "53-5022.00",
    "aptitudeProfile": {
      "Verbal": 17,
      "Numeric": 19,
      "Spatial": 98,
      "ClericalPerception": 72,
      "FormPerception": 92,
      "GeneralLearning": 26
    },
    "interestProfile": {
      "Artistic": 15,
      "Scientific": 25,
      "Plants/Animals": 16,
      "Protective": 92,
      "Mechanical": 98,
      "Industrial": 19,
      "Business Detail": 31,
      "Selling": 16,
      "Accommodating": 34,
      "Humanitarian": 62,
      "Leading/Influencing": 38,
      "Physical Performing": 11
    },
    "fitScore": 46
  },
  {
    "code": "53-5031.00",
    "aptitudeProfile": {
      "Verbal": 52,
      "Numeric": 51,
      "Spatial": 69,
      "ClericalPerception": 66,
      "FormPerception": 71,
      "GeneralLearning": 65
    },
    "interestProfile": {
      "Artistic": 59,
      "Scientific": 63,
      "Plants/Animals": 55,
      "Protective": 71,
      "Mechanical": 69,
      "Industrial": 31,
      "Business Detail": 51,
      "Selling": 64,
      "Accommodating": 57,
      "Humanitarian": 27,
      "Leading/Influencing": 41,
      "Physical Performing": 63
    },
    "fitScore": 58
  },
  {
    "code": "53-6011.00",
    "aptitudeProfile": {
      "Verbal": 9,
      "Numeric": 16,
      "Spatial": 23,
      "ClericalPerception": 16,
      "FormPerception": 49,
      "GeneralLearning": 12
    },
    "interestProfile": {
      "Artistic": 10,
      "Scientific": 8,
      "Plants/Animals": 18,
      "Protective": 49,
      "Mechanical": 23,
      "Industrial": 11,
      "Business Detail": 12,
      "Selling": 4,
      "Accommodating": 19,
      "Humanitarian": 14,
      "Leading/Influencing": 13,
      "Physical Performing": 6
    },
    "fitScore": 18
  },
  {
    "code": "53-6021.00",
    "aptitudeProfile": {
      "Verbal": 5,
      "Numeric": 36,
      "Spatial": 83,
      "ClericalPerception": 10,
      "FormPerception": 46,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 11,
      "Scientific": 8,
      "Plants/Animals": 41,
      "Protective": 46,
      "Mechanical": 83,
      "Industrial": 17,
      "Business Detail": 6,
      "Selling": 6,
      "Accommodating": 34,
      "Humanitarian": 27,
      "Leading/Influencing": 17,
      "Physical Performing": 11
    },
    "fitScore": 29
  },
  {
    "code": "53-6031.00",
    "aptitudeProfile": {
      "Verbal": 23,
      "Numeric": 39,
      "Spatial": 56,
      "ClericalPerception": 11,
      "FormPerception": 30,
      "GeneralLearning": 10
    },
    "interestProfile": {
      "Artistic": 15,
      "Scientific": 9,
      "Plants/Animals": 29,
      "Protective": 30,
      "Mechanical": 56,
      "Industrial": 16,
      "Business Detail": 81,
      "Selling": 11,
      "Accommodating": 26,
      "Humanitarian": 17,
      "Leading/Influencing": 67,
      "Physical Performing": 43
    },
    "fitScore": 31
  },
  {
    "code": "53-6041.00",
    "aptitudeProfile": {
      "Verbal": 50,
      "Numeric": 73,
      "Spatial": 57,
      "ClericalPerception": 71,
      "FormPerception": 74,
      "GeneralLearning": 58
    },
    "interestProfile": {
      "Artistic": 53,
      "Scientific": 59,
      "Plants/Animals": 76,
      "Protective": 74,
      "Mechanical": 57,
      "Industrial": 59,
      "Business Detail": 59,
      "Selling": 59,
      "Accommodating": 74,
      "Humanitarian": 28,
      "Leading/Influencing": 62,
      "Physical Performing": 66
    },
    "fitScore": 62
  },
  {
    "code": "53-6051.00",
    "aptitudeProfile": {
      "Verbal": 61,
      "Numeric": 62,
      "Spatial": 73,
      "ClericalPerception": 66,
      "FormPerception": 81,
      "GeneralLearning": 64
    },
    "interestProfile": {
      "Artistic": 62,
      "Scientific": 59,
      "Plants/Animals": 65,
      "Protective": 81,
      "Mechanical": 73,
      "Industrial": 56,
      "Business Detail": 60,
      "Selling": 55,
      "Accommodating": 76,
      "Humanitarian": 44,
      "Leading/Influencing": 56,
      "Physical Performing": 63
    },
    "fitScore": 65
  },
  {
    "code": "53-6051.01",
    "aptitudeProfile": {
      "Verbal": 76,
      "Numeric": 53,
      "Spatial": 64,
      "ClericalPerception": 81,
      "FormPerception": 88,
      "GeneralLearning": 87
    },
    "interestProfile": {
      "Artistic": 69,
      "Scientific": 79,
      "Plants/Animals": 41,
      "Protective": 88,
      "Mechanical": 64,
      "Industrial": 49,
      "Business Detail": 91,
      "Selling": 62,
      "Accommodating": 60,
      "Humanitarian": 36,
      "Leading/Influencing": 69,
      "Physical Performing": 84
    },
    "fitScore": 70
  },
  {
    "code": "53-6051.07",
    "aptitudeProfile": {
      "Verbal": 18,
      "Numeric": 13,
      "Spatial": 41,
      "ClericalPerception": 13,
      "FormPerception": 63,
      "GeneralLearning": 18
    },
    "interestProfile": {
      "Artistic": 15,
      "Scientific": 11,
      "Plants/Animals": 15,
      "Protective": 63,
      "Mechanical": 41,
      "Industrial": 16,
      "Business Detail": 19,
      "Selling": 14,
      "Accommodating": 30,
      "Humanitarian": 19,
      "Leading/Influencing": 24,
      "Physical Performing": 14
    },
    "fitScore": 26
  },
  {
    "code": "53-6061.00",
    "aptitudeProfile": {
      "Verbal": 19,
      "Numeric": 13,
      "Spatial": 6,
      "ClericalPerception": 5,
      "FormPerception": 24,
      "GeneralLearning": 25
    },
    "interestProfile": {
      "Artistic": 27,
      "Scientific": 15,
      "Plants/Animals": 22,
      "Protective": 24,
      "Mechanical": 6,
      "Industrial": 15,
      "Business Detail": 3,
      "Selling": 16,
      "Accommodating": 21,
      "Humanitarian": 10,
      "Leading/Influencing": 8,
      "Physical Performing": 8
    },
    "fitScore": 15
  },
  {
    "code": "53-7011.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 11,
      "Spatial": 43,
      "ClericalPerception": 49,
      "FormPerception": 79,
      "GeneralLearning": 41
    },
    "interestProfile": {
      "Artistic": 26,
      "Scientific": 32,
      "Plants/Animals": 15,
      "Protective": 79,
      "Mechanical": 43,
      "Industrial": 13,
      "Business Detail": 0,
      "Selling": 29,
      "Accommodating": 29,
      "Humanitarian": 15,
      "Leading/Influencing": 2,
      "Physical Performing": 68
    },
    "fitScore": 34
  },
  {
    "code": "53-7021.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 37,
      "Spatial": 88,
      "ClericalPerception": 35,
      "FormPerception": 61,
      "GeneralLearning": 13
    },
    "interestProfile": {
      "Artistic": 14,
      "Scientific": 13,
      "Plants/Animals": 31,
      "Protective": 61,
      "Mechanical": 88,
      "Industrial": 30,
      "Business Detail": 24,
      "Selling": 11,
      "Accommodating": 35,
      "Humanitarian": 40,
      "Leading/Influencing": 26,
      "Physical Performing": 22
    },
    "fitScore": 37
  },
  {
    "code": "53-7031.00",
    "aptitudeProfile": {
      "Verbal": 6,
      "Numeric": 15,
      "Spatial": 63,
      "ClericalPerception": 25,
      "FormPerception": 55,
      "GeneralLearning": 5
    },
    "interestProfile": {
      "Artistic": 3,
      "Scientific": 7,
      "Plants/Animals": 12,
      "Protective": 55,
      "Mechanical": 63,
      "Industrial": 7,
      "Business Detail": 36,
      "Selling": 7,
      "Accommodating": 21,
      "Humanitarian": 20,
      "Leading/Influencing": 32,
      "Physical Performing": 8
    },
    "fitScore": 25
  },
  {
    "code": "53-7041.00",
    "aptitudeProfile": {
      "Verbal": 10,
      "Numeric": 23,
      "Spatial": 78,
      "ClericalPerception": 55,
      "FormPerception": 63,
      "GeneralLearning": 26
    },
    "interestProfile": {
      "Artistic": 13,
      "Scientific": 25,
      "Plants/Animals": 24,
      "Protective": 63,
      "Mechanical": 78,
      "Industrial": 20,
      "Business Detail": 10,
      "Selling": 22,
      "Accommodating": 19,
      "Humanitarian": 23,
      "Leading/Influencing": 26,
      "Physical Performing": 10
    },
    "fitScore": 35
  },
  {
    "code": "53-7051.00",
    "aptitudeProfile": {
      "Verbal": 6,
      "Numeric": 26,
      "Spatial": 90,
      "ClericalPerception": 23,
      "FormPerception": 47,
      "GeneralLearning": 12
    },
    "interestProfile": {
      "Artistic": 4,
      "Scientific": 9,
      "Plants/Animals": 22,
      "Protective": 47,
      "Mechanical": 90,
      "Industrial": 14,
      "Business Detail": 39,
      "Selling": 5,
      "Accommodating": 18,
      "Humanitarian": 39,
      "Leading/Influencing": 7,
      "Physical Performing": 16
    },
    "fitScore": 30
  },
  {
    "code": "53-7061.00",
    "aptitudeProfile": {
      "Verbal": 1,
      "Numeric": 6,
      "Spatial": 18,
      "ClericalPerception": 1,
      "FormPerception": 3,
      "GeneralLearning": 5
    },
    "interestProfile": {
      "Artistic": 1,
      "Scientific": 3,
      "Plants/Animals": 5,
      "Protective": 3,
      "Mechanical": 18,
      "Industrial": 1,
      "Business Detail": 14,
      "Selling": 2,
      "Accommodating": 2,
      "Humanitarian": 7,
      "Leading/Influencing": 7,
      "Physical Performing": 4
    },
    "fitScore": 6
  },
  {
    "code": "53-7062.00",
    "aptitudeProfile": {
      "Verbal": 12,
      "Numeric": 20,
      "Spatial": 38,
      "ClericalPerception": 2,
      "FormPerception": 3,
      "GeneralLearning": 11
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 8,
      "Plants/Animals": 14,
      "Protective": 3,
      "Mechanical": 38,
      "Industrial": 9,
      "Business Detail": 56,
      "Selling": 5,
      "Accommodating": 5,
      "Humanitarian": 12,
      "Leading/Influencing": 38,
      "Physical Performing": 20
    },
    "fitScore": 16
  },
  {
    "code": "53-7062.04",
    "aptitudeProfile": {
      "Verbal": 14,
      "Numeric": 12,
      "Spatial": 28,
      "ClericalPerception": 22,
      "FormPerception": 68,
      "GeneralLearning": 4
    },
    "interestProfile": {
      "Artistic": 10,
      "Scientific": 4,
      "Plants/Animals": 10,
      "Protective": 68,
      "Mechanical": 28,
      "Industrial": 7,
      "Business Detail": 41,
      "Selling": 6,
      "Accommodating": 22,
      "Humanitarian": 15,
      "Leading/Influencing": 34,
      "Physical Performing": 9
    },
    "fitScore": 23
  },
  {
    "code": "53-7063.00",
    "aptitudeProfile": {
      "Verbal": 8,
      "Numeric": 27,
      "Spatial": 7,
      "ClericalPerception": 12,
      "FormPerception": 52,
      "GeneralLearning": 5
    },
    "interestProfile": {
      "Artistic": 9,
      "Scientific": 4,
      "Plants/Animals": 25,
      "Protective": 52,
      "Mechanical": 7,
      "Industrial": 12,
      "Business Detail": 25,
      "Selling": 4,
      "Accommodating": 30,
      "Humanitarian": 6,
      "Leading/Influencing": 13,
      "Physical Performing": 17
    },
    "fitScore": 18
  },
  {
    "code": "53-7064.00",
    "aptitudeProfile": {
      "Verbal": 2,
      "Numeric": 14,
      "Spatial": 11,
      "ClericalPerception": 1,
      "FormPerception": 4,
      "GeneralLearning": 2
    },
    "interestProfile": {
      "Artistic": 2,
      "Scientific": 2,
      "Plants/Animals": 11,
      "Protective": 4,
      "Mechanical": 11,
      "Industrial": 6,
      "Business Detail": 9,
      "Selling": 2,
      "Accommodating": 4,
      "Humanitarian": 8,
      "Leading/Influencing": 4,
      "Physical Performing": 10
    },
    "fitScore": 6
  },
  {
    "code": "53-7065.00",
    "aptitudeProfile": {
      "Verbal": 9,
      "Numeric": 18,
      "Spatial": 26,
      "ClericalPerception": 18,
      "FormPerception": 12,
      "GeneralLearning": 4
    },
    "interestProfile": {
      "Artistic": 13,
      "Scientific": 7,
      "Plants/Animals": 21,
      "Protective": 12,
      "Mechanical": 26,
      "Industrial": 15,
      "Business Detail": 5,
      "Selling": 17,
      "Accommodating": 7,
      "Humanitarian": 17,
      "Leading/Influencing": 4,
      "Physical Performing": 13
    },
    "fitScore": 14
  },
  {
    "code": "53-7071.00",
    "aptitudeProfile": {
      "Verbal": 29,
      "Numeric": 35,
      "Spatial": 37,
      "ClericalPerception": 68,
      "FormPerception": 85,
      "GeneralLearning": 25
    },
    "interestProfile": {
      "Artistic": 16,
      "Scientific": 27,
      "Plants/Animals": 25,
      "Protective": 85,
      "Mechanical": 37,
      "Industrial": 25,
      "Business Detail": 82,
      "Selling": 17,
      "Accommodating": 37,
      "Humanitarian": 20,
      "Leading/Influencing": 69,
      "Physical Performing": 31
    },
    "fitScore": 43
  },
  {
    "code": "53-7072.00",
    "aptitudeProfile": {
      "Verbal": 33,
      "Numeric": 57,
      "Spatial": 56,
      "ClericalPerception": 69,
      "FormPerception": 93,
      "GeneralLearning": 20
    },
    "interestProfile": {
      "Artistic": 35,
      "Scientific": 17,
      "Plants/Animals": 68,
      "Protective": 93,
      "Mechanical": 56,
      "Industrial": 31,
      "Business Detail": 48,
      "Selling": 25,
      "Accommodating": 68,
      "Humanitarian": 23,
      "Leading/Influencing": 41,
      "Physical Performing": 49
    },
    "fitScore": 50
  },
  {
    "code": "53-7073.00",
    "aptitudeProfile": {
      "Verbal": 7,
      "Numeric": 25,
      "Spatial": 44,
      "ClericalPerception": 25,
      "FormPerception": 39,
      "GeneralLearning": 23
    },
    "interestProfile": {
      "Artistic": 8,
      "Scientific": 14,
      "Plants/Animals": 17,
      "Protective": 39,
      "Mechanical": 44,
      "Industrial": 14,
      "Business Detail": 27,
      "Selling": 3,
      "Accommodating": 10,
      "Humanitarian": 16,
      "Leading/Influencing": 15,
      "Physical Performing": 15
    },
    "fitScore": 23
  },
  {
    "code": "53-7081.00",
    "aptitudeProfile": {
      "Verbal": 3,
      "Numeric": 11,
      "Spatial": 39,
      "ClericalPerception": 1,
      "FormPerception": 7,
      "GeneralLearning": 2
    },
    "interestProfile": {
      "Artistic": 4,
      "Scientific": 1,
      "Plants/Animals": null,
      "Protective": 7,
      "Mechanical": 39,
      "Industrial": 16,
      "Business Detail": 2,
      "Selling": 2,
      "Accommodating": 16,
      "Humanitarian": 16,
      "Leading/Influencing": 5,
      "Physical Performing": 2
    },
    "fitScore": 10
  },
  {
    "code": "53-7121.00",
    "aptitudeProfile": {
      "Verbal": 13,
      "Numeric": 30,
      "Spatial": 74,
      "ClericalPerception": 67,
      "FormPerception": 85,
      "GeneralLearning": 12
    },
    "interestProfile": {
      "Artistic": 17,
      "Scientific": 15,
      "Plants/Animals": 43,
      "Protective": 85,
      "Mechanical": 74,
      "Industrial": 34,
      "Business Detail": 3,
      "Selling": 17,
      "Accommodating": 46,
      "Humanitarian": 37,
      "Leading/Influencing": 12,
      "Physical Performing": 6
    },
    "fitScore": 40
  }
]